export default {
  '(4<=条码长度<=10)': '(4<=条码长度<=10)',
  '1*1*1规格或默认规格,不允许被删除': '1*1*1规格或默认规格,不允许被删除',
  '17位生鲜条码': '17位生鲜条码',
  '2. 打开浏览器扩展程序，并打开右上角开发者模式': '2. 打开浏览器扩展程序，并打开右上角开发者模式',
  '24位生鲜条码': '24位生鲜条码',
  '3. 点击“加载已解压的扩展程序”按钮，选择第一步下载并解压的文件目录': '3. 点击“加载已解压的扩展程序”按钮，选择第一步下载并解压的文件目录',
  '4. 此时可看到扩展程序里有一个串口插件，将插件ID复制到本页面又上角的检查插件页面': '4. 此时可看到扩展程序里有一个串口插件，将插件ID复制到本页面又上角的检查插件页面',
  '5. 刷新页面即可': '5. 刷新页面即可',
  ':共生成{length}张供应商拣货单': ':共生成{length}张供应商拣货单',
  '<空>': '<空>',
  'AGV入库回传': 'AGV入库回传',
  'AGV入库暂存位': 'AGV入库暂存位',
  'AGV内部管理指令': 'AGV内部管理指令',
  'AGV出库分拣机': 'AGV出库分拣机',
  'AGV出库暂存位': 'AGV出库暂存位',
  'AGV异常处理位': 'AGV异常处理位',
  'AGV拣货': 'AGV拣货',
  'AGV拣货位': 'AGV拣货位',
  'AGV盘点库存处理方式配置': 'AGV盘点库存处理方式配置',
  'AGV盘点移库': 'AGV盘点移库',
  'AGV移库': 'AGV移库',
  'AGV移库出': 'AGV移库出',
  'AGV配置': 'AGV配置',
  'AGV集货': 'AGV集货',
  'App操作': 'App操作',
  'EAN128码': 'EAN128码',
  'EAN128码打印机配置': 'EAN128码打印机配置',
  'ERP发起': 'ERP发起',
  'Failed to update theme': 'Failed to update theme',
  'IPS拣货': 'IPS拣货',
  'IP地址': 'IP地址',
  'I型货道-由大到小': 'I型货道-由大到小',
  'I型货道-由小到大': 'I型货道-由小到大',
  'OMS订单号': 'OMS订单号',
  'PC打印': 'PC打印',
  'RFiD配置': 'RFiD配置',
  'RF上传': 'RF上传',
  'RF上架是否启用货位别名二次校验': 'RF上架是否启用货位别名二次校验',
  'RF作业数量默认录入方式配置': 'RF作业数量默认录入方式配置',
  'RF安装文件': 'RF安装文件',
  'RF安装文件不能为空': 'RF安装文件不能为空',
  'RF容器复查计入方式': 'RF容器复查计入方式',
  'RF库存分配限制配置': 'RF库存分配限制配置',
  'RF库存查询忽略货位用途配置': 'RF库存查询忽略货位用途配置',
  'RF快捷键配置': 'RF快捷键配置',
  'RF打印': 'RF打印',
  'RF打印机': 'RF打印机',
  'RF打印机管理配置': 'RF打印机管理配置',
  'RF收货混载框勾选配置': 'RF收货混载框勾选配置',
  'RF模块名': 'RF模块名',
  'RF模块名称': 'RF模块名称',
  'RF生成拣货指令货位': 'RF生成拣货指令货位',
  'RF生成拣货指令货位配置': 'RF生成拣货指令货位配置',
  'RF管理': 'RF管理',
  'RF装车': 'RF装车',
  'RF记录卸货方式': 'RF记录卸货方式',
  'RF货位展示及录入配置': 'RF货位展示及录入配置',
  'RF货位展示及确认配置': 'RF货位展示及确认配置',
  'RF边拣边播任务获取方式配置': 'RF边拣边播任务获取方式配置',
  'RF边拣边播任务获取方式：': 'RF边拣边播任务获取方式：',
  'RF边拣边播自动分配容器类型配置': 'RF边拣边播自动分配容器类型配置',
  'RF退仓收货是否展示退货条件信息': 'RF退仓收货是否展示退货条件信息',
  'RF退仓收货自动上架': 'RF退仓收货自动上架',
  'SCC配置': 'SCC配置',
  'TMS配置': 'TMS配置',
  'Token不能为空': 'Token不能为空',
  'T值尾盘修复': 'T值尾盘修复',
  '按整箱': '按整箱',
  '严格出货量': '严格出货量',
  'T型上架配置': 'T型上架配置',
  'U型货道': 'U型货道',
  'WCS包装机配置': 'WCS包装机配置',
  'WCS配置': 'WCS配置',
  'WMS系统功能': 'WMS系统功能',
  'Web摘果实拣显示': 'Web摘果实拣显示',
  'Web播种实拣显示': 'Web播种实拣显示',
  'Web操作': 'Web操作',
  'Web收货': 'Web收货',
  'WEB收货': 'WEB收货',
  'Web端权限': 'Web端权限',
  'XX 指数': 'XX 指数',
  'Your device does not support files downloading. Please try again in desktop browser.': 'Your device does not support files downloading. Please try again in desktop browser.',
  ']吗?': ']吗?',
  ']角色吗?': ']角色吗?',
  'account.center.setting.avatar.button': '更换头像',
  'account.center.setting.avatar.tips.add': '添加图片',
  'account.center.setting.avatar.tips.update': '修改图片',
  'account.center.setting.avatar.title': '头像',
  'account.center.setting.avatar.validate.message.Limit2M': '图片大小限制在2M以内',
  'account.center.setting.avatar.validate.message.notImage': '仅支持PNG、GIF 或者 JPG的图片',
  'account.center.setting.button.updateInfo': '确认修改',
  'account.center.setting.form.item.avatar': '头像',
  'account.center.setting.form.item.code': '代码',
  'account.center.setting.form.item.name': '名称',
  'account.center.setting.form.item.name.placeholder': '请输入名称',
  'account.center.setting.form.item.name.validate.message.limitLength': '用户名称最大长度30',
  'account.center.setting.form.item.name.validate.message.notNull': '用户名称不能为空',
  'account.center.setting.form.item.orgs': '所属组织',
  'account.center.setting.form.item.phone': '手机号',
  'account.center.setting.form.item.phone.placeholder': '请输入手机号',
  'account.center.setting.form.item.phone.validate.message.integrality': '请输入真实手机号',
  'account.center.setting.form.item.phone.validate.message.notNull': '手机号不能为空',
  'account.center.setting.message.success.changeAvatar': '更新头像成功',
  'account.center.setting.message.success.changeBasicInfo': '更换信息成功',
  'account.center.setting.tittle': '账户信息',
  'adjBill.adjBillItems': '修正单明细',
  'adjBill.adjer': '修正人',
  'adjBill.article': '商品',
  'adjBill.binAndBinUsage': '货位及货位用途',
  'adjBill.contained': '容器',
  'adjBill.down': '逆向修正',
  'adjBill.endTime': '结束时间',
  'adjBill.handover': '交接员',
  'adjBill.manageReason': '管理修正原因',
  'adjBill.note': '备注',
  'adjBill.reason': '修正原因',
  'adjBill.receiver': '收货员',
  'adjBill.rtner': '退仓员',
  'adjBill.sourceBill': '来源单号',
  'adjBill.spec': '规格',
  'adjBill.startTime': '开始时间',
  'adjBill.state': '状态',
  'adjBill.title': '修正单',
  'adjBill.type': '修正类型',
  'adjBill.up': '正向修正',
  'alcDiff.diffReason': '差异原因',
  'alcDiff.manageDiffReason': '管理差异原因',
  'alcDiff.manageDiffType': '管理配差单类型',
  'alcNtc.alcDate': '配货日期',
  'alcNtc.alcTime': '配货时间',
  'alcNtc.articleItems': '商品明细',
  'alcNtc.batch.fail': '获取批量导入模板失败',
  'alcNtc.createTime': '配单接收时间',
  'alcNtc.endPickTime': '结束拣货时间',
  'alcNtc.endShipTime': '结束装车时间',
  'alcNtc.expireDate': '到效日期',
  'alcNtc.groupName': '组别',
  'alcNtc.manageType': '管理配货类型',
  'alcNtc.oldArticle': '原商品',
  'alcNtc.pickUpload': '拣货上传',
  'alcNtc.pickUploadDate': '拣货上传日期',
  'alcNtc.qpcStrAndMunit': '包装规格/单位',
  'alcNtc.replaceItems': '替换明细',
  'alcNtc.shipState': '装车状态',
  'alcNtc.shipUpload': '装车上传',
  'alcNtc.shipUploadDate': '装车上传日期',
  'alcNtc.sourceBillNumber': '来源单号',
  'alcNtc.sourceOrderBillNumber': '订单来源单号',
  'alcNtc.startPickTime': '开始拣货时间',
  'alcNtc.startShipTime': '开始装车时间',
  'alcNtc.title': '配货通知单',
  'alcNtc.type': '配货类型',
  'alcNtc.waveBillNumber': '波次单号',
  'app.analysis.all-day': '今日',
  'app.analysis.all-month': '本月',
  'app.analysis.all-week': '本周',
  'app.analysis.all-year': '全年',
  'app.analysis.channel.all': '全部渠道',
  'app.analysis.channel.online': '线上',
  'app.analysis.channel.stores': '门店',
  'app.analysis.conversion-rate': '转化率',
  'app.analysis.day': '日同比',
  'app.analysis.day-sales': '日销售额',
  'app.analysis.day-visits': '日访问量',
  'app.analysis.introduce': '指标说明',
  'app.analysis.online-top-search': '线上热门搜索',
  'app.analysis.operational-effect': '运营活动效果',
  'app.analysis.payments': '支付笔数',
  'app.analysis.per-capita-search': '人均搜索次数',
  'app.analysis.sales': '销售额',
  'app.analysis.sales-ranking': '门店销售额排名',
  'app.analysis.sales-trend': '销售趋势',
  'app.analysis.search-users': '搜索用户数',
  'app.analysis.table.rank': '排名',
  'app.analysis.table.search-keyword': '搜索关键词',
  'app.analysis.table.users': '用户数',
  'app.analysis.table.weekly-range': '周涨幅',
  'app.analysis.test': '工专路 {no} 号店',
  'app.analysis.the-proportion-of-sales': '销售额类别占比',
  'app.analysis.total-sales': '总销售额',
  'app.analysis.traffic': '客流量',
  'app.analysis.visits': '访问量',
  'app.analysis.visits-ranking': '门店访问量排名',
  'app.analysis.visits-trend': '访问量趋势',
  'app.analysis.week': '周同比',
  'app.desc': '好看的仓库千篇一律，海鼎的系统百里挑一',
  'app.desc.end': '海鼎的系统百里挑一',
  'app.desc.front': '好看的仓库千篇一律',
  'app.exception.back': '返回首页',
  'app.exception.description.403': '抱歉，你无权访问该页面',
  'app.exception.description.404': '抱歉，你访问的页面不存在',
  'app.exception.description.500': '抱歉，服务器出错了',
  'app.exist.account.title': '使用已有账户登录',
  'app.forget.title': '忘记密码',
  'app.forms.basic.description': '表单页用于向用户收集或验证信息，基础表单常见于数据项较少的表单场景。',
  'app.forms.basic.title': '基础表单',
  'app.home.introduce': '介绍',
  'app.login.againPassword': '6-16位新密码，区分大小写',
  'app.login.change-captcha': '看不清，换一张',
  'app.login.ckeckPassword': '密码必须为6-16位数字、字母、符号组合',
  'app.login.forgot-password': '忘记密码',
  'app.login.login': '登录',
  'app.login.message-invalid-credentials': '账户或密码错误',
  'app.login.message-invalid-verification-code': '验证码错误',
  'app.login.password': '请输入密码',
  'app.login.remember-me': '记住密码',
  'app.login.sign-in-with': '其他登录方式',
  'app.login.signup': '注册账户',
  'app.login.sure': '确认',
  'app.login.tab-login-credentials': '账户密码登录',
  'app.login.tab-login-mobile': '手机号登录',
  'app.login.title': '登录',
  'app.login.type.account.title': '账户密码登录',
  'app.login.type.phone.title': '手机号登录',
  'app.login.user.not.exist': '用户不存在',
  'app.login.userName': '请输入手机号',
  'app.monitor.activity-forecast': '活动情况预测',
  'app.monitor.efficiency': '券核效率',
  'app.monitor.fast-food': '中式快餐',
  'app.monitor.fund-surplus': '补贴资金剩余',
  'app.monitor.hot-pot': '火锅',
  'app.monitor.popular-searches': '热门搜索',
  'app.monitor.proportion-per-category': '各品类占比',
  'app.monitor.ratio': '跳出率',
  'app.monitor.remaining-time': '活动剩余时间',
  'app.monitor.resource-surplus': '资源剩余',
  'app.monitor.sales-target': '销售目标完成率',
  'app.monitor.total-transactions': '今日交易总额',
  'app.monitor.total-transactions-per-second': '每秒交易总额',
  'app.monitor.trading-activity': '活动实时交易情况',
  'app.monitor.waiting-for-implementation': 'Waiting for implementation',
  'app.monitor.western-food': '西餐',
  'app.register-result.activation-email': '激活邮件已发送到你的邮箱中，邮件有效期为24小时。请及时登录邮箱，点击邮件中的链接激活帐户。',
  'app.register-result.back-home': '返回首页',
  'app.register-result.msg': '你的账户：{email} 注册成功',
  'app.register-result.view-mailbox': '查看邮箱',
  'app.register.get-verification-code': '获取验证码',
  'app.register.register': '注册',
  'app.register.sing-in': '使用已有账户登录',
  'app.result.error.btn-text': '返回修改',
  'app.result.error.description': '请核对并修改以下信息后，再重新提交。',
  'app.result.error.hint-btn1': '立即解冻',
  'app.result.error.hint-btn2': '立即升级',
  'app.result.error.hint-text1': '您的账户已被冻结',
  'app.result.error.hint-text2': '您的账户还不具备申请资格',
  'app.result.error.hint-title': '您提交的内容有如下错误：',
  'app.result.error.title': '提交失败',
  'app.result.success.btn-print': '打印',
  'app.result.success.btn-project': '查看项目',
  'app.result.success.btn-return': '返回列表',
  'app.result.success.description': '提交结果页用于反馈一系列操作任务的处理结果， 如果仅是简单操作，使用 Message 全局提示反馈即可。 本文字区域可以展示简单的补充说明，如果有类似展示 “单据”的需求，下面这个灰色区域可以呈现比较复杂的内容。',
  'app.result.success.operate-id': '项目 ID：',
  'app.result.success.operate-time': '生效时间：',
  'app.result.success.operate-title': '项目名称',
  'app.result.success.principal': '负责人：',
  'app.result.success.step1-operator': '曲丽丽',
  'app.result.success.step1-title': '创建项目',
  'app.result.success.step2-extra': '催一下',
  'app.result.success.step2-operator': '周毛毛',
  'app.result.success.step2-title': '部门初审',
  'app.result.success.step3-title': '财务复核',
  'app.result.success.step4-title': '完成',
  'app.result.success.title': '提交成功',
  'app.setting.content-width': '内容区域宽度',
  'app.setting.content-width.fixed': '定宽',
  'app.setting.content-width.fluid': '流式',
  'app.setting.copy': '拷贝设置',
  'app.setting.copyinfo': '拷贝成功，请到 src/defaultSettings.js 中替换默认配置',
  'app.setting.fixedheader': '固定 Header',
  'app.setting.fixedsidebar': '固定侧边菜单',
  'app.setting.fixedsidebar.hint': '侧边菜单布局时可配置',
  'app.setting.hideheader': '下滑时隐藏 Header',
  'app.setting.hideheader.hint': '固定 Header 时可配置',
  'app.setting.navigationmode': '导航模式',
  'app.setting.othersettings': '其他设置',
  'app.setting.pagestyle': '整体风格设置',
  'app.setting.pagestyle.dark': '暗色菜单风格',
  'app.setting.pagestyle.light': '亮色菜单风格',
  'app.setting.production.hint': '配置栏只在开发环境用于预览，生产环境不会展现，请拷贝后手动修改配置文件',
  'app.setting.sidemenu': '侧边菜单布局',
  'app.setting.themecolor': '主题色',
  'app.setting.themecolor.cyan': '明青',
  'app.setting.themecolor.daybreak': '拂晓蓝（默认）',
  'app.setting.themecolor.dust': '薄暮',
  'app.setting.themecolor.geekblue': '极客蓝',
  'app.setting.themecolor.green': '极光绿',
  'app.setting.themecolor.purple': '酱紫',
  'app.setting.themecolor.sunset': '日暮',
  'app.setting.themecolor.volcano': '火山',
  'app.setting.topmenu': '顶部菜单布局',
  'app.setting.weakmode': '色弱模式',
  'app.settings.basic.address': '街道地址',
  'app.settings.basic.address-message': '请输入您的街道地址!',
  'app.settings.basic.avatar': '头像',
  'app.settings.basic.change-avatar': '更换头像',
  'app.settings.basic.country': '国家/地区',
  'app.settings.basic.country-message': '请输入您的国家或地区!',
  'app.settings.basic.email': '邮箱',
  'app.settings.basic.email-message': '请输入您的邮箱!',
  'app.settings.basic.geographic': '所在省市',
  'app.settings.basic.geographic-message': '请输入您的所在省市!',
  'app.settings.basic.nickname': '昵称',
  'app.settings.basic.nickname-message': '请输入您的昵称!',
  'app.settings.basic.phone': '联系电话',
  'app.settings.basic.phone-message': '请输入您的联系电话!',
  'app.settings.basic.profile': '个人简介',
  'app.settings.basic.profile-message': '请输入个人简介!',
  'app.settings.basic.profile-placeholder': '个人简介',
  'app.settings.basic.update': '更新基本信息',
  'app.settings.binding.alipay': '绑定支付宝',
  'app.settings.binding.alipay-description': '当前未绑定支付宝账号',
  'app.settings.binding.bind': '绑定',
  'app.settings.binding.dingding': '绑定钉钉',
  'app.settings.binding.dingding-description': '当前未绑定钉钉账号',
  'app.settings.binding.taobao': '绑定淘宝',
  'app.settings.binding.taobao-description': '当前未绑定淘宝账号',
  'app.settings.close': '关',
  'app.settings.menuMap.basic': '基本设置',
  'app.settings.menuMap.binding': '账号绑定',
  'app.settings.menuMap.notification': '新消息通知',
  'app.settings.menuMap.security': '安全设置',
  'app.settings.notification.messages': '系统消息',
  'app.settings.notification.messages-description': '系统消息将以站内信的形式通知',
  'app.settings.notification.password': '账户密码',
  'app.settings.notification.password-description': '其他用户的消息将以站内信的形式通知',
  'app.settings.notification.todo': '账户密码',
  'app.settings.notification.todo-description': '账户密码',
  'app.settings.open': '开',
  'app.settings.security.bind': '绑定',
  'app.settings.security.email': '备用邮箱',
  'app.settings.security.email-description': '已绑定邮箱：',
  'app.settings.security.medium': '中',
  'app.settings.security.mfa': 'MFA 设备',
  'app.settings.security.mfa-description': '未绑定 MFA 设备，绑定后，可以进行二次确认',
  'app.settings.security.modify': '修改',
  'app.settings.security.password': '账户密码',
  'app.settings.security.password-description': '当前密码强度：',
  'app.settings.security.phone': '密保手机',
  'app.settings.security.phone-description': '已绑定手机：',
  'app.settings.security.question': '密保问题',
  'app.settings.security.question-description': '未设置密保问题，密保问题可有效保护账户安全',
  'app.settings.security.set': '设置',
  'app.settings.security.strong': '强',
  'app.settings.security.weak': '弱',
  'article.attachment.column.articleAttachmentRatioLocale': '商品件数和附件个数比例',
  'article.attachment.column.attachmentLocale': '附件',
  'article.barcode': '条码',
  'article.barcode.qpcStr': '规格',
  'article.column.barcode': '第二代码',
  'article.column.category': '类别',
  'article.column.categoryCodeName': '类别代码/名称',
  'article.column.checkType': '质检类型',
  'article.column.codeNameBarcode': '代码/名称/条码',
  'article.column.defaultVendor': '默认供应商',
  'article.column.deliveryControlDays': '配货控制天数',
  'article.column.groupName': '组别',
  'article.column.origin': '产地',
  'article.column.owner': '货主',
  'article.column.physicsCheckType': '质检强度',
  'article.column.pluCode': 'plu码',
  'article.column.priceType': '定价类型',
  'article.column.processing': '出货前加工',
  'article.column.purchasePrice': '进价',
  'article.column.qcr': '需要检疫证',
  'article.column.receiveControlDays': '收货控制天数',
  'article.column.returnControlDays': '退货控制天数',
  'article.column.salePrice': '售价',
  'article.column.shelfLifeDays': '保质期天数',
  'article.column.shelfLifeType': '保质期类型',
  'article.column.spec': '计量',
  'article.column.taxRate': '费率',
  'article.column.trackRecord': '产生追溯码',
  'article.create': '新建商品',
  'article.create.beforeuploadsizetip': '图片大小不超过1M',
  'article.create.beforeuploadtypetip': '图片支持PNG/JPG格式',
  'article.create.title': '新建商品',
  'article.create.unloadAdvice': '管理卸货指导',
  'article.create.uploaderror': '图片存入OSS时发生错误，请重试',
  'article.create.uploading': '上传中',
  'article.create.uploadtips': '拖拽至此&nbsp;或&nbsp;点击上传<br/>限1M以内',
  'article.dc.setting': '配送设置',
  'article.detail.basicinfo.picture': '图片',
  'article.detail.tab.barcode': '条码详情',
  'article.detail.tab.basicInfo': '商品信息',
  'article.detail.tab.dclist': '配送中心范围',
  'article.detail.tab.maintaincate': '附件维护绑定维护分类',
  'article.detail.tab.qc': '商品质检',
  'article.detail.tab.qpc': '规格详情',
  'article.detail.tab.storePickQpc': '门店起要量详情',
  'article.detail.tab.storeprice': '门店价格',
  'article.detail.tab.vendor': '供应商详情',
  'article.import.article': '导入商品',
  'article.import.articleBarcode': '导入商品条码',
  'article.import.articleQpc': '导入商品规格',
  'article.import.articleVendor': '导入商品供应商',
  'article.import.storePickQty': '导入商品门店起要量',
  'article.mixGroup': '混载组',
  'article.panel.basic': '基本信息',
  'article.panel.business': '业务信息',
  'article.panel.note': '备注',
  'article.panel.shelfLife': '保质期',
  'article.physics.column.articlePhysics': '理化质检科目',
  'article.physics.column.qualifiedRange': '合格区间范围',
  'article.physics.column.qualifiedType': '合格标识',
  'article.qpc.column.defaultQpcStr': '默认规格',
  'article.qpc.column.height': '高(cm)',
  'article.qpc.column.length': '长(cm)',
  'article.qpc.column.munit': '计量单位',
  'article.qpc.column.paq': '包装件数',
  'article.qpc.column.qpcStr': '包装规格',
  'article.qpc.column.weight': '重(g)',
  'article.qpc.column.width': '宽(cm)',
  'article.qpc.validate.munit.notNull': '请输入计量单位',
  'article.qpc.validate.plateAdvice.notMatch': '请输入m*n格式的商品装盘建议且长度不能超过30',
  'article.qpc.validate.qpcStr.notMatch': '请输入1*m*n格式的规格',
  'article.sense.column.articlesense': '感官质检科目',
  'article.storepickqty.column.count': '出货倍数',
  'article.storepickqty.column.pickQpc': '起要量',
  'article.storepickqty.column.sourceCount': '上游出货倍数',
  'article.storepickqty.column.storeType': '门店业态',
  'article.storepickqty.validate.count': '出货倍数须是大于0且小于等于1000的整数',
  'article.storeprice.column.deductedWeight': '扣损重量',
  'article.storeprice.column.price': '单价',
  'article.title': '商品',
  'article.vendor.column.defaultReceive': '首选收货',
  'article.vendor.column.defaultReceivePrice': '默认入库价格（元）',
  'article.vendor.column.defaultReturn': '首选退货',
  'article.vendor.column.defaultReturnPrice': '默认退货价格（元）',
  'article.vendor.column.isDefaultVendor': '默认供应商',
  'article.vendor.column.vendor': '供应商',
  'article.vendor.message.setDefaultVendor': '设置默认供应商成功',
  'article.vendor.operate.setPreferred': '设为首选',
  'articleBusiness.column.binState': '商品状态',
  'articleBusiness.column.outProcess': '出货前加工',
  'articleBusiness.column.overDeliveryRate': '超出比例(%)',
  'articleBusiness.column.overPickRate': '超拣比例(%)',
  'articleBusiness.column.overReceiveRate': '超收比例(%)',
  'articleBusiness.column.process': '收货后加工',
  'articleBusiness.column.putawayBin': '上架货位',
  'articleBusiness.column.settleQpcStr': '标准规格',
  'articleBusiness.column.settleUnit': '结算单位',
  'articleBusiness.column.stockMode': '库存模式',
  'articleBusiness.column.storageType': '存储条件',
  'articleBusiness.column.unLoadAdvice': '卸货指导',
  'articleBusiness.column.weighing': '支持小数操作',
  'articlePlate.column.plate': '装盘件数',
  'articlePlate.column.plateAdvice': '装盘建议',
  'articleReplace.adaptAllStore': '支持所有门店',
  'articleReplace.adjustOrder': '序号调整',
  'articleReplace.articleCode': '商品代码',
  'articleReplace.articleName': '商品名称',
  'articleReplace.createReplaceScheme': '新建商品替换方案',
  'articleReplace.items': '明细',
  'articleReplace.judgeFalse': '否',
  'articleReplace.judgeTrue': '是',
  'articleReplace.replaceArticleItems': '可替换商品',
  'articleReplace.replaceArticleItemsIsNull': '商品替换方案可替换商品明细为空',
  'articleReplace.replaceOrder': '序号',
  'articleReplace.replaceStoreItems': '适用门店',
  'articleReplace.storeCode': '门店代码',
  'articleReplace.storeName': '门店名称',
  'articleReplace.title': '商品替换方案',
  'articleStorage.article': '商品',
  'articleStorage.articleCodeName': '代码/名称',
  'articleStorage.binRange': '货位范围',
  'articleStorage.binRange.add': '货位范围',
  'articleStorage.binRange.not.match': '货位范围不匹配',
  'articleStorage.create.title': '新增',
  'articleStorage.qpcStr': '商品规格',
  'articleStorage.select': '商品',
  'articleStorage.select.article': '商品',
  'articleStorage.title': '商品存储范围配置',
  'basic.data.order': '顺序字段只允许输入数字',
  'bill.config': '单据配置',
  'bill.maxCount': '最大明细数',
  'bin.facility.path': '货道',
  'bin.facility.shelf': '货架',
  'bin.facility.stockInfo': '货位库存信息',
  'bin.facility.zone': '货区',
  'bin.modal.alterBinAlias': '设置货位别名',
  'bin.modal.alterType': '修改货位类型',
  'bin.modal.alterUsage': '修改货位用途',
  'bin.modal.bin': '新建货位',
  'bin.modal.bin.bin.avgcount': '平均货道数',
  'bin.modal.bin.column.range': '列码范围',
  'bin.modal.bin.level.range': '层码范围',
  'bin.modal.bin.path.avgcount': '平均货道数',
  'bin.modal.bin.quick': '快速新建货位',
  'bin.modal.bin.shelf.avgcount': '平均货架数',
  'bin.modal.bin.start': '起始货位',
  'bin.modal.path': '新建货道',
  'bin.modal.path.range': '货道范围',
  'bin.modal.path.start': '起始货道',
  'bin.modal.remove': '删除',
  'bin.modal.shelf': '新建货架',
  'bin.modal.shelf.range': '货架范围',
  'bin.modal.shelf.start': '起始货架',
  'bin.modal.zone': '新建货区',
  'bin.modal.zone.range': '货区范围',
  'bin.search': '请输入...',
  'bin.state.exception': '异常',
  'bin.state.free': '空闲',
  'bin.state.locked': '已锁定',
  'bin.state.using': '使用中',
  'bin.table.article.code': '商品代码',
  'bin.table.article.name': '商品名称',
  'bin.table.binAlias': '货位别名',
  'bin.table.bincode': '货位代码',
  'bin.table.container': '容器',
  'bin.table.pathcode': '货道代码',
  'bin.table.price': '单价',
  'bin.table.productionDate': '生产日期',
  'bin.table.qpcStr': '包装规格',
  'bin.table.qty': '数量',
  'bin.table.shelfcode': '货架代码',
  'bin.table.stockBatch': '批次',
  'bin.table.supplier': '供应商',
  'bin.table.validDate': '到效日期',
  'bin.table.zooncode': '货区代码',
  'bin.title': '货位',
  'bin.usage': '货位用途',
  'bin.validate.bin.address': '货位代码必须为8位数字',
  'bin.validate.bin.bin.avgcount.notnull': '平均货位数不能为空',
  'bin.validate.bin.bin.start.notnull': '起始货位不能为空',
  'bin.validate.bin.column.code': '列码必须为1位数字',
  'bin.validate.bin.column.endcode.notnull': '截止列码不能为空',
  'bin.validate.bin.column.startcode.notnull': '起始列码不能为空',
  'bin.validate.bin.level.code': '层码必须为1位数字',
  'bin.validate.bin.level.endcode.notnull': '截止层码不能为空',
  'bin.validate.bin.level.startcode.notnull': '起始层码不能为空',
  'bin.validate.bin.path.avgcount.notnull': '平均货道数不能为空',
  'bin.validate.bin.path.start.notnull': '起始货道不能为空',
  'bin.validate.bin.shelf.avgcount.notnull': '平均货架数不能为空',
  'bin.validate.bin.shelf.start.notnull': '起始货架不能为空',
  'bin.validate.bintype.notnull': '货位类型不能为空',
  'bin.validate.binusage.notnull': '货位用途不能为空',
  'bin.validate.path.code': '货道代码必须为4位数字或前两位数字加第三位字母加第四位数字或字母',
  'bin.validate.path.endcode.notnull': '截至货道代码不能为空',
  'bin.validate.path.start.length': '起始货道代码为1或2位数字或第一位字母加第二位字母或数字',
  'bin.validate.path.startcode.notnull': '起始货道代码不能为空',
  'bin.validate.shelf.code': '货架代码不合规',
  'bin.validate.shelf.endcode.notnull': '截至货架代码不能为空',
  'bin.validate.shelf.start.length': '起始货架代码为1或2位数字或第一位字母加第二位字母或数字',
  'bin.validate.shelf.startcode.notnull': '起始货架代码不能为空',
  'bin.validate.wrh.notnull': '仓位不能为空',
  'bin.validate.zone.code': '货区代码必须为两位数字或大写字母',
  'bin.validate.zone.code.notnull': '货区代码不能为空',
  'bin.validate.zone.endcode.notnull': '截至货区代码不能为空',
  'bin.validate.zone.startcode.notnull': '起始货区代码不能为空',
  'binTypeStorage.binType': '货位类型',
  'binTypeStorage.binTypeCode': '货位类型',
  'binTypeStorage.create.title': '新增',
  'binTypeStorage.select': '货位类型',
  'binTypeStorage.select.binType': '货位类型',
  'binTypeStorage.storageBinType': '可存储货位类型',
  'binTypeStorage.storageBinTypeCode': '商品可存储的货位类型',
  'binTypeStorage.title': '货位类型存储配置',
  'binView.binFormat': '货位展示格式',
  'binView.binFormat.add': '请填写货位展示格式',
  'bindConfig.BINDING': '绑定',
  'bindConfig.SPLITSAND': '拆并',
  'bindConfig.title': '容器绑定/拆并配置',
  'bintype.create.basic': '基本信息',
  'bintype.create.button.cancel': '取消',
  'bintype.create.button.confirm': '确认',
  'bintype.create.button.confirmCreate': '确认并新建',
  'bintype.create.form.item.code': '代码',
  'bintype.create.form.item.code.validate.message.integrality': '代码必须为2-7位字母,数字或字母数字组合',
  'bintype.create.form.item.code.validate.message.notNull': '代码不能为空',
  'bintype.create.form.item.dc': '配送中心',
  'bintype.create.form.item.dc.validate.message.notNull': '配送中心不能为空',
  'bintype.create.form.item.height': '高度(cm)',
  'bintype.create.form.item.height.validate.length': '高度最多为12位',
  'bintype.create.form.item.height.validate.message.notNull': '高度不能为空',
  'bintype.create.form.item.input.placeholder': '请输入',
  'bintype.create.form.item.input.placeholder.code': '请输入代码',
  'bintype.create.form.item.input.placeholder.name': '请输入4到30位的字符',
  'bintype.create.form.item.input.placeholder.note': '请输入备注',
  'bintype.create.form.item.length': '长度(cm)',
  'bintype.create.form.item.length.validate.length': '长度最多为12位',
  'bintype.create.form.item.length.validate.message.notNull': '长度不能为空',
  'bintype.create.form.item.name': '名称',
  'bintype.create.form.item.name.validate.message.limitLength': '名称最大长度30',
  'bintype.create.form.item.name.validate.message.notNull': '名称不能为空',
  'bintype.create.form.item.note': '备注',
  'bintype.create.form.item.note.validate.message.limitLength': '备注最大长度255',
  'bintype.create.form.item.option.placeholder': '请选择',
  'bintype.create.form.item.plotRatio': '容积率(%)',
  'bintype.create.form.item.plotratio.validate.message.notNull': '容积率不能为空',
  'bintype.create.form.item.storageNumber': '存储托盘数',
  'bintype.create.form.item.storageNumber.validate.int': '存储托盘数必须为大于0的整数',
  'bintype.create.form.item.storageNumber.validate.message.notNull': '存储托盘数不能为空',
  'bintype.create.form.item.weight': '承重(kg)',
  'bintype.create.form.item.weight.validate.length': '承重最多为12位',
  'bintype.create.form.item.weight.validate.message.notNull': '承重不能为空',
  'bintype.create.form.item.width': '宽度(cm)',
  'bintype.create.form.item.width.validate.length': '宽度最多为12位',
  'bintype.create.form.item.width.validate.message.notNull': '宽度不能为空',
  'bintype.create.note': '备注',
  'bintype.create.qpc': '规格信息',
  'bintype.create.title': '新建货位类型',
  'bintype.detail.basic': '基本信息',
  'bintype.detail.basic.code': '代码',
  'bintype.detail.basic.dc': '配送中心',
  'bintype.detail.basic.height': '高度(cm)',
  'bintype.detail.basic.length': '长度(cm)',
  'bintype.detail.basic.name': '名称',
  'bintype.detail.basic.note': '备注',
  'bintype.detail.basic.plotRatio': '容积率(%)',
  'bintype.detail.basic.storageNumber': '存储托盘数',
  'bintype.detail.basic.weight': '承重(kg)',
  'bintype.detail.basic.width': '宽度(cm)',
  'bintype.detail.button.back': '返回',
  'bintype.detail.button.cancel': '取消',
  'bintype.detail.button.confirm': '确定',
  'bintype.detail.label.edit': '编辑',
  'bintype.detail.label.remove': '删除',
  'bintype.detail.tab.binTypeInfo': '货位类型信息',
  'bintype.detail.tab.operateInfo': '操作日志',
  'bintype.edit.title': '修改货位类型',
  'bintype.index.message.success.operate': '操作成功',
  'bintype.index.search.button.reset': '重置',
  'bintype.index.search.button.search': '查询',
  'bintype.index.search.input.code': '代码',
  'bintype.index.search.input.name': '名称',
  'bintype.index.search.input.placeholder': '请输入关键词查询',
  'bintype.index.table.button.new': '新建',
  'bintype.index.table.column.code': '代码',
  'bintype.index.table.column.dc': '配送中心',
  'bintype.index.table.column.height': '高度(cm)',
  'bintype.index.table.column.length': '长度(cm)',
  'bintype.index.table.column.name': '名称',
  'bintype.index.table.column.operate': '操作',
  'bintype.index.table.column.plotRatio': '容积率(%)',
  'bintype.index.table.column.storageNumber': '存储托盘数',
  'bintype.index.table.column.weight': '承重(kg)',
  'bintype.index.table.column.width': '宽度(cm)',
  'bintype.index.table.operate.edit': '编辑',
  'bintype.index.table.operate.view': '查看',
  'bintype.title': '货位类型',
  'bintype.update.title': '编辑货位类型',
  'book.abort.confirm': '确认作废该预约单吗？',
  'book.allArticles': '总品项数',
  'book.allOrders': '总订单数',
  'book.audit.confirm': '确认审核该预约单吗？',
  'book.beginBook': '开始预约',
  'book.beginTime': '开始时间',
  'book.bookArticleQty': '预约品项数',
  'book.booker': '预约人',
  'book.date': '预约日期',
  'book.dockGroup': '码头集',
  'book.endTime': '结束时间',
  'book.orderInfo': '订单信息',
  'book.qtyStr': '预约件数',
  'book.remove.confirm': '确认删除该预约单吗？',
  'book.timeRange': '预约时间段',
  'book.title': '预约单',
  'book.type': '预约方式',
  'bookQtyStrConfig.column.dockGroup': '码头集',
  'bookQtyStrConfig.column.dockGroupCode': '码头集代码',
  'bookQtyStrConfig.column.dockGroupCodeName': '码头集代码/名称',
  'bookQtyStrConfig.column.dockGroupName': '码头集名称',
  'bookQtyStrConfig.column.exceedRatio': '超约比例',
  'bookQtyStrConfig.column.maxReceiveArticleCount': '最多可预品项数',
  'bookQtyStrConfig.column.maxReceiveQtyStr': '最多可预约件数',
  'bookQtyStrConfig.create.title': '新增码头集收货量配置',
  'bookQtyStrConfig.title': '预约量配置',
  'bookTimeConfig.column.endTime': '结束时间',
  'bookTimeConfig.column.preDays': '提前预约天数（天）',
  'bookTimeConfig.column.startTime': '开始时间',
  'bookTimeConfig.column.time': '预约时间',
  'bookTimeConfig.column.timeRange': '预约单位时间（分钟）',
  'bookTimeConfig.title': '预约时间配置',
  'bookTimeConfigPattern.column.preDays': '预约天数必须大于等于0',
  'bookTimeConfigPattern.column.time': '预约时间段必须大于0',
  'carrier.code': '代码',
  'carrier.contactPhone': '联系方式',
  'carrier.contactor': '联系人',
  'carrier.create.form.item.homeUrl.name': '主页',
  'carrier.create.form.item.homeUrl.validate.message.limitLength': '主页最大长度100',
  'carrier.detail.tab.basicInfo': '承运商信息',
  'carrier.index.button.new': '新建',
  'carrier.index.button.reset': '重置',
  'carrier.index.button.search': '查询',
  'carrier.index.column.operate': '操作',
  'carrier.index.search.button.close': '收起',
  'carrier.index.search.button.open': '展开',
  'carrier.index.search.content.all': '全部',
  'carrier.index.search.content.offline': '已禁用',
  'carrier.index.search.content.online': '已启用',
  'carrier.index.search.input.codeName': '承运商代码/名称',
  'carrier.index.search.input.state': '状态',
  'carrier.index.table.content.offline': '已禁用',
  'carrier.index.table.content.online': '已启用',
  'carrier.name': '名称',
  'carrier.note': '备注',
  'carrier.owner': '货主',
  'carrier.placeholder': '请输入',
  'carrier.popup.addTitle': '新增承运商',
  'carrier.popup.code.validate.integrality': '代码最大长度为4，只能是字母和数字',
  'carrier.popup.code.validate.notNull': '代码不能为空',
  'carrier.popup.contactPhone.validate.limitLength': '联系方式最大长度30',
  'carrier.popup.contactPhone.validate.notNull': '联系方式不能为空',
  'carrier.popup.contactor.validate.limitLength': '联系人最大长度30',
  'carrier.popup.contactor.validate.notNull': '联系人不能为空',
  'carrier.popup.editTitle': '编辑承运商',
  'carrier.popup.name.validate.limitLength': '名称最大长度30',
  'carrier.popup.name.validate.notNull': '名称不能为空',
  'carrier.popup.note.validate.limitLength': '备注最大长度255',
  'carrier.popup.shortName.validate.limitLength': '简称最大长度30',
  'carrier.popup.shortName.validate.notNull': '简称不能为空',
  'carrier.popup.title': '基本信息',
  'carrier.popup.zipCode.validate.limitLength': '邮编最大长度30',
  'carrier.shortName': '简称',
  'carrier.sourceWay': '来源方式',
  'carrier.title': '承运商',
  'carrier.zipCode': '邮编',
  'category.IPopconfirmTitle': '是否删除该商品类别',
  'category.create.button': '新建类别',
  'category.create.child': '新增子级商品类别',
  'category.create.form.item.code.validate.message.limitLength': '类别代码最大长度30',
  'category.create.form.item.code.validate.message.notNull': '类别代码不能为空',
  'category.create.form.item.level.validate.message.notNull': '类别级别不能为空',
  'category.create.form.item.name.validate.message.limitLength': '类别名称最大长度10',
  'category.create.form.item.name.validate.message.notNull': '类别名称不能为空',
  'category.create.form.item.note.validate.message.limitLength': '备注最长为255',
  'category.create.form.item.state.validate.message.notNull': '类别状态不能为空',
  'category.create.from.code': '类别代码',
  'category.create.from.level': '级别',
  'category.create.from.level.select.placeholder': '请选择级别',
  'category.create.from.name': '类别名称',
  'category.create.from.note': '备注',
  'category.create.from.note.select.placeholder': '长度不超过255',
  'category.create.from.owner': '货主',
  'category.create.from.sourceWay': '来源方式',
  'category.create.from.state': '状态',
  'category.create.super': '新增一级商品类别',
  'category.detail.tab.dclist': '配送中心范围',
  'category.index.search.button.open.and.close': '展开/收起',
  'category.index.search.placeholder': '类别代码/名称',
  'category.index.table.column.code': '代码',
  'category.index.table.column.level': '级别',
  'category.index.table.column.name': '名称',
  'category.index.table.column.operate': '操作',
  'category.index.table.column.owner': '货主',
  'category.index.table.column.upperCategory.name': '上级类别',
  'category.index.table.operate.create.child': '新增子级',
  'category.index.table.operate.edit': '编辑',
  'category.index.table.operate.remove': '删除',
  'category.modify.child': '编辑子级商品类别',
  'category.modify.super': '编辑一级商品类别',
  'category.pretype.level.manage': '管理商品类别级别',
  'category.pretype.level.title': '商品类别级别',
  'category.small.title': '类别',
  'category.title': '商品类别',
  'categoryStorageConfig.AddTitle': '新增',
  'categoryStorageConfig.Categorye': '商品类别',
  'categoryStorageConfig.Placeholder': '请输入',
  'categoryStorageConfig.code': '代码',
  'categoryStorageConfig.column.binRange': '货位范围',
  'categoryStorageConfig.column.categoryCode': '商品类别代码',
  'categoryStorageConfig.column.categoryName': '商品类别名称',
  'categoryStorageConfig.name': '名称',
  'categoryStorageConfig.title': '类别存储范围配置',
  'checkInWrh.bookedArticleCount': '预约品项数',
  'checkInWrh.bookedQtyStr': '预约件数',
  'checkInWrh.businessType': '业务类型',
  'checkInWrh.checkin': '登记',
  'checkInWrh.checkin.inWrh': '入园登记',
  'checkInWrh.checkin.outWrh': '出园登记',
  'checkInWrh.checkin.type': '登记类型',
  'checkInWrh.clear': '清空',
  'checkInWrh.driver': '司机',
  'checkInWrh.driverInfo': '司机信息',
  'checkInWrh.driverName': '司机姓名',
  'checkInWrh.driverPhone': '联系方式',
  'checkInWrh.inWrhBillNumber': '入园单号',
  'checkInWrh.inWrhInfo': '入园信息',
  'checkInWrh.orderInfo': '订单信息',
  'checkInWrh.receiptBusinessType': '收货',
  'checkInWrh.releaseContent': '放行内容',
  'checkInWrh.returnBusinessType': '退货',
  'checkInWrh.state': '状态',
  'checkInWrh.stevedoreState': '装卸状况',
  'checkInWrh.title': '出入园登记',
  'checkInWrh.totalArticleCount': '送货品项数',
  'checkInWrh.totalQtyStr': '送货件数',
  'checkInWrh.vehicleNum': '车牌号',
  'close.closeBill': '封仓单',
  'close.closeReason': '封仓解仓原因',
  'close.column.closer': '操作人',
  'close.column.reason': '原因',
  'close.column.type': '单据类型',
  'close.title': '封仓解仓单',
  'close.validate.binCodeRepeat': '第{line1}行与第{line2}行货位代码重复',
  'closeConfig.title': '封仓解仓配置',
  'collectBin.collectBin': '集货位',
  'collectBin.collectBinScope': '集货位范围',
  'collectBin.confirm.clear': '修改{item}会导致明细清空，请确认修改？',
  'collectBin.dock': '码头',
  'collectBin.dockGroup': '码头集',
  'collectBin.dockGroupItem': '码头集明细',
  'collectBin.dockItem': '码头明细',
  'collectBin.logisticMode': '物流模式',
  'collectBin.loopFindLable': '循环查找',
  'collectBin.loopFindPlaceholder': '是否循环查找',
  'collectBin.mgrType': '管理类型',
  'collectBin.pickarea': '拣货分区',
  'collectBin.sourceBin': '来源货位',
  'collectBin.sourceBinScope': '来源货位范围',
  'collectBin.startFromFirstLable': '起始位置查找',
  'collectBin.startFromFirstPlaceholder': '是否每次从起始位置查找',
  'collectBin.storeFixCollectBin': '门店固定集货位范围',
  'collectBin.title': '集货管理方案',
  'collectBinReviewBill.beginReviewTime': '开始复查时间',
  'collectBinReviewBill.collectBin': '集货位',
  'collectBinReviewBill.createReviewBillTime': '创建时间',
  'collectBinReviewBill.dockGroup': '码头集',
  'collectBinReviewBill.endReviewTime': '结束复查时间',
  'collectBinReviewBill.reviewItem': '复查项',
  'collectBinReviewBill.reviewType': '复查类型',
  'collectBinReviewBill.reviewed': '复查',
  'collectBinReviewBill.reviewedInfo': '复查信息',
  'collectBinReviewBill.reviewedQtyStr': '复查件数',
  'collectBinReviewBill.reviewedWholeContainerQtyStr': '复查整箱数',
  'collectBinReviewBill.reviewer': '复查员',
  'collectBinReviewBill.stockQtyStr': '原件数',
  'collectBinReviewBill.stockWholeContainerQtyStr': '整箱数',
  'collectBinReviewBill.store': '复查对象',
  'collectBinReviewBill.title': '集货区复查单',
  'collectSchemeConfig.likeStepCollectBinScheme': '类越库集货方案',
  'collectSchemeConfig.oneStepCollectBinScheme': '一步越库集货方案',
  'collectSchemeConfig.title': '业务集货方案配置',
  'collectSchemeConfig.twoStepCollectBinScheme': '二步越库集货方案',
  'collectSchemeConfig.unifyCollectBinScheme': '统配集货方案',
  'common.action.add': '新增',
  'common.action.approve': '批准',
  'common.action.audit': '审核',
  'common.action.create': '新建',
  'common.action.delete': '删除',
  'common.action.edit': '编辑',
  'common.action.editNode': '修改备注',
  'common.action.finish': '完成',
  'common.action.import': '导入',
  'common.action.save': '保存',
  'common.action.setDefault': '设为默认',
  'common.action.view': '查看',
  'common.address': '地址',
  'common.address.notNull': '地址不能为空',
  'common.addressDetail.limitLength': '详细地址最大长度为200',
  'common.addressDetail.notNull': '请输入详细地址',
  'common.addressSelected': '请选择国家/省/市/区',
  'common.all': '全部',
  'common.allAmount': '总金额',
  'common.allBillCount': '总单数',
  'common.allPlanAmount': '计划金额',
  'common.allPlanArticleCount': '计划品项数',
  'common.allPlanBillCount': '计划单数',
  'common.allPlanQty': '总计划数量',
  'common.allPlanQtyStr': '总计划件数',
  'common.allPlanStoreCount': '计划门店数',
  'common.allPlanVolume': '计划体积(m³)',
  'common.allPlanWeight': '计划重量(kg)',
  'common.allQty': '总数量',
  'common.allQtyStr': '总件数',
  'common.allRealAmount': '实际金额',
  'common.allRealArticleCount': '实际品项数',
  'common.allRealBillCount': '实际单数',
  'common.allRealQty': '总实际数量',
  'common.allRealQtyStr': '总实际件数',
  'common.allRealStoreCount': '实际门店数',
  'common.allRealVolume': '实际体积(m³)',
  'common.allRealWeight': '实际重量(kg)',
  'common.allShipAmount': '装车金额',
  'common.allShipArticleCount': '装车品项数',
  'common.allShipBillCount': '装车单数',
  'common.allShipQtyStr': '总装车件数',
  'common.allShipStoreCount': '装车门店数',
  'common.allShipVolume': '装车体积(m³)',
  'common.allShipWeight': '装车重量(kg)',
  'common.allStoreCount': '总门店数',
  'common.allVolume': '总体积(m³)',
  'common.allWeight': '总重量(kg)',
  'common.allTotalAmount': '总金额(万元)',
  'common.amount': '金额',
  'common.articleCount': '总品项数',
  'common.billNumner': '单号',
  'common.binCode': '货位代码',
  'common.binScope': '货位范围',
  'common.binUsage': '货位用途',
  'common.bookDate': '预约日期',
  'common.button.back': '返回',
  'common.button.batchDelete': '删除',
  'common.button.batchDisable': '禁用',
  'common.button.batchEdit': '编辑',
  'common.button.batchEnable': '启用',
  'common.button.cancel': '取消',
  'common.button.confirm': '确认',
  'common.button.confirm.new': '确认并新建',
  'common.button.edit': '编辑',
  'common.button.import': '导入',
  'common.button.manage': '管理',
  'common.button.new': '新建',
  'common.button.reset': '重置',
  'common.button.search': '查询',
  'common.code': '代码',
  'common.component.StantardtTable.tag.alreadySelected': '已选择',
  'common.component.StantardtTable.tag.clear': '清空',
  'common.component.StantardtTable.tag.item': '项',
  'common.component.StantardtTable.tag.total': '总计',
  'common.confirm.audit': '确认审核该{item}？',
  'common.confirm.clearItems': '修改{item}会导致明细清空，请确认修改？',
  'common.content.city': '市',
  'common.content.country': '国家',
  'common.content.description': '格式说明',
  'common.content.district': '区',
  'common.content.format': '格式',
  'common.content.meaning': '含义',
  'common.content.province': '省',
  'common.content.street': '详细地址',
  'common.detail.operate': '操作信息',
  'common.detail.operate.table.column.detail': '详情',
  'common.detail.operate.table.column.operateTime': '操作时间',
  'common.detail.operate.table.column.operateType': '操作类型',
  'common.detail.operate.table.column.operator': '操作人',
  'common.downloadDate': '下发时间',
  'common.excelImport.result.button.continueImport': '继续导入',
  'common.excelImport.result.button.downloadFailed': '下载失败',
  'common.excelImport.result.message.error.import': '批量导入失败',
  'common.excelImport.result.message.error.noData': 'Excel中无数据被检测到，无法导入',
  'common.excelImport.result.message.success.import': '批量导入成功',
  'common.excelImport.result.message.success.someError': ', 有部分失败，请下载失败文件查看',
  'common.excelImport.result.tips.failed': '失败',
  'common.excelImport.result.tips.importSituation': '导入情况',
  'common.excelImport.result.tips.importing': '正在导入数据，请等待',
  'common.excelImport.result.tips.record': '条',
  'common.excelImport.result.tips.successed': '成功',
  'common.excelImport.select.button.downloadTemplate': '下载模板',
  'common.excelImport.select.button.downloadTemplate.errror': '获取批量导入模板失败',
  'common.excelImport.select.button.next': '下一步',
  'common.excelImport.select.excelLimit': '仅支持xls、xlsx格式文件',
  'common.excelImport.select.fileSizeLimit': '文件大小不要超过2M',
  'common.excelImport.select.nextTips': '请点击下一步按钮进行批量导入',
  'common.excelImport.select.ossErrorTips': '文件存入OSS时发生错误，无法继续导入，请重试',
  'common.excelImport.select.templateEmptyTips': '导入模板为空，无法下载',
  'common.excelImport.select.templateTips': '导入文件具体格式规范，请下载模板进行参考',
  'common.excelImport.select.tips.1': '1. 建议条数≤1000条，条数过多可分批次导入；',
  'common.excelImport.select.tips.2': '2. 模板中列标题为红色的是必填项；',
  'common.excelImport.select.tips.3': '3. 选择文件后即在后端进行缓存，点击下一步进行批量导入；',
  'common.excelImport.select.tips.4': '4. 若批量导入有数据导入失败，可以下载具体导入失败数据（包括导入失败原因）',
  'common.excelImport.select.tips.title': '提示:',
  'common.excelImport.select.uploadText': '将文件拖至此处或者点击上传文件',
  'common.excelImport.select.uploadTips': '支持xls、xlsx格式文件，建议上传文件大小不超过2M',
  'common.excelImport.step1.tips': '选择导入文件',
  'common.excelImport.step2.tips': '导入结果',
  'common.excelImport.title': '导入',
  'common.excelImportSet.select.tips.2': '2. 选择文件后即在后端进行缓存，点击下一步进行批量导入；',
  'common.excelImportSet.select.tips.3': '3. 若批量导入有数据导入失败，可以下载具体导入失败数据（包括导入失败原因）',
  'common.form.input.placeholder': '请输入',
  'common.form.select.placeholder': '请选择',
  'common.leaveconfirm.action.edit': '编辑',
  'common.leaveconfirm.action.new': '新建',
  'common.line': '行',
  'common.logisticMode': '物流模式',
  'common.message.error.authorize': '授权失败，请重试',
  'common.message.error.create': '新增失败，请重试',
  'common.message.error.delete': '删除失败，请重试',
  'common.message.error.disable': '禁用失败，请重试',
  'common.message.error.enable': '启用失败，请重试',
  'common.message.error.modify': '修改失败，请重试',
  'common.message.error.operate': '操作失败，请重试',
  'common.message.success.authorize': '授权成功',
  'common.message.success.create': '新增成功',
  'common.message.success.delete': '删除成功',
  'common.message.success.modify': '修改成功',
  'common.message.success.operate': '操作成功',
  'common.name': '名称',
  'common.no': '否',
  'common.notnull.validate': '{name}不能为空',
  'common.operate': '操作',
  'common.operate.abort': '作废',
  'common.operate.approve': '批准',
  'common.operate.audit': '审核',
  'common.operate.batchAdd': '批量添加',
  'common.operate.confirm': '确认',
  'common.operate.confirm.audit': '确认审核该{item}？',
  'common.operate.confirm.clearItems': '修改{item}会导致明细清空，请确认修改？',
  'common.operate.confirm.delete': '确认删除吗？',
  'common.operate.confirm.disable': '确认禁用吗？',
  'common.operate.confirm.enable': '确认启用吗？',
  'common.operate.confirm.lineFieldNotNull': '第{line}行{item}不能为空',
  'common.operate.copy': '复制',
  'common.operate.create': '新建',
  'common.operate.dcset': '配送设置',
  'common.operate.delete': '删除',
  'common.operate.disable': '禁用',
  'common.operate.edit': '编辑',
  'common.operate.enable': '启用',
  'common.operate.finish': '完成',
  'common.operate.modify': '修改',
  'common.operate.modifyState': '修改状态',
  'common.operate.new': '新增',
  'common.operate.replace': '替换',
  'common.operate.view': '查看',
  'common.operateMethod': '操作方式',
  'common.orderBillNumner': '订单号',
  'common.pagination.tag.records': '条',
  'common.pagination.tag.total': '共',
  'common.placeholder': '请输入{name}',
  'common.placeholder.choose': '请选择{name}',
  'common.placeholder.choose.contained': '请选择所含{name}',
  'common.placeholder.contained': '请输入所含{name}',
  'common.price': '单价',
  'common.productDate': '生产日期',
  'common.productionBatch': '批号',
  'common.progress.confirmModal.title': '批量',
  'common.progress.progressModal.title': '完成进度',
  'common.progress.retry': '重试',
  'common.progress.select.tips': '请勾选，再进行批量操作',
  'common.qpcAndMunit': '规格/计量单位',
  'common.qty': '数量',
  'common.qtyStr': '件数',
  'common.remark': '自定义',
  'common.remark1': '自定义1',
  'common.remark2': '自定义2',
  'common.remark3': '自定义3',
  'common.remark4': '自定义4',
  'common.remark5': '自定义5',
  'common.remark6': '自定义6',
  'common.sourceBill': '来源单据',
  'common.sourceBillNumber': '来源单号',
  'common.sourceOrderBillNumber': '来源订单号',
  'common.sourceType': '来源单据类型',
  'common.sourceWay': '来源方式',
  'common.sourceWay.create.name': '手工创建',
  'common.sourceWay.fileImport.name': '文件导入',
  'common.sourceWay.interfaceImport.name': '接口导入',
  'common.state': '状态',
  'common.stock.article': '商品',
  'common.stock.bincode': '货位',
  'common.stock.caseQtyStr': '件数',
  'common.stock.container': '容器',
  'common.stock.owner': '货主',
  'common.stock.productionBatch': '批号',
  'common.stock.productionDate': '生产日期',
  'common.stock.qpc': '包装',
  'common.stock.qpcStr': '规格',
  'common.stock.qty': '数量',
  'common.stock.stockBatch': '外部批次',
  'common.stock.validDate': '到效日期',
  'common.stock.vendor': '供应商',
  'common.stockBatch': '批次',
  'common.table.content.disabled': '已禁用',
  'common.table.content.enabled': '已启用',
  'common.tips.empty': '暂无数据',
  'common.tmsAllWeight': '总重量(吨)',
  'common.tmsWeight': '重量(吨)',
  'common.toolong.validate': '{name}长度不能超过{length}',
  'common.uplaodDate': '上传时间',
  'common.validDate': '到效日期',
  'common.volume': '体积(m³)',
  'common.waveType': '波次类型',
  'common.weight': '重量(kg)',
  'common.yes': '是',
  'company.authorize.form.item.resources.name': '权限',
  'company.authorize.form.item.validDate.name': '到效期',
  'company.authorize.form.item.validDate.validate.message.notNull': '请选择日期',
  'company.authorize.title': '授权',
  'company.create.basic': '基本信息',
  'company.create.button.cancel': '取消',
  'company.create.button.confirm': '确认',
  'company.create.button.confirmCreate': '确认并创建',
  'company.create.button.save': '保存',
  'company.create.button.saveAndAudit': '保存并审核',
  'company.create.form.item.adminName.name': '管理员名称',
  'company.create.form.item.adminName.validate.message.limitLength': '管理员名称最大长度30',
  'company.create.form.item.adminName.validate.message.notNull': '管理员名称不能为空',
  'company.create.form.item.adminPhone.name': '管理员手机号',
  'company.create.form.item.adminPhone.validate.message.integrality': '管理员手机号请输入真实手机号',
  'company.create.form.item.adminPhone.validate.message.notNull': '手机号不能为空',
  'company.create.form.item.code.name': '企业代码',
  'company.create.form.item.code.validate.message.integrality': '代码必须为4位，字母数字组合、纯数字、纯字母',
  'company.create.form.item.code.validate.message.limitLength': '代码最大长度4',
  'company.create.form.item.code.validate.message.notNull': '代码不能为空',
  'company.create.form.item.interfaceUrl.name': '接口平台',
  'company.create.form.item.interfaceUrl.validate.message.limitLength': '接口平台最大长度100',
  'company.create.form.item.interfaceUrl.validate.message.notNull': '接口平台不能为空',
  'company.create.form.item.maxCarrierUserCount.name': '最大承运商用户数',
  'company.create.form.item.maxCompanyUserCount.name': '最大企业端用户数',
  'company.create.form.item.maxDcCount.name': '最大配送中心数',
  'company.create.form.item.maxDcUserCount.name': '最大配送端用户数',
  'company.create.form.item.maxStoreUserCount.name': '最大门店用户数',
  'company.create.form.item.maxUserCount.name': '最大用户数',
  'company.create.form.item.maxUserCount.validate.message.notNull': '最大用户数不能为空',
  'company.create.form.item.maxVendorUserCount.name': '最大供应商用户数',
  'company.create.form.item.name.name': '企业名称',
  'company.create.form.item.name.validate.message.limitLength': '名称最大长度30',
  'company.create.form.item.name.validate.message.notNull': '名称不能为空',
  'company.create.form.item.placeholder.adminName': '请输入2到10位的字符',
  'company.create.form.item.placeholder.adminPhone': '请输入11位手机号',
  'company.create.form.item.placeholder.code': '请输入4位数字或字母',
  'company.create.form.item.placeholder.companyAdminName': '请输入管理员名称',
  'company.create.form.item.placeholder.companyCode': '请输入企业代码',
  'company.create.form.item.placeholder.companyInterfaceUrl': '请输入接口平台',
  'company.create.form.item.placeholder.companyName': '请输入企业名称',
  'company.create.form.item.placeholder.companyNumber': '请输入数字',
  'company.create.form.item.placeholder.companyPhone': '请输入手机号',
  'company.create.form.item.placeholder.companyReportUrl': '请输入报表路径',
  'company.create.form.item.placeholder.name': '请输入4到30位的字符',
  'company.create.form.item.placeholder.number': '请输入大于0的数字',
  'company.create.form.item.placeholder.validDate': '请选择',
  'company.create.form.item.reportUrl.name': '报表路径',
  'company.create.form.item.reportUrl.validate.message.limitLength': '报表路径最大长度100',
  'company.create.form.item.reportUrl.validate.message.notNull': '报表路径不能为空',
  'company.create.form.item.validDate.name': '到效日期',
  'company.create.form.item.validDate.validate.message.notNull': '到效日期不能为空',
  'company.create.permission': '权限信息',
  'company.create.register': '注册信息',
  'company.create.title': '新建企业',
  'company.daily.time': '企业日结时间',
  'company.detail.basic': '基本信息',
  'company.detail.basic.administratorName': '管理员名称',
  'company.detail.basic.administratorPhone': '管理员手机号',
  'company.detail.basic.code': '代码',
  'company.detail.basic.name': '名称',
  'company.detail.basic.status': '状态',
  'company.detail.button.back': '返回',
  'company.detail.button.cancel': '取消',
  'company.detail.button.confirm': '确定',
  'company.detail.dc': '配送中心',
  'company.detail.erp': 'ERP',
  'company.detail.interfaceAddress': '接口地址',
  'company.detail.label.edit': '编辑',
  'company.detail.operate': '操作信息',
  'company.detail.operate.table.column.detail': '详情',
  'company.detail.operate.table.column.event': '事件',
  'company.detail.operate.table.column.operateTime': '操作时间',
  'company.detail.operate.table.column.operator': '操作人',
  'company.detail.tab.comapnyInfo': '企业信息',
  'company.detail.tab.dcConfiguration': '配送中心配置',
  'company.detail.tab.erpConfiguration': 'ERP配置',
  'company.detail.tab.operateInfo': '操作日志',
  'company.detail.tab.permissionInfo': '权限信息',
  'company.detail.used': '使用信息',
  'company.detail.used.CarrierUser': '承运商数',
  'company.detail.used.CompanyUser': '企业端用户',
  'company.detail.used.DcCount': 'DC数',
  'company.detail.used.DcUser': '配送端用户',
  'company.detail.used.StoreUser': '门店数',
  'company.detail.used.User': '总用户',
  'company.detail.used.VendorUser': '供应商数',
  'company.detail.used.validDate': '到效日期',
  'company.importTemplate.create.temp': '新建模板',
  'company.importTemplate.create.temp.button': '导入模板',
  'company.importTemplate.create.temp.name': '模板名称',
  'company.importTemplate.create.temp.type': '模板类型',
  'company.importTemplate.manageTitle': '导入模板管理',
  'company.importTemplate.title': '导入模板',
  'company.importTemplate.upload.fail': '上传失败',
  'company.importTemplate.upload.success': '上传成功',
  'company.index.search.button.reset': '重置',
  'company.index.search.button.search': '查询',
  'company.index.search.input.codeName': '企业代码/名称',
  'company.index.search.input.codeName.placeholder': '请输入关键词查询',
  'company.index.search.input.status': '状态',
  'company.index.search.input.status.placeholder': '请选择状态',
  'company.index.search.input.validDate': '到效日期',
  'company.index.table.button.batchDisable': '禁用',
  'company.index.table.button.batchEnable': '启用',
  'company.index.table.button.new': '新建',
  'company.index.table.column.code': '代码',
  'company.index.table.column.dcInfo': 'DC信息',
  'company.index.table.column.name': '名称',
  'company.index.table.column.operate': '操作',
  'company.index.table.column.remainingDays': '剩余天数',
  'company.index.table.column.status': '状态',
  'company.index.table.column.userInfo': '用户信息',
  'company.index.table.column.validDate': '到效日期',
  'company.index.table.column.valided': '已过期',
  'company.index.table.content.disable': '已禁用',
  'company.index.table.content.enable': '已启用',
  'company.index.table.operate.authorize': '授权',
  'company.index.table.operate.confirm': '确认',
  'company.index.table.operate.disable': '禁用',
  'company.index.table.operate.edit': '编辑',
  'company.index.table.operate.enable': '启用',
  'company.index.table.operate.view': '查看',
  'company.message.error.create': '新建企业失败',
  'company.message.error.disbale': '禁用企业失败',
  'company.message.error.enbale': '启用企业失败',
  'company.message.error.update': '修改企业基本信息失败',
  'company.message.error.usedInfo': '修改企业使用信息失败',
  'company.message.success.create': '新建企业成功',
  'company.message.success.disable': '禁用企业成功',
  'company.message.success.enbale': '启用企业成功',
  'company.message.success.update': '修改企业信息成功',
  'company.message.success.updateBasic': '修改企业基本信息成功',
  'company.message.success.usedInfo': '修改企业使用信息成功',
  'company.printTemplate.create.temp': '新建模板',
  'company.printTemplate.create.temp.name': '模板名称',
  'company.printTemplate.create.temp.path': '模板路径',
  'company.printTemplate.create.temp.type': '模板类型',
  'company.printTemplate.manageTitle': '打印管理',
  'company.returnDistributionTypeConfig.name': '名称',
  'company.returnDistributionTypeConfig.title': '返配类型配置',
  'company.title': '企业注册',
  'component.globalHeader.event': '待办',
  'component.globalHeader.event.empty': '你已完成所有待办',
  'component.globalHeader.help': '使用文档',
  'component.globalHeader.message': '消息',
  'component.globalHeader.message.empty': '您已读完所有消息',
  'component.globalHeader.notification': '通知',
  'component.globalHeader.notification.empty': '您已查看所有通知',
  'component.globalHeader.search': '站内搜索',
  'component.globalHeader.search.example1': '搜索提示一',
  'component.globalHeader.search.example2': '搜索提示二',
  'component.globalHeader.search.example3': '搜索提示三',
  'component.noticeIcon.clear': '清空',
  'component.noticeIcon.cleared': '清空了',
  'component.noticeIcon.empty': '暂无数据',
  'config.containerTypeBind.containerType': '子容器类型',
  'config.containerTypeBind.containerType.CodeAndName': '子容器类型',
  'config.containerTypeBind.containerType.code': '子容器类型代码',
  'config.containerTypeBind.containerType.name': '子容器类型名称',
  'config.containerTypeBind.parentContainerType': '父容器类型',
  'config.containerTypeBind.parentContainerType.CodeAndName': '父容器类型',
  'config.containerTypeBind.parentContainerType.code': '父容器类型代码',
  'config.containerTypeBind.parentContainerType.name': '父容器类型名称',
  'config.containerTypeBind.title': '容器类型承载关系配置',
  'config.stockTakeConfig.decincState': '损溢单的状态',
  'config.stockTakeConfig.maxBins': '最大货位数',
  'config.title': '配置信息',
  'consumingBill.consumingStore': '领用对象',
  'consumingBill.consumingType': '领用类型',
  'consumingBill.consuminger': '领用人',
  'consumingBill.title': '领用单',
  'consumingRtnBill.rtn': '返还对象',
  'consumingRtnBill.rtnStore': '领用返还对象',
  'consumingRtnBill.rtnType': '返还类型',
  'consumingRtnBill.rtner': '领用返还人',
  'consumingRtnBill.title': '领用返还单',
  'consumingRtnBillLocale.consumingNumber': '领用单号',
  'container.title': '容器',
  'container.validate.genCount': '容器生成数量必须是1~999之间的整数',
  'cost.cost': '费用项',
  'cost.includeText': '包含字段',
  'cost.info': '说明',
  'cost.state': '状态',
  'cost.textSum': '字段数',
  'create': 'create',
  'cunsuming.formItem_Warning': '修改{name}会导致明细清空，请确认修改？',
  'daily.config': '日结配置',
  'dc.create.button.cancel': '取消',
  'dc.create.button.confirm': '确认',
  'dc.create.button.confirmCreate': '确认并创建',
  'dc.create.form.item.address.validate.message.limitLength': '地址最大长度100',
  'dc.create.form.item.address.validate.message.notNull': '地址不能为空',
  'dc.create.form.item.code.validate.message.integrality': '代码必须为4位，字母数字组合、纯数字、纯字母',
  'dc.create.form.item.code.validate.message.limitLength': '代码最大长度30',
  'dc.create.form.item.code.validate.message.notNull': '代码不能为空',
  'dc.create.form.item.contactPhone.validate.limitLength': '联系方式最大长度30',
  'dc.create.form.item.contactPhone.validate.message.integrality': '联系人手机号请输入真实手机号',
  'dc.create.form.item.contactPhone.validate.message.notNull': '联系人手机号不能为空',
  'dc.create.form.item.contactor.validate.message.limitLength': '联系人最大长度30',
  'dc.create.form.item.contactor.validate.message.notNull': '联系人不能为空',
  'dc.create.form.item.name.validate.message.limitLength': '名称最大长度30',
  'dc.create.form.item.name.validate.message.notNull': '名称不能为空',
  'dc.create.form.item.note.name': '备注',
  'dc.create.form.item.note.validate.message.limitLength': '备注最大长度255',
  'dc.create.form.item.operatingArea.name': '经营面积（㎡）',
  'dc.create.form.item.operatingArea.validate.message.greaterThanZero': '经营面积必须大于等于0',
  'dc.create.form.item.owner.name': '货主',
  'dc.create.form.item.placeholder': '请输入',
  'dc.create.form.item.shortName.name': '简称',
  'dc.create.form.item.shortName.validate.message.limitLength': '简称最大长度30',
  'dc.create.form.item.useWMS.validate.message.notNull': '是否使用WMS不能为空',
  'dc.create.form.item.zipCode.name': '邮编',
  'dc.create.form.item.zipCode.validate.message.limitLength': '邮编最大长度30',
  'dc.create.title': '新建配送中心',
  'dc.detail.button.cancel': '取消',
  'dc.detail.button.confirm': '确定',
  'dc.detail.tab.dcInfo': '配送中心信息',
  'dc.detail.tab.operateInfo': '操作日志',
  'dc.edit.title': '修改配送中心',
  'dc.index.message.success.operate': '操作成功',
  'dc.index.search.button.reset': '重置',
  'dc.index.search.button.search': '查询',
  'dc.index.search.content.all': '全部',
  'dc.index.search.content.disable': '已禁用',
  'dc.index.search.content.enable': '已启用',
  'dc.index.search.input.codeName': '配送中心代码/名称',
  'dc.index.search.input.state': '状态',
  'dc.index.table.button.new': '新建',
  'dc.index.table.column.address': '地址',
  'dc.index.table.column.code': '代码',
  'dc.index.table.column.contactPhone': '联系人电话',
  'dc.index.table.column.contactor': '联系人',
  'dc.index.table.column.name': '名称',
  'dc.index.table.column.operate': '操作',
  'dc.index.table.column.shortName': '简称',
  'dc.index.table.column.state': '状态',
  'dc.index.table.column.useWMS': '使用WMS',
  'dc.index.table.operate.edit': '编辑',
  'dc.message.success.disable': '禁用配送中心成功',
  'dc.message.success.enable': '启用配送中心成功',
  'dc.select.no': '否',
  'dc.select.please': '请选择',
  'dc.select.yes': '是',
  'dc.title': '配送中心',
  'dec.btn.manageType': '管理损耗类型',
  'dec.column.amount': '损耗金额',
  'dec.column.article': '包含商品',
  'dec.column.bin': '包含的货位代码',
  'dec.column.container': '包含的容器代码',
  'dec.column.decer': '报损员',
  'dec.column.qty': '损耗数量',
  'dec.column.qtyStr': '损耗件数',
  'dec.column.realAmount': '实际损耗金额',
  'dec.column.realQty': '实际损耗数量',
  'dec.column.realQtyStr': '实际损耗件数',
  'dec.column.type': '损耗类型',
  'dec.confirm.audit': '确认审核该损耗单？',
  'dec.confirm.clear': '修改{item}会导致明细清空，请确认修改？',
  'dec.items': '损耗单明细',
  'dec.title': '损耗单',
  'dec.validate.itemNotLessZero': '损耗单明细第{line}行{item}不能小于0',
  'dec.validate.itemNotZero': '损耗单明细第{line}行{item}不能为0',
  'dec.validate.itemRepeat': '损耗单明细第{line1}行与第{line2}行重复',
  'dec.validate.noteTooLong': '第{line}行备注长度最大为255',
  'dec.validate.realQtyTooBig': '第{line}行实际损耗数量不允许大于损耗数量',
  'decincConfig.ALL': '全部',
  'decincConfig.LOCK': '锁定',
  'decincConfig.LOSS': '损耗',
  'decincConfig.SPILL': '溢余',
  'decincConfig.STOCKADJ': '库存调整',
  'decincConfig.column.binUsage': '货位用途',
  'decincConfig.column.configType': '配置类型',
  'decincConfig.column.note': '备注',
  'decincConfig.create.form.item.input.placeholder.binUsage': '请输入货位用途',
  'decincConfig.title': '损溢规则',
  'deliverycycle.add': '新建配送周期',
  'deliverycycle.preserveWave': '维护波次',
  'deliverycycle.update': '更新配送周期',
  'displayBoard.alcNtcBillNumber': '配货通知单号',
  'displayBoard.allocateType': '库存分配类型',
  'displayBoard.articleGroups': '商品组',
  'displayBoard.articleInfo': '商品信息',
  'displayBoard.canUse': '可分配量',
  'displayBoard.comment': '未读消息',
  'displayBoard.fillRate': '波次满足率(%)',
  'displayBoard.fillRateForStock': '满足率(%)',
  'displayBoard.force': '强分',
  'displayBoard.generate': '生成指令',
  'displayBoard.itemInfo': '明细',
  'displayBoard.itemViewButton': '详情',
  'displayBoard.noWaveInfoMessage': '暂无正在进行中的波次',
  'displayBoard.planQty': '波次已分量',
  'displayBoard.planQtyForForce': '计划分配量',
  'displayBoard.planQtyForStock': '计划量',
  'displayBoard.qpcStr': '规格',
  'displayBoard.qty': '波次要货量',
  'displayBoard.qtyForStock': '要货量',
  'displayBoard.replace': '替换',
  'displayBoard.replaceArticle': '替换商品',
  'displayBoard.replaceQty': '替换量',
  'displayBoard.reserve': '预留',
  'displayBoard.reserveCount': '预留量',
  'displayBoard.setAllocateType': '设置库存分配类型',
  'displayBoard.stockInfo': '库存明细',
  'displayBoard.stockOutTabTitle': '缺货看板',
  'displayBoard.stockTabTitle': '库存看板',
  'displayBoard.stockView': '库存查看',
  'displayBoard.storeInfo': '门店信息',
  'displayBoard.title': '备货看板',
  'displayBoard.usableStock': '可用库存',
  'displayBoard.waveBillNumber': '波次单号',
  'displayBoard.waveInfo': '波次信息',
  'dock.code': '代码',
  'dock.create.form.item.input.placeholder.code': '请输入代码',
  'dock.create.form.item.input.placeholder.name': '请输入4到30位的字符',
  'dock.create.form.item.input.placeholder.note': '请输入备注',
  'dock.create.form.item.option.placeholder': '请选择',
  'dock.detail.label.edit': '编辑',
  'dock.detail.tab.basicInfo': '码头信息',
  'dock.detail.tab.operateInfo': '操作日志',
  'dock.dockGroup': '码头集',
  'dock.index.button.dockGroup': '码头集',
  'dock.index.search.input.codeName': '码头代码/名称',
  'dock.index.search.input.codeName.placeholder': '请输入',
  'dock.index.search.input.state': '状态',
  'dock.index.table.column.operate': '操作',
  'dock.name': '名称',
  'dock.note': '备注',
  'dock.popup.addTitle': '新增码头',
  'dock.popup.code.validate.integrality': '代码最大长度为4，只能是字母和数字',
  'dock.popup.code.validate.notNull': '代码不能为空',
  'dock.popup.dockGroup.validate.notNull': '码头集不能为空',
  'dock.popup.editTitle': '编辑码头',
  'dock.popup.name.validate.limitLength': '名称最大长度30',
  'dock.popup.name.validate.notNull': '名称不能为空',
  'dock.popup.note.validate.limitLength': '备注最大长度255',
  'dock.popup.title': '基本信息',
  'dock.popup.usages.validate.notNull': '码头用途不能为空',
  'dock.state': '状态',
  'dock.state.all': '全部',
  'dock.state.assinged': '已分配',
  'dock.state.disenabled': '已停用',
  'dock.state.free': '空闲',
  'dock.state.using': '使用中',
  'dock.title': '码头',
  'dock.usage.delivery': '出货',
  'dock.usage.receipt': '收货',
  'dock.usage.returned': '退货',
  'dock.usages': '用途',
  'dockGroup.code': '代码',
  'dockGroup.create.form.item.input.placeholder.code': '请输入代码',
  'dockGroup.create.form.item.input.placeholder.name': '请输入4到30位的字符',
  'dockGroup.create.form.item.input.placeholder.note': '请输入备注',
  'dockGroup.create.form.item.option.placeholder': '请选择',
  'dockGroup.index.search.input.codeName': '码头代码/名称',
  'dockGroup.index.search.input.codeName.placeholder': '请输入',
  'dockGroup.name': '名称',
  'dockGroup.note': '备注',
  'dockGroup.popup.addTitle': '新增码头',
  'dockGroup.popup.code.validate.integrality': '代码最大长度为4，只能是字母和数字',
  'dockGroup.popup.code.validate.notNull': '代码不能为空',
  'dockGroup.popup.editTitle': '编辑码头',
  'dockGroup.popup.name.validate.limitLength': '名称最大长度30',
  'dockGroup.popup.name.validate.notNull': '名称不能为空',
  'dockGroup.popup.note.validate.limitLength': '备注最大长度255',
  'dockGroup.popup.title': '基本信息',
  'dockGroup.title': '码头集',
  'end.test': '停止测试',
  'end.test.success': '停止测试成功',
  'end.work': '停止作业',
  'end.work.success': '停止作业成功',
  'excel表字段': 'excel表字段',
  'form.captcha.second': '秒',
  'form.client.label': '客户',
  'form.client.label.tooltip': '目标的服务对象',
  'form.client.placeholder': '请描述你服务的客户，内部客户直接 @姓名／工号',
  'form.confirm-password.placeholder': '确认密码',
  'form.date.label': '起止日期',
  'form.date.placeholder.end': '结束日期',
  'form.date.placeholder.start': '开始日期',
  'form.email.placeholder': '邮箱',
  'form.get-captcha': '发送验证码',
  'form.goal.label': '目标描述',
  'form.goal.placeholder': '请输入你的阶段性工作目标',
  'form.invites.label': '邀评人',
  'form.invites.placeholder': '请直接 @姓名／工号，最多可邀请 5 人',
  'form.optional': '（选填）',
  'form.password.placeholder': '至少6位密码，区分大小写',
  'form.phone-number.placeholder': '11位手机号',
  'form.public.label': '目标公开',
  'form.public.label.help': '客户、邀评人默认被分享',
  'form.public.radio.partially-public': '部分公开',
  'form.public.radio.private': '不公开',
  'form.public.radio.public': '公开',
  'form.publicUsers.option.A': '同事甲',
  'form.publicUsers.option.B': '同事乙',
  'form.publicUsers.option.C': '同事丙',
  'form.publicUsers.placeholder': '公开给',
  'form.save': '保存',
  'form.standard.label': '衡量标准',
  'form.standard.placeholder': '请输入衡量标准',
  'form.submit': '提交',
  'form.title.label': '标题',
  'form.title.placeholder': '给目标起个名字',
  'form.verification-code.placeholder': '验证码',
  'form.weight.label': '权重',
  'form.weight.placeholder': '请输入',
  'fresh.freshPickOrderConfig.title': '生鲜拣货顺序配置',
  'fresh.freshPickTempBinConfig.name': '拣货暂存位',
  'fresh.freshPickTempBinConfig.title': '生鲜拣货暂存位配置',
  'fresh.storeAllocationSchemeConfig.storeAllocation': '门店分播位方案',
  'fresh.storeAllocationSchemeConfig.title': '门店分播位方案配置',
  'freshPickBoardConfig.HangPrintTemplate': '悬挂称打印模板',
  'freshPickBoardConfig.boardPickOrderScheme': '面板拣货顺序方案',
  'freshPickBoardConfig.boardPickOrderSchemeLog': '面板拣货顺序方案操作日志',
  'freshPickBoardConfig.pickPrintConfig': '拣货打印配置',
  'freshPickBoardConfig.pickPrintConfigLog': '拣货打印配置操作日志',
  'freshPickBoardConfig.pickPrintTemplate': '摘果打印模板',
  'freshPickBoardConfig.sowPrintTemplate': '播种打印模板',
  'freshPickBoardConfig.whetherHangPrint': '是否配置悬挂称打印',
  'freshPickBoardConfig.whetherPickPrint': '是否配置摘果打印',
  'freshPickBoardConfig.whetherSowPrint': '是否配置播种打印',
  'freshPickUp.PickType': '播种纬度',
  'freshPickUp.PickTypeForArticle': '商品纬度',
  'freshPickUp.PickTypeForStore': '门店纬度',
  'freshPickUp.articleCountForPick': '待拣品项数',
  'freshPickUp.articleGroup': '商品组',
  'freshPickUp.batchGenerateTask': '批量生成任务',
  'freshPickUp.binCode': '分播位',
  'freshPickUp.changeContainerButton': '换容',
  'freshPickUp.changeOrderButton': '调序',
  'freshPickUp.containerBarcode': '分播容器',
  'freshPickUp.customTask': '自定义任务',
  'freshPickUp.freshPickTitle': '生鲜摘果拣货',
  'freshPickUp.freshSowTitle': '生鲜播种拣货',
  'freshPickUp.getInstruct': '获取指令',
  'freshPickUp.getInstructSuccess': '获取拣货指令成功',
  'freshPickUp.instructTitle': '指令',
  'freshPickUp.mergeTask': '合并任务',
  'freshPickUp.myPickTask': '我的摘果任务',
  'freshPickUp.mySowTask': '我的播种任务',
  'freshPickUp.onViewButton': '详情',
  'freshPickUp.overDeliveryNum': '超配数量',
  'freshPickUp.overDeliveryRate': '超配比例',
  'freshPickUp.pick': '摘果',
  'freshPickUp.pickTask': '摘果任务',
  'freshPickUp.pickTaskTitle': '摘果任务看板',
  'freshPickUp.pickUpButton': '拣货',
  'freshPickUp.pickingProgress': '拣货进度',
  'freshPickUp.qty': '应拣数量',
  'freshPickUp.qtyForSow': '待播数量',
  'freshPickUp.qtyStr': '应拣件数',
  'freshPickUp.qtyStrForSow': '待播件数',
  'freshPickUp.realArticleCountForPick': '实拣品项数',
  'freshPickUp.realQty': '实拣数量',
  'freshPickUp.realQtyStr': '实拣件数',
  'freshPickUp.realStoreCountForSow': '实播门店数',
  'freshPickUp.realTaskCountForPick': '实拣指令数',
  'freshPickUp.realTaskCountForSow': '实播指令数',
  'freshPickUp.registerContainerTitle': '容器注册',
  'freshPickUp.release': '释放',
  'freshPickUp.sow': '播种',
  'freshPickUp.sowTask': '播种任务',
  'freshPickUp.sowTaskTitle': '播种任务看板',
  'freshPickUp.storeCountForSow': '待播门店数',
  'freshPickUp.storeGroup': '门店组',
  'freshPickUp.storePickOrderSchema': '拣货顺序方案',
  'freshPickUp.targetNumber': '目标序号',
  'freshPickUp.taskCount': '指令数',
  'freshPickUp.taskCountForPick': '待拣指令数',
  'freshPickUp.taskCountForSow': '待播指令数',
  'freshPickUp.taskNumber': '指令号',
  'freshPickUp.taskTitle': '任务面板',
  'freshPickUp.taskType': '作业模式',
  'freshPickUp.type': '模式',
  'freshPickUp.unitVolumn': '分单体积',
  'freshReceive.articleCode': '商品条码',
  'freshReceive.articleCodeUnExit': '商品条码不存在',
  'freshReceive.articleInfo': '商品信息',
  'freshReceive.articleName': '商品名称',
  'freshReceive.articleUnFinishReceive': '当前商品尚未完成收货',
  'freshReceive.billNumber': '订单号/入园单号/预检序号',
  'freshReceive.checkResult': '是否合格',
  'freshReceive.checkType': '质检类型',
  'freshReceive.chooseArticle': '请选择商品',
  'freshReceive.clearButton': '清屏',
  'freshReceive.codeAndBarCodeAndName': '代码、条码、名称',
  'freshReceive.codeAndName': '名称代码',
  'freshReceive.comment': '收货批注',
  'freshReceive.confirmButton': '确认',
  'freshReceive.confirmFull': '确认满容',
  'freshReceive.containerBarcode': '容器条码',
  'freshReceive.containerName': '容器名称',
  'freshReceive.containerType': '容器类型',
  'freshReceive.endButton': '结束',
  'freshReceive.fullButton': '满容',
  'freshReceive.hadReceivable': '已收',
  'freshReceive.inWrh': '入库',
  'freshReceive.makeSureEnd': '确认结束',
  'freshReceive.netWeight': '净重',
  'freshReceive.noCareShelfDate': '不管理保质期',
  'freshReceive.plateAdvice': '装盘建议',
  'freshReceive.receivable': '应收',
  'freshReceive.receiveAndWaitQty': '应收/待收数量',
  'freshReceive.receiveBill': '单号的收货',
  'freshReceive.receiveBillInfo': '收货单信息',
  'freshReceive.receiveQpcStr': '收货规格',
  'freshReceive.retrieve': '归还',
  'freshReceive.sense': '质检科目',
  'freshReceive.shelfLifeDays': '保质期天数',
  'freshReceive.tare': '皮重',
  'freshReceive.title': '收货',
  'freshReceive.toReceiveQtyStr': '待收件数',
  'freshReceive.unReceivedArticleCount': '未收品项数：',
  'freshReceive.unReceivedOrderInfo': '订单未收货信息',
  'freshReceive.unReceivedQtyStr': '未收件数：',
  'freshReceive.viewButton': '明细',
  'freshReceive.viewItemTitle': '查看明细',
  'freshReceive.waitReceivable': '待收',
  'freshReceive.weight': '毛重',
  'goodsGroupConfig.goodsGroup': '商品组',
  'goodsGroupConfig.storeBin': '请输入虚拟货位',
  'goodsGroupConfig.title': '商品组配置',
  'highLowStock.article': '商品',
  'highLowStock.binCode': '货位',
  'highLowStock.binCodeRange': '货位范围',
  'highLowStock.binType': '货位类型',
  'highLowStock.binTypeAndRange.validate.message.notNull': '货位类型和货位范围不能同时为空',
  'highLowStock.highStockExplain': '最高库存（箱/包/零）',
  'highLowStock.highStockQty': '最高库存',
  'highLowStock.highStockQty.validate.message.integrality': '最高库存只允许输入整数',
  'highLowStock.highStockQty.validate.message.notNull': '最高库存不能为空',
  'highLowStock.highStockQtyStr': '最高库存件数',
  'highLowStock.lowAndHighStock.validate.message.notNull': '最低库存和最高库存不能同时为空',
  'highLowStock.lowStockExplain': '最低库存（箱/包/零）',
  'highLowStock.lowStockQty': '最低库存',
  'highLowStock.lowStockQty.validate.message.integrality': '最低库存只允许输入整数',
  'highLowStock.lowStockQty.validate.message.notNull': '最低库存不能为空',
  'highLowStock.lowStockQtyStr': '最低库存件数',
  'highLowStock.qpcStr': '规格',
  'highLowStock.select.fixValue': '固定值',
  'highLowStock.select.placeholder': '全部',
  'highLowStock.select.plate': '装盘规格',
  'highLowStock.title': '最高最低库存',
  'inWrhBill.articleCount': '订单品项数',
  'inWrhBill.assignDockErrorMessage': '请选择码头',
  'inWrhBill.assignReceiptDock': '分配收货码头',
  'inWrhBill.assignReturnDock': '分配退货码头',
  'inWrhBill.bookArticleCount': '订单已预约品项数',
  'inWrhBill.bookBillNumber': '预约单号',
  'inWrhBill.bookQtyStr': '订单已预约件数',
  'inWrhBill.bookTime': '预约时间',
  'inWrhBill.button.audit': '审核',
  'inWrhBill.button.delete': '删除',
  'inWrhBill.button.save': '保存',
  'inWrhBill.button.saveAndAudit': '保存并审核',
  'inWrhBill.cancelReceiptAssignment': '取消分配收货码头',
  'inWrhBill.cancelReturnAssignment': '取消分配退货码头',
  'inWrhBill.carNumber': '车牌号',
  'inWrhBill.configAutoFresh': '配置自动刷新',
  'inWrhBill.configReleaseContent': '配置放行内容',
  'inWrhBill.dock': '码头',
  'inWrhBill.dockAssignDate': '码头分配时间',
  'inWrhBill.dockCancelDate': '码头释放时间',
  'inWrhBill.dockEmptyErrorMessage': '暂无相关码头信息',
  'inWrhBill.driver': '司机',
  'inWrhBill.driverPhone': '司机联系方式',
  'inWrhBill.inWrhBillNumber': '入园单号',
  'inWrhBill.inWrhErrorMessage': '请选择入园单',
  'inWrhBill.inWrhNumberErrorMessage': '请选择单条入园单',
  'inWrhBill.isReceipt': '是否有收货',
  'inWrhBill.isReturn': '是否有退货',
  'inWrhBill.note': '备注',
  'inWrhBill.operate': '操作',
  'inWrhBill.operateType': '操作方式',
  'inWrhBill.orderState': '预约状态',
  'inWrhBill.outTime': '出园时间',
  'inWrhBill.qtyStr': '订单件数',
  'inWrhBill.receipt': '收货',
  'inWrhBill.receiptInformation': '收货信息',
  'inWrhBill.return': '退货',
  'inWrhBill.returnInformation': '退货信息',
  'inWrhBill.stevedoreState': '配置卸货情况',
  'inWrhBill.time': '入园时间',
  'inWrhBill.title': '入园看板',
  'inc.binCodes': '包含的货位代码',
  'inc.containerBarCodes': '包含的容器代码',
  'inc.incer': '报溢员',
  'inc.manage.type': '管理溢余类型',
  'inc.title': '溢余单',
  'inc.type': '溢余类型',
  'iwms.create.button.cancel': '取消',
  'iwms.create.button.confirm': '确认',
  'iwms.create.button.confirmCreate': '确认并新建',
  'iwms.create.title.create': '新建',
  'iwms.create.title.edit': '编辑',
  'iwms.index.create.basic': '基本信息',
  'iwms.index.create.bussiness': '业务信息',
  'iwms.index.create.remark': '备注',
  'iwms.index.search.button.collapse': '收起/折叠',
  'iwms.index.search.button.reset': '重置',
  'iwms.index.search.button.search': '查询',
  'iwms.print.tips': '打印数据不能为空。',
  'labelSow.title': '标签提总/分播',
  'labelTpick.searchform.containerdivider': '容器分配方式',
  'labelTpick.searchform.printoption': '打印选项',
  'labelTpick.title': '标签提总',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'lockConfig.title': '库存锁定解锁配置',
  'manage': '管理',
  'menu.account': '个人中心',
  'menu.account.center': '账户信息',
  'menu.account.logout': '退出登录',
  'menu.account.modify': '修改密码',
  'menu.account.switch': '切换组织',
  'menu.account.version': '版本信息',
  'menu.account.loginConfig': '登录页设置',
  'menu.account.homeConfig': '首页设置',
  'menu.api': '接口平台',
  'menu.api.config': '接口平台配置',
  'menu.api.dispath': '接口看板',
  'menu.api.erpdown': 'WMS&ERP 下行接口',
  'menu.api.erpup': 'WMS&ERP 上行接口',
  'menu.api.log': '接口日志',
  'menu.api.notify': '接口待执行数据',
  'menu.api.wcsdown': 'WMS&WCS 下行接口',
  'menu.api.wcsup': 'WMS&WCS 上行接口',
  'menu.basic': '基本资料',
  'menu.basic.article': '商品',
  'menu.basic.carrier': '承运商',
  'menu.basic.category': '类别',
  'menu.basic.dc': '配送中心',
  'menu.basic.owner': '货主',
  'menu.basic.store': '门店',
  'menu.basic.vendor': '供应商',
  'menu.basic.wrh': '仓位',
  'menu.bigData': '大数据',
  'menu.bms': '计费管理',
  'menu.bms.accountBill': '账单',
  'menu.bms.contract': '合同',
  'menu.bms.cost': '费用项',
  'menu.bms.dataSource': '费用数据池',
  'menu.bms.feeBill': '费用单',
  'menu.bms.genFeeBill': '手工生成费用单',
  'menu.bms.sortScheme': '结算分类方案',
  'menu.call': '叫货管理',
  'menu.call.alcNtc': '配货通知单',
  'menu.call.storeHandover': '门店交接单',
  'menu.call.vehicleMonitoring': '车辆监控',
  'menu.chargeManagement': '计费管理',
  'menu.chargeManagement.accountClassScheme': '结算分类方案',
  'menu.chargeManagement.cost': '费用项',
  'menu.compmgr': '系统管理',
  'menu.compmgr.billImport': '单据导入',
  'menu.compmgr.config': '配置中心',
  'menu.compmgr.customImport': '自定义导入',
  'menu.compmgr.report': '报表管理',
  'menu.compmgr.role': '角色',
  'menu.compmgr.template': '打印管理',
  'menu.compmgr.user': '用户',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.Demo': 'Demo',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.dcmgr': '仓储管理',
  'menu.dcmgr.processingScheme': '加工方案',
  'menu.exception': '异常页',
  'menu.exception.not-find': '404',
  'menu.exception.not-permission': '403',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.facility': '物流设施',
  'menu.facility.allocateWall': '分播墙',
  'menu.facility.articleReplace': '商品替换方案',
  'menu.facility.bin': '货位',
  'menu.facility.binType': '货位类型',
  'menu.facility.collectBin': '集货管理方案',
  'menu.facility.config': '配置中心',
  'menu.facility.container': '容器',
  'menu.facility.containerType': '容器类型',
  'menu.facility.deliverycycle': '配送周期方案',
  'menu.facility.dock': '码头',
  'menu.facility.dynamicpickupgroup': '动态拣货组',
  'menu.facility.highLowStock': '最高最低库存',
  'menu.facility.pickArea': '拣货分区',
  'menu.facility.pickOrder': '拣货顺序方案',
  'menu.facility.stockorder': '库存分配方案',
  'menu.facility.storeAllocationScheme': '分播管理方案',
  'menu.facility.superManagementBoard': '超保管理看板',
  'menu.facility.wrh': '仓位',
  'menu.form': '表单页',
  'menu.form.advancedform': '高级表单',
  'menu.form.basicform': '基础表单',
  'menu.form.stepform': '分步表单',
  'menu.form.stepform.confirm': '分步表单（确认转账信息）',
  'menu.form.stepform.info': '分步表单（填写转账信息）',
  'menu.form.stepform.result': '分步表单（完成）',
  'menu.hdmgr': '海鼎管理',
  'menu.hdmgr.RFManage': 'RF管理',
  'menu.hdmgr.comp': '企业注册',
  'menu.hdmgr.config': '配置中心',
  'menu.hdmgr.imTemplate': '导入管理',
  'menu.hdmgr.licence': '许可证管理',
  'menu.hdmgr.onlinehelp': '在线帮助维护',
  'menu.hdmgr.report': '报表管理',
  'menu.hdmgr.server': '服务器管理',
  'menu.hdmgr.template': '打印管理',
  'menu.home': '首页',
  'menu.in': '入库管理',
  'menu.in.adjBill': '修正单',
  'menu.in.book': '预约单',
  'menu.in.bookboard': '预约看板',
  'menu.in.checkinwrh': '出入园登记',
  'menu.in.freshReceive': 'Web收货',
  'menu.in.inwrhbill': '入园看板',
  'menu.in.mixbox': '拼箱订单',
  'menu.in.move': '平移单',
  'menu.in.order': '入库订单',
  'menu.in.physicsCheckNtc': '质检通知单',
  'menu.in.physicscheck': '理化质检单',
  'menu.in.physicscheckpool': '理化质检看板',
  'menu.in.precheck': '预检单',
  'menu.in.putaway': '上架单',
  'menu.in.receive': '收货单',
  'menu.in.senseCheck': '感官质检单',
  'menu.inMsg': '入库管理',
  'menu.inMsg.order': '入库订单',
  'menu.inMsg.receive': '收货单',
  'menu.inner': '内部管理',
  'menu.inner.close': '封仓解仓单',
  'menu.inner.consuming': '领用单',
  'menu.inner.consumingNtc': '领用通知单',
  'menu.inner.consumingRtnBill': '领用返还单',
  'menu.inner.containerAssert': '容器出入单',
  'menu.inner.dec': '损耗单',
  'menu.inner.electcert': '电子凭证单',
  'menu.inner.freshTake': '生鲜盘点',
  'menu.inner.inc': '溢余单',
  'menu.inner.movebill': '移库单',
  'menu.inner.pickBinAdjBill': '拣货位调整单',
  'menu.inner.prerpl': '预补业务',
  'menu.inner.processBill': '加工单',
  'menu.inner.processTask': '加工任务',
  'menu.inner.processingScheme': '加工方案',
  'menu.inner.rawRequisitionBill': '领料单',
  'menu.inner.stockAdjBill': '库存调整单',
  'menu.inner.stockTakeBill': '盘点单',
  'menu.inner.stockTakePlan': '盘点计划',
  'menu.inner.stocklock': '锁定解锁单',
  'menu.inner.supermanagement': '超保管理看板',
  'menu.inner.webProcess': 'Web加工',
  'menu.list': '列表页',
  'menu.list.basiclist': '标准列表',
  'menu.list.cardlist': '卡片列表',
  'menu.list.searchlist': '搜索列表',
  'menu.list.searchlist.applications': '搜索列表（应用）',
  'menu.list.searchlist.articles': '搜索列表（文章）',
  'menu.list.searchlist.projects': '搜索列表（项目）',
  'menu.list.searchtable': '查询表格',
  'menu.notice': '通知发布',
  'menu.out': '出库管理',
  'menu.out.crossAllocate': '越库分播看板',
  'menu.out.alcNtc': '配货通知单',
  'menu.out.articleArrangement': '分配商品拣货量',
  'menu.out.carriertransfer': '承运商交接单',
  'menu.out.checkPack': '复核打包台',
  'menu.out.checkplate': '复核打包台',
  'menu.out.collectbinreview': '集货区复查单',
  'menu.out.containerItemreview': '容器复查',
  'menu.out.containerbind': '容器绑定单',
  'menu.out.containermerger': '容器拆并单',
  'menu.out.containerreview': '容器复查单',
  'menu.out.displayBoard': '备货看板',
  'menu.out.ecBill': '电商运单信息',
  'menu.out.freshPickUp': '拣货面板',
  'menu.out.labelTpick': '标签提总/分播',
  'menu.out.pickInstruct': '拣货指令',
  'menu.out.pickUpBill': '拣货单',
  'menu.out.pickupCombined': '拣货单组合',
  'menu.out.pickUpBillPrintLabel': '打印标签拣货',
  'menu.out.picking': '摘果拣货',
  'menu.out.processWave': '出库加工',
  'menu.out.rpl': '补货单',
  'menu.out.sow': '播种拣货',
  'menu.out.sowingPickUp': '播种拣货单',
  'menu.out.storePickAdjustPanel': '门店拣货信息调整面板',
  'menu.out.waveBill': '波次单',
  'menu.out.alcPrintDisboard': '配单打印看板',
  'menu.profile': '详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.profile.basic': '基础详情页',
  'menu.result': '结果页',
  'menu.result.fail': '失败页',
  'menu.result.success': '成功页',
  'menu.rtn': '逆向物流',
  'menu.rtn.rtnPutaway': '退仓上架单',
  'menu.rtn.storeRtn': '退仓单',
  'menu.rtn.storeRtnNtc': '退仓通知单',
  'menu.rtn.vendorDispatch': '供应商退货看板',
  'menu.rtn.vendorHandover': '供应商交接单',
  'menu.rtn.vendorRtnNtc': '供应商退货通知单',
  'menu.rtn.vendorRtnPick': '供应商拣货单',
  'menu.rtnMsg': '退仓管理',
  'menu.rtnMsg.storeRtn': '门店退仓单',
  'menu.rtnMsg.storeRtnNtc': '退仓通知单',
  'menu.tms': '运输管理',
  'menu.tms.ShipPlanDispatch': '调度看板',
  'menu.rtn.alcDiff': '配货差异单',
  'menu.tms.carrier': '承运商',
  'menu.tms.carriertransfer': '承运商交接单',
  'menu.tms.config': '配置中心',
  'menu.tms.containerRecycle': '容器回收',
  'menu.tms.serialArch': '线路体系',
  'menu.tms.shipbill': '装车单',
  'menu.tms.shipplanbill': '排车单',
  'menu.tms.storehandoverbill': '门店交接单',
  'menu.tms.vehicle': '车辆',
  'menu.tms.vehicleMonitoring': '车辆监控',
  'menu.tms.vehicleType': '车型',
  'menu.tmsMsg': '运输管理',
  'menu.tmsMsg.shipbill': '装车单',
  'menu.tmsMsg.shipplanbill': '排车单',
  'menu.tmsMsg.storeHandover': '门店交接单',
  'menu.tmsMsg.vehicle': '车辆',
  'menu.tmsMsg.vehicleMonitoring': '车辆监控',
  'menu.wcs': 'WCS',
  'menu.wcs.agv': 'AGV',
  'menu.wcs.agv.agvin': '入库指令',
  'menu.wcs.agv.agvinner': '内部管理指令',
  'menu.wcs.agv.agvout': '出库指令',
  'menu.wcs.asrs': 'AS/RS',
  'menu.wcs.dps': 'DPS',
  'menu.wcs.dps.ElectronicLabelLog': '电子标签日志',
  'menu.wcs.dps.facilitiesMaintenance': '设备维护',
  'menu.wcs.dps.job': '电子标签拣货作业',
  'menu.wcs.dps.operationPoint': '基本资料维护',
  'menu.wcs.dps.pickUpBillElectronicLabel': '电子标签打印',
  'menu.wcs.electronicBalance': '电子秤',
  'menu.wcs.hangWeight': '悬挂称',
  'menu.wcs.hangWeight.hangWeightSowing': '悬挂称分播',
  'menu.wcs.packager': '包装机',
  'menu.wcs.packager.articleConsumable': '商品耗材管理',
  'menu.wcs.packager.consumable': '包装耗材管理',
  'menu.wcs.packager.instructBoard': '指令看板',
  'menu.wcs.packager.packDeviceConfig': '包装机商品维护',
  'menu.wcs.print': '打印',
  'menu.wcs.print.printplug': '打印插件',
  'menu.wcs.sorter': '分拣机',
  'menu.wcs.sorter.sortCrossing': '分拣道口管理',
  'menu.wcs.sorter.sortStrategy': '门店道口关系方案',
  'menu.wcs.sorter.sortorder': '分拣机指令看板',
  'menu.wcs.sorter.stockManage': '分拣道口方案',
  'moveBill.fromBin': '来源货位',
  'moveBill.fromBinUsage': '来源货位用途',
  'moveBill.fromContainer': '来源容器',
  'moveBill.fromWrh': '来源仓位',
  'moveBill.manageMoveType': '管理移库类型',
  'moveBill.moveType': '移库类型',
  'moveBill.mover': '移库员',
  'moveBill.title': '移库单',
  'moveBill.toBin': '目标货位',
  'moveBill.toBinUsage': '目标货位用途',
  'moveBill.toContainer': '目标容器',
  'moveBill.toWrh': '目标仓位',
  'moveruleConfig.column.changeOwner': '是否需要修改所有者',
  'moveruleConfig.column.fromBinUsage': '来源货位用途',
  'moveruleConfig.column.targetOwnerType': '所有者类型',
  'moveruleConfig.column.toBinUsage': '目标货位用途',
  'moveruleConfig.create.form.item.input.placeholder.fromBinUsage': '请输入来源货位用途',
  'moveruleConfig.create.form.item.input.placeholder.toBinUsage': '请输入目标货位用途',
  'moveruleConfig.modify': '修改',
  'moveruleConfig.not.modify': '不修改',
  'moveruleConfig.title': '移库规则',
  'navBar.lang': '语言',
  'notice.create.AllCOMPANY': '所有企业',
  'notice.create.CARRIER': '所有承运商',
  'notice.create.COMPANY': '企业',
  'notice.create.DC': '所有配送中心',
  'notice.create.HEADING': '海鼎',
  'notice.create.SELF': '自己',
  'notice.create.STORE': '所有门店',
  'notice.create.VENDOR': '所有供应商',
  'notice.create.answer': '支持回复',
  'notice.create.attachment': '附件',
  'notice.create.receiver': '接收人',
  'notice.create.receiver.placeholder': '请选择 可选海鼎、门店、配送中心、供应商、承运商',
  'notice.create.text': '正文',
  'notice.create.title': '标题',
  'notice.create.upload': '上传附件',
  'notice.create.uploadDescribe': '支持扩展名：.rar .zip .doc .docx .pdf .jpg...',
  'notice.create.uploadError': '文件上传失败',
  'notice.create.uploadSuccess': '文件上传成功',
  'notice.index.button.new': '我要发布',
  'notice.index.radioAll': '全部',
  'notice.index.radioReceived': '我接收的',
  'notice.index.radiopublished': '我发布的',
  'notice.inputTitle': '请输入标题',
  'notice.item.close': '点击收回',
  'notice.item.download': '下载附件',
  'notice.item.hasReaded': '已阅',
  'notice.item.noAttachment': '暂无附件',
  'notice.item.open': '点击展开',
  'notice.item.readedCount': '已阅读数',
  'notice.item.reply': '回复',
  'notice.item.text.validate': '内容不能为空且长度不能大于255',
  'notice.item.unReaded': '未阅',
  'notice.new': '新建通知',
  'notice.placeholder': '请输入',
  'notice.published': '发布于',
  'notice.responsed': '回复了你',
  'notice.title': '通知',
  'notice.title.new': '通知发布',
  'notice.type': '类型',
  'notice.type.manage': '管理通知类型',
  'notice.viewAll': '查看所有通知',
  'onlinehelp.title': '在线帮助维护',
  'orderBill.abort': '作废',
  'orderBill.abort.confirm': '是否作废该订单',
  'orderBill.arrivalDate': '到货日期',
  'orderBill.articleAndSpec': '商品/商品规格',
  'orderBill.articleCodeMessege': '商品代码',
  'orderBill.articleCount': '总品项数',
  'orderBill.articleInfo': '商品信息',
  'orderBill.articleTableTitle': '商品信息',
  'orderBill.articles': '订单所包含商品',
  'orderBill.audit.confirm': '确认审核',
  'orderBill.audit.confirm.message': '确认审核通过该入库订单吗？审核通过后，将开始收货。',
  'orderBill.batch.fail': '获取批量导入模板失败',
  'orderBill.batchPricing': '核价',
  'orderBill.beginReceiveUploadTime': '开始收货上传',
  'orderBill.bookedArticleCount': '已预约品项数',
  'orderBill.bookedQtyStr': '已预约件数',
  'orderBill.createTime': '接收日期',
  'orderBill.endReceiveUploadTime': '接口上传',
  'orderBill.finish.confirm': '是否完成该订单',
  'orderBill.isPricing': '是否核价',
  'orderBill.lastModified': '最后修改日期',
  'orderBill.loadNumber': '装载号',
  'orderBill.originalPrice': '原价',
  'orderBill.preCheck': '预检',
  'orderBill.preCheckedQtyStr': '已预检件数',
  'orderBill.price': '单价',
  'orderBill.qpcPrice': '规格价',
  'orderBill.pricing': '核价',
  'orderBill.pricingContent': '将按原价核价',
  'orderBill.pricingSuccess': '核价成功',
  'orderBill.qtyStrs': '应收/预收/实收件数',
  'orderBill.receive': '收货',
  'orderBill.receivedAmount': '已收金额',
  'orderBill.receivedAndAmount': '已收金额/商品金额',
  'orderBill.receivedAndQtyStr': '已收件数/商品件数',
  'orderBill.receivedArticleCount': '已收品项数',
  'orderBill.receivedQtyStr': '已收件数',
  'orderBill.remove.confirm': '是否删除该订单',
  'orderBill.sourceBillNumber': '来源单号',
  'orderBill.steps': '流程进度',
  'orderBill.stepsBeginReceiveTime': '开始收货',
  'orderBill.stepsCreateTime': '订单接收',
  'orderBill.stepsEndReceiveTime': '结束收货',
  'orderBill.stepsUploadTime': '上传日期',
  'orderBill.title': '入库订单',
  'orderBill.totalReceivedVolume': '已收总体积(m³)',
  'orderBill.totalReceivedWeight': '已收总重量(kg)',
  'orderBill.totalVolume': '总体积(m³)',
  'orderBill.totalWeight': '总重量(kg)',
  'orderBill.type': '订单类型',
  'orderBill.validate.itemRepeat': '订单明细第{line1}行与第{line2}行重复',
  'orderBill.wrh': '入库仓位',
  'owner.create.basic': '基本信息',
  'owner.create.button.cancel': '取消',
  'owner.create.button.confirm': '确认',
  'owner.create.button.confirm.new': '确认并新建',
  'owner.create.form.item.address.name': '地址',
  'owner.create.form.item.address.validate.message.limitLength': '地址最大长度100',
  'owner.create.form.item.address.validate.message.notNull': '地址不能为空',
  'owner.create.form.item.code.name': '代码',
  'owner.create.form.item.code.validate.message.integrality': '代码必须为4位，字母数字组合、纯数字、纯字母',
  'owner.create.form.item.code.validate.message.notNull': '代码不能为空',
  'owner.create.form.item.contactPhone.name': '联系方式',
  'owner.create.form.item.contactPhone.validate.message.limitLength': '联系人手机号最长为30',
  'owner.create.form.item.contactPhone.validate.message.notNull': '联系人手机号不能为空',
  'owner.create.form.item.contactor.name': '联系人',
  'owner.create.form.item.contactor.validate.message.limitLength': '联系人最大长度30',
  'owner.create.form.item.contactor.validate.message.notNull': '联系人不能为空',
  'owner.create.form.item.homePage.name': '主页',
  'owner.create.form.item.homePage.validate.message.limitLength': '主页最大长度255',
  'owner.create.form.item.input.placeholder': '请输入',
  'owner.create.form.item.input.placeholder.address': '请输入地址',
  'owner.create.form.item.input.placeholder.code': '请输入代码',
  'owner.create.form.item.input.placeholder.contactPhone': '请输入联系方式',
  'owner.create.form.item.input.placeholder.contactor': '请输入联系人',
  'owner.create.form.item.input.placeholder.homePage': '请输入主页',
  'owner.create.form.item.input.placeholder.name': '请输入4到30位的字符',
  'owner.create.form.item.input.placeholder.note': '请输入备注',
  'owner.create.form.item.input.placeholder.shortName': '请输入简称',
  'owner.create.form.item.input.placeholder.zipCode': '请输入邮编',
  'owner.create.form.item.name.name': '名称',
  'owner.create.form.item.name.validate.message.limitLength': '名称最大长度30',
  'owner.create.form.item.name.validate.message.notNull': '名称不能为空',
  'owner.create.form.item.note.name': '备注',
  'owner.create.form.item.note.validate.message.limitLength': '备注最大长度255',
  'owner.create.form.item.shortName.name': '简称',
  'owner.create.form.item.shortName.validate.message.limitLength': '简称最大长度30',
  'owner.create.form.item.zipCode.name': '邮编',
  'owner.create.form.item.zipCode.validate.message.limitLength': '邮编最大长度30',
  'owner.create.title': '新建货主',
  'owner.detail.basic': '基本信息',
  'owner.detail.basic.address': '地址',
  'owner.detail.basic.code': '代码',
  'owner.detail.basic.contactPhone': '联系方式',
  'owner.detail.basic.contactor': '联系人',
  'owner.detail.basic.homePage': '主页',
  'owner.detail.basic.name': '名称',
  'owner.detail.basic.note': '备注',
  'owner.detail.basic.shortName': '简称',
  'owner.detail.basic.zipCode': '邮编',
  'owner.detail.button.back': '返回',
  'owner.detail.button.cancel': '取消',
  'owner.detail.button.confirm': '确定',
  'owner.detail.label.edit': '编辑',
  'owner.detail.tab.dclist': '配送中心范围',
  'owner.detail.tab.operateInfo': '操作日志',
  'owner.detail.tab.ownerInfo': '货主信息',
  'owner.index.search.button.reset': '重置',
  'owner.index.search.button.search': '查询',
  'owner.index.search.content.all': '全部',
  'owner.index.search.content.disable': '已禁用',
  'owner.index.search.content.enable': '已启用',
  'owner.index.search.input.codeName': '货主代码/名称',
  'owner.index.search.input.codeName.placeholder': '请输入关键词查询',
  'owner.index.search.input.state': '状态',
  'owner.index.search.input.state.placeholder': '全部',
  'owner.index.table.button.new': '新建',
  'owner.index.table.column.code': '代码',
  'owner.index.table.column.name': '名称',
  'owner.index.table.column.operate': '操作',
  'owner.index.table.column.shortName': '简称',
  'owner.index.table.column.sourceWay': '来源方式',
  'owner.index.table.column.state': '状态',
  'owner.index.table.content.disable': '已禁用',
  'owner.index.table.content.enable': '已启用',
  'owner.index.table.operate.edit': '编辑',
  'owner.index.table.operate.view': '查看',
  'owner.message.error.create': '新建货主失败',
  'owner.message.error.disbale': '禁用货主失败',
  'owner.message.error.enbale': '启用货主失败',
  'owner.message.error.update': '修改货主失败',
  'owner.message.success.create': '新建货主成功',
  'owner.message.success.disable': '禁用货主成功',
  'owner.message.success.enbale': '启用货主成功',
  'owner.message.success.update': '修改货主成功',
  'owner.title': '货主',
  'owner.update.title': '编辑货主',
  'pick.rpl.config.title': '补货配置',
  'pick.type.title': '配置',
  'pickArea.CASEANDSPLIT': '整件+拆零',
  'pickArea.CASEORSPLIT': '整件/拆零',
  'pickArea.DT': '向下修补件数',
  'pickArea.IPopconfirmTitle': '是否删除拣货分区',
  'pickArea.PICKING': '单店摘果',
  'pickArea.PICKUPTPICK': '拣货位提总',
  'pickArea.STORAGE': '存储位提总',
  'pickArea.STORAGET': '存储位整托提总',
  'pickArea.STORAGETPICK': '存储位回板提总',
  'pickArea.STOREANDPICK': '混合提总',
  'pickArea.UT': '向上修补件数',
  'pickArea.WHOLEPICK': '单店整托盘',
  'pickArea.addPickInfo': '+ 添加拣货模式',
  'pickArea.adjustOrderNo': '调序',
  'pickArea.allocateBinScope': '分播位范围',
  'pickArea.allocateMethod': '分播工具',
  'pickArea.allocateSheme': '门店分播位方案',
  'pickArea.allocateShemeNew': '分播管理方案',
  'pickArea.allocateTransferBin': '分播中转位',
  'pickArea.allocateType': '分播位类型',
  'pickArea.basicDirectCollect': '整托拣是否直接集货',
  'pickArea.basicUnifyCollectTempBin': '集货暂存位',
  'pickArea.binScope': '货位范围',
  'pickArea.containerType': '容器类型',
  'pickArea.create.title': '新建拣货分区',
  'pickArea.create.title.case': '整件配置',
  'pickArea.create.title.split': '拆零配置',
  'pickArea.customPickBinOrder': '自定义拣货路径',
  'pickArea.directCollect': '直接集货',
  'pickArea.index.create.button': '新建',
  'pickArea.lastVolumeRate': '体积单位比(%)',
  'pickArea.maxArticleCount': '分单品项数',
  'pickArea.maxVolume': '分单体积(m³)',
  'pickArea.orderNo': '序号',
  'pickArea.pickBinOrderType': '拣货路径顺序',
  'pickArea.pickMethod': '拣货方式',
  'pickArea.pickMode': '拣货模式',
  'pickArea.pickTempBin': '拣货暂存位',
  'pickArea.pickType': '拣货类型',
  'pickArea.qtyStr': '单店件数',
  'pickArea.rplMethod': '补货算法',
  'pickArea.rplMethodExtend': '补货算法加强',
  'pickArea.rplMode': '补货方式',
  'pickArea.rplStep': '补货步骤',
  'pickArea.rplTempBin': '补货暂存位',
  'pickArea.rplType': '补货类型',
  'pickArea.storeArticleCount': '单店品项数',
  'pickArea.title': '拣货分区',
  'pickArea.tpickMethod': '提总工具',
  'pickArea.unifyCollectTempBin': '集货暂存位',
  'pickArea.update.title': '编辑拣货分区',
  'pickArea.wholeContainer': '是否整托拣',
  'pickArea.wholePickMethod': '整托拣方式',
  'pickBinOrderConfig.pickOrder': '拣货顺序',
  'pickBinOrderConfig.title': '拣货位拣货顺序配置',
  'pickInstruct.actualPickQtr': '实拣件数',
  'pickInstruct.actualPickQty': '实拣数量',
  'pickInstruct.addBookOrder': '新建预约单',
  'pickInstruct.articleCountforPicking': '待拣品项数',
  'pickInstruct.billNumber': '指令号',
  'pickInstruct.goodsGroup': '商品组',
  'pickInstruct.inQpc': '规格',
  'pickInstruct.operator': '操作员',
  'pickInstruct.pickQtr': '应拣件数',
  'pickInstruct.pickQty': '应拣数量',
  'pickInstruct.pickSpeed': '拣货进度(%)',
  'pickInstruct.pickViewTitle': '拣货作业查看',
  'pickInstruct.pickarea': '拣货分区',
  'pickInstruct.picker': '拣货员',
  'pickInstruct.picking': '摘果',
  'pickInstruct.pickupDepth': '拣货深度',
  'pickInstruct.psTaskNumber': '任务号',
  'pickInstruct.realArticleCount': '实拣品项数',
  'pickInstruct.realQty': '实拣数量',
  'pickInstruct.realQtyStr': '实拣件数',
  'pickInstruct.realStoreCount': '实播门店数',
  'pickInstruct.realTaskCount': '实拣指令数',
  'pickInstruct.realTaskCountForSow': '实播指令数',
  'pickInstruct.sow': '播种',
  'pickInstruct.sowSpeed': '分播进度(%)',
  'pickInstruct.state': '状态',
  'pickInstruct.storeCount': '待播门店数',
  'pickInstruct.targetContainerBarcode': '目标容器',
  'pickInstruct.taskCount': '待拣指令数',
  'pickInstruct.taskCountForSow': '待播指令数',
  'pickInstruct.taskDrawerTitle': '任务指令',
  'pickInstruct.title': '拣货指令',
  'pickInstruct.todoQty': '应拣数量',
  'pickInstruct.todoQtyStr': '应拣件数',
  'pickInstruct.waveNumber': '波次单号',
  'pickOrder.addScheme': '新建',
  'pickOrder.addStoreGroup': '添加门店组',
  'pickOrder.addStorePickOrder': '添加门店',
  'pickOrder.endOrder': '结束顺序',
  'pickOrder.noData': '暂无数据',
  'pickOrder.orderNo': '序号',
  'pickOrder.pickOrderScheme': '拣货顺序方案',
  'pickOrder.progressTitle': '删除门店拣货顺序',
  'pickOrder.progressWarn': '请勾选，再进行批量操作',
  'pickOrder.scheme': '拣货方案',
  'pickOrder.schemeCode': '方案代码',
  'pickOrder.schemeName': '方案名称',
  'pickOrder.startOrder': '起始顺序',
  'pickOrder.storeGroupAdd': '新增门店组',
  'pickOrder.storeGroupTitle': '门店组',
  'pickOrder.storeGroupUpdate': '修改门店组',
  'pickOrder.syn.line': '同步',
  'pickOrder.syn.line.Scheme': '同步线路体系方案',
  'pickOrder.tabOperateInfoTitle': '操作日志',
  'pickOrder.tabPickOrderTitle': '拣货顺序',
  'pickOrder.title': '门店拣货顺序',
  'pickOrder.validate.startOrderGreatEndOrder': '拣货顺序起始顺序不能大于结束顺序',
  'pickSchema.column.caseBin': '整件拣货位',
  'pickSchema.column.splitBin': '拆零拣货位',
  'pickSchema.message.noDefaultQpcStr': '商品没有默认规格，保存失败',
  'pickScopeConfig.pickArea': '拣货分区',
  'pickScopeConfig.picker': '拣货员',
  'pickScopeConfig.pickerCodeAndName': '员工代码或名称',
  'pickScopeConfig.title': '拣货员作业配置',
  'rawRequisitionPickerConfig.processTables': '加工台',
  'rawRequisitionPickerConfig.picker': '领料员',
  'rawRequisitionPickerConfig.pickerCodeAndName': '员工代码或名称',
  'rawRequisitionPickerConfig.title': '领料员员作业配置',
  'pickUp.articleCount': '应拣品项数',
  'pickUp.auditMessage': '确认审核',
  'pickUp.batchModifyOperate': '批量修改拣货方式',
  'pickUp.batchModifyPickType': '批量修改拣货类型',
  'pickUp.binContain': '包含的货位代码',
  'pickUp.containerBarcode': '拣货容器',
  'pickUp.containerBarcodeQty': '容器数',
  'pickUp.electronicLabel': '电子标签',
  'pickUp.endPickTime': '结束拣货时间',
  'pickUp.isAudit': '打印并审核',
  'pickUp.modifyOperate': '修改拣货方式',
  'pickUp.operate': '操作方式',
  'pickUp.operateMethod': '拣货方式',
  'pickUp.pickType': '拣货类型',
  'pickUp.pickarea': '拣货分区',
  'pickUp.picker': '拣货员',
  'pickUp.pickerCodeEnter': '刷卡/输入卡号并回车确认',
  'pickUp.price': '应拣金额',
  'pickUp.printLabel': '打印标签拣货',
  'pickUp.printRecord': '打印记录',
  'pickUp.qtyStr': '应拣件数',
  'pickUp.queryResult': '查询结果',
  'pickUp.realArticleCount': '实拣品项数',
  'pickUp.realPrice': '实拣金额',
  'pickUp.realQtyStr': '实拣件数',
  'pickUp.realVolume': '实拣体积(m³)',
  'pickUp.realWeight': '实拣重量(kg)',
  'pickUp.recalculate': '重算',
  'pickUp.sourceOperate': '当前操作方式',
  'pickUp.startPickTime': '开始拣货时间',
  'pickUp.targetBinCode': '目标货位',
  'pickUp.targetBinCodeUsage': '目标货位用途',
  'pickUp.targetContainerBarcode': '目标容器',
  'pickUp.targetOperate': '目标操作方式',
  'pickUp.title': '拣货单',
  'pickUp.volume': '应拣体积(m³)',
  'pickUp.waveBillNumber': '波次单号',
  'pickUp.weight': '应拣重量(kg)',
  'pickareaStorageConfig.column.binRange': '货位范围',
  'pickareaStorageConfig.column.pickarea': '拣货分区',
  'pickareaStorageConfig.column.pickareaCode': '拣货分区代码',
  'pickareaStorageConfig.column.pickareaCodeName': '代码/名称',
  'pickareaStorageConfig.column.pickareaName': '拣货分区名称',
  'pickareaStorageConfig.create.title': '新增',
  'pickareaStorageConfig.title': '拣货分区存储范围配置',
  'planeMove.IPopconfirmAbortTitle': '确定要审核该平移单吗',
  'planeMove.adjBinCodes': '建议货位',
  'planeMove.articleAndSpec': '商品/商品规格',
  'planeMove.containerBarcodes': '包含容器',
  'planeMove.containerBarcodesRule': '容器条码，逗号分隔',
  'planeMove.endPlanMoveDate': '结束平移时间',
  'planeMove.mover': '平移员',
  'planeMove.qpcStrAndMunit': '包装规格/单位',
  'planeMove.sourceBinCode': '来源货位',
  'planeMove.sourceContainerBarcode': '来源容器',
  'planeMove.sourceWrh': '来源仓位',
  'planeMove.startPlanMoveDate': '开始平移时间',
  'planeMove.targetBinCode': '目标货位',
  'planeMove.targetContainerBarcode': '目标容器',
  'planeMove.targetWrh': '目标仓位',
  'planeMove.title': '平移单',
  'planeMove.type': '平移类型',
  'plu码': 'plu码',
  'pretype.back': '返回',
  'pretype.create': '新建',
  'pretype.create.form.item.input.limitLength.note': '说明最大长度255',
  'pretype.create.form.item.input.placeholder.name': '请输入名称',
  'pretype.create.form.item.input.placeholder.note': '请输入说明',
  'pretype.create.form.item.name.validate.message.notNull': '类型名称不能为空',
  'pretype.create.form.name': '类型名称',
  'pretype.create.form.note': '说明',
  'pretype.index.column.operate': '操作',
  'pretype.index.search.input.placeholder.pretype.name': '请输入类型名称查询',
  'pretype.name': '名称',
  'pretype.note': '说明',
  'pretype.title': '类型',
  'printerConfig.defaultPrintMethod': 'RF默认打印方式',
  'printerConfig.getPrinter': '获取打印机',
  'printerConfig.printAddress': '打印服务地址',
  'printerConfig.shortName': '别名',
  'processBill.confirm.change': '变更{item}会导致明细清空，请确认修改？',
  'processBill.confirm.clear': '修改{item}会导致明细清空，请确认修改？',
  'processBill.containsBarCode': '包含的容器代码',
  'processBill.containsBinCode': '包含的货位代码',
  'processBill.end': '成品',
  'processBill.endInfoList': '成品明细',
  'processBill.items': '加工单明细',
  'processBill.processScheme': '加工方案',
  'processBill.raw': '原料',
  'processBill.rawInfoList': '原料明细',
  'processBill.spec': '商品规格',
  'processBill.title': '加工单',
  'processBill.validate.cannotProcessPlan': '必须加入加工方案',
  'processBill.validate.confirmTitleOnSave': '没有录入加工方案,是否继续保存？',
  'processBill.validate.confirmTitleOnSaveAndAudit': '没有录入加工方案,是否继续保存并审核？',
  'processBill.validate.itemNotLessZero': '加工单原料明细第{line}行{item}不能小于0',
  'processBill.validate.itemNotZero': '加工单原料明细第{line}行{item}不能为0',
  'processBill.validate.itemRepeat': '加工单原料明细第{line1}行与第{line2}行重复',
  'processBill.validate.itemRepeatend': '加工单成品明细第{line1}行与第{line2}行重复',
  'processBill.validate.noteTooLong': '加工单原料明细第{line}行备注长度最大为255',
  'processBill.validate.realQtyTooBig': '加工单原料明细第{line}行实际数量不允许大于数量',
  'processTask.createTask': '生成任务',
  'processTask.title': '生成加工任务',
  'processing.articleAndSpec': '商品/商品规格',
  'processing.detail.tab.dclist': '配送中心范围',
  'processing.endproduct.article': '成品商品',
  'processing.endproduct.article.codes': '成品商品代码',
  'processing.raw.article': '原料商品',
  'processing.raw.article.codes': '原料商品代码',
  'processing.scheme.title': '加工方案',
  'putaway.IPopconfirmDeleteTitle': '确认删除',
  'putaway.adjBinCodes': '建议货位',
  'putaway.articleAndSpec': '商品/商品规格',
  'putaway.auditMessage': '确认审核通过该上架单吗？',
  'putaway.endTime': '结束上架时间',
  'putaway.putawayBillType': '上架类型',
  'putaway.putawayer': '上架员',
  'putaway.sourceBin': '来源货位',
  'putaway.sourceBinUsage': '来源货位用途',
  'putaway.sourceContainerBar': '来源容器',
  'putaway.spec': '包装规格',
  'putaway.startTime': '开始上架时间',
  'putaway.stockTableTitle': '库存信息',
  'putaway.targetBin': '目标货位',
  'putaway.targetBinUsage': '目标货位用途',
  'putaway.targetContainerBar': '目标容器',
  'putaway.title': '上架单',
  'receive.allArticles': '总品项数',
  'receive.article': '所含商品',
  'receive.article.placeholder': '代码，以逗号隔开',
  'receive.audit.confirm': '确认审核该收货单吗？',
  'receive.businessInfo': '业务信息',
  'receive.endReceiveTime': '结束收货时间',
  'receive.method': '收货方式',
  'receive.overReceive': '商品：{articleCode}超收比例为0，不允许超收',
  'receive.receiver': '收货员',
  'receive.remove.confirm': '确认删除该收货单吗？',
  'receive.startReceiveTime': '开始收货时间',
  'receive.targetBin': '目标货位',
  'receive.targetBinCode': '目标货位代码',
  'receive.title': '收货单',
  'receive.type': '收货类型',
  'refund.received': '存在退货是否允许收货',
  'releaseContent.operate': '操作',
  'releaseContent.placeholder.search': '请输入放行内容的名称进行查询',
  'releaseContent.title': '放行内容',
  'report.baisc.directory.name': '目录名称',
  'report.basic.directory.name.validate.message.limitLength': '目录名称最大长度是30',
  'report.basic.directory.name.validate.message.notNull': '目录名称不能为空',
  'report.basic.report.name': '报表名称',
  'report.basic.report.name.validate.message.limitLength': '报表名称最大长度是30',
  'report.basic.report.name.validate.message.notNull': '报表名称不能为空',
  'report.basic.report.path': '模板路径',
  'report.basic.report.path.validate.message.limitLength': '模板路径最大长度是30',
  'report.display': '显示终端',
  'report.display.validate.message.notNull': '显示终端不能为空',
  'report.headingReport': '海鼎报表',
  'report.new.directory': '新建目录',
  'report.import': '导入',
  'report.export': '导出',
  'report.new.report': '新建报表',
  'report.no': '否',
  'report.note': '备注',
  'report.note.validate.message.limitLength': '备注最大长度是100',
  'report.title': '报表挂载',
  'report.yes': '是',
  'role.addUser.search.placeholder': '成员代码/用户名',
  'role.addUser.title': '添加用户',
  'role.create.form.item.code.validate.message.integrality': '代码必须为4位，字母数字组合、纯数字、纯字母',
  'role.create.form.item.code.validate.message.limitLength': '代码最大长度30',
  'role.create.form.item.code.validate.message.notNull': '代码不能为空',
  'role.create.form.item.name.validate.message.limitLength': '名称最大长度30',
  'role.create.form.item.name.validate.message.notNull': '名称不能为空',
  'role.create.form.item.placeholder': '请输入',
  'role.create.title': '新建角色',
  'role.edit.title': '修改角色',
  'role.index.button.addUser': '添加用户',
  'role.index.button.batchDelete': '移除',
  'role.index.button.delete': '删除',
  'role.index.button.modify': '修改',
  'role.index.button.new': '新建',
  'role.index.button.newRole': '新建角色',
  'role.index.disable': '已禁用',
  'role.index.enable': '已启用',
  'role.index.tab.permissionInfo': '权限信息',
  'role.index.tab.userInfo': '用户信息',
  'role.index.table.column.code': '代码',
  'role.index.table.column.name': '名称',
  'role.index.table.column.operate': '操作',
  'role.index.table.column.phone': '电话',
  'role.index.table.operate.delete': '移除',
  'role.message.error.addUser': '添加用户失败，请重试',
  'role.message.error.fetchUserInfo': '获取角色信息失败',
  'role.message.success.addUser': '添加用户成功',
  'role.title': '角色',
  'rpl.currentMode': '现操作方式',
  'rpl.endRplTime': '结束补货时间',
  'rpl.fromBinCode': '来源货位',
  'rpl.fromBinCodes': '包含的货位代码',
  'rpl.fromContainerBarCode': '来源容器',
  'rpl.genFrom': '补货来源',
  'rpl.mode': '补货方式',
  'rpl.modifyMode': '修改补货方式',
  'rpl.pickArea': '拣货分区',
  'rpl.rpler': '补货员',
  'rpl.startRplTime': '开始补货时间',
  'rpl.step': '补货步骤',
  'rpl.targetMode': '目标操作方式',
  'rpl.title': '补货单',
  'rpl.toBinCode': '目标货位',
  'rpl.toBinCodes': '包含的货位代码',
  'rpl.type': '补货类型',
  'rpl.waveBillNumber': '波次单号',
  'rtnPutaway.column.method': '操作方式',
  'rtnPutaway.column.sourceBin': '来源货位',
  'rtnPutaway.column.targetBin': '目标货位',
  'rtnPutaway.putAwayer': '上架员',
  'rtnPutaway.sourceContainer': '来源容器',
  'rtnPutaway.targetContainer': '目标容器',
  'rtnPutaway.title': '退仓上架单',
  'senseCheck.checkDate': '质检时间',
  'senseCheck.checkResult': '质检结果',
  'senseCheck.checkType': '质检类型',
  'senseCheck.checker': '质检员',
  'senseCheck.sense': '感官质检科目',
  'senseCheck.title': '感官质检单',
  'sowingPickUpBill.allocateType': '分播类型',
  'sowingPickUpBill.binContain': '包含的货位代码',
  'sowingPickUpBill.collectBin': '集货位',
  'sowingPickUpBill.collectTempBin': '集货暂存位',
  'sowingPickUpBill.crossAllocateBin': '分播中转位',
  'sowingPickUpBill.endPickTime': '结束拣货时间',
  'sowingPickUpBill.endSowingTime': '结束播种时间',
  'sowingPickUpBill.pickQty': '应拣数量',
  'sowingPickUpBill.pickQtyStr': '应拣件数',
  'sowingPickUpBill.pickTempBin': '拣货暂存位',
  'sowingPickUpBill.pickTime': '拣货时间',
  'sowingPickUpBill.pickType': '拣货方式',
  'sowingPickUpBill.pickarea': '拣货分区',
  'sowingPickUpBill.picker': '拣货员',
  'sowingPickUpBill.realPickQty': '实拣数量',
  'sowingPickUpBill.realPickQtyStr': '实拣件数',
  'sowingPickUpBill.realSowingQtyStr': '实际分播件数',
  'sowingPickUpBill.sourceBinCode': '来源货位',
  'sowingPickUpBill.sourceContainerBarcode': '来源容器',
  'sowingPickUpBill.sower': '分播员',
  'sowingPickUpBill.sowingItems': '分播明细',
  'sowingPickUpBill.sowingMethod': '分播方式',
  'sowingPickUpBill.sowingPickStockItems': '分播库存明细',
  'sowingPickUpBill.sowingQtyStr': '应分播件数',
  'sowingPickUpBill.sowingState': '分播状态',
  'sowingPickUpBill.sowingTime': '分播时间',
  'sowingPickUpBill.startPickTime': '开始拣货时间',
  'sowingPickUpBill.startSowingTime': '开始播种时间',
  'sowingPickUpBill.storeSowingBin': '门店分播位',
  'sowingPickUpBill.sumPickMethod': '提总方式',
  'sowingPickUpBill.summaryPickItems': '拣货明细',
  'sowingPickUpBill.summaryPickMethod': '提总拣货方式',
  'sowingPickUpBill.summaryPickStockItems': '拣货库存明细',
  'sowingPickUpBill.summaryState': '提总状态',
  'sowingPickUpBill.summaryType': '提总类型',
  'sowingPickUpBill.targetBinCode': '目标货位',
  'sowingPickUpBill.targetContainerBarcode': '目标容器',
  'sowingPickUpBill.title': '播种拣货单',
  'sowingPickUpBill.totalRealSowingArticleCount': '实际总分播品项数',
  'sowingPickUpBill.totalRealSowingQtyStr': '实际总分播件数',
  'sowingPickUpBill.totalRealSowingStoreCount': '实际总分播门店数',
  'sowingPickUpBill.totalRealSowingVolume': '实际总分播体积',
  'sowingPickUpBill.totalRealSowingWeight': '实际总分播重量',
  'sowingPickUpBill.totalRealSummaryArticleCount': '实际总提总品项数',
  'sowingPickUpBill.totalRealSummaryQtyStr': '实际总提总件数',
  'sowingPickUpBill.totalRealSummaryVolume': '实际总提总体积',
  'sowingPickUpBill.totalRealSummaryWeight': '实际总提总重量',
  'sowingPickUpBill.totalSowingArticleCount': '总分播品项数',
  'sowingPickUpBill.totalSowingQtyStr': '总分播件数',
  'sowingPickUpBill.totalSowingStoreCount': '总分播门店数',
  'sowingPickUpBill.totalSowingVolume': '总分播体积',
  'sowingPickUpBill.totalSowingWeight': '总分播重量',
  'sowingPickUpBill.totalSummaryArticleCount': '总提总品项数',
  'sowingPickUpBill.totalSummaryQtyStr': '总提总件数',
  'sowingPickUpBill.totalSummaryVolume': '总提总体积',
  'sowingPickUpBill.totalSummaryWeight': '总提总重量',
  'sowingPickUpBill.waveBillNumber': '波次单号',
  'start.test': '开始测试',
  'start.test.success': '开始测试成功',
  'start.work': '开始作业',
  'start.work.success': '开始作业成功',
  'stevedorestate.title': '卸货情况',
  'stockBatch.configInfo': '配置信息',
  'stockBatch.dateLength': '日期长度',
  'stockBatch.flowLength': '流水号长度',
  'stockBatch.operate.info': '操作日志',
  'stockLockBill.IPopconfirmDeleteTitle': '确认删除',
  'stockLockBill.articleAndSpec': '商品/商品规格',
  'stockLockBill.articleInfo': '商品信息',
  'stockLockBill.auditMessage': '确认审核该库存锁定单',
  'stockLockBill.billItem.notNull.message': '库存锁定解锁单明细不能为空',
  'stockLockBill.bin': '货位',
  'stockLockBill.lockBill': '库存锁定单',
  'stockLockBill.locker': '操作员',
  'stockLockBill.ownerChange.moda.message': '修改货主会导致明细清空，请确认修改？',
  'stockLockBill.reason': '原因',
  'stockLockBill.reasonButton': '锁定解锁原因',
  'stockLockBill.reasonTitle': '锁定解锁原因',
  'stockLockBill.title': '锁定解锁单',
  'stockLockBill.type': '单据类型',
  'stockLockBill.typeChange.modal.message': '修改单据类型会导致明细清空，请确认修改？',
  'stockOrder.addScheme': '新建方案',
  'stockOrder.addStore': '添加门店',
  'stockOrder.addStoreGroup': '添加门店组',
  'stockOrder.down': '下移',
  'stockOrder.order': '顺序',
  'stockOrder.orderNo': '序号',
  'stockOrder.progressTitle': '删除门店库存分配顺序',
  'stockOrder.progressWarn': '请勾选，再进行批量操作',
  'stockOrder.scheme': '分配方案',
  'stockOrder.schemeCode': '方案代码',
  'stockOrder.schemeName': '方案名称',
  'stockOrder.storeGroupAdd': '新增门店组',
  'stockOrder.storeGroupTitle': '门店组',
  'stockOrder.storeGroupUpdate': '修改门店组',
  'stockOrder.storeStockOrderTitle': '门店库存分配顺序',
  'stockOrder.success': '成功',
  'stockOrder.tabStockOrderTitle': '库存分配顺序',
  'stockOrder.title': '库存分配方案',
  'stockOrder.up': '上移',
  'stockOutConfig.stockAllocateScheme': '库存分配顺序方案',
  'stockOutConfig.stockAllocateType': '库存分配类型',
  'stockOutConfig.title': '缺货库存分配方案',
  'stockTakePlan.articleScope': '商品范围',
  'stockTakePlan.change': '动销',
  'stockTakePlan.changeTimes': '次数',
  'stockTakePlan.conditionInfo.byBinUsage': '货位用途',
  'stockTakePlan.conditionInfo.byPath': '货道',
  'stockTakePlan.conditionInfo.byPickArea': '拣货分区',
  'stockTakePlan.conditionInfo.byZone': '货区',
  'stockTakePlan.conditionInfo.message.notNull': '分单依据不能为空',
  'stockTakePlan.existStock': '存在库存',
  'stockTakePlan.maxBillCount': '最大单据数',
  'stockTakePlan.maxBinCount': '最大货位数',
  'stockTakePlan.maxBinCount.message.notNull': '数量不能为空',
  'stockTakePlan.owner.message.notNull': '货主不能为空',
  'stockTakePlan.splitCondition': '分单条件',
  'stockTakePlan.splitCondition.message.notNull': '分单条件不能为空',
  'stockTakePlan.startDate': '动销日期',
  'store.create.basic': '基本信息',
  'store.create.button.cancel': '取消',
  'store.create.button.confirm': '确认',
  'store.create.button.confirm.new': '确认并新建',
  'store.create.form.item.address.name': '门店地址',
  'store.create.form.item.address.validate.message.limitLength': '地址最大长度100',
  'store.create.form.item.address.validate.message.notNull': '地址不能为空',
  'store.create.form.item.code.name': '门店代码',
  'store.create.form.item.code.validate.message.integrality': '代码必须为4位，字母数字组合、纯数字、纯字母',
  'store.create.form.item.code.validate.message.notNull': '代码不能为空',
  'store.create.form.item.contactPhone.name': '联系方式',
  'store.create.form.item.contactPhone.validate.message.limitLength': '联系电话最大长度30',
  'store.create.form.item.contactPhone.validate.message.notNull': '联系人手机号不能为空',
  'store.create.form.item.contactor.name': '联系人',
  'store.create.form.item.contactor.validate.message.limitLength': '联系人最大长度30',
  'store.create.form.item.contactor.validate.message.notNull': '联系人不能为空',
  'store.create.form.item.distance.name': '离仓距离',
  'store.create.form.item.distance.unit': '公里',
  'store.create.form.item.distance.validate.message.greaterThanZero': '离仓距离必须大于0',
  'store.create.form.item.homeUrl.name': '主页',
  'store.create.form.item.homeUrl.validate.message.limitLength': '主页最大长度100',
  'store.create.form.item.input.placeholder': '请输入',
  'store.create.form.item.input.placeholder.address': '请输入门店的具体地址',
  'store.create.form.item.input.placeholder.addressChoose': '请选择国家\省\市\区',
  'store.create.form.item.input.placeholder.code': '请输入4位数字或字母',
  'store.create.form.item.input.placeholder.contactPhone': '请输入联系方式',
  'store.create.form.item.input.placeholder.contactor': '请输入联系人',
  'store.create.form.item.input.placeholder.distance': '请输入距离货主仓库的距离',
  'store.create.form.item.input.placeholder.homeUrl': '请输入主页',
  'store.create.form.item.input.placeholder.inputNumber': '请输入大于0的数字',
  'store.create.form.item.input.placeholder.name': '请输入4到30位的字符',
  'store.create.form.item.input.placeholder.note': '请输入本门店额外的备注说明，不超过255个字',
  'store.create.form.item.input.placeholder.operatingArea': '请输入门店的经营面积',
  'store.create.form.item.input.placeholder.shortName': '请输入门店简称',
  'store.create.form.item.input.placeholder.zipCode': '请输入门店地址的邮编',
  'store.create.form.item.name.name': '门店名称',
  'store.create.form.item.name.validate.message.limitLength': '名称最大长度30',
  'store.create.form.item.name.validate.message.notNull': '名称不能为空',
  'store.create.form.item.note.name': '备注',
  'store.create.form.item.note.validate.message.limitLength': '备注最大长度255',
  'store.create.form.item.operatingArea.name': '经营面积',
  'store.create.form.item.operatingArea.unit': '平米',
  'store.create.form.item.operatingArea.validate.message.greaterThanZero': '经营面积必须大于0',
  'store.create.form.item.operatingType.name': '经营类型',
  'store.create.form.item.operatingType.validate.message.notNull': '门店经营类型不能为空',
  'store.create.form.item.owner.name': '货主',
  'store.create.form.item.owner.validate.message.limitLength': '货主最大长度30',
  'store.create.form.item.owner.validate.message.notNull': '货主不能为空',
  'store.create.form.item.select.placeholder': '请选择',
  'store.create.form.item.select.placeholder.operatingType': '请选择门店经营类型',
  'store.create.form.item.select.placeholder.owner': '请选择货主',
  'store.create.form.item.select.placeholder.storeType': '请选择门店业态',
  'store.create.form.item.shortName.name': '简称',
  'store.create.form.item.shortName.validate.message.limitLength': '简称最大长度30',
  'store.create.form.item.shortName.validate.message.notNull': '简称不能为空',
  'store.create.form.item.sourceWay.name': '来源方式',
  'store.create.form.item.state.name': '状态',
  'store.create.form.item.storeType.name': '门店业态',
  'store.create.form.item.storeType.validate.message.limitLength': '门店业态最大长度30',
  'store.create.form.item.storeType.validate.message.notNull': '门店业态不能为空',
  'store.create.form.item.zipCode.name': '邮编',
  'store.create.form.item.zipCode.validate.message.limitLength': '邮编最大长度30',
  'store.create.form.item.zipCode.validate.message.notNull': '邮编不能为空',
  'store.create.title': '新建门店',
  'store.detail.basic': '基本信息',
  'store.detail.basic.address': '地址',
  'store.detail.basic.code': '代码',
  'store.detail.basic.contactPhone': '联系方式',
  'store.detail.basic.contactor': '联系人',
  'store.detail.basic.distance': '离仓距离(km)',
  'store.detail.basic.homeUrl': '主页',
  'store.detail.basic.name': '名称',
  'store.detail.basic.note': '备注',
  'store.detail.basic.operatingArea': '经营面积(m²)',
  'store.detail.basic.operatingType': '经营类型',
  'store.detail.basic.owner': '货主',
  'store.detail.basic.shortName': '简称',
  'store.detail.basic.type': '门店业态',
  'store.detail.basic.zipCode': '邮编',
  'store.detail.button.back': '返回',
  'store.detail.button.cancel': '取消',
  'store.detail.button.confirm': '确定',
  'store.detail.label.edit': '编辑',
  'store.detail.tab.dclist': '配送中心范围',
  'store.detail.tab.operateInfo': '操作日志',
  'store.detail.tab.storeInfo': '门店信息',
  'store.import.title': '导入门店',
  'store.index.search.button.close': '收起',
  'store.index.search.button.more': '展开更多',
  'store.index.search.button.reset': '重置',
  'store.index.search.button.search': '查询',
  'store.index.search.content.disable': '已禁用',
  'store.index.search.content.enable': '已启用',
  'store.index.search.input.codeName': '门店代码/名称',
  'store.index.search.input.codeName.placeholder': '请输入关键词查询',
  'store.index.search.input.operatingType': '经营类型',
  'store.index.search.input.placeholder': '全部',
  'store.index.search.input.state': '状态',
  'store.index.search.input.storeType': '类型',
  'store.index.table.button.new': '新建',
  'store.index.table.column.code': '代码',
  'store.index.table.column.name': '名称',
  'store.index.table.column.operate': '操作',
  'store.index.table.column.operatingType': '经营类型',
  'store.index.table.column.shortName': '简称',
  'store.index.table.column.sourceWay': '来源方式',
  'store.index.table.column.state': '状态',
  'store.index.table.column.storeType': '门店业态',
  'store.index.table.content.disable': '已禁用',
  'store.index.table.content.enable': '已启用',
  'store.index.table.operate.edit': '编辑',
  'store.index.table.operate.view': '查看',
  'store.manage. operateType': '管理门店经营类型',
  'store.manage.type': '管理门店业态',
  'store.message.error.create': '新建门店失败',
  'store.message.error.disbale': '禁用门店失败',
  'store.message.error.enbale': '启用门店失败',
  'store.message.error.update': '修改门店失败',
  'store.message.success.create': '新建门店成功',
  'store.message.success.disable': '禁用门店成功',
  'store.message.success.enbale': '启用门店成功',
  'store.message.success.update': '修改门店成功',
  'store.name': '门店',
  'store.operating': '门店经营',
  'store.title': '门店',
  'store.update.title': '编辑门店',
  'storeAllocation.allocation': '分播位',
  'storeAllocation.createTitle': '门店分播位新增',
  'storeAllocation.select': '门店下拉框',
  'storeAllocation.selectAllocation': '分播位下拉框',
  'storeAllocation.store': '门店',
  'storeAllocation.title': '门店分播位配置',
  'storeAllocationScheme.addStore': '添加门店',
  'storeAllocationScheme.batchConfig': '批量设置',
  'storeAllocationScheme.progressTitle': '删除门店分播位',
  'storeAllocationScheme.storeAllocation': '门店分播位',
  'storeAllocationScheme.title': '门店分播位方案',
  'storeGroupConfig.storeGroup': '门店组',
  'storeGroupConfig.title': '门店组配置',
  'storeRtn.button.batchRefreshContainer': '批量设置目标容器',
  'storeRtn.button.batchRefreshType': '批量设置退仓类型',
  'storeRtn.column.articleCount': '总品项数',
  'storeRtn.column.method': '操作方式',
  'storeRtn.column.rtner': '退仓员',
  'storeRtn.column.targetBin': '目标货位',
  'storeRtn.column.type': '退仓类型',
  'storeRtn.rtnNtcBillNumber': '通知单号',
  'storeRtn.title': '退仓单',
  'storeRtnNtc.button.copy': '复制',
  'storeRtnNtc.button.manageLessBackReason': '管理少退原因',
  'storeRtnNtc.button.manageReason': '管理退仓原因',
  'storeRtnNtc.button.manageType': '管理退仓类型',
  'storeRtnNtc.button.rtnWrh': '退仓',
  'storeRtnNtc.column.expireDate': '到效时间',
  'storeRtnNtc.column.reason': '退仓原因',
  'storeRtnNtc.column.rtnDate': '退货时间',
  'storeRtnNtc.column.sourceBillNumber': '来源单号',
  'storeRtnNtc.column.type': '退仓类型',
  'storeRtnNtc.detail.tab.batch': '批次',
  'storeRtnNtc.detail.tab.pieces': '件数',
  'storeRtnNtc.detail.tab.quantity': '数量',
  'storeRtnNtc.detail.tab.realPieces': '实退件数',
  'storeRtnNtc.detail.tab.realQuantity': '实退数量',
  'storeRtnNtc.detail.tab.uploadTime': '上传时间',
  'storeRtnNtc.title': '退仓通知单',
  'superManagementBoard.ValidIdentification': '有效标识',
  'superManagementBoard.add': '添加',
  'superManagementBoard.articleCodeName': '商品',
  'superManagementBoard.batchInvalid': '批量无效',
  'superManagementBoard.billTitle': '超保单',
  'superManagementBoard.date': '日期',
  'superManagementBoard.endDate': '截止日期',
  'superManagementBoard.invalid': '无效',
  'superManagementBoard.newControlDays': '新控制天数',
  'superManagementBoard.oldControlDays': '原控制天数',
  'superManagementBoard.operateTime': '操作时间',
  'superManagementBoard.operator': '操作人',
  'superManagementBoard.shelf': '保质期天数',
  'superManagementBoard.shelfType': '保质期类型',
  'superManagementBoard.startDate': '起始日期',
  'superManagementBoard.startToEndDate': '起止日期',
  'superManagementBoard.title': '超保管理看板',
  'superManagementBoard.type': '超保类型',
  'superManagementBoard.valid': '有效',
  'tag.start.address': '标签范围必须为4位数字',
  'taskScopeConfig.binRange': '货位范围',
  'taskScopeConfig.binRange.notAllNull': '货位范围不能全部为空',
  'taskScopeConfig.manualSelectionType': '手工选择指令类型',
  'taskScopeConfig.orderNo': '序号',
  'taskScopeConfig.priority.alreadyFirst': '当前记录优先级已为最高',
  'taskScopeConfig.priority.upSuccess': '优先级调整成功',
  'taskScopeConfig.priority.validate': '无法调整当前记录的优先级',
  'taskScopeConfig.taskType': '作业指令',
  'taskScopeConfig.tasker': '高叉员',
  'taskScopeConfig.taskerCodeAndName': '员工代码或名称',
  'taskScopeConfig.title': '高叉员作业配置',
  'user.authorize.form.item.resources.name': '权限',
  'user.authorize.form.item.role.name': '角色',
  'user.authorize.form.item.role.placeholder': '请选择角色',
  'user.authorize.title': '授权',
  'user.create.form.item.code.name': '代码',
  'user.create.form.item.code.validate.message.limitLength': '代码最大长度30',
  'user.create.form.item.code.validate.message.notNull': '代码不能为空',
  'user.create.form.item.input.placeholder': '请输入',
  'user.create.form.item.name.name': '名称',
  'user.create.form.item.name.validate.message.limitLength': '名称最大长度30',
  'user.create.form.item.name.validate.message.notNull': '名称不能为空',
  'user.create.form.item.org.name': '所属组织',
  'user.create.form.item.org.validate.message.required': '组织必选',
  'user.create.form.item.phone.name': '手机号',
  'user.create.form.item.phone.validate.message.integrality': '手机号请输入真实手机号',
  'user.create.form.item.phone.validate.message.notNull': '手机号不能为空',
  'user.create.form.item.role.name': '角色',
  'user.create.form.item.role.validate.message.required': '角色必选',
  'user.create.form.item.select.placeholder': '请选择',
  'user.create.title': '新建用户',
  'user.detail.basic': '基本信息',
  'user.detail.basic.code': '代码',
  'user.detail.basic.name': '名称',
  'user.detail.basic.phone': '手机号',
  'user.detail.button.back': '返回搜索',
  'user.detail.org': '所属组织',
  'user.detail.org.disable': '禁用',
  'user.detail.org.enable': '启用',
  'user.detail.org.table.column.code': '组织代码',
  'user.detail.org.table.column.name': '组织名称',
  'user.detail.org.table.column.operate': '操作',
  'user.detail.org.table.column.status': '状态',
  'user.detail.org.table.column.type': '组织类型',
  'user.detail.role': '角色列表',
  'user.detail.role.offline': '已禁用',
  'user.detail.role.online': '已启用',
  'user.detail.role.table.column.code': '角色代码',
  'user.detail.role.table.column.name': '角色名称',
  'user.detail.role.table.column.status': '角色状态',
  'user.forget.againPassword': '6-16位新密码，区分大小写',
  'user.forget.confirm-password.required': '确认密码',
  'user.forget.confirm-password.required.notnull': '确认密码不能为空',
  'user.forget.find.password': '找回密码',
  'user.forget.get-verification-code': '获取验证码',
  'user.forget.password.setting.success': '密码设置成功',
  'user.forget.phone-number.placeholder': '11位手机号',
  'user.forget.phone-number.required': '请输入手机号',
  'user.forget.phone-number.wrong-format': '手机号格式错误',
  'user.forget.placeholder': '至少6位密码，区分大小写',
  'user.forget.register.sing-in': '使用已有账户登录',
  'user.forget.second': '秒',
  'user.forget.sure': '确认',
  'user.forget.twice.pwd.not.same': '两次密码输入不一致',
  'user.forget.validation.password.required': '登录密码不能为空',
  'user.forget.verification-code.required': '请输入验证码',
  'user.index.search.button.reset': '重置',
  'user.index.search.button.search': '查询',
  'user.index.search.input.code': '代码',
  'user.index.search.input.code.placeholder': '请输入',
  'user.index.search.input.name': '名称',
  'user.index.search.input.name.placeholder': '请输入',
  'user.index.table.button.batchDelete': '删除',
  'user.index.table.button.new': '新建',
  'user.index.table.column.code': '代码',
  'user.index.table.column.name': '用户名',
  'user.index.table.column.operate': '操作',
  'user.index.table.column.phone': '手机号',
  'user.index.table.operate.authorize': '授权',
  'user.index.table.operate.confirmDelete': '确认要删除吗？',
  'user.index.table.operate.delete': '删除',
  'user.index.table.operate.edit': '编辑',
  'user.modify.checkOrg.success': '组织切换成功',
  'user.modify.ckeckPassword': '密码必须为6-16位数字、字母、符号组合',
  'user.modify.new.password': '请输入新密码',
  'user.modify.new.password.label': '新密码',
  'user.modify.new.password.sure': '再次确认新密码',
  'user.modify.old.password': '请输入原密码',
  'user.modify.old.password.label': '原密码',
  'user.modify.password.success': '密码修改成功',
  'user.modify.twice.pwd.not.same': '两次密码输入不一致',
  'user.title': '用户',
  'user.update.title': '修改用户',
  'validation.againPassword.required': '确认密码不能为空',
  'validation.confirm-password.required': '请确认密码',
  'validation.date.required': '请选择起止日期',
  'validation.email.required': '请输入邮箱地址',
  'validation.email.wrong-format': '邮箱地址格式错误',
  'validation.goal.required': '请输入目标描述',
  'validation.loginAccount.required': '登录的手机号不能为空',
  'validation.password.required': '请输入密码',
  'validation.password.strength.medium': '强度：中',
  'validation.password.strength.msg': '请至少输入 6 个字符。请不要使用容易被猜到的密码。',
  'validation.password.strength.short': '强度：太短',
  'validation.password.strength.strong': '强度：强',
  'validation.password.twice': '两次输入的密码不匹配!',
  'validation.phone-number.required': '请输入手机号',
  'validation.phone-number.wrong-format': '手机号格式错误',
  'validation.standard.required': '请输入衡量标准',
  'validation.title.required': '请输入标题',
  'validation.verification-code.required': '请输入验证码',
  'vendor.basic.info': '基本信息',
  'vendor.code': '代码',
  'vendor.contactPhone': '联系方式',
  'vendor.contactor': '联系人',
  'vendor.create.button.cancel': '取消',
  'vendor.create.button.confirm': '确认',
  'vendor.create.button.confirmAndAdd': '确认并创建',
  'vendor.create.form.item.code.name': '代码',
  'vendor.create.form.item.code.validate.message.integrality': '代码必须为4位，字母数字组合、纯数字、纯字母',
  'vendor.create.form.item.code.validate.message.notNull': '代码不能为空',
  'vendor.create.form.item.contactPhone.name': '联系人电话',
  'vendor.create.form.item.contactPhone.validate.message.limitLength': '联系人电话最大长度30',
  'vendor.create.form.item.contactPhone.validate.message.notNull': '联系人电话不能为空',
  'vendor.create.form.item.contactor.name': '联系人',
  'vendor.create.form.item.contactor.validate.message.limitLength': '联系人最大长度30',
  'vendor.create.form.item.contactor.validate.message.notNull': '联系人不能为空',
  'vendor.create.form.item.homeUrl.name': '主页',
  'vendor.create.form.item.homeUrl.validate.message.limitLength': '主页最大长度100',
  'vendor.create.form.item.input.placeholder': '请输入',
  'vendor.create.form.item.name.name': '名称',
  'vendor.create.form.item.name.validate.message.limitLength': '名称最大长度30',
  'vendor.create.form.item.name.validate.message.notNull': '名称不能为空',
  'vendor.create.form.item.note.name': '备注',
  'vendor.create.form.item.note.validate.message.limitLength': '备注最大长度255',
  'vendor.create.form.item.owner.name': '货主',
  'vendor.create.form.item.owner.validate.message.limitLength': '货主最大长度30',
  'vendor.create.form.item.owner.validate.message.notNull': '货主不能为空',
  'vendor.create.form.item.shortName.name': '简称',
  'vendor.create.form.item.shortName.validate.message.limitLength': '简称最大长度30',
  'vendor.create.form.item.zipCode.name': '邮编',
  'vendor.create.form.item.zipCode.validate.message.limitLength': '邮编最大长度30',
  'vendor.create.title': '新建供应商',
  'vendor.customField1': '自定义字段1',
  'vendor.detail.tab.dclist': '配送中心范围',
  'vendor.homeUrl': '主页',
  'vendor.index.search.button.close': '收起',
  'vendor.index.search.button.open': '展开',
  'vendor.index.search.button.reset': '重置',
  'vendor.index.search.button.search': '查询',
  'vendor.index.search.content.disable': '已禁用',
  'vendor.index.search.content.enable': '已启用',
  'vendor.index.search.input.code': '代码',
  'vendor.index.search.input.code.placeholder': '请输入',
  'vendor.index.search.input.codeAndName': '代码/名称',
  'vendor.index.search.input.name': '名称',
  'vendor.index.search.input.name.placeholder': '请输入',
  'vendor.index.search.input.state': '状态',
  'vendor.index.search.input.state.placeholder': '请选择',
  'vendor.index.table.button.new': '新建',
  'vendor.index.table.column.code': '代码',
  'vendor.index.table.column.contactPhone': '联系人电话',
  'vendor.index.table.column.contactor': '联系人',
  'vendor.index.table.column.name': '名称',
  'vendor.index.table.column.operate': '操作',
  'vendor.index.table.column.state': '状态',
  'vendor.index.table.content.disable': '已禁用',
  'vendor.index.table.content.enable': '已启用',
  'vendor.index.table.operate.edit': '编辑',
  'vendor.index.table.operate.view': '查看',
  'vendor.info': '供应商信息',
  'vendor.message.success.disable': '禁用供应商成功',
  'vendor.message.success.enable': '启用供应商成功',
  'vendor.name': '名称',
  'vendor.note': '备注',
  'vendor.operate.info': '操作日志',
  'vendor.operatorRecordCode': '经营者备案码',
  'vendor.owner': '货主',
  'vendor.ownerUuid': '货主uuid',
  'vendor.shortName': '简称',
  'vendor.sourceCode': '来源代码',
  'vendor.state': '状态',
  'vendor.title': '供应商',
  'vendor.update.title': '修改供应商',
  'vendor.zipCode': '邮编',
  'vendorDispatch.containerCount': '托盘数',
  'vendorDispatch.containerInfo': '容器信息',
  'vendorDispatch.genPickupBill': '生成拣货单',
  'vendorDispatch.genSuccess': '生成拣货单成功',
  'vendorDispatch.method': '操作方式',
  'vendorDispatch.shelveInfo': '已下架信息',
  'vendorDispatch.stockInfo': '库存信息',
  'vendorDispatch.title': '供应商退货看板',
  'vendorDispatch.unShelveInfo': '待下架信息',
  'vendorDispatch.vendorCode': '供应商代码',
  'vendorDispatch.vendorName': '供应商名称',
  'vendorHandover.IPopconfirmAuditTitle': '是否确认审核供应商交接单',
  'vendorHandover.IPopconfirmDeleteTitle': '是否删除供应商交接单',
  'vendorHandover.beginHandoverTime': '开始交接时间',
  'vendorHandover.containerCount': '托盘数',
  'vendorHandover.containerInfo': '容器信息',
  'vendorHandover.endHandoverTime': '结束交接时间',
  'vendorHandover.genPickupBill': '生成拣货单',
  'vendorHandover.genSuccess': '生成拣货单成功',
  'vendorHandover.handover': '交接员',
  'vendorHandover.handoverTime': '交接时间',
  'vendorHandover.method': '操作方式',
  'vendorHandover.outBillNumber': '通知单',
  'vendorHandover.stockInfo': '库存信息',
  'vendorHandover.title': '供应商交接单',
  'vendorRtnNtc.IPopconfirmAbortTitle': '是否作废通知单',
  'vendorRtnNtc.IPopconfirmApproveTitle': '是否审核通知单',
  'vendorRtnNtc.IPopconfirmConfirmTitle': '是否确认通知单',
  'vendorRtnNtc.IPopconfirmCopyTitle': '是否复制通知单',
  'vendorRtnNtc.IPopconfirmDeleteTitle': '是否删除通知单',
  'vendorRtnNtc.IPopconfirmFinishTitle': '是否确认完成通知单',
  'vendorRtnNtc.IPopconfirmRollbackTitle': '是否回滚通知单',
  'vendorRtnNtc.amount': '总金额',
  'vendorRtnNtc.articleCount': '总品项数',
  'vendorRtnNtc.confirm': '确认',
  'vendorRtnNtc.confirmSuccess': '确认成功',
  'vendorRtnNtc.copy': '复制',
  'vendorRtnNtc.copySuccess': '复制成功',
  'vendorRtnNtc.createTime': '创建时间',
  'vendorRtnNtc.endHandoverTime': '结束交接时间',
  'vendorRtnNtc.endPickTime': '结束拣货时间',
  'vendorRtnNtc.expireDate': '到效期',
  'vendorRtnNtc.generate': '生成拣货单',
  'vendorRtnNtc.generateSuccess': '生成成功',
  'vendorRtnNtc.handoverAmount': '交接金额',
  'vendorRtnNtc.handoverArticleCount': '交接品项数',
  'vendorRtnNtc.handoverQty': '交接数量',
  'vendorRtnNtc.handoverQtyStr': '交接件数',
  'vendorRtnNtc.handoverVolume': '交接体积',
  'vendorRtnNtc.handoverWeight': '交接重量',
  'vendorRtnNtc.method': '操作方式',
  'vendorRtnNtc.pickAmount': '拣货金额',
  'vendorRtnNtc.pickArticleCount': '拣货品项数',
  'vendorRtnNtc.pickQty': '拣货数量',
  'vendorRtnNtc.pickQtyStr': '拣货件数',
  'vendorRtnNtc.pickVolume': '拣货体积',
  'vendorRtnNtc.pickWeight': '拣货重量',
  'vendorRtnNtc.planAmount': '计划金额',
  'vendorRtnNtc.planArticleCount': '计划品项数',
  'vendorRtnNtc.planQtyStr': '计划件数',
  'vendorRtnNtc.planVolume': '计划体积',
  'vendorRtnNtc.planWeight': '计划重量',
  'vendorRtnNtc.qtyStr': '总件数',
  'vendorRtnNtc.rollback': '回滚',
  'vendorRtnNtc.rollbackSuccess': '回滚成功',
  'vendorRtnNtc.rtnDate': '退货日期',
  'vendorRtnNtc.sourceBillNumber': '来源单号',
  'vendorRtnNtc.startHandoverTime': '开始交接时间',
  'vendorRtnNtc.startPickTime': '开始拣货时间',
  'vendorRtnNtc.title': '供应商退货通知单',
  'vendorRtnNtc.type': '退货类型',
  'vendorRtnNtc.uploadTime': '上传时间',
  'vendorRtnNtc.vendorPickUpBill': '供应商拣货单',
  'vendorRtnNtc.volume': '总体积',
  'vendorRtnNtc.weight': '总重量',
  'vendorRtnPick.IPopconfirmAuditTitle': '是否确认审核供应商拣货单',
  'vendorRtnPick.batchAddBinCode': '批量添加货位',
  'vendorRtnPick.batchAddContainer': '批量添加容器',
  'vendorRtnPick.batchAlterMethod': '修改操作方式',
  'vendorRtnPick.batchAlterPicker': '修改拣货员',
  'vendorRtnPick.batchWholeAudit': '整托审核',
  'vendorRtnPick.beginPickTime': '开始拣货时间',
  'vendorRtnPick.binCode': '来源货位',
  'vendorRtnPick.containerBarcode': '来源容器',
  'vendorRtnPick.content': '是否确认修改供应商拣货单的操作方式',
  'vendorRtnPick.endPickTime': '结束拣货时间',
  'vendorRtnPick.method': '操作方式',
  'vendorRtnPick.ntcBillNumber': '供应商退货通知单单号',
  'vendorRtnPick.ntcBillNumberAndSource': '通知单号',
  'vendorRtnPick.pickTime': '拣货时间',
  'vendorRtnPick.picker': '拣货员',
  'vendorRtnPick.qtyStr': '应拣件数',
  'vendorRtnPick.realQty': '实拣数量',
  'vendorRtnPick.realQtyStr': '实拣件数',
  'vendorRtnPick.sourceBillNumber': '来源单号',
  'vendorRtnPick.title': '供应商拣货单',
  'vendorRtnPick.toBinCode': '目标货位',
  'vendorRtnPick.toContainerBarcode': '目标容器',
  'vendorRtnPick.type': '拣货类型',
  'vendorRtnPick.uploadTime': '上传时间',
  'vendorRtnPick.vendorInntcBillNumber': '单号',
  'vendorRtnPick.vendorInntcSourceBillNumber': '来源单号',
  'version.account': '账号组件',
  'version.basic': '基本资料组件',
  'version.facility': '业务流程组件',
  'version.openapi': '接口组件',
  'version.rf': 'RF客户端',
  'version.title': '版本信息',
  'wave.addAlcNtc': '加单',
  'wave.alcBillNumber': '配单单号',
  'wave.alcNtcBillAmount': '配单数',
  'wave.alcNtcBillNumber': '配货通知单单号',
  'wave.alcNtcTab': '配货单',
  'wave.all': '全部',
  'wave.collectBin': '集货位',
  'wave.collectBinMgrScheme': '集货管理方案',
  'wave.confirm.clear': '修改{item}会导致明细清空，请确认修改？',
  'wave.confirmButton': '确认',
  'wave.confirmTime': '确认时间',
  'wave.createdTime': '创建时间',
  'wave.deliverycycle': '配送周期',
  'wave.endPickTime': '结束拣货时间',
  'wave.endRplTime': '结束补货时间',
  'wave.fillRate': '满足率（%）',
  'wave.finishOrder': '是否完成订单',
  'wave.lineNum': '拣货行数',
  'wave.message': '详情',
  'wave.operateMethod': '拣货方式',
  'wave.pickOrder': '拣货顺序',
  'wave.pickOrderBillNUmber': '拣货单号',
  'wave.pickOrderScheme': '拣货顺序方案',
  'wave.pickTask': '指令池',
  'wave.pickTaskNumber': '指令号',
  'wave.pickUpTab': '拣货单',
  'wave.pickarea': '拣货分区',
  'wave.pickupBillNum': '拣货单数',
  'wave.pickupTotalAmount': '应拣金额',
  'wave.pickupTotalQtyStr': '应拣件数',
  'wave.planQty': '计划配货数量',
  'wave.qty': '要货数量',
  'wave.rollBack': '回滚',
  'wave.rplBillNumber': '补货单号',
  'wave.rplMode': '补货方式',
  'wave.rplRealTotalAmount': '实补金额',
  'wave.rplRealTotalQtyStr': '实补件数',
  'wave.rplTab': '补货单',
  'wave.rplTotalQtyStr': '应补件数',
  'wave.schedule': '执行进度',
  'wave.selectStoreGroup': '请选择门店组',
  'wave.showDifferentButton': '查看差异',
  'wave.start': '启动',
  'wave.startCompleteTime': '启动完成时间',
  'wave.startPickTime': '开始拣货时间',
  'wave.startRplTime': '开始补货时间',
  'wave.startTime': '启动时间',
  'wave.stockAllocateScheme': '库存分配方案',
  'wave.stockAllocateType': '库存分配类型',
  'wave.stockOrder': '库存分配顺序',
  'wave.stockQty': '库存可用数量',
  'wave.store': '门店',
  'wave.storeAmount': '门店数',
  'wave.title': '波次单',
  'wave.totalAmount': '要货金额',
  'wave.totalPlanAmount': '应拣金额',
  'wave.totalPlanQtyStr': '应拣件数',
  'wave.totalQtyStr': '要货件数',
  'wave.totalRealAmount': '实拣金额',
  'wave.totalRealQtyStr': '实拣件数',
  'wave.totalShipAmount': '装车金额',
  'wave.totalShipQtyStr': '装车件数',
  'wave.type': '波次原因',
  'wave.waveConfirm': '波次确认',
  'wave.waveNumber': '波次',
  'wave.waveType': '管理波次原因',
  'wave.waveWeeks': '周时间',
  'web单据审核': 'web单据审核',
  'web打印机': 'web打印机',
  'wms下发': 'wms下发',
  'wrh.create.basic': '基本信息',
  'wrh.create.button.cancel': '取消',
  'wrh.create.button.confirm': '确认',
  'wrh.create.button.confirmCreate': '确认并新建',
  'wrh.create.form.item.code.name': '代码',
  'wrh.create.form.item.code.validate.message.integrality': '代码必须是数字、字母、二者组合，长度最大为30位',
  'wrh.create.form.item.code.validate.message.notNull': '代码不能为空',
  'wrh.create.form.item.dc.name': '配送中心',
  'wrh.create.form.item.dc.validate.message.notNull': '配送中心不能为空',
  'wrh.create.form.item.input.placeholder.code': '请输入代码',
  'wrh.create.form.item.input.placeholder.name': '请输入名称',
  'wrh.create.form.item.input.placeholder.note': '请输入备注',
  'wrh.create.form.item.name.name': '名称',
  'wrh.create.form.item.name.validate.message.limitLength': '名称最大长度30',
  'wrh.create.form.item.name.validate.message.notNull': '名称不能为空',
  'wrh.create.form.item.note.name': '备注',
  'wrh.create.form.item.note.validate.message.limitLength': '备注最大长度255',
  'wrh.create.form.item.option.placeholder': '请选择',
  'wrh.create.form.item.placeholder': '请输入',
  'wrh.create.form.item.sourceWrhCode.name': '上游仓位代码',
  'wrh.create.form.item.sourceWrhCode.validate.message.limitLength': '上游仓位代码最大长度10',
  'wrh.create.title': '新建仓位',
  'wrh.detail.basic': '基本信息',
  'wrh.detail.basic.code': '代码',
  'wrh.detail.basic.dc': '配送中心',
  'wrh.detail.basic.name': '名称',
  'wrh.detail.basic.note': '备注',
  'wrh.detail.basic.sourceWrhCode': '上游仓位代码',
  'wrh.detail.button.back': '返回',
  'wrh.detail.button.cancel': '取消',
  'wrh.detail.button.confirm': '确定',
  'wrh.detail.label.edit': '编辑',
  'wrh.detail.tab.operateInfo': '操作日志',
  'wrh.detail.tab.wrhInfo': '仓位信息',
  'wrh.edit.title': '修改仓位',
  'wrh.index.message.success.operate': '操作成功',
  'wrh.index.search.button.reset': '重置',
  'wrh.index.search.button.search': '查询',
  'wrh.index.search.content.disable': '已禁用',
  'wrh.index.search.content.enable': '已启用',
  'wrh.index.search.input.codeName': '仓位代码/名称',
  'wrh.index.search.input.codeName.placeholder': '请输入关键词查询',
  'wrh.index.search.input.state': '状态',
  'wrh.index.search.input.state.placeholder': '全部',
  'wrh.index.table.button.new': '新建',
  'wrh.index.table.column.code': '代码',
  'wrh.index.table.column.dc': '配送中心',
  'wrh.index.table.column.name': '名称',
  'wrh.index.table.column.operate': '操作',
  'wrh.index.table.column.sourceWrhCode': '上游仓位代码',
  'wrh.index.table.column.sourceWrhName': '上游仓位名称',
  'wrh.index.table.column.state': '状态',
  'wrh.index.table.content.disable': '已禁用',
  'wrh.index.table.content.enable': '已启用',
  'wrh.index.table.operate.edit': '编辑',
  'wrh.index.table.operate.view': '查看',
  'wrh.message.error.create': '新建仓位失败',
  'wrh.message.error.disbale': '禁用仓位失败',
  'wrh.message.error.enbale': '启用仓位失败',
  'wrh.message.error.update': '修改仓位失败',
  'wrh.message.success.create': '新建仓位成功',
  'wrh.message.success.disable': '禁用仓位成功',
  'wrh.message.success.enable': '启用仓位成功',
  'wrh.message.success.enbale': '启用仓位成功',
  'wrh.message.success.update': '修改仓位成功',
  'wrh.title': '仓位',
  'wrh.update.title': '编辑仓位',
  '{action}完成': '{action}完成',
  '{barcode}为自动生成的条码不允许删除': '{barcode}为自动生成的条码不允许删除',
  '{caption}模块{caption}所在行不能为空': '{caption}模块{caption}所在行不能为空',
  '{caption}模块所在行不能为空': '{caption}模块所在行不能为空',
  '{caption}第{line}行与第{otherLine}盘点员不一致': '{caption}第{line}行与第{otherLine}盘点员不一致',
  '{caption}第{line}行与第{otherLine}行容器相同，货位不同！': '{caption}第{line}行与第{otherLine}行容器相同，货位不同！',
  '{caption}第{line}行与第{otherLine}行重复！': '{caption}第{line}行与第{otherLine}行重复！',
  '{caption}第{line}行商品不能为空！': '{caption}第{line}行商品不能为空！',
  '{caption}第{line}行容器条码不能为空！': '{caption}第{line}行容器条码不能为空！',
  '{caption}第{line}行生产日期不能为空！': '{caption}第{line}行生产日期不能为空！',
  '{caption}第{line}行生产日期不能晚于当前日期！': '{caption}第{line}行生产日期不能晚于当前日期！',
  '{caption}第{line}行盘点员不能为空！': '{caption}第{line}行盘点员不能为空！',
  '{caption}第{line}行货位代码不能为空！': '{caption}第{line}行货位代码不能为空！',
  '{caption}第{line}行商品未维护业务信息（结算单位）！': '{caption}第{line}行商品未维护业务信息（结算单位）！',
  '{id}行道口重复': '{id}行道口重复',
  '{line}行件数不能小于0！': '{line}行件数不能小于0！',
  '{line}行实盘数量不能为0！': '{line}行实盘数量不能为0！',
  '{line}行数量不能小于0！': '{line}行数量不能小于0！',
  '{line}行数量不能等于0！': '{line}行数量不能等于0！',
  '{line}行数量和件数不能同时等于0！': '{line}行数量和件数不能同时等于0！',
  '{line}行目标货位不能为空！': '{line}行目标货位不能为空！',
  '{line}行退仓数量不能为0！': '{line}行退仓数量不能为0！',
  '{name}-选择释放时机': '{name}-选择释放时机',
  '{name}大小超过5M,无法上传': '{name}大小超过5M,无法上传',
  '{name}文件上传失败': '{name}文件上传失败',
  '{name}文件上传成功': '{name}文件上传成功',
  '{name}格式不正确,请检查后上传': '{name}格式不正确,请检查后上传',
  '{title}{logisticMode}容器类型不能为空': '{title}{logisticMode}容器类型不能为空',
  '{title}{logisticMode}打印模板不能为空': '{title}{logisticMode}打印模板不能为空',
  '{title}物流模式不能为空': '{title}物流模式不能为空',
  '{type}不能大于保质期天数': '{type}不能大于保质期天数',
  '|\n\t\t\t\t总实盘件数：': '|\n\t\t\t\t总实盘件数：',
  '|\n\t\t\t\t总实盘数量：': '|\n\t\t\t\t总实盘数量：',
  '一件一容器': '一件一容器',
  '一件一标签': '一件一标签',
  '一单一容器': '一单一容器',
  '一品一容器': '一品一容器',
  '一品一标签': '一品一标签',
  '一次性': '一次性',
  '一次性补货': '一次性补货',
  '一步二步补货': '一步二步补货',
  '一步补货': '一步补货',
  '一步补货来源货位': '一步补货来源货位',
  '一步补货补货单将修改为二步补货，二步补货补货单将修改为一步补货': '一步补货补货单将修改为二步补货，二步补货补货单将修改为一步补货',
  '一步越库': '一步越库',
  '一步越库分播管理方案配置': '一步越库分播管理方案配置',
  '一步越库容器类型': '一步越库容器类型',
  '一步越库打印模板': '一步越库打印模板',
  '一步越库收货': '一步越库收货',
  '一步越库收货后去向': '一步越库收货后去向',
  '一步越库收货实收显示': '一步越库收货实收显示',
  '一步越库收货暂存位': '一步越库收货暂存位',
  '一步越库收货暂存位范围': '一步越库收货暂存位范围',
  '一步越库自动获取容器': '一步越库自动获取容器',
  '一键复核': '一键复核',
  '一键装车配置': '一键装车配置',
  '三项不能同时为空！': '三项不能同时为空！',
  '上一单': '上一单',
  '上一步': '上一步',
  '上传供应商': '上传供应商',
  '上传供应商退货交接单': '上传供应商退货交接单',
  '上传供应商退货通知单': '上传供应商退货通知单',
  '上传加工单': '上传加工单',
  '上传商品': '上传商品',
  '上传商品类别': '上传商品类别',
  '上传商品装盘建议': '上传商品装盘建议',
  '上传库存锁定解锁单': '上传库存锁定解锁单',
  '上传成功': '上传成功',
  '上传承运商': '上传承运商',
  '上传损耗单': '上传损耗单',
  '上传收货单': '上传收货单',
  '上传时间': '上传时间',
  '上传溢余单': '上传溢余单',
  '上传用户': '上传用户',
  '上传移库单': '上传移库单',
  '上传自动差错配货差异单': '上传自动差错配货差异单',
  '上传许可证': '上传许可证',
  '上传车辆': '上传车辆',
  '上传退仓单': '上传退仓单',
  '上传配货差异单': '上传配货差异单',
  '上传门店': '上传门店',
  '上传门店交接单': '上传门店交接单',
  '上传附件': '上传附件',
  '上传附件不能为空': '上传附件不能为空',
  '上分拣机': '上分拣机',
  '上架': '上架',
  '上架中': '上架中',
  '上架中转位': '上架中转位',
  '上架中转位配置': '上架中转位配置',
  '上架允许修改目标货位': '上架允许修改目标货位',
  '上架入': '上架入',
  '上架展示库存货位': '上架展示库存货位',
  '上海海鼎信息工程股份有限公司 版权所有': '上海海鼎信息工程股份有限公司 版权所有',
  '上移': '上移',
  '上限': '上限',
  '下一个门店组': '下一个门店组',
  '下一单': '下一单',
  '下一单门店': '下一单门店',
  '下单时间': '下单时间',
  '下发明细': '下发明细',
  '下架员': '下架员',
  '下载': '下载',
  '下载安装': '下载安装',
  '下载模板': '下载模板',
  '下限': '下限',
  '不上传商品类别配置': '不上传商品类别配置',
  '不上传商品配置': '不上传商品配置',
  '不允许为空': '不允许为空',
  '不勾选默认是商品拆并，勾选是整箱拆并': '不勾选默认是商品拆并，勾选是整箱拆并',
  '不合格': '不合格',
  '不合格数量': '不合格数量',
  '不启用': '不启用',
  '不存在上一单': '不存在上一单',
  '不存在下一单': '不存在下一单',
  '不得输入空格': '不得输入空格',
  '不控制': '不控制',
  '不校验': '不校验',
  '不管理': '不管理',
  '不管理保质期': '不管理保质期',
  '不维护': '不维护',
  '不能替换为当前商品': '不能替换为当前商品',
  '不能替换为自己': '不能替换为自己',
  '不选择商品时，货位类型和货位范围不可同时为空': '不选择商品时，货位类型和货位范围不可同时为空',
  '不采集': '不采集',
  '不限制': '不限制',
  '不允许': '不允许',
  '业务信息': '业务信息',
  '业务功能': '业务功能',
  '业务单据使用货位用途配置': '业务单据使用货位用途配置',
  '业务单据操作限制配置': '业务单据操作限制配置',
  '业务模块': '业务模块',
  '业务生成': '业务生成',
  '业务类型': '业务类型',
  '业务集货方案配置': '业务集货方案配置',
  '严格控制': '严格控制',
  '严格管理': '严格管理',
  '严格限制': '严格限制',
  '个': '个',
  '个人中心': '个人中心',
  '个商品': '个商品',
  '个选项': '个选项',
  '个选项?': '个选项?',
  '个选项，\n               失败': '个选项，\n               失败',
  '个选项，\n               跳过': '个选项，\n               跳过',
  '个选项，\n        失败': '个选项，\n        失败',
  '个选项，\n        跳过': '个选项，\n        跳过',
  '中国': '中国',
  '中断': '中断',
  '中间表': '中间表',
  '中间表名': '中间表名',
  '中间表字段名': '中间表字段名',
  '临时车辆': '临时车辆',
  '主体码': '主体码',
  '主动': '主动',
  '主动上架': '主动上架',
  '主机': '主机',
  '买单单价': '买单单价',
  '买单金额': '买单金额',
  '事件': '事件',
  '二步类越库容器类型': '二步类越库容器类型',
  '二步补货': '二步补货',
  '二步补货上限': '二步补货上限',
  '二步越库': '二步越库',
  '二步越库分播管理方案配置': '二步越库分播管理方案配置',
  '二步越库打印模板': '二步越库打印模板',
  '二步越库收货暂存、分播中转位': '二步越库收货暂存、分播中转位',
  '二步越库收货暂存位': '二步越库收货暂存位',
  '二步越库自动获取容器': '二步越库自动获取容器',
  '二步越库配单是否按订单全部添加': '二步越库配单是否按订单全部添加',
  '二步越库配单是否按订单全部添加配置': '二步越库配单是否按订单全部添加配置',
  '交接中': '交接中',
  '交接信息': '交接信息',
  '交接单': '交接单',
  '交接员': '交接员',
  '交接明细': '交接明细',
  '交接状态': '交接状态',
  '交接类型': '交接类型',
  '交接项': '交接项',
  '产品商标': '产品商标',
  '产品批次': '产品批次',
  '产地': '产地',
  '人员': '人员',
  '人员信息': '人员信息',
  '人员类型': '人员类型',
  '仅提示': '仅提示',
  '仅质检': '仅质检',
  '仅配置': '仅配置',
  '仓位': '仓位',
  '仓位:{wrh}未配置虚拟货位': '仓位:{wrh}未配置虚拟货位',
  '仓位下没有退仓收货暂存位，无法退仓': '仓位下没有退仓收货暂存位，无法退仓',
  '仓位不能为空。': '仓位不能为空。',
  '仓位为空时只允许配置一条明细': '仓位为空时只允许配置一条明细',
  '仓位代码': '仓位代码',
  '仓位名称': '仓位名称',
  '仓位和货主不能空。': '仓位和货主不能空。',
  '仓位：{wrh}已有配置项': '仓位：{wrh}已有配置项',
  '仓库看板': '仓库看板',
  '代码': '代码',
  '代码/名称': '代码/名称',
  '代码/名称,多个代码以逗号隔开': '代码/名称,多个代码以逗号隔开',
  '代码/车牌': '代码/车牌',
  '代码不能为空': '代码不能为空',
  '代码只能是四位数字': '代码只能是四位数字',
  '代码必须是4位字母、数字、二者组合': '代码必须是4位字母、数字、二者组合',
  '代码必须是4位数字': '代码必须是4位数字',
  '代码必须是4位数字、字母或者二者组合': '代码必须是4位数字、字母或者二者组合',
  '代码必须是数字、字母、二者组合，长度最大为30位': '代码必须是数字、字母、二者组合，长度最大为30位',
  '以下': '以下',
  '以复查结果装车': '以复查结果装车',
  '以容器计算配置': '以容器计算配置',
  '以整箱计算配置': '以整箱计算配置',
  '以整箱计算配置，容器类型“[-]-”必选': '以整箱计算配置，容器类型“[-]-”必选',
  '件': '件',
  '件/重': '件/重',
  '件数': '件数',
  '件数/净重': '件数/净重',
  '件数/重量': '件数/重量',
  '件数为0': '件数为0',
  '件数信息': '件数信息',
  '件数信息第{line}行件数必须大于0！': '件数信息第{line}行件数必须大于0！',
  '件数信息第{line}行码头集不能为空！': '件数信息第{line}行码头集不能为空！',
  '件数信息第{line}行装车项不能为空！': '件数信息第{line}行装车项不能为空！',
  '件数信息第{line}行门店不能为空！': '件数信息第{line}行门店不能为空！',
  '件数复查': '件数复查',
  '件数小于0': '件数小于0',
  '件数选择应拣数量，目标货位必填！': '件数选择应拣数量，目标货位必填！',
  '价格': '价格',
  '任务号': '任务号',
  '任务量': '任务量',
  '任意': '任意',
  '企业': '企业',
  '企业代码': '企业代码',
  '企业代码不能为空': '企业代码不能为空',
  '企业名称': '企业名称',
  '企业权限信息': '企业权限信息',
  '企业组织': '企业组织',
  '优先拣货位': '优先拣货位',
  '优先级': '优先级',
  '优先级调整': '优先级调整',
  '传输方向': '传输方向',
  '传输时间': '传输时间',
  '体积(cm³)': '体积(cm³)',
  '体积(m³)': '体积(m³)',
  '体积不能为空': '体积不能为空',
  '体积取值来源': '体积取值来源',
  '体积大于等于': '体积大于等于',
  '体积小于等于': '体积小于等于',
  '体积模式配置': '体积模式配置',
  '体积范围': '体积范围',
  '体积范围(m³)': '体积范围(m³)',
  '品项数范围': '品项数范围',
  '最大值': '最大值',
  '最小值': '最小值',
  '最大值不能为空': '最大值不能为空',
  '作业模式': '作业模式',
  '作业点': '作业点',
  '作业点代码': '作业点代码',
  '作业点号': '作业点号',
  '作业点名称': '作业点名称',
  '作业点顺序': '作业点顺序',
  '作业类型': '作业类型',
  '作业面板配置': '作业面板配置',
  '作废': '作废',
  '作废{length}个选项': '作废{length}个选项',
  '作废供应商退货通知单': '作废供应商退货通知单',
  '作废成功': '作废成功',
  '作废订单': '作废订单',
  '作废退仓通知单': '作废退仓通知单',
  '作废配货通知单': '作废配货通知单',
  '使用中': '使用中',
  '使用本地打印机': '使用本地打印机',
  '使用率': '使用率',
  '使用货位': '使用货位',
  '供应商': '供应商',
  '供应商:{vendors},不在退仓调拨配置范围内，请添加配置': '供应商:{vendors},不在退仓调拨配置范围内，请添加配置',
  '供应商交接单': '供应商交接单',
  '供应商交接单日结': '供应商交接单日结',
  '供应商交接单明细不能为空': '供应商交接单明细不能为空',
  '供应商代码': '供应商代码',
  '供应商作条件': '供应商作条件',
  '供应商创建': '供应商创建',
  '供应商名称': '供应商名称',
  '供应商寄售管理': '供应商寄售管理',
  '供应商拣货单': '供应商拣货单',
  '供应商拣货单默认操作方式配置': '供应商拣货单默认操作方式配置',
  '供应商权限信息': '供应商权限信息',
  '供应商独占': '供应商独占',
  '供应商独占退货位': '供应商独占退货位',
  '供应商组织': '供应商组织',
  '供应商调整': '供应商调整',
  '供应商退货': '供应商退货',
  '供应商退货位': '供应商退货位',
  '供应商退货位容器管理': '供应商退货位容器管理',
  '供应商退货位容器管理 保存成功': '供应商退货位容器管理 保存成功',
  '供应商退货位配置': '供应商退货位配置',
  '供应商退货单分单退货类型配置': '供应商退货单分单退货类型配置',
  '供应商退货拣货暂存位': '供应商退货拣货暂存位',
  '供应商退货控制天数': '供应商退货控制天数',
  '供应商退货是否限制供应商': '供应商退货是否限制供应商',
  '供应商退货是否需要交接': '供应商退货是否需要交接',
  '供应商退货是否需要交接配置': '供应商退货是否需要交接配置',
  '供应商退货通知单': '供应商退货通知单',
  '供应商退货通知单交接日结': '供应商退货通知单交接日结',
  '供应商退货通知单单号/来源单号': '供应商退货通知单单号/来源单号',
  '供应商退货通知单回传时机配置': '供应商退货通知单回传时机配置',
  '供应商退货通知单过期日结': '供应商退货通知单过期日结',
  '供应商退货限制配置': '供应商退货限制配置',
  '供应商退货集货位': '供应商退货集货位',
  '供应商退货集货暂存位': '供应商退货集货暂存位',
  '供应商集货位': '供应商集货位',
  '供应商集货位配置': '供应商集货位配置',
  '供应商：': '供应商：',
  '供应商：{code} 为默认供应商,不允许删除': '供应商：{code} 为默认供应商,不允许删除',
  '供应商：{code} 已存在': '供应商：{code} 已存在',
  '供应商：{code}不允许主动退货': '供应商：{code}不允许主动退货',
  '供应商：{code}不允许生成拣货单': '供应商：{code}不允许生成拣货单',
  '依次分配': '依次分配',
  '依次满足': '依次满足',
  '保存': '保存',
  '保存/修改': '保存/修改',
  '保存上传附件成功': '保存上传附件成功',
  '保存并审核成功': '保存并审核成功',
  '保存成功': '保存成功',
  '保存更正': '保存更正',
  '保底拣货位': '保底拣货位',
  '保底比例分配': '保底比例分配',
  '保质期': '保质期',
  '保质期天数不能小于供应商退货控制天数': '保质期天数不能小于供应商退货控制天数',
  '保质期天数不能小于收货控制天数': '保质期天数不能小于收货控制天数',
  '保质期天数不能小于返厂控制天数': '保质期天数不能小于返厂控制天数',
  '保质期天数不能小于退货控制天数': '保质期天数不能小于退货控制天数',
  '保质期天数不能小于配货控制天数': '保质期天数不能小于配货控制天数',
  '保质期类型': '保质期类型',
  '信息': '信息',
  '信息填写': '信息填写',
  '信息未补全': '信息未补全',
  '修改': '修改',
  '修改交接单会清除明细信息，是否确认修改？': '修改交接单会清除明细信息，是否确认修改？',
  '修改仓位会导致商品信息清空，请确认修改？': '修改仓位会导致商品信息清空，请确认修改？',
  '修改仓位会导致明细清空，请确认修改？': '修改仓位会导致明细清空，请确认修改？',
  '修改仓位会清空明细信息，请确认修改？': '修改仓位会清空明细信息，请确认修改？',
  '修改仓位会清空明细，请确认修改？': '修改仓位会清空明细，请确认修改？',
  '修改仓位会清除明细信息，是否确认修改？': '修改仓位会清除明细信息，是否确认修改？',
  '修改仓位将导致明细清空,确定修改？': '修改仓位将导致明细清空,确定修改？',
  '修改供应商会导致商品信息清空，请确认修改？': '修改供应商会导致商品信息清空，请确认修改？',
  '修改供应商会导致明细清空，请确认修改？': '修改供应商会导致明细清空，请确认修改？',
  '修改供应商会清空明细信息，请确认修改？': '修改供应商会清空明细信息，请确认修改？',
  '修改供应商会清空明细，请确认修改？': '修改供应商会清空明细，请确认修改？',
  '修改修正类型会导致明细清空，请确认修改？': '修改修正类型会导致明细清空，请确认修改？',
  '修改分播方式': '修改分播方式',
  '修改单号': '修改单号',
  '修改单号会导致商品信息清空，请确认修改？': '修改单号会导致商品信息清空，请确认修改？',
  '修改单据类型会导致明细清空，请确认修改？': '修改单据类型会导致明细清空，请确认修改？',
  '修改可用库存失败': '修改可用库存失败',
  '修改可用库存成功': '修改可用库存成功',
  '修改可用条码解析规则失败': '修改可用条码解析规则失败',
  '修改可用条码解析规则成功': '修改可用条码解析规则成功',
  '修改商品规格': '修改商品规格',
  '修改容器条码': '修改容器条码',
  '修改密码': '修改密码',
  '修改快递单号': '修改快递单号',
  '修改感官质检单会导致明细改变，请确认修改？': '修改感官质检单会导致明细改变，请确认修改？',
  '修改成功': '修改成功',
  '修改承运商': '修改承运商',
  '修改承运商会导致明细清空，确认修改？': '修改承运商会导致明细清空，确认修改？',
  '修改拣货员': '修改拣货员',
  '修改拣货员{length}个选项': '修改拣货员{length}个选项',
  '修改拣货方式{length}个选项': '修改拣货方式{length}个选项',
  '修改拣货类型': '修改拣货类型',
  '修改拣货类型{length}个选项': '修改拣货类型{length}个选项',
  '修改控制器': '修改控制器',
  '修改提总方式': '修改提总方式',
  '修改操作方式': '修改操作方式',
  '修改操作方式{length}个选项': '修改操作方式{length}个选项',
  '修改日志级别': '修改日志级别',
  '修改来源仓位会导致明细清空，请确认修改？': '修改来源仓位会导致明细清空，请确认修改？',
  '修改标签': '修改标签',
  '修改波次单将会导致明细清空，确认修改？': '修改波次单将会导致明细清空，确认修改？',
  '修改波次类型会导致明细改变，请确认修改？': '修改波次类型会导致明细改变，请确认修改？',
  '修改物流模式会导致商品信息清空，请确认修改？': '修改物流模式会导致商品信息清空，请确认修改？',
  '修改物流模式会导致订单或者明细清空，请确认修改？': '修改物流模式会导致订单或者明细清空，请确认修改？',
  '修改状态': '修改状态',
  '修改状态成功': '修改状态成功',
  '修改盘点员': '修改盘点员',
  '修改盘点方式': '修改盘点方式',
  '修改盘点模式': '修改盘点模式',
  '修改目标仓位会导致明细清空，请确认修改？': '修改目标仓位会导致明细清空，请确认修改？',
  '修改类型会导致相关明细清空，请确认修改？': '修改类型会导致相关明细清空，请确认修改？',
  '修改类型会清空其他信息，请确认修改？': '修改类型会清空其他信息，请确认修改？',
  '修改线路体系会导致明细清空，请确认修改？': '修改线路体系会导致明细清空，请确认修改？',
  '修改网关服务': '修改网关服务',
  '修改补货方式': '修改补货方式',
  '修改补货方式{length}个选项': '修改补货方式{length}个选项',
  '修改补货步骤': '修改补货步骤',
  '修改补货步骤{length}个选项': '修改补货步骤{length}个选项',
  '修改角色': '修改角色',
  '修改订单会导致仓位及明细改变，请确认修改？': '修改订单会导致仓位及明细改变，请确认修改？',
  '修改订单会导致明细改变，请确认修改？': '修改订单会导致明细改变，请确认修改？',
  '修改调整类型会导致明细清空，请确认修改？': '修改调整类型会导致明细清空，请确认修改？',
  '修改货主会导致商品信息清空，请确认修改？': '修改货主会导致商品信息清空，请确认修改？',
  '修改货主会导致库存信息清空，请确认修改？': '修改货主会导致库存信息清空，请确认修改？',
  '修改货主会导致明细清空，请确认修改？': '修改货主会导致明细清空，请确认修改？',
  '修改货主会导致相关明细清空，请确认修改？': '修改货主会导致相关明细清空，请确认修改？',
  '修改货主会导致订单或明细清空，请确认修改？': '修改货主会导致订单或明细清空，请确认修改？',
  '修改货主会清空其他信息，请确认修改？': '修改货主会清空其他信息，请确认修改？',
  '修改货主会清除门店和明细信息，是否确认修改？': '修改货主会清除门店和明细信息，是否确认修改？',
  '修改货位用途': '修改货位用途',
  '修改货位类型': '修改货位类型',
  '修改货区': '修改货区',
  '修改超控制天数出库配置失败': '修改超控制天数出库配置失败',
  '修改超控制天数出库配置成功': '修改超控制天数出库配置成功',
  '修改退仓类型': '修改退仓类型',
  '修改通知单会导致明细改变，请确认修改？': '修改通知单会导致明细改变，请确认修改？',
  '修改配送中心会导致仓位及商品信息清空，请确认修改？': '修改配送中心会导致仓位及商品信息清空，请确认修改？',
  '修改配送中心会导致明细清空，请确认修改？': '修改配送中心会导致明细清空，请确认修改？',
  '修改配送中心会导致订单类型、仓位及商品信息清空，请确认修改？': '修改配送中心会导致订单类型、仓位及商品信息清空，请确认修改？',
  '修改配送中心会导致配货类型、仓位及商品信息清空，请确认修改？': '修改配送中心会导致配货类型、仓位及商品信息清空，请确认修改？',
  '修改门店会清除明细信息，是否确认修改？': '修改门店会清除明细信息，是否确认修改？',
  '修改门店组': '修改门店组',
  '修改领用单会导致明细清空，请确认修改？': '修改领用单会导致明细清空，请确认修改？',
  '修正': '修正',
  '修正单': '修正单',
  '修正原因': '修正原因',
  '倒排序': '倒排序',
  '停止': '停止',
  '停止位': '停止位',
  '停止读取': '停止读取',
  '停用': '停用',
  '偶数货架': '偶数货架',
  '允分分货满足率': '允分分货满足率(%)',
  '允分收货占比': '允分收货占比(%)',
  '允许': '允许',
  '允许主动退货': '允许主动退货',
  '允许多次执行': '允许多次执行',
  '允许定位交接': '允许定位交接',
  '允许批号混载': '允许批号混载',
  '允许收货': '允许收货',
  '允许空闲容器装车': '允许空闲容器装车',
  '允许装车': '允许装车',
  '允许负库存的业务操作配置': '允许负库存的业务操作配置',
  '允许退仓': '允许退仓',
  '允许重复执行': '允许重复执行',
  '元': '元',
  '入园单': '入园单',
  '入库': '入库',
  '入库业务': '入库业务',
  '入库仓位': '入库仓位',
  '入库指令': '入库指令',
  '入库管理': '入库管理',
  '入库订单': '入库订单',
  '入库订单号': '入库订单号',
  '入库订单来源单号': '入库订单来源单号',
  '入库订单行号': '入库订单行号',
  '入库配置': '入库配置',
  '入库采集皮重信息': '入库采集皮重信息',
  '入库采集皮重维度': '入库采集皮重维度',
  '入库采集皮重维度设置': '入库采集皮重维度设置',
  '全家便利店': '全家便利店',
  '全部': '全部',
  '全部供应商': '全部供应商',
  '全部导入': '全部导入',
  '全部添加': '全部添加',
  '全部项目': '全部项目',
  '公共资源': '公共资源',
  '共': '共',
  '共 {total} 条': '共 {total} 条',
  '共{number}个控制器': '共{number}个控制器',
  '共生成{data}张拣货单': '共生成{data}张拣货单',
  '关联货位': '关联货位',
  '关联货位配置': '关联货位配置',
  '关闭': '关闭',
  '其他': '其他',
  '内存详情': '内存详情',
  '内宽(cm)': '内宽(cm)',
  '内部管理': '内部管理',
  '内部管理指令': '内部管理指令',
  '内部配置': '内部配置',
  '内长(cm)': '内长(cm)',
  '内长/宽/高(cm)': '内长/宽/高(cm)',
  '内高(cm)': '内高(cm)',
  '冷藏': '冷藏',
  '凭证原因': '凭证原因',
  '凭证附件': '凭证附件',
  '凭证附件支持jpg、jpeg、png、docx、xlsx等格式文件,建议上传文件大小不超过1M': '凭证附件支持jpg、jpeg、png、docx、xlsx等格式文件,建议上传文件大小不超过1M',
  '凭证附件支持jpg、jpeg、png、docx、xlsx等格式文件,建议上传文件大小不超过5M': '凭证附件支持jpg、jpeg、png、docx、xlsx等格式文件,建议上传文件大小不超过5M',
  '出库': '出库',
  '出库使用皮重记录': '出库使用皮重记录',
  '出库加工': '出库加工',
  '出库单': '出库单',
  '出库打印机': '出库打印机',
  '出库打印模板': '出库打印模板',
  '出库指令': '出库指令',
  '出库控制': '出库控制',
  '出库管理': '出库管理',
  '出库配置': '出库配置',
  '出货': '出货',
  '出货前加工': '出货前加工',
  '出货后打印容器条码': '出货后打印容器条码',
  '出货容器后置打印': '出货容器后置打印',
  '出货打印容器': '出货打印容器',
  '出货打印模板配置': '出货打印模板配置',
  '出货打印模板配置日志': '出货打印模板配置日志',
  '出车里程数': '出车里程数',
  '分区': '分区',
  '分区名称': '分区名称',
  '分区编号': '分区编号',
  '分区配置': '分区配置',
  '分区顺序': '分区顺序',
  '分单体积': '分单体积',
  '分单依据': '分单依据',
  '分单内容': '分单内容',
  '分单数量': '分单数量',
  '分单条件': '分单条件',
  '分单配置': '分单配置',
  '分单门店数': '分单门店数',
  '分拣口': '分拣口',
  '分拣序号': '分拣序号',
  '分拣扫描': '分拣扫描',
  '分拣机': '分拣机',
  '分拣机中转暂存位': '分拣机中转暂存位',
  '分拣机拣货': '分拣机拣货',
  '分拣机指令看板': '分拣机指令看板',
  '分拣机收货': '分拣机收货',
  '分拣机集货': '分拣机集货',
  '分拣机集货暂存位': '分拣机集货暂存位',
  '分拣策略': '分拣策略',
  '分拣策略不存在': '分拣策略不存在',
  '分拣道口': '分拣道口',
  '分拣道口方案': '分拣道口方案',
  '分拣道口管理': '分拣道口管理',
  '分拣道口管理不存在': '分拣道口管理不存在',
  '分拨中': '分拨中',
  '分播': '分播',
  '分播中': '分播中',
  '分播中转位': '分播中转位',
  '分播件数': '分播件数',
  '分播件数必须大于0！': '分播件数必须大于0！',
  '分播位': '分播位',
  '分播位不能为空': '分播位不能为空',
  '分播位方案': '分播位方案',
  '分播列表': '分播列表',
  '分播墙': '分播墙',
  '分播墙类型': '分播墙类型',
  '分播墙：': '分播墙：',
  '分播审核': '分播审核',
  '分播序号': '分播序号',
  '分播成功': '分播成功',
  '分播打印模板': '分播打印模板',
  '分播数量': '分播数量',
  '分播数量必须大于0！': '分播数量必须大于0！',
  '分播方式': '分播方式',
  '分播方案': '分播方案',
  '分播状态': '分播状态',
  '分播管理方案': '分播管理方案',
  '分播管理方案:{code}不存在': '分播管理方案:{code}不存在',
  '分播管理方案不存在': '分播管理方案不存在',
  '分播门店': '分播门店',
  '分组': '分组',
  '分组成功': '分组成功',
  '分配': '分配',
  '分配{number}个选项': '分配{number}个选项',
  '分配件数': '分配件数',
  '分配商品拣货量': '分配商品拣货量',
  '分配成功': '分配成功',
  '分配数量': '分配数量',
  '分配数量大于库存数量,分配数量应小于等于库存数量！': '分配数量大于库存数量,分配数量应小于等于库存数量！',
  '分配状态': '分配状态',
  '分配集货位': '分配集货位',
  '切换商品': '切换商品',
  '切换指令': '切换指令',
  '切换组织': '切换组织',
  '切换门店': '切换门店',
  '列展示': '列展示',
  '列数': '列数',
  '列码': '列码',
  '列码范围': '列码范围',
  '列码范围不为空，请填写完整': '列码范围不为空，请填写完整',
  '列表': '列表',
  '列表页行数': '列表页行数',
  '创建': '创建',
  '创建/接收': '创建/接收',
  '创建/接收时间': '创建/接收时间',
  '创建人': '创建人',
  '创建信息': '创建信息',
  '创建方式': '创建方式',
  '创建日期': '创建日期',
  '创建时间': '创建时间',
  '初始': '初始',
  '初始化或者手动配置供应商退货位管理容器配置': '初始化或者手动配置供应商退货位管理容器配置',
  '删除': '删除',
  '删除{length}个选项': '删除{length}个选项',
  '删除失败': '删除失败',
  '删除成功': '删除成功',
  '删除标签': '删除标签',
  '删除网关服务失败': '删除网关服务失败',
  '删除货位': '删除货位',
  '到效日期': '到效日期',
  '到效期': '到效期',
  '到效期不能早于当前日期': '到效期不能早于当前日期',
  '刷新任务成功': '刷新任务成功',
  '刷新装车员': '刷新装车员',
  '前端地址不能为空': '前端地址不能为空',
  '剩余件数': '剩余件数',
  '剩余原料': '剩余原料',
  '剩余原料/成品': '剩余原料/成品',
  '剩余库存转移': '剩余库存转移',
  '剩余成品': '剩余成品',
  '剩余数量': '剩余数量',
  '剩余门店数': '剩余门店数',
  '功能': '功能',
  '加工中': '加工中',
  '加工人数': '加工人数',
  '加工任务': '加工任务',
  '加工倍数': '加工倍数',
  '加工单': '加工单',
  '加工单原料明细第{line}行{rawRecordTitle}不能为空！': '加工单原料明细第{line}行{rawRecordTitle}不能为空！',
  '加工单成品明细第{line}行{endRecordTitle}不能为空！': '加工单成品明细第{line}行{endRecordTitle}不能为空！',
  '加工单成品明细第{line}行供应商不能为空！': '加工单成品明细第{line}行供应商不能为空！',
  '加工单成品明细第{line}行到效期不能为空！': '加工单成品明细第{line}行到效期不能为空！',
  '加工单成品明细第{line}行单价不能为空！': '加工单成品明细第{line}行单价不能为空！',
  '加工单成品明细第{line}行商品不能为空！': '加工单成品明细第{line}行商品不能为空！',
  '加工单成品明细第{line}行容器条码不能为空！': '加工单成品明细第{line}行容器条码不能为空！',
  '加工单成品明细第{line}行生产日期不能为空！': '加工单成品明细第{line}行生产日期不能为空！',
  '加工单成品明细第{line}行货位代码不能为空！': '加工单成品明细第{line}行货位代码不能为空！',
  '加工单记录值信息配置': '加工单记录值信息配置',
  '领料单默认操作方式配置': '领料单默认操作方式配置',
  '领料员作业配置': '领料员作业配置',
  '加工单配方限制': '加工单配方限制',
  '加工单限制配置': '加工单限制配置',
  '加工单限制配置 保存成功': '加工单限制配置 保存成功',
  '满容录入附件限制配置': '满容录入附件限制配置',
  '满容录入附件限制配置 保存成功': '满容录入附件限制配置 保存成功',
  '退仓超退限制影响配置': '退仓超退限制影响配置',
  '退仓超退限制影响配置 保存成功': '退仓超退限制影响配置 保存成功',
  '加工台': '加工台',
  '加工台管理': '加工台管理',
  '加工员': '加工员',
  '加工方案': '加工方案',
  '加工波次': '加工波次',
  '加工波次单号': '加工波次单号',
  '加载中...': '加载中...',
  '动态': '动态',
  '动态分播位': '动态分播位',
  '动态存储区域配置': '动态存储区域配置',
  '动态拣货': '动态拣货',
  '动态拣货分组代码/名称': '动态拣货分组代码/名称',
  '动态拣货区域配置': '动态拣货区域配置',
  '动态拣货组': '动态拣货组',
  '动态拣货组有值，是否继续保存': '动态拣货组有值，是否继续保存',
  '动态拣货补货算法': '动态拣货补货算法',
  '动态拣货配置': '动态拣货配置',
  '动态方案': '动态方案',
  '动态补货': '动态补货',
  '动销': '动销',
  '勾选为累计，不勾选为替换': '勾选为累计，不勾选为替换',
  '勾选后RF上架和混载上架的时候建议位置展示推荐系统库存位置': '勾选后RF上架和混载上架的时候建议位置展示推荐系统库存位置',
  '勾选后RF上架的时候会进行货位别名栏显示并进行校验': '勾选后RF上架的时候会进行货位别名栏显示并进行校验',
  '勾选后RF单品复查扫描条码显示规格数量': '勾选后RF单品复查扫描条码显示规格数量',
  '勾选后RF拣货获取到拣货单的时候提示该门店支持哪些容器类型拣货': '勾选后RF拣货获取到拣货单的时候提示该门店支持哪些容器类型拣货',
  '勾选后RF收货记录卸货方式': '勾选后RF收货记录卸货方式',
  '勾选后RF正常收货/快速收货显示商品拆零拣货位，不勾选不显示': '勾选后RF正常收货/快速收货显示商品拆零拣货位，不勾选不显示',
  '勾选后RF正常收货模块,实收处显示待收信息,不勾选显示空,允许修改': '勾选后RF正常收货模块,实收处显示待收信息,不勾选显示空,允许修改',
  '勾选后RF生鲜摘果使用容器方式为自动分配': '勾选后RF生鲜摘果使用容器方式为自动分配',
  '勾选后RF统配拣货模块(含明细)显示商品代码,不勾选不显示': '勾选后RF统配拣货模块(含明细)显示商品代码,不勾选不显示',
  '勾选后RF统配拣货模块,实拣处显示待拣信息,不勾选显示空,允许修改': '勾选后RF统配拣货模块,实拣处显示待拣信息,不勾选显示空,允许修改',
  '勾选后RF统配拣货满容后自动跳转平移': '勾选后RF统配拣货满容后自动跳转平移',
  '勾选后RF装车界面装车时允许扫描空闲容器装车': '勾选后RF装车界面装车时允许扫描空闲容器装车',
  '勾选后RF装车界面，待装车容器按容器最后修改时间升序排序': '勾选后RF装车界面，待装车容器按容器最后修改时间升序排序',
  '勾选后RF退仓收货模块,收货处显示待退信息,不勾选显示空,允许修改': '勾选后RF退仓收货模块,收货处显示待退信息,不勾选显示空,允许修改',
  '勾选后WEB摘果默认显示件数/数量': '勾选后WEB摘果默认显示件数/数量',
  '勾选后WEB播种默认显示件数/数量': '勾选后WEB播种默认显示件数/数量',
  '勾选后上架可不输入推荐的上架货位': '勾选后上架可不输入推荐的上架货位',
  '勾选后以外部批次作为系统批次管理，反之单独管理': '勾选后以外部批次作为系统批次管理，反之单独管理',
  '勾选后优先查询拣货单中缺货或跳过的数据': '勾选后优先查询拣货单中缺货或跳过的数据',
  '勾选后出货打印容器条码': '勾选后出货打印容器条码',
  '勾选后则启用': '勾选后则启用',
  '勾选后单品复查扫描条码后显示条码对应规格数量,不勾选显示数量1': '勾选后单品复查扫描条码后显示条码对应规格数量,不勾选显示数量1',
  '勾选后可在排车看板页面查看一步越库收货暂存位上的信息，不可装车': '勾选后可在排车看板页面查看一步越库收货暂存位上的信息，不可装车',
  '勾选后可在排车看板页面查看拣货暂存位上的信息，不可装车': '勾选后可在排车看板页面查看拣货暂存位上的信息，不可装车',
  '勾选后可在排车看板页面查看统配集货暂存位上的信息': '勾选后可在排车看板页面查看统配集货暂存位上的信息',
  '勾选后可在排车看板页面查看越库集货暂存位上的信息': '勾选后可在排车看板页面查看越库集货暂存位上的信息',
  '勾选后可在排车看板页面查看门店分播位上的信息': '勾选后可在排车看板页面查看门店分播位上的信息',
  '勾选后可在排车看板页面查看集货位上的信息': '勾选后可在排车看板页面查看集货位上的信息',
  '勾选后在RF退仓收货展示商品退货条件信息': '勾选后在RF退仓收货展示商品退货条件信息',
  '勾选后平移时输入的目标位置，可以不在系统建议货位范围内': '勾选后平移时输入的目标位置，可以不在系统建议货位范围内',
  '勾选后平移界面显示固定拣货位、集货位信息，显示货位代码': '勾选后平移界面显示固定拣货位、集货位信息，显示货位代码',
  '勾选后支持web单据审核负库存': '勾选后支持web单据审核负库存',
  '勾选后支持打印标签拣货负库存': '勾选后支持打印标签拣货负库存',
  '勾选后收货打印容器条码': '勾选后收货打印容器条码',
  '勾选后显示类越库分播门店代码，不勾选不显示': '勾选后显示类越库分播门店代码，不勾选不显示',
  '勾选后电商提总自动带出箱零': '勾选后电商提总自动带出箱零',
  '勾选后类越库分播显示门店代码，不勾选不显示': '勾选后类越库分播显示门店代码，不勾选不显示',
  '勾选后系统扫描容器后，若商品未混载系统自动跳转到容器一栏，不需要扫描商品确认，分播另一家门店的时候光标跳转到容器一栏': '勾选后系统扫描容器后，若商品未混载系统自动跳转到容器一栏，不需要扫描商品确认，分播另一家门店的时候光标跳转到容器一栏',
  '勾选后累加,不勾选为替换': '勾选后累加,不勾选为替换',
  '勾选后自动回主界面': '勾选后自动回主界面',
  '勾选后配合rf分配复选框可以自动跳转到库存分配界面，不勾选不跳转': '勾选后配合rf分配复选框可以自动跳转到库存分配界面，不勾选不跳转',
  '勾选后高叉作业补货跳过源容器校验': '勾选后高叉作业补货跳过源容器校验',
  '勾选的明细必须退仓类型必须是好退或返厂类型': '勾选的明细必须退仓类型必须是好退或返厂类型',
  '勾选的明细退仓类型必须是好退类型': '勾选的明细退仓类型必须是好退类型',
  '包名': '包名',
  '包名不能为空': '包名不能为空',
  '包含的商品代码': '包含的商品代码',
  '包含的商品代码,多个代码以逗号隔开': '包含的商品代码,多个代码以逗号隔开',
  '包含的组别': '包含的组别',
  '包含的门店': '包含的门店',
  '包含的门店代码,多个代码以逗号隔开': '包含的门店代码,多个代码以逗号隔开',
  '包含门店': '包含门店',
  '包装代码': '包装代码',
  '包装件数': '包装件数',
  '包装名称': '包装名称',
  '包装形式': '包装形式',
  '包装机': '包装机',
  '包装机/分拣机配置': '包装机/分拣机配置',
  '包装机商品维护': '包装机商品维护',
  '包装机类型': '包装机类型',
  '包装耗材': '包装耗材',
  '包装耗材代码': '包装耗材代码',
  '包装耗材名称': '包装耗材名称',
  '包装耗材管理': '包装耗材管理',
  '包装耗材配置': '包装耗材配置',
  '包装规格/计量单位': '包装规格/计量单位',
  '包裹号': '包裹号',
  '包裹重量(kg)': '包裹重量(kg)',
  '区域': '区域',
  '区域代码': '区域代码',
  '区域名称': '区域名称',
  '区段': '区段',
  '区段代码': '区段代码',
  '区段名称': '区段名称',
  '区段标签': '区段标签',
  '区段顺序': '区段顺序',
  '华北': '华北',
  '单件皮重': '单件皮重',
  '单件皮重(g)': '单件皮重(g)',
  '单件皮重(kg)': '单件皮重(kg)',
  '单价': '单价',
  '单价或者扣损重量': '单价或者扣损重量',
  '单位': '单位',
  '单号': '单号',
  '单号/容器': '单号/容器',
  '单号/来源单号': '单号/来源单号',
  '单号/来源单号/网络订单号，多个以逗号隔开': '单号/来源单号/网络订单号，多个以逗号隔开',
  '单号不存在': '单号不存在',
  '单号：': '单号：',
  '单品复查': '单品复查',
  '单品复查扫描条码显示数量': '单品复查扫描条码显示数量',
  '单品最大数量': '单品最大数量',
  '单品最大金额': '单品最大金额',
  '单品模式': '单品模式',
  '单品模式的拣货单将修改为多品模式，多品模式的将修改为单品模式': '单品模式的拣货单将修改为多品模式，多品模式的将修改为单品模式',
  '单品要货数量上限': '单品要货数量上限',
  '单店摘果': '单店摘果',
  '单店整托盘': '单店整托盘',
  '单据': '单据',
  '单据使用容器后置打印配置': '单据使用容器后置打印配置',
  '单据供应商': '单据供应商',
  '单据供应商取值配置': '单据供应商取值配置',
  '单据信息': '单据信息',
  '单据创建配置': '单据创建配置',
  '单据字段': '单据字段',
  '单据导入': '单据导入',
  '单据日结': '单据日结',
  '单据日结配置': '单据日结配置',
  '单据明细': '单据明细',
  '单据明细不能为空': '单据明细不能为空',
  '单据状态配置': '单据状态配置',
  '单据类型': '单据类型',
  '单据类型与所选复核台不匹配': '单据类型与所选复核台不匹配',
  '单据装车': '单据装车',
  '单据规格': '单据规格',
  '单据规格取值配置': '单据规格取值配置',
  '单据配置': '单据配置',
  '单据默认仓位取值配置': '单据默认仓位取值配置',
  '单据默认仓位取值配置{successLocale}': '单据默认仓位取值配置{successLocale}',
  '单独释放': '单独释放',
  '卡片': '卡片',
  '卸货方式': '卸货方式',
  '原件数': '原件数',
  '原商品': '原商品',
  '原因': '原因',
  '原数量': '原数量',
  '原料': '原料',
  '原料信息': '原料信息',
  '原料加工位': '原料加工位',
  '原料加工位代码': '原料加工位代码',
  '原料明细': '原料明细',
  '原料明细不能为空': '原料明细不能为空',
  '原料明细第{line}行件数不能为0': '原料明细第{line}行件数不能为0',
  '原料明细第{line}行包装规格不能为空': '原料明细第{line}行包装规格不能为空',
  '原料池': '原料池',
  '原料记录值是否有默认值': '原料记录值是否有默认值',
  '原料记录值标题': '原料记录值标题',
  '原料量上下限制计算维度': '原料量上下限制计算维度',
  '县/区': '县/区',
  '参考规格': '参考规格',
  '发票': '发票',
  '发票打印机': '发票打印机',
  '发票打印模板': '发票打印模板',
  '发送成功': '发送成功',
  '发送拣货单到IPS': '发送拣货单到IPS',
  '发送日期': '发送日期',
  '发送时间': '发送时间',
  '取值不能为空': '取值不能为空',
  '取消': '取消',
  '取消{length}个选项': '取消{length}个选项',
  '取消分配成功': '取消分配成功',
  '取消成功': '取消成功',
  '取消收藏': '取消收藏',
  '可分配量': '可分配量',
  '可替换商品明细第{line}行商品不能为空！': '可替换商品明细第{line}行商品不能为空！',
  '可替换商品明细第{line}行商品不能和被替换商品相同！': '可替换商品明细第{line}行商品不能和被替换商品相同！',
  '可用处理方式': '可用处理方式',
  '可用库存货位用途范围配置': '可用库存货位用途范围配置',
  '可用条码解析规则配置': '可用条码解析规则配置',
  '可用空间': '可用空间',
  '可缺货处理配单类型': '可缺货处理配单类型',
  '司机': '司机',
  '合并任务': '合并任务',
  '合并规则': '合并规则',
  '合格': '合格',
  '合格区间': '合格区间',
  '合格区间范围': '合格区间范围',
  '合格标识': '合格标识',
  '合计单数': '合计单数',
  '同一货架内校验码不重复': '同一货架内校验码不重复',
  '同单同品记录': '同单同品记录',
  '同步线路体系方案': '同步线路体系方案',
  '名称': '名称',
  '名称不能为空': '名称不能为空',
  '向上修正': '向上修正',
  '向下修正': '向下修正',
  '否': '否',
  '含税单价': '含税单价',
  '启动': '启动',
  '启动中': '启动中',
  '启动完成': '启动完成',
  '启动异常': '启动异常',
  '启动成功': '启动成功',
  '启动时间': '启动时间',
  '启动波次': '启动波次',
  '启用': '启用',
  '启用{length}个选项': '启用{length}个选项',
  '启用封签号': '启用封签号',
  '启用成功': '启用成功',
  '员工': '员工',
  '员工代码': '员工代码',
  '员工名称': '员工名称',
  '员工工号': '员工工号',
  '周一': '周一',
  '周三': '周三',
  '周二': '周二',
  '周五': '周五',
  '周六': '周六',
  '周四': '周四',
  '周日': '周日',
  '品项': '品项',
  '品项数': '品项数',
  '商品': '商品',
  '商品/商品规格': '商品/商品规格',
  '商品: {article}': '商品: {article}',
  '商品[{article}]不在当前容器内，是否继续？': '商品[{article}]不在当前容器内，是否继续？',
  '商品{article}未维护长宽高重信息': '商品{article}未维护长宽高重信息',
  '商品{code}正在收货，确认切换？': '商品{code}正在收货，确认切换？',
  '商品{repeatItem}存在多个规格，不允许收货': '商品{repeatItem}存在多个规格，不允许收货',
  '商品{repeatItem}存在多个规格，不允许预检': '商品{repeatItem}存在多个规格，不允许预检',
  '商品{repeatItem}存在多个规格，是否继续收货': '商品{repeatItem}存在多个规格，是否继续收货',
  '商品{repeatItem}存在多个规格，是否继续预检': '商品{repeatItem}存在多个规格，是否继续预检',
  '商品不能为空': '商品不能为空',
  '商品业务信息': '商品业务信息',
  '商品代码': '商品代码',
  '商品代码,多个商品以逗号隔开': '商品代码,多个商品以逗号隔开',
  '商品代码/名称': '商品代码/名称',
  '商品代码/容器': '商品代码/容器',
  '商品代码{newArticleCodeStr}是新品，请维护商品业务信息后再进行{operate}操作': '商品代码{newArticleCodeStr}是新品，请维护商品业务信息后再进行{operate}操作',
  '商品代码{newArticleCodeStr}是新品，请维护商品业务信息后再进行收货操作': '商品代码{newArticleCodeStr}是新品，请维护商品业务信息后再进行收货操作',
  '商品代码{newArticleCodeStr}是新品，请维护商品业务信息后再进行预检操作': '商品代码{newArticleCodeStr}是新品，请维护商品业务信息后再进行预检操作',
  '商品件数和附件个数比例': '商品件数和附件个数比例',
  '商品件数和附件个数比例 最长是30': '商品件数和附件个数比例 最长是30',
  '商品件数：{totalQtyStr}/{canBookQtyStr}（单个时间段{maxReceiveQtyStr}）': '商品件数：{totalQtyStr}/{canBookQtyStr}（单个时间段{maxReceiveQtyStr}）',
  '商品供应商': '商品供应商',
  '商品信息': '商品信息',
  '商品信息刷新失败': '商品信息刷新失败',
  '商品分播管理方案配置': '商品分播管理方案配置',
  '商品名称': '商品名称',
  '商品品项数：      {totalArticleCount}/{maxReceiveArticleCount}': '商品品项数：      {totalArticleCount}/{maxReceiveArticleCount}',
  '商品备注': '商品备注',
  '商品存储范围配置': '商品存储范围配置',
  '商品尺寸规格信息维护提示': '商品尺寸规格信息维护提示',
  '收货规格是否需确认': '收货规格是否需确认',
  '商品是否严格按明细供应商收货': '商品是否严格按明细供应商收货',
  '商品库存不足': '商品库存不足',
  '商品收货成功': '商品收货成功',
  '商品明细': '商品明细',
  '商品是否跨容器': '商品是否跨容器',
  '商品条码': '商品条码',
  '商品状态': '商品状态',
  '商品类别': '商品类别',
  '商品组': '商品组',
  '商品组分单': '商品组分单',
  '商品组分单配置': '商品组分单配置',
  '商品组名称': '商品组名称',
  '商品组配置': '商品组配置',
  '商品结算方式配置': '商品结算方式配置',
  '商品维度': '商品维度',
  '商品耗材': '商品耗材',
  '商品耗材不存在': '商品耗材不存在',
  '商品耗材管理': '商品耗材管理',
  '商品耗材配置': '商品耗材配置',
  '商品范围': '商品范围',
  '商品范围最大长度100': '商品范围最大长度100',
  '商品规格': '商品规格',
  '商品超过到效期': '商品超过到效期',
  '商品超过收货控制天数': '商品超过收货控制天数',
  '商品默认信息配置': '商品默认信息配置',
  '商品默认信息配置 保存成功': '商品默认信息配置 保存成功',
  '商品：[{articleCode}]{articleName}/{qpcStr}已收完，请切换规格或商品再提交': '商品：[{articleCode}]{articleName}/{qpcStr}已收完，请切换规格或商品再提交',
  '商品：{codename}分播数量不能大于拣货数量': '商品：{codename}分播数量不能大于拣货数量',
  '商品：{tips}，已超收，是否继续？': '商品：{tips}，已超收，是否继续？',
  '回仓': '回仓',
  '回传日期': '回传日期',
  '回传时间': '回传时间',
  '回收信息': '回收信息',
  '回收信息不能为空': '回收信息不能为空',
  '回收容器取值模式': '回收容器取值模式',
  '回收容器取值模式配置': '回收容器取值模式配置',
  '回收成功': '回收成功',
  '回收数量': '回收数量',
  '回收明细': '回收明细',
  '回收类型': '回收类型',
  '回滚': '回滚',
  '回滚成功': '回滚成功',
  '回车中': '回车中',
  '回车里程数': '回车里程数',
  '团队': '团队',
  '团队内排名': '团队内排名',
  '固定值': '固定值',
  '固定分播位': '固定分播位',
  '固定方案': '固定方案',
  '图片': '图片',
  '图片：{name}上传成功': '图片：{name}上传成功',
  '在店': '在店',
  '在门店': '在门店',
  '地址': '地址',
  '地址不能为空': '地址不能为空',
  '基本信息': '基本信息',
  '基本信息的货主和仓位不能为空，请选择之后再检索！': '基本信息的货主和仓位不能为空，请选择之后再检索！',
  '基本资料': '基本资料',
  '基本资料维护': '基本资料维护',
  '填写序号': '填写序号',
  '填写打印时间间隔': '填写打印时间间隔',
  '填写振幅': '填写振幅',
  '填写最小打印标签数': '填写最小打印标签数',
  '填写连续打印次数': '填写连续打印次数',
  '填写降幅': '填写降幅',
  '填写预留操作高度': '填写预留操作高度',
  '处理中...': '处理中...',
  '处理人': '处理人',
  '处理方式': '处理方式',
  '备注': '备注',
  '备注不能为空': '备注不能为空',
  '备注最大长度为255': '备注最大长度为255',
  '备注：': '备注：',
  '备用字段1': '备用字段1',
  '备用字段2': '备用字段2',
  '备用字段3': '备用字段3',
  '备用字段4': '备用字段4',
  '备货(%)': '备货(%)',
  '备货满足率(%)': '备货满足率(%)',
  '复制{length}个选项': '复制{length}个选项',
  '复制成功': '复制成功',
  '复查': '复查',
  '复查/装车': '复查/装车',
  '复查件数': '复查件数',
  '复查员': '复查员',
  '复查子容器数': '复查子容器数',
  '复查容器': '复查容器',
  '复查总件数': '复查总件数',
  '复查总体积': '复查总体积',
  '复查总品项数': '复查总品项数',
  '复查总重量': '复查总重量',
  '复查总金额': '复查总金额',
  '复查数据存在差异，是否确认结束？': '复查数据存在差异，是否确认结束？',
  '复查数量': '复查数量',
  '复查方式': '复查方式',
  '复查类型': '复查类型',
  '复查组织': '复查组织',
  '复查项': '复查项',
  '复查项为容器，一次只能提交一个数量': '复查项为容器，一次只能提交一个数量',
  '复核中': '复核中',
  '复核件数': '复核件数',
  '复核区': '复核区',
  '复核区还有待提交数据，请先满箱': '复核区还有待提交数据，请先满箱',
  '复核台': '复核台',
  '复核台不能为空': '复核台不能为空',
  '复核台代码': '复核台代码',
  '复核台名称': '复核台名称',
  '复核台配置': '复核台配置',
  '复核台配置代码': '复核台配置代码',
  '复核商品': '复核商品',
  '复核对应承运商': '复核对应承运商',
  '复核差异生成': '复核差异生成',
  '复核成功': '复核成功',
  '复核打包': '复核打包',
  '复核打印': '复核打印',
  '复核数量': '复核数量',
  '复核数量不能为0': '复核数量不能为0',
  '复核数量异常,请检查你的拣货单': '复核数量异常,请检查你的拣货单',
  '复核规格': '复核规格',
  '复核配置代码': '复核配置代码',
  '复核配置名称': '复核配置名称',
  '复满': '复满',
  '复盘': '复盘',
  '复盘{length}个选项': '复盘{length}个选项',
  '复盘成功': '复盘成功',
  '复盘次数': '复盘次数',
  '外宽(cm)': '外宽(cm)',
  '外部批号': '外部批号',
  '外部批号存储解析': '外部批号存储解析',
  '外部批号展示解析': '外部批号展示解析',
  '外部批号解析配置': '外部批号解析配置',
  '外部批次': '外部批次',
  '外长(cm)': '外长(cm)',
  '外长/宽/高(cm)': '外长/宽/高(cm)',
  '外高(cm)': '外高(cm)',
  '多个以逗号隔开,不可输入特殊符号,最大长度100': '多个以逗号隔开,不可输入特殊符号,最大长度100',
  '多品模式': '多品模式',
  '多店整托盘': '多店整托盘',
  '多店整托盘、单店摘果和三种提总至少需选择一项': '多店整托盘、单店摘果和三种提总至少需选择一项',
  '多店整托盘、存储位提总、拣货位提总、混合提总、四种模式最多只允许存在一项': '多店整托盘、存储位提总、拣货位提总、混合提总、四种模式最多只允许存在一项',
  '多货强分算法加强': '多货强分算法加强',
  '多轮录入': '多轮录入',
  '多配': '多配',
  '多配不可重复配置可用处理方式': '多配不可重复配置可用处理方式',
  '多配可用处理方式': '多配可用处理方式',
  '够出货量': '够出货量',
  '大型拣货位': '大型拣货位',
  '大型拣货位自动生成拣货指令商品配置': '大型拣货位自动生成拣货指令商品配置',
  '大型拣货位范围': '大型拣货位范围',
  '大型集货位范围': '大型集货位范围',
  '大润发条码': '大润发条码',
  '失效': '失效',
  '失效成功': '失效成功',
  '失败': '失败',
  '失败{action}': '失败{action}',
  '奇偶位': '奇偶位',
  '奇数货架': '奇数货架',
  '好退': '好退',
  '好退控制天数': '好退控制天数',
  '好退的目标货位': '好退的目标货位',
  '无独占退货位时默认退货位配置': '无独占退货位时默认退货位配置',
  '好退退仓收货中': '好退退仓收货中',
  '如果输入多个，以英文逗号隔开': '如果输入多个，以英文逗号隔开',
  '子容器': '子容器',
  '子容器拣货': '子容器拣货',
  '子容器数': '子容器数',
  '子容器满容': '子容器满容',
  '字符串': '字符串',
  '存储位': '存储位',
  '存储位优先': '存储位优先',
  '存储位提总': '存储位提总',
  '存储位整托盘提总': '存储位整托盘提总',
  '存储位非整托盘提总': '存储位非整托盘提总',
  '存储区域': '存储区域',
  '存储范围': '存储范围',
  '存储货位高度限制': '存储货位高度限制',
  '存储过程': '存储过程',
  '存储过程名': '存储过程名',
  '存在原料明细剩余数量件数大于原始数量件数': '存在原料明细剩余数量件数大于原始数量件数',
  '存在商品库存为0和商品库存小于门店要货量的数据，确认继续执行分配？': '存在商品库存为0和商品库存小于门店要货量的数据，确认继续执行分配？',
  '存在商品库存为0的数据，确认继续执行分配？': '存在商品库存为0的数据，确认继续执行分配？',
  '存在商品库存小于门店要货量的数据，确认继续执行分配？': '存在商品库存小于门店要货量的数据，确认继续执行分配？',
  '存在库存': '存在库存',
  '存在重命名未保存，请先回车保存': '存在重命名未保存，请先回车保存',
  '存在门店未分播，是否确认结束加工': '存在门店未分播，是否确认结束加工',
  '完成': '完成',
  '完成{length}个选项': '完成{length}个选项',
  '完成加工波次单成功': '完成加工波次单成功',
  '完成成功': '完成成功',
  '完成指示': '完成指示',
  '完成日期': '完成日期',
  '完成时间': '完成时间',
  '完成装车': '完成装车',
  '完成装车时间': '完成装车时间',
  '完成订单': '完成订单',
  '完成进度': '完成进度',
  '完成退仓通知单': '完成退仓通知单',
  '完成配货通知单': '完成配货通知单',
  '定价类型': '定价类型',
  '实体日志表保留时长(天)': '实体日志表保留时长(天)',
  '实体日志表保留时长不能为空': '实体日志表保留时长不能为空',
  '实体标示': '实体标示',
  '实分件数': '实分件数',
  '实分数量': '实分数量',
  '实拣': '实拣',
  '实拣件数': '实拣件数',
  '实拣件数不为0时，数量不允许为0': '实拣件数不为0时，数量不允许为0',
  '实拣分播数量': '实拣分播数量',
  '实拣品项数': '实拣品项数',
  '实拣拣货单数': '实拣拣货单数',
  '实拣数量': '实拣数量',
  '实拣数量不能为0': '实拣数量不能为0',
  '实拣数量不能大于应拣数量': '实拣数量不能大于应拣数量',
  '实拣重量': '实拣重量',
  '实损件数': '实损件数',
  '实损数量': '实损数量',
  '实播': '实播',
  '实播 :': '实播 :',
  '实播件数': '实播件数',
  '实播数量': '实播数量',
  '实盘件数': '实盘件数',
  '实盘数量': '实盘数量',
  '实盘结果一致，是否更新盘点数据': '实盘结果一致，是否更新盘点数据',
  '实盘结果存在差异，是否更新盘点数据': '实盘结果存在差异，是否更新盘点数据',
  '实补件数': '实补件数',
  '实退数量不等于应退数量，是否确认完成？': '实退数量不等于应退数量，是否确认完成？',
  '实际交接数': '实际交接数',
  '实际件数': '实际件数',
  '实际件数不能大于件数': '实际件数不能大于件数',
  '实际值': '实际值',
  '实际原料量': '实际原料量',
  '实际回收数': '实际回收数',
  '实际成品量': '实际成品量',
  '实际数量': '实际数量',
  '实际数量不等于下发数量提示': '实际数量不等于下发数量提示',
  '实际数量大于超拣数量，是否确认？': '实际数量大于超拣数量，是否确认？',
  '实际返配件数': '实际返配件数',
  '实际集货位': '实际集货位',
  '实验数量': '实验数量',
  '审核': '审核',
  '审核{length}个选项': '审核{length}个选项',
  '审核成功': '审核成功',
  '审核领用单': '审核领用单',
  '客户下单时间': '客户下单时间',
  '客户单数': '客户单数',
  '客户单数不能为空': '客户单数不能为空',
  '容器': '容器',
  '容器/整箱': '容器/整箱',
  '容器[{container}]不是当前的子容器，是否继续？': '容器[{container}]不是当前的子容器，是否继续？',
  '容器{containerCode}中没有需要复查的明细': '容器{containerCode}中没有需要复查的明细',
  '容器不存在': '容器不存在',
  '容器不能为空': '容器不能为空',
  '容器代码': '容器代码',
  '容器件数': '容器件数',
  '容器件数复查': '容器件数复查',
  '容器信息': '容器信息',
  '容器出入单': '容器出入单',
  '容器出入单明细不能为空': '容器出入单明细不能为空',
  '容器分配方式': '容器分配方式',
  '容器号': '容器号',
  '容器后置打印配置日志': '容器后置打印配置日志',
  '容器回收': '容器回收',
  '容器复查': '容器复查',
  '容器复查单': '容器复查单',
  '容器复查单日结': '容器复查单日结',
  '容器复查数量不能为空': '容器复查数量不能为空',
  '容器复查最大输入数量': '容器复查最大输入数量',
  '容器库存': '容器库存',
  '容器打印机推荐': '容器打印机推荐',
  '容器拆并': '容器拆并',
  '容器拆并单': '容器拆并单',
  '容器拆并单日结': '容器拆并单日结',
  '容器拆并默认操作方式': '容器拆并默认操作方式',
  '容器数': '容器数',
  '容器明细': '容器明细',
  '容器条码': '容器条码',
  '容器条码最多8位最少4位': '容器条码最多8位最少4位',
  '容器满容复查配置': '容器满容复查配置',
  '容器状态': '容器状态',
  '容器码': '容器码',
  '容器管理': '容器管理',
  '容器类型': '容器类型',
  '容器类型大类': '容器类型大类',
  '大类': '大类',
  '容器类型不能为空': '容器类型不能为空',
  '容器类型代码': '容器类型代码',
  '容器类型代码/名称': '容器类型代码/名称',
  '容器类型名称': '容器类型名称',
  '容器类型承载关系': '容器类型承载关系',
  '容器类型承载绑定时机': '容器类型承载绑定时机',
  '容器类型承载绑定时机{successLocale}': '容器类型承载绑定时机{successLocale}',
  '容器绑定/拆并': '容器绑定/拆并',
  '容器绑定单': '容器绑定单',
  '容器绑定单日结': '容器绑定单日结',
  '容器：{barcode}': '容器：{barcode}',
  '容积率(%)': '容积率(%)',
  '容超上限': '容超上限',
  '宽': '宽',
  '宽(cm)': '宽(cm)',
  '密码': '密码',
  '对于重量结算的商品,在RF生鲜摘果拣货,RF类越库分播模块,RF类越库商品分播模块,web端摘果拣货和播种拣货,当拣货数量大于等于应拣数量时,自动提交完成,自动获取并跳转下一个拣货任务': '对于重量结算的商品,在RF生鲜摘果拣货,RF类越库分播模块,RF类越库商品分播模块,web端摘果拣货和播种拣货,当拣货数量大于等于应拣数量时,自动提交完成,自动获取并跳转下一个拣货任务',
  '对于重量结算的商品,在RF生鲜摘果拣货,RF类越库分播模块,RF类越库商品分播模块,当拣货数量大于等于应拣数量时,自动提交完成,自动获取并跳转下一个拣货任务': '对于重量结算的商品,在RF生鲜摘果拣货,RF类越库分播模块,RF类越库商品分播模块,当拣货数量大于等于应拣数量时,自动提交完成,自动获取并跳转下一个拣货任务',
  '对应码头用途不符，是否分配？': '对应码头用途不符，是否分配？',
  '对接外部系统': '对接外部系统',
  '导入': '导入',
  '导入{title}': '导入{title}',
  '导入单据': '导入单据',
  '导入明细': '导入明细',
  '导入模板': '导入模板',
  '导入模板名称': '导入模板名称',
  '导入通知单': '导入通知单',
  '导入门店': '导入门店',
  '导出': '导出',
  '封仓': '封仓',
  '封仓人': '封仓人',
  '封仓解仓配置': '封仓解仓配置',
  '封仓锁定': '封仓锁定',
  '封存仓位': '封存仓位',
  '封存数量': '封存数量',
  '小数位数不超过4位': '小数位数不超过4位',
  '小润发生鲜条码': '小润发生鲜条码',
  '少退原因': '少退原因',
  '少配': '少配',
  '少配不可重复配置可用处理方式': '少配不可重复配置可用处理方式',
  '少配可用处理方式': '少配可用处理方式',
  '尾板': '尾板',
  '尾板剩余': '尾板剩余',
  '层数': '层数',
  '层码': '层码',
  '层码范围': '层码范围',
  '层码范围不为空，请填写完整': '层码范围不为空，请填写完整',
  '展开': '展开',
  '展示货位取值': '展示货位取值',
  '差异件数': '差异件数',
  '差异体积': '差异体积',
  '差异信息': '差异信息',
  '差异原因': '差异原因',
  '差异品项数': '差异品项数',
  '差异处理': '差异处理',
  '差异容器数': '差异容器数',
  '差异数量': '差异数量',
  '差异明细不能为空': '差异明细不能为空',
  '差异类型': '差异类型',
  '差异虚拟维护': '差异虚拟维护',
  '差异货位数': '差异货位数',
  '差异重量': '差异重量',
  '差异量': '差异量',
  '差异金额': '差异金额',
  '已下架': '已下架',
  '已交接': '已交接',
  '已作废': '已作废',
  '已使用': '已使用',
  '已保存': '已保存',
  '已停用': '已停用',
  '已入园': '已入园',
  '已出园': '已出园',
  '已分配': '已分配',
  '已分配码头': '已分配码头',
  '已分配集货位': '已分配集货位',
  '已分量': '已分量',
  '已删除': '已删除',
  '已发送': '已发送',
  '已启用': '已启用',
  '已回传': '已回传',
  '已回收': '已回收',
  '已回收数': '已回收数',
  '已复SKU数': '已复SKU数',
  '已复数量': '已复数量',
  '已复核': '已复核',
  '已复箱': '已复箱',
  '已完成': '已完成',
  '已审核': '已审核',
  '已打印': '已打印',
  '已执行': '已执行',
  '已批准': '已批准',
  '已拣货': '已拣货',
  '已排车': '已排车',
  '已揽件': '已揽件',
  '已收/应收件数': '已收/应收件数',
  '已收/应收数量': '已收/应收数量',
  '已收/拒收/件数': '已收/拒收/件数',
  '已收/拒收/数量': '已收/拒收/数量',
  '已收货件数': '已收货件数',
  '已收货体积': '已收货体积',
  '已收货品项数': '已收货品项数',
  '已收货重量': '已收货重量',
  '已收货金额': '已收货金额',
  '已有{workType}人员{empName}': '已有{workType}人员{empName}',
  '已核价': '已核价',
  '已添加': '已添加',
  '已添加{number}个用户': '已添加{number}个用户',
  '已盘入': '已盘入',
  '已禁用': '已禁用',
  '已签收': '已签收',
  '已被设置为标准规格，不允许被删除': '已被设置为标准规格，不允许被删除',
  '已装车': '已装车',
  '已超过预约配置的最大可预约件数,是否确认保存？': '已超过预约配置的最大可预约件数,是否确认保存？',
  '已跳过！': '已跳过！',
  '已退/总件数': '已退/总件数',
  '已退/总数量': '已退/总数量',
  '已退/总金额': '已退/总金额',
  '已退件数': '已退件数',
  '已退品项数': '已退品项数',
  '已退金额': '已退金额',
  '已选中': '已选中',
  '已锁定': '已锁定',
  '已预约': '已预约',
  '已领用': '已领用',
  '市': '市',
  '帐单': '帐单',
  '帮助说明': '帮助说明',
  '常温': '常温',
  '常规': '常规',
  '平均货架数': '平均货架数',
  '平均货道数': '平均货道数',
  '平板模块名': '平板模块名',
  '平板模块名称': '平板模块名称',
  '平移': '平移',
  '平移中': '平移中',
  '平移允许修改目标位置': '平移允许修改目标位置',
  '平移入': '平移入',
  '平移展示拣/集货位信息': '平移展示拣/集货位信息',
  '序列号': '序列号',
  '序号': '序号',
  '序号调整': '序号调整',
  '库存+配置+空闲': '库存+配置+空闲',
  '库存不足': '库存不足',
  '库存件数': '库存件数',
  '库存信息': '库存信息',
  '库存分配方案': '库存分配方案',
  '库存分配类型：': '库存分配类型：',
  '库存合并': '库存合并',
  '库存处理': '库存处理',
  '库存复查': '库存复查',
  '库存实物': '库存实物',
  '库存对账': '库存对账',
  '库存批号': '库存批号',
  '库存批号校验': '库存批号校验',
  '库存操作日志表保留时长(天)': '库存操作日志表保留时长(天)',
  '库存操作日志表保留时长不能为空': '库存操作日志表保留时长不能为空',
  '库存数量': '库存数量',
  '库存方案': '库存方案',
  '库存日期': '库存日期',
  '库存日结': '库存日结',
  '库存明细': '库存明细',
  '库存模式': '库存模式',
  '库存模式&商品状态使用配置': '库存模式&商品状态使用配置',
  '库存比例': '库存比例',
  '库存流水表保留时长(天)': '库存流水表保留时长(天)',
  '库存流水表保留时长不能为空': '库存流水表保留时长不能为空',
  '库存调整': '库存调整',
  '库存调整单': '库存调整单',
  '库存调整配置': '库存调整配置',
  '库存转移成功': '库存转移成功',
  '库存过期日结': '库存过期日结',
  '库存过配货控制天数日结': '库存过配货控制天数日结',
  '应交接数': '应交接数',
  '应分件数': '应分件数',
  '应分数量': '应分数量',
  '应回收数': '应回收数',
  '应拣': '应拣',
  '应拣件数': '应拣件数',
  '应拣分播数量': '应拣分播数量',
  '应拣品项数': '应拣品项数',
  '应拣拣货单数': '应拣拣货单数',
  '应拣数量': '应拣数量',
  '应播': '应播',
  '应播件数': '应播件数',
  '应播数量': '应播数量',
  '应播：{qtyStr}/{qty}   实播：{realQtyStr}/{realQty}': '应播：{qtyStr}/{qty}   实播：{realQtyStr}/{realQty}',
  '应收': '应收',
  '应收数量': '应收数量',
  '应用名称': '应用名称',
  '应用详情': '应用详情',
  '应补件数': '应补件数',
  '建议原料量': '建议原料量',
  '开启': '开启',
  '开始上架': '开始上架',
  '开始上架时间': '开始上架时间',
  '开始交接': '开始交接',
  '开始作业': '开始作业',
  '开始复查': '开始复查',
  '开始复查时间': '开始复查时间',
  '开始平移': '开始平移',
  '开始拆并': '开始拆并',
  '开始拆并时间': '开始拆并时间',
  '开始拣货': '开始拣货',
  '开始排车': '开始排车',
  '开始排车时间': '开始排车时间',
  '开始播种': '开始播种',
  '开始收货': '开始收货',
  '开始收货时间': '开始收货时间',
  '开始时间': '开始时间',
  '开始盘点': '开始盘点',
  '开始盘点时间': '开始盘点时间',
  '开始移库': '开始移库',
  '开始移库时间': '开始移库时间',
  '开始绑定': '开始绑定',
  '开始绑定时间': '开始绑定时间',
  '开始补货': '开始补货',
  '开始装车': '开始装车',
  '开始装车时间': '开始装车时间',
  '开始退仓': '开始退仓',
  '开始退仓时间': '开始退仓时间',
  '开始配送': '开始配送',
  '开始预检': '开始预检',
  '异常': '异常',
  '异常原因': '异常原因',
  '异常口': '异常口',
  '异常品出货配置': '异常品出货配置',
  '异常处理信息': '异常处理信息',
  '异常处理明细第{line}行与第{otherLine}行重复！': '异常处理明细第{line}行与第{otherLine}行重复！',
  '异常处理明细第{line}行处理方式不能为空！': '异常处理明细第{line}行处理方式不能为空！',
  '异常处理明细第{line}行数量不能为空！': '异常处理明细第{line}行数量不能为空！',
  '异常处理明细第{line}行条码不能为空！': '异常处理明细第{line}行条码不能为空！',
  '异常待处理': '异常待处理',
  '异常货位范围': '异常货位范围',
  '张单据已被打印，是否重复打印？': '张单据已被打印，是否重复打印？',
  '强分': '强分',
  '强分数量大于可用库存！': '强分数量大于可用库存！',
  '强制': '强制',
  '强制不使用': '强制不使用',
  '强制使用': '强制使用',
  '强制报错': '强制报错',
  '强制整托盘': '强制整托盘',
  '强制限制': '强制限制',
  '归还标识': '归还标识',
  '当前': '当前',
  '当前任务拣货完成！': '当前任务拣货完成！',
  '当前位置': '当前位置',
  '当前位置用途': '当前位置用途',
  '当前加工波次不存在原料商品明细，无法分播': '当前加工波次不存在原料商品明细，无法分播',
  '当前商品图': '当前商品图',
  '当前商品已超收，是否继续收货': '当前商品已超收，是否继续收货',
  '当前商品收货未完成，是否换商品？': '当前商品收货未完成，是否换商品？',
  '当前商品超收比例为0，不允许超收': '当前商品超收比例为0，不允许超收',
  '当前库存内存在更新的库存批号': '当前库存内存在更新的库存批号',
  '当前快递单号': '当前快递单号',
  '当前承运商': '当前承运商',
  '当前指令已结束！': '当前指令已结束！',
  '当前指令拣货完成！': '当前指令拣货完成！',
  '当前无可生成拣货单的通知单': '当前无可生成拣货单的通知单',
  '当前无容器，无法满容！': '当前无容器，无法满容！',
  '当前电商承运商未配置打印配置': '当前电商承运商未配置打印配置',
  '当前箱号': '当前箱号',
  '当前箱号不能为空或-,请确定当前箱号': '当前箱号不能为空或-,请确定当前箱号',
  '当前箱号：': '当前箱号：',
  '当前网络不可用': '当前网络不可用',
  '当前角色下存在用户,不能被删除': '当前角色下存在用户,不能被删除',
  '当前订单中包含正在进行中的收货单，确认是否完成该订单?': '当前订单中包含正在进行中的收货单，确认是否完成该订单?',
  '当前订单收货完成，确认是否结束？': '当前订单收货完成，确认是否结束？',
  '当前货位': '当前货位',
  '当前门店分播任务已结束！': '当前门店分播任务已结束！',
  '当天': '当天',
  '当月一号': '当月一号',
  '录入方式': '录入方式',
  '录入结果1': '录入结果1',
  '录入结果1盘点员与录入结果2盘点员不可重复': '录入结果1盘点员与录入结果2盘点员不可重复',
  '录入结果2': '录入结果2',
  '录入默认值': '录入默认值',
  '影响库存分配算法': '影响库存分配算法',
  '待分/应分门店': '待分/应分门店',
  '待分件数': '待分件数',
  '待分数量': '待分数量',
  '待分量': '待分量',
  '待司机交接': '待司机交接',
  '待回容器数(总)': '待回容器数(总)',
  '待回容器数(数量)': '待回容器数(数量)',
  '待回容器数(条码)': '待回容器数(条码)',
  '待回收数': '待回收数',
  '待处理数量': '待处理数量',
  '待处理货位': '待处理货位',
  '待复': '待复',
  '待复SKU数：': '待复SKU数：',
  '待复数量：': '待复数量：',
  '待复核区': '待复核区',
  '待复箱号：': '待复箱号：',
  '待拣货': '待拣货',
  '待揽收': '待揽收',
  '待播 :': '待播 :',
  '待收': '待收',
  '待收数量': '待收数量',
  '待生成': '待生成',
  '待签收': '待签收',
  '待补货出': '待补货出',
  '待补货进': '待补货进',
  '待配货': '待配货',
  '待释放': '待释放',
  '待领用件数': '待领用件数',
  '待领用数量': '待领用数量',
  '循环分配': '循环分配',
  '必检': '必检',
  '必须为0-100之间的整数': '必须为0-100之间的整数',
  '必须满足AABBCCDD，以-隔开的格式': '必须满足AABBCCDD，以-隔开的格式',
  '快捷键配置': '快捷键配置',
  '快照件数': '快照件数',
  '快照数量': '快照数量',
  '快递公司': '快递公司',
  '快递公司不能为空': '快递公司不能为空',
  '快递公司代码': '快递公司代码',
  '快递单号': '快递单号',
  '快递单号不能为空': '快递单号不能为空',
  '快递单号状态日志': '快递单号状态日志',
  '快递单号链接配置': '快递单号链接配置',
  '快递无法配送地址维护': '快递无法配送地址维护',
  '快递无法配送地址配置': '快递无法配送地址配置',
  '快递状态': '快递状态',
  '快递配置名称': '快递配置名称',
  '快递面单': '快递面单',
  '快递面单号': '快递面单号',
  '快速开始 / 便捷导航': '快速开始 / 便捷导航',
  '快速收货': '快速收货',
  '快速装车': '快速装车',
  '忽略': '忽略',
  '总件数': '总件数',
  '总体积': '总体积',
  '总体积(m³)': '总体积(m³)',
  '总品项数': '总品项数',
  '总实盘件数': '总实盘件数',
  '总实盘数量': '总实盘数量',
  '总容器数': '总容器数',
  '总店/待分': '总店/待分',
  '总数量': '总数量',
  '总皮重': '总皮重',
  '总要货/待播 :': '总要货/待播 :',
  '总订单数': '总订单数',
  '总货位数': '总货位数',
  '总重量': '总重量',
  '总金额': '总金额',
  '总门店数': '总门店数',
  '您将修改为{method}，是否修改？': '您将修改为{method}，是否修改？',
  '悬挂称': '悬挂称',
  '悬挂称分播': '悬挂称分播',
  '悬挂称打印模板': '悬挂称打印模板',
  '悬挂称配置': '悬挂称配置',
  '感官质检': '感官质检',
  '感官质检保存成功': '感官质检保存成功',
  '感官质检单': '感官质检单',
  '感官质检单为空': '感官质检单为空',
  '感官质检配置': '感官质检配置',
  '成功': '成功',
  '成功{action}': '成功{action}',
  '成功批量{action}{success}个选项，跳过{skip}个选项': '成功批量{action}{success}个选项，跳过{skip}个选项',
  '成功批量{action}{success}个选项，跳过{skip}个选项，共生成拣货指令{generatedPickTaskCnt}个': '成功批量{action}{success}个选项，跳过{skip}个选项，共生成拣货指令{generatedPickTaskCnt}个',
  '成功退仓0个选项，跳过{length}个选项': '成功退仓0个选项，跳过{length}个选项',
  '成功退仓{length}个选项，跳过{skipUuids}个选项，失败{failNumber}个选项': '成功退仓{length}个选项，跳过{skipUuids}个选项，失败{failNumber}个选项',
  '成员代码/名称': '成员代码/名称',
  '成品': '成品',
  '成品件数': '成品件数',
  '成品信息': '成品信息',
  '成品加工位': '成品加工位',
  '成品加工位代码': '成品加工位代码',
  '成品商品': '成品商品',
  '成品容器': '成品容器',
  '成品数量/重量': '成品数量/重量',
  '成品明细': '成品明细',
  '成品明细不能为空': '成品明细不能为空',
  '成品明细第{line}行件数不能为0': '成品明细第{line}行件数不能为0',
  '成品明细第{line}行包装规格不能为空': '成品明细第{line}行包装规格不能为空',
  '成品记录值是否有默认值': '成品记录值是否有默认值',
  '成品记录值标题': '成品记录值标题',
  '所填写的内容将不会被保存，确认离开{name}页面吗？': '所填写的内容将不会被保存，确认离开{name}页面吗？',
  '所填写的内容将不会被保存，确认离开当前页面吗？': '所填写的内容将不会被保存，确认离开当前页面吗？',
  '所填写的录入结果数据将不会被保存': '所填写的录入结果数据将不会被保存',
  '所属对象': '所属对象',
  '所属组织': '所属组织',
  '所属组织类型': '所属组织类型',
  '所属配送中心：': '所属配送中心：',
  '所执行的操作将不会被保存': '所执行的操作将不会被保存',
  '所有供应商不允许主动退货': '所有供应商不允许主动退货',
  '所有供应商不允许生成拣货单': '所有供应商不允许生成拣货单',
  '所有商品': '所有商品',
  '所有门店': '所有门店',
  '手动包装': '手动包装',
  '手工创建': '手工创建',
  '手工单据': '手工单据',
  '手工差错': '手工差错',
  '手工扫描': '手工扫描',
  '手工指定虚拟货位': '手工指定虚拟货位',
  '手工模式': '手工模式',
  '手工预约': '手工预约',
  '手持终端': '手持终端',
  '手机号仅支持20位以内的字符': '手机号仅支持20位以内的字符',
  '手机号码': '手机号码',
  '打包复核': '打包复核',
  '打包复核台': '打包复核台',
  '打包完成位': '打包完成位',
  '打包完成位/集货位': '打包完成位/集货位',
  '打包拣货': '打包拣货',
  '打包暂存位': '打包暂存位',
  '打包目标位': '打包目标位',
  '打印': '打印',
  '打印后是否自动回主界面': '打印后是否自动回主界面',
  '打印失败：原因未知': '打印失败：原因未知',
  '打印并审核': '打印并审核',
  '打印成功': '打印成功',
  '打印插件': '打印插件',
  '打印时机': '打印时机',
  '打印时间': '打印时间',
  '打印时间间隔': '打印时间间隔',
  '打印机': '打印机',
  '打印机设置': '打印机设置',
  '打印标签': '打印标签',
  '打印标签{length}个选项': '打印标签{length}个选项',
  '打印标签前询问': '打印标签前询问',
  '打印标签拣货': '打印标签拣货',
  '打印标签配置': '打印标签配置',
  '打印模板': '打印模板',
  '打印模板设置': '打印模板设置',
  '打印进度': '打印进度',
  '打开设备端口失败，检查插件是否正常': '打开设备端口失败，检查插件是否正常',
  '扣重比例': '扣重比例',
  '执行': '执行',
  '执行失败！': '执行失败！',
  '执行成功！': '执行成功！',
  '执行标准': '执行标准',
  '执行结果': '执行结果',
  '执行进度': '执行进度',
  '扩展信息': '扩展信息',
  '扩展程序，并解压到本地目录，妥善存储': '扩展程序，并解压到本地目录，妥善存储',
  '扫描件数': '扫描件数',
  '扫描数量': '扫描数量',
  '扫描方式': '扫描方式',
  '扫描枪': '扫描枪',
  '扫描添加': '扫描添加',
  '批准{length}个选项': '批准{length}个选项',
  '批准成功': '批准成功',
  '批号': '批号',
  '批号调整': '批号调整',
  '批次': '批次',
  '批次皮重调整': '批次皮重调整',
  '批次规则配置': '批次规则配置',
  '批注': '批注',
  '批注管理': '批注管理',
  '批量修改': '批量修改',
  '批量修改供应商': '批量修改供应商',
  '批量修改拣货员': '批量修改拣货员',
  '批量修改状态成功': '批量修改状态成功',
  '批量修改生产日期': '批量修改生产日期',
  '批量分配': '批量分配',
  '批量删除': '批量删除',
  '批量删除成功': '批量删除成功',
  '批量填充实盘数量': '批量填充实盘数量',
  '批量处理框': '批量处理框',
  '批量复核': '批量复核',
  '批量复核成功': '批量复核成功',
  '批量完成': '批量完成',
  '批量平移': '批量平移',
  '批量录入': '批量录入',
  '批量录入{title}': '批量录入{title}',
  '批量搜索': '批量搜索',
  '批量搜索货位': '批量搜索货位',
  '批量添加': '批量添加',
  '批量生成`{data}`个货位': '批量生成`{data}`个货位',
  '批量生成`{data}`个货架': '批量生成`{data}`个货架',
  '批量生成`{data}`个货道': '批量生成`{data}`个货道',
  '批量确认': '批量确认',
  '批量移除': '批量移除',
  '批量设置': '批量设置',
  '批量设置供应商目标供应商退货位{count}条成功！': '批量设置供应商目标供应商退货位{count}条成功！',
  '批量设置商品目标拣货位{count}条成功！': '批量设置商品目标拣货位{count}条成功！',
  '批量设置处理方式': '批量设置处理方式',
  '批量设置容器': '批量设置容器',
  '批量设置差异原因': '批量设置差异原因',
  '批量设置成功': '批量设置成功',
  '批量设置拒收原因': '批量设置拒收原因',
  '批量设置拒收数量': '批量设置拒收数量',
  '批量设置拣货位': '批量设置拣货位',
  '批量设置生产日期': '批量设置生产日期',
  '批量设置盘点员': '批量设置盘点员',
  '批量设置目标位置': '批量设置目标位置',
  '批量设置目标供应商退货位': '批量设置目标供应商退货位',
  '批量设置目标容器': '批量设置目标容器',
  '批量设置目标容器为来源容器': '批量设置目标容器为来源容器',
  '批量设置目标拣货位': '批量设置目标拣货位',
  '批量设置目标货位': '批量设置目标货位',
  '批量设置目标货位需先选择商品和退仓类型！': '批量设置目标货位需先选择商品和退仓类型！',
  '批量设置调整数量': '批量设置调整数量',
  '批量设置货位': '批量设置货位',
  '批量设置货位别名成功': '批量设置货位别名成功',
  '批量设置货位校验码成功': '批量设置货位校验码成功',
  '批量设置集货位': '批量设置集货位',
  '批量退仓成功,共生成{data}张退仓单': '批量退仓成功,共生成{data}张退仓单',
  '找不到此商品条码,请核对拣货单': '找不到此商品条码,请核对拣货单',
  '承运商': '承运商',
  '承运商不存在': '承运商不存在',
  '承运商交接单': '承运商交接单',
  '承运商交接单不存在': '承运商交接单不存在',
  '承运商交接单号': '承运商交接单号',
  '承运商打印模板配置': '承运商打印模板配置',
  '承运商权限信息': '承运商权限信息',
  '承运商组织': '承运商组织',
  '承重(kg)': '承重(kg)',
  '抑制率': '抑制率',
  '报损': '报损',
  '报损员': '报损员',
  '报表': '报表',
  '报表名称': '报表名称',
  '报警前缀': '报警前缀',
  '报警前缀不能为空': '报警前缀不能为空',
  '报错': '报错',
  '抽样数量': '抽样数量',
  '抽样时间': '抽样时间',
  '抽检': '抽检',
  '拆并': '拆并',
  '拆并中': '拆并中',
  '拆并员': '拆并员',
  '拆并对象': '拆并对象',
  '拆零': '拆零',
  '拆零拣货位': '拆零拣货位',
  '拆零拣货配置': '拆零拣货配置',
  '拒收': '拒收',
  '拒收件数': '拒收件数',
  '拒收原因': '拒收原因',
  '拒收成功': '拒收成功',
  '拒收数量': '拒收数量',
  '拒收明细第{length}行的原因不能为空': '拒收明细第{length}行的原因不能为空',
  '拒收明细第{length}行的数量最大为{maxQty}': '拒收明细第{length}行的数量最大为{maxQty}',
  '拒绝收货': '拒绝收货',
  '拖拽至此 或 点击上传': '拖拽至此 或 点击上传',
  '拖拽至此 或 点击上传': '拖拽至此 或 点击上传',
  '拣容器号': '拣容器号',
  '拣货': '拣货',
  '拣货中': '拣货中',
  '未开始': '未开始',
  '拣货件数': '拣货件数',
  '拣货件数必须大于0！': '拣货件数必须大于0！',
  '拣货任务列表': '拣货任务列表',
  '拣货任务号': '拣货任务号',
  '拣货任务释放成功！': '拣货任务释放成功！',
  '拣货位': '拣货位',
  '拣货位分组配置': '拣货位分组配置',
  '拣货位提总': '拣货位提总',
  '拣货位调整单': '拣货位调整单',
  '拣货位调整单不存在': '拣货位调整单不存在',
  '拣货作业': '拣货作业',
  '拣货出': '拣货出',
  '拣货分区': '拣货分区',
  '拣货分区存储范围': '拣货分区存储范围',
  '拣货分区：{pickarea}已有配置项': '拣货分区：{pickarea}已有配置项',
  '拣货分组': '拣货分组',
  '拣货区域': '拣货区域',
  '拣货单': '拣货单',
  '拣货单位': '拣货单位',
  '拣货单分组是否考虑货位重合度配置': '拣货单分组是否考虑货位重合度配置',
  '拣货单分组货位重合度配置': '拣货单分组货位重合度配置',
  '拣货单列表': '拣货单列表',
  '拣货单号': '拣货单号',
  '拣货单号,多个单号以逗号隔开': '拣货单号,多个单号以逗号隔开',
  '拣货单审核是否校验配货控制天数': '拣货单审核是否校验配货控制天数',
  '拣货单审核校验配货控制天数配置': '拣货单审核校验配货控制天数配置',
  '拣货单据类型': '拣货单据类型',
  '拣货单据默认容器配置': '拣货单据默认容器配置',
  '拣货单数': '拣货单数',
  '拣货后是否直接平移': '拣货后是否直接平移',
  '拣货员': '拣货员',
  '拣货员不能为空': '拣货员不能为空',
  '拣货员不能为空。': '拣货员不能为空。',
  '拣货员代码': '拣货员代码',
  '拣货员作业配置': '拣货员作业配置',
  '拣货员名称': '拣货员名称',
  '拣货员拣货范围配置': '拣货员拣货范围配置',
  '拣货存储位': '拣货存储位',
  '拣货完成': '拣货完成',
  '拣货容器': '拣货容器',
  '拣货指令': '拣货指令',
  '拣货提总': '拣货提总',
  '拣货操作影响RF补货动线': '拣货操作影响RF补货动线',
  '拣货数量': '拣货数量',
  '拣货数量不能超过设置的超拣比例！': '拣货数量不能超过设置的超拣比例！',
  '拣货数量必须大于0！': '拣货数量必须大于0！',
  '拣货数量调整': '拣货数量调整',
  '拣货方式': '拣货方式',
  '拣货时间': '拣货时间',
  '拣货显示代码': '拣货显示代码',
  '拣货显示数量': '拣货显示数量',
  '拣货显示整箱数量': '拣货显示整箱数量',
  '拣货显示零散数量': '拣货显示零散数量',
  '拣货暂存位': '拣货暂存位',
  '拣货深度': '拣货深度',
  '拣货满足率(%)': '拣货满足率(%)',
  '拣货状态': '拣货状态',
  '拣货类型': '拣货类型',
  '拣货组配置': '拣货组配置',
  '拣货规格': '拣货规格',
  '拣货记录': '拣货记录',
  '拣货进度': '拣货进度',
  '拣货释放时机': '拣货释放时机',
  '拣货量': '拣货量',
  '拣货门店': '拣货门店',
  '拣货面板': '拣货面板',
  '拣货面板功能配置': '拣货面板功能配置',
  '拣货面板员工任务分配配置': '拣货面板员工任务分配配置',
  '拣货顺序': '拣货顺序',
  '拣货顺序不能为空，请填写完整': '拣货顺序不能为空，请填写完整',
  '拣货顺序方案': '拣货顺序方案',
  '拣货顺序方案配置': '拣货顺序方案配置',
  '越库分播拣货容器类型配置': '越库分播拣货容器类型配置',
  '拼托盘门店数': '拼托盘门店数',
  '拼箱': '拼箱',
  '拼箱收货': '拼箱收货',
  '拼箱订单': '拼箱订单',
  '挂起': '挂起',
  '挂起原因': '挂起原因',
  '挂起原因不能为空': '挂起原因不能为空',
  '挂起成功': '挂起成功',
  '挂起时间': '挂起时间',
  '指令上架': '指令上架',
  '指令号': '指令号',
  '指令号: {taskNumber}': '指令号: {taskNumber}',
  '指令看板': '指令看板',
  '指令确认成功！': '指令确认成功！',
  '指令类型': '指令类型',
  '指定的上架单{billNumber}不存在！': '指定的上架单{billNumber}不存在！',
  '指定的上架单不存在！': '指定的上架单不存在！',
  '指定的仓位不存在！': '指定的仓位不存在！',
  '指定的供应商不存在！': '指定的供应商不存在！',
  '指定的供应商交接单{billNumber}不存在！': '指定的供应商交接单{billNumber}不存在！',
  '指定的供应商拣货单{billNumber}不存在！': '指定的供应商拣货单{billNumber}不存在！',
  '指定的供应商退货通知单{billNumber}不存在！': '指定的供应商退货通知单{billNumber}不存在！',
  '指定的修正单{billNumber}不存在！': '指定的修正单{billNumber}不存在！',
  '指定的修正单不存在！': '指定的修正单不存在！',
  '指定的入园单{billNumber}不存在！': '指定的入园单{billNumber}不存在！',
  '指定的入园单{value}不存在！': '指定的入园单{value}不存在！',
  '指定的入库指令{billNumber}不存在！': '指定的入库指令{billNumber}不存在！',
  '指定的入库指令不存在！': '指定的入库指令不存在！',
  '指定的入库订单{billNumber}不存在！': '指定的入库订单{billNumber}不存在！',
  '指定的入库订单不存在！': '指定的入库订单不存在！',
  '指定的内部管理指令{billNumber}不存在！': '指定的内部管理指令{billNumber}不存在！',
  '指定的内部管理指令不存在！': '指定的内部管理指令不存在！',
  '指定的出库指令{billNumber}不存在！': '指定的出库指令{billNumber}不存在！',
  '指定的出库指令不存在！': '指定的出库指令不存在！',
  '指定的分播墙不存在！': '指定的分播墙不存在！',
  '指定的加工单{billNumber}不存在！': '指定的加工单{billNumber}不存在！',
  '指定的加工单不存在！': '指定的加工单不存在！',
  '指定的加工方案不存在！': '指定的加工方案不存在！',
  '指定的商品不存在！': '指定的商品不存在！',
  '指定的容器出入单{billNumber}不存在！': '指定的容器出入单{billNumber}不存在！',
  '指定的容器复查单{billNumber}不存在！': '指定的容器复查单{billNumber}不存在！',
  '指定的容器拆并单{billNumber}不存在！': '指定的容器拆并单{billNumber}不存在！',
  '指定的容器类型不存在！': '指定的容器类型不存在！',
  '指定的容器绑定单{billNumber}不存在！': '指定的容器绑定单{billNumber}不存在！',
  '指定的封仓解仓单{billNumber}不存在！': '指定的封仓解仓单{billNumber}不存在！',
  '指定的封仓解仓单不存在！': '指定的封仓解仓单不存在！',
  '指定的平移单{billNumber}不存在！': '指定的平移单{billNumber}不存在！',
  '指定的库存调整单{billNumber}不存在！': '指定的库存调整单{billNumber}不存在！',
  '指定的库存调整单不存在！': '指定的库存调整单不存在！',
  '指定的感官质检单{billNumber}不存在！': '指定的感官质检单{billNumber}不存在！',
  '指定的感官质检单不存在！': '指定的感官质检单不存在！',
  '指定的承运商不存在！': '指定的承运商不存在！',
  '指定的拣货位调整单{billNumber}不存在！': '指定的拣货位调整单{billNumber}不存在！',
  '指定的拣货分区不存在！': '指定的拣货分区不存在！',
  '指定的拣货单{billNumber}不存在！': '指定的拣货单{billNumber}不存在！',
  '指定的拣货单不存在！': '指定的拣货单不存在！',
  '指定的拣货指令{taskNumber}不存在！': '指定的拣货指令{taskNumber}不存在！',
  '指定的拣货指令不存在！': '指定的拣货指令不存在！',
  '指定的拼箱订单{billNumber}不存在！': '指定的拼箱订单{billNumber}不存在！',
  '指定的拼箱订单不存在！': '指定的拼箱订单不存在！',
  '指定的损耗单{billNumber}不存在！': '指定的损耗单{billNumber}不存在！',
  '指定的损耗单不存在！': '指定的损耗单不存在！',
  '指定的排车单{billNumber}不存在！': '指定的排车单{billNumber}不存在！',
  '指定的收货单{billNumber}不存在！': '指定的收货单{billNumber}不存在！',
  '指定的收货单不存在！': '指定的收货单不存在！',
  '指定的替换方案不存在！': '指定的替换方案不存在！',
  '指定的模板不存在！': '指定的模板不存在！',
  '指定的波次单{billNumber}不存在！': '指定的波次单{billNumber}不存在！',
  '指定的波次单不存在！': '指定的波次单不存在！',
  '指定的溢余单{billNumber}不存在！': '指定的溢余单{billNumber}不存在！',
  '指定的溢余单不存在！': '指定的溢余单不存在！',
  '指定的理化质检单{billNumber}不存在！': '指定的理化质检单{billNumber}不存在！',
  '指定的理化质检单不存在！': '指定的理化质检单不存在！',
  '指定的电商运单{billNumber}不存在！': '指定的电商运单{billNumber}不存在！',
  '指定的电商运单不存在！': '指定的电商运单不存在！',
  '指定的电子凭证单{billNumber}不存在！': '指定的电子凭证单{billNumber}不存在！',
  '指定的电子凭证单不存在！': '指定的电子凭证单不存在！',
  '指定的盘点单{billNumber}不存在！': '指定的盘点单{billNumber}不存在！',
  '指定的盘点计划{billNumber}不存在！': '指定的盘点计划{billNumber}不存在！',
  '指定的移库单{billNumber}不存在！': '指定的移库单{billNumber}不存在！',
  '指定的移库单不存在！': '指定的移库单不存在！',
  '指定的类别不存在！': '指定的类别不存在！',
  '指定的补货单{billNumber}不存在！': '指定的补货单{billNumber}不存在！',
  '指定的装车单{billNumber}不存在！': '指定的装车单{billNumber}不存在！',
  '指定的货主不存在！': '指定的货主不存在！',
  '指定的货位类型不存在！': '指定的货位类型不存在！',
  '指定的质检通知单{billNumber}不存在！': '指定的质检通知单{billNumber}不存在！',
  '指定的车型不存在！': '指定的车型不存在！',
  '指定的车辆不存在！': '指定的车辆不存在！',
  '指定的退仓上架单{billNumber}不存在！': '指定的退仓上架单{billNumber}不存在！',
  '指定的退仓单{billNumber}不存在！': '指定的退仓单{billNumber}不存在！',
  '指定的退仓通知单{billNumber}不存在！': '指定的退仓通知单{billNumber}不存在！',
  '指定的配货差异单{billNumber}不存在！': '指定的配货差异单{billNumber}不存在！',
  '指定的配货通知单{billNumber}不存在！': '指定的配货通知单{billNumber}不存在！',
  '指定的配货通知单不存在！': '指定的配货通知单不存在！',
  '指定的配送中心不存在！': '指定的配送中心不存在！',
  '指定的锁定解锁单{billNumber}不存在！': '指定的锁定解锁单{billNumber}不存在！',
  '指定的锁定解锁单不存在！': '指定的锁定解锁单不存在！',
  '指定的门店不存在！': '指定的门店不存在！',
  '指定的门店交接单{billNumber}不存在！': '指定的门店交接单{billNumber}不存在！',
  '指定的门店交接单不存在！': '指定的门店交接单不存在！',
  '指定的集货区复查单{billNumber}不存在！': '指定的集货区复查单{billNumber}不存在！',
  '指定的集货管理方案不存在！': '指定的集货管理方案不存在！',
  '指定的预检单{billNumber}不存在！': '指定的预检单{billNumber}不存在！',
  '指定的预检单不存在！': '指定的预检单不存在！',
  '指定的预约单{billNumber}不存在！': '指定的预约单{billNumber}不存在！',
  '指定的预约单不存在！': '指定的预约单不存在！',
  '指定的领用单{billNumber}不存在！': '指定的领用单{billNumber}不存在！',
  '指定的领用单不存在！': '指定的领用单不存在！',
  '指定的领用返还单{billNumber}不存在！': '指定的领用返还单{billNumber}不存在！',
  '指定的领用返还单不存在！': '指定的领用返还单不存在！',
  '指定箱号': '指定箱号',
  '指定货位数分配集货位需人为确认': '指定货位数分配集货位需人为确认',
  '指定货位数管理': '指定货位数管理',
  '按体积计算': '按体积计算',
  '按到效期': '按到效期',
  '按库存量': '按库存量',
  '按应拣件数审核时，目标容器不能设置为虚拟容器': '按应拣件数审核时，目标容器不能设置为虚拟容器',
  '按数量': '按数量',
  '按数量回收': '按数量回收',
  '按数量回收容器数': '按数量回收容器数',
  '按数量批量回收': '按数量批量回收',
  '按条码': '按条码',
  '按条码回收': '按条码回收',
  '按条码回收容器数': '按条码回收容器数',
  '按生产日期': '按生产日期',
  '按货位体积计算': '按货位体积计算',
  '按门店组打印': '按门店组打印',
  '振幅': '振幅',
  '损溢商品数量金额限制配置': '损溢商品数量金额限制配置',
  '损溢处理方式': '损溢处理方式',
  '损溢配置': '损溢配置',
  '损耗': '损耗',
  '损耗件数': '损耗件数',
  '损耗前件数': '损耗前件数',
  '损耗前数量': '损耗前数量',
  '损耗单': '损耗单',
  '损耗单品数量金额限制': '损耗单品数量金额限制',
  '损耗后件数': '损耗后件数',
  '损耗后数量': '损耗后数量',
  '损耗溢余': '损耗溢余',
  '损耗类型': '损耗类型',
  '损耗类型的明细不设置目标货位！': '损耗类型的明细不设置目标货位！',
  '换容失败': '换容失败',
  '换容成功': '换容成功',
  '换播箱扫描': '换播箱扫描',
  '换箱时打印': '换箱时打印',
  '授权成功': '授权成功',
  '排车中': '排车中',
  '排车任务信息': '排车任务信息',
  '排车任务明细和附件明细不能同时为空': '排车任务明细和附件明细不能同时为空',
  '排车任务明细看板': '排车任务明细看板',
  '排车任务看板': '排车任务看板',
  '排车单': '排车单',
  '排车单中门店所属线路体系必须相同，请先根据线路体系筛选！': '排车单中门店所属线路体系必须相同，请先根据线路体系筛选！',
  '排车单号': '排车单号',
  '接口中间表保留时长(天)': '接口中间表保留时长(天)',
  '接口中间表保留时长不能为空': '接口中间表保留时长不能为空',
  '接口名称': '接口名称',
  '接口日志': '接口日志',
  '接口日志表保留时长(天)': '接口日志表保留时长(天)',
  '接口日志表保留时长不能为空': '接口日志表保留时长不能为空',
  '接口配置': '接口配置',
  '接收供应商': '接收供应商',
  '接收供应商退货通知单': '接收供应商退货通知单',
  '接收入库订单': '接收入库订单',
  '接收商品': '接收商品',
  '接收商品类别': '接收商品类别',
  '接收日期': '接收日期',
  '接收时间': '接收时间',
  '接收用户': '接收用户',
  '接收退仓通知单': '接收退仓通知单',
  '接收配货差异单': '接收配货差异单',
  '接收配货通知单': '接收配货通知单',
  '接收门店': '接收门店',
  '接收（创建）时间': '接收（创建）时间',
  '控制器': '控制器',
  '控制器删除失败': '控制器删除失败',
  '推荐类型': '推荐类型',
  '推荐集货位': '推荐集货位',
  '提交': '提交',
  '提交成功': '提交成功',
  '提交成功！': '提交成功！',
  '提总': '提总',
  '提总后自动平移': '提总后自动平移',
  '提总审核': '提总审核',
  '提总成功': '提总成功',
  '提总打印模板': '提总打印模板',
  '提总拣货': '提总拣货',
  '提总方式': '提总方式',
  '提总状态': '提总状态',
  '提总类型': '提总类型',
  '提总组': '提总组',
  '提示': '提示',
  '插件ID': '插件ID',
  '插件类型': '插件类型',
  '插件类型不能为空': '插件类型不能为空',
  '搜索': '搜索',
  '搜索{title}': '搜索{title}',
  '搜索商品名称': '搜索商品名称',
  '搜索菜单': '搜索菜单',
  '搜索配置名称': '搜索配置名称',
  '搜索门店名称': '搜索门店名称',
  '摘果': '摘果',
  '摘果打印模板': '摘果打印模板',
  '播种': '播种',
  '播种剩余库存生成': '播种剩余库存生成',
  '播种打印模板': '播种打印模板',
  '播种拣货': '播种拣货',
  '播种拣货单': '播种拣货单',
  '播种拣货单审核校验配货控制天数': '播种拣货单审核校验配货控制天数',
  '操作': '操作',
  '操作一': '操作一',
  '操作三': '操作三',
  '操作二': '操作二',
  '操作五': '操作五',
  '操作人': '操作人',
  '操作人：': '操作人：',
  '操作六': '操作六',
  '操作员': '操作员',
  '操作四': '操作四',
  '操作成功': '操作成功',
  '操作成功！': '操作成功！',
  '操作方式': '操作方式',
  '操作方式不能为空': '操作方式不能为空',
  '操作日志': '操作日志',
  '操作时间': '操作时间',
  '操作记录': '操作记录',
  '操作配置': '操作配置',
  '支持异常商品出货配单类型配置': '支持异常商品出货配单类型配置',
  '支持扩展名：.xls xlsx': '支持扩展名：.xls xlsx',
  '收藏': '收藏',
  '收藏成功': '收藏成功',
  '收藏模块': '收藏模块',
  '收货': '收货',
  '收货不校验控制天数订单类型配置': '收货不校验控制天数订单类型配置',
  '收货中': '收货中',
  '收货人姓名': '收货人姓名',
  '收货人电话': '收货人电话',
  '收货件数': '收货件数',
  '收货修正': '收货修正',
  '收货分配跳转至库存分配': '收货分配跳转至库存分配',
  '收货单': '收货单',
  '收货单号': '收货单号',
  '收货后打印容器条码': '收货后打印容器条码',
  '收货员': '收货员',
  '收货容器后置打印': '收货容器后置打印',
  '收货容器类型': '收货容器类型',
  '收货容超': '收货容超',
  '收货展示拆零拣货位': '收货展示拆零拣货位',
  '收货库存多规格校验': '收货库存多规格校验',
  '收货成功！': '收货成功！',
  '收货打印': '收货打印',
  '收货打印模板配置': '收货打印模板配置',
  '收货打印模板配置日志': '收货打印模板配置日志',
  '收货批注预设内容配置': '收货批注预设内容配置',
  '收货控制天数': '收货控制天数',
  '收货数量': '收货数量',
  '收货日结': '收货日结',
  '收货时仅录入': '收货时仅录入',
  '收货时采集': '收货时采集',
  '收货未分播信息': '收货未分播信息',
  '收货规格': '收货规格',
  '收货规格是否采集': '收货规格是否采集',
  '收货配置': '收货配置',
  '收起': '收起',
  '效期先进先出': '效期先进先出',
  '数字': '数字',
  '数据不能为空': '数据不能为空',
  '数据位': '数据位',
  '数据库名': '数据库名',
  '数据类型': '数据类型',
  '数量': '数量',
  '数量不能为空': '数量不能为空',
  '数量不能为空且需大于0': '数量不能为空且需大于0',
  '数量不能大于对应商品的领用数量': '数量不能大于对应商品的领用数量',
  '数量为0': '数量为0',
  '数量大于': '数量大于',
  '数量小于': '数量小于',
  '数量小于0': '数量小于0',
  '数量必须大于0': '数量必须大于0',
  '数量明细': '数量明细',
  '数量结算': '数量结算',
  '整件': '整件',
  '整件+拆零': '整件+拆零',
  '整件+拆零拣货配置': '整件+拆零拣货配置',
  '整件+拆零配置': '整件+拆零配置',
  '整件或拆零拣货位有值，是否继续保存': '整件或拆零拣货位有值，是否继续保存',
  '整件拣货位': '整件拣货位',
  '整件拣货配置': '整件拣货配置',
  '整件数': '整件数',
  '整体满足率(%)': '整体满足率(%)',
  '整单加工': '整单加工',
  '整托': '整托',
  '整托拣': '整托拣',
  '整托盘': '整托盘',
  '整托盘优先级': '整托盘优先级',
  '整托盘优先级配置': '整托盘优先级配置',
  '整托补货': '整托补货',
  '整托补货实际件数数量须等于待补': '整托补货实际件数数量须等于待补',
  '整箱': '整箱',
  '整箱数': '整箱数',
  '整箱配置': '整箱配置',
  '文件列名': '文件列名',
  '文件：{fileName}上传成功，请导入！': '文件：{fileName}上传成功，请导入！',
  '新供应商': '新供应商',
  '新到效日期': '新到效日期',
  '新品标识默认值': '新品标识默认值',
  '新品结算方式默认值': '新品结算方式默认值',
  '新品结算方式默认值 保存成功': '新品结算方式默认值 保存成功',
  '新品资料默认值配置': '新品资料默认值配置',
  '新增任务': '新增任务',
  '新增商品组': '新增商品组',
  '新增明细': '新增明细',
  '新增附件': '新增附件',
  '新建': '新建',
  '新建{bill}': '新建{bill}',
  '新建体系': '新建体系',
  '新建作业点': '新建作业点',
  '新建供应商退货位配置': '新建供应商退货位配置',
  '新建供应商集货位配置': '新建供应商集货位配置',
  '新建保存成功': '新建保存成功',
  '新建分播墙': '新建分播墙',
  '新建分播管理方案': '新建分播管理方案',
  '新建加工波次': '新建加工波次',
  '新建周期': '新建周期',
  '新建承运商': '新建承运商',
  '新建拣货员拣货范围配置': '新建拣货员拣货范围配置',
  '新建控制器': '新建控制器',
  '新建标签': '新建标签',
  '新建网关服务': '新建网关服务',
  '新建角色': '新建角色',
  '新建配送周期': '新建配送周期',
  '新建门店组': '新建门店组',
  '新建高叉员': '新建高叉员',
  '新批号': '新批号',
  '新批次': '新批次',
  '新父容器': '新父容器',
  '新生产日期': '新生产日期',
  '新的快递单号': '新的快递单号',
  '新的承运商': '新的承运商',
  '新的目录': '新的目录',
  '新皮重值': '新皮重值',
  '新皮重值(kg)': '新皮重值(kg)',
  '新皮重类型': '新皮重类型',
  '新规格': '新规格',
  '新规格/计量单位': '新规格/计量单位',
  '方案': '方案',
  '方案策略': '方案策略',
  '旋转灯': '旋转灯',
  '无': '无',
  '无可打印数据': '无可打印数据',
  '无可核价的明细！': '无可核价的明细！',
  '无感官质检科目': '无感官质检科目',
  '无效': '无效',
  '无法删除企业端维护的门店起要量': '无法删除企业端维护的门店起要量',
  '无法获取打印模板': '无法获取打印模板',
  '无需质检': '无需质检',
  '无预约': '无预约',
  '日志': '日志',
  '日志时间': '日志时间',
  '日志清理配置': '日志清理配置',
  '日志类型': '日志类型',
  '日志级别': '日志级别',
  '日志级别不能为空': '日志级别不能为空',
  '日志详情': '日志详情',
  '日志路径': '日志路径',
  '日结日志': '日结日志',
  '日结类型': '日结类型',
  '日结配置': '日结配置',
  '旧父容器': '旧父容器',
  '早安，': '早安，',
  '时间轴': '时间轴',
  '明盘': '明盘',
  '明细': '明细',
  '明细不能为空': '明细不能为空',
  '明细第{line}和第{otherLine}重复': '明细第{line}和第{otherLine}重复',
  '明细第{line}行不能为空！': '明细第{line}行不能为空！',
  '明细第{line}行与第{line}行重复！': '明细第{line}行与第{line}行重复！',
  '明细第{line}行与第{otherLine}行单据字段重复！': '明细第{line}行与第{otherLine}行单据字段重复！',
  '明细第{line}行与第{otherLine}行商品不同,目标货位相同！': '明细第{line}行与第{otherLine}行商品不同,目标货位相同！',
  '明细第{line}行与第{otherLine}行封签号不一致！': '明细第{line}行与第{otherLine}行封签号不一致！',
  '明细第{line}行与第{otherLine}行文件列名重复！': '明细第{line}行与第{otherLine}行文件列名重复！',
  '明细第{line}行与第{otherLine}行重复！': '明细第{line}行与第{otherLine}行重复！',
  '明细第{line}行商品不能为空！': '明细第{line}行商品不能为空！',
  '明细第{line}行地址不能为空': '明细第{line}行地址不能为空',
  '明细第{line}行地址街道不能为空': '明细第{line}行地址街道不能为空',
  '明细第{line}行地址街道最大长度为200': '明细第{line}行地址街道最大长度为200',
  '明细第{line}行数量结算商品，件数是m+n格式，m和n不能同时为0': '明细第{line}行数量结算商品，件数是m+n格式，m和n不能同时为0',
  '明细第{line}行文件列名不能为空！': '明细第{line}行文件列名不能为空！',
  '明细第{line}行新供应商不能与原供应商一致！': '明细第{line}行新供应商不能与原供应商一致！',
  '明细第{line}行新供应商不能为空！': '明细第{line}行新供应商不能为空！',
  '明细第{line}行新到效期不能为空！': '明细第{line}行新到效期不能为空！',
  '明细第{line}行新生产日期不能为空！': '明细第{line}行新生产日期不能为空！',
  '明细第{line}行新生产日期与原生产日期、新到效期也原到效期不能都一致！': '明细第{line}行新生产日期与原生产日期、新到效期也原到效期不能都一致！',
  '明细第{line}行新皮重类型不能为空！': '明细第{line}行新皮重类型不能为空！',
  '明细第{line}行新规格不能与原规格一致！': '明细第{line}行新规格不能与原规格一致！',
  '明细第{line}行新规格不能为空！': '明细第{line}行新规格不能为空！',
  '明细第{line}行无商品规格1*1*1！': '明细第{line}行无商品规格1*1*1！',
  '明细第{line}行服务模式不能为空': '明细第{line}行服务模式不能为空',
  '明细第{line}行来源货位不能等于目标货位！': '明细第{line}行来源货位不能等于目标货位！',
  '明细第{line}行来源货位代码不能为空！': '明细第{line}行来源货位代码不能为空！',
  '明细第{line}行目标货位代码不能为空！': '明细第{line}行目标货位代码不能为空！',
  '明细第{line}行码头集不能为空！': '明细第{line}行码头集不能为空！',
  '明细第{line}行移库数量不能为0！': '明细第{line}行移库数量不能为0！',
  '明细第{line}行移库数量为0！': '明细第{line}行移库数量为0！',
  '明细第{line}行移库目标容器不能为空！': '明细第{line}行移库目标容器不能为空！',
  '明细第{line}行移库目标货位不能为空！': '明细第{line}行移库目标货位不能为空！',
  '明细第{line}行线路不能为空！': '明细第{line}行线路不能为空！',
  '明细第{line}行重复': '明细第{line}行重复',
  '明细第{line}行重量结算的商品，件数和数量不能同时为0': '明细第{line}行重量结算的商品，件数和数量不能同时为0',
  '明细第{line}行门店不能为空！': '明细第{line}行门店不能为空！',
  '明细行': '明细行',
  '明细行只能为同一供应商': '明细行只能为同一供应商',
  '是': '是',
  '是否为默认': '是否为默认',
  '是否为默认生产日期': '是否为默认生产日期',
  '是否作废通知单': '是否作废通知单',
  '是否删除容器出入单': '是否删除容器出入单',
  '是否删除该用户': '是否删除该用户',
  '是否删除质检通知单': '是否删除质检通知单',
  '是否删除退仓上架单': '是否删除退仓上架单',
  '是否删除退仓单': '是否删除退仓单',
  '是否删除通知单': '是否删除通知单',
  '是否删除配货差异单': '是否删除配货差异单',
  '是否动态拣货': '是否动态拣货',
  '是否合并生成任务': '是否合并生成任务',
  '是否合格': '是否合格',
  '是否启动多货强分加强算法': '是否启动多货强分加强算法',
  '是否启用': '是否启用',
  '是否启用RFiD装车复核': '是否启用RFiD装车复核',
  '是否启用RFiD集货平移复核': '是否启用RFiD集货平移复核',
  '是否启用分拣机配置': '是否启用分拣机配置',
  '是否启用加工单完成状态': '是否启用加工单完成状态',
  '是否启用包装机配置': '是否启用包装机配置',
  '是否复制通知单': '是否复制通知单',
  '是否复查': '是否复查',
  '是否审核': '是否审核',
  '是否审核通知单': '是否审核通知单',
  '是否差异': '是否差异',
  '是否已分配': '是否已分配',
  '是否已加工': '是否已加工',
  '是否已打印': '是否已打印',
  '是否已盘': '是否已盘',
  '是否强制绑定': '是否强制绑定',
  '是否强制预检': '是否强制预检',
  '是否强制预约': '是否强制预约',
  '是否批准质检通知单': '是否批准质检通知单',
  '是否批量': '是否批量',
  '是否批量{action}{number} 个选项?': '是否批量{action}{number} 个选项?',
  '是否批量{action}{number}个{item}?': '是否批量{action}{number}个{item}?',
  '是否批量{action}{number}个选项?': '是否批量{action}{number}个选项?',
  '是否损耗': '是否损耗',
  '是否新品': '是否新品',
  '是否最新版本': '是否最新版本',
  '是否核价': '是否核价',
  '是否生成质检单': '是否生成质检单',
  '是否电商专属': '是否电商专属',
  '直接集货': '直接集货',
  '是否确认切换新指令拣货？': '是否确认切换新指令拣货？',
  '是否确认切换门店分播？': '是否确认切换门店分播？',
  '是否确认回收': '是否确认回收',
  '是否确认完成通知单': '是否确认完成通知单',
  '是否确认审核:{billNumber}': '是否确认审核:{billNumber}',
  '是否确认审核容器出入单': '是否确认审核容器出入单',
  '是否确认审核退仓上架单': '是否确认审核退仓上架单',
  '是否确认审核退仓单': '是否确认审核退仓单',
  '是否确认审核配货差异单': '是否确认审核配货差异单',
  '是否确认配送门店交接单': '是否确认配送门店交接单',
  '是否称重': '是否称重',
  '是否管理温度': '是否管理温度',
  '是否自动绑箱': '是否自动绑箱',
  '是否自动获取容器': '是否自动获取容器',
  '是否要删除所选数据？': '是否要删除所选数据？',
  '是否要删除此行？': '是否要删除此行？',
  '是否要删除选择行？': '是否要删除选择行？',
  '是否设为默认': '是否设为默认',
  '是否配置悬挂称打印': '是否配置悬挂称打印',
  '是否配置摘果打印': '是否配置摘果打印',
  '是否配置播种打印': '是否配置播种打印',
  '是否零库存': '是否零库存',
  '是否默认': '是否默认',
  '显示规格数量': '显示规格数量',
  '暂不支持{printPluginType}打印': '暂不支持{printPluginType}打印',
  '暂无任务': '暂无任务',
  '暂无数据': '暂无数据',
  '暂无数据,请先选择任务': '暂无数据,请先选择任务',
  '暂无数据，请刷新重试': '暂无数据，请刷新重试',
  '暂无符合条件的数据': '暂无符合条件的数据',
  '暂未添加此数据': '暂未添加此数据',
  '更多': '更多',
  '更换商品': '更换商品',
  '更新': '更新',
  '更新商品组': '更新商品组',
  '更新成功': '更新成功',
  '更新配送周期': '更新配送周期',
  '更正件数': '更正件数',
  '更正成功': '更正成功',
  '更正数量': '更正数量',
  '替换': '替换',
  '替换商品明细第{line}行与第{otherLine}行重复！': '替换商品明细第{line}行与第{otherLine}行重复！',
  '替换明细': '替换明细',
  '替换量必须大于0': '替换量必须大于0',
  '最低库存应小于等于最高库存': '最低库存应小于等于最高库存',
  '最后打印时间：': '最后打印时间：',
  '最多可预品项数必须大于0！': '最多可预品项数必须大于0！',
  '最多可预约件数必须大于0！': '最多可预约件数必须大于0！',
  '最大体积': '最大体积',
  '最大体积不能为空': '最大体积不能为空',
  '最大单据数': '最大单据数',
  '最大容量': '最大容量',
  '最大批号': '最大批号',
  '最大明细数必须是正整数': '最大明细数必须是正整数',
  '最大用户数不能小于1': '最大用户数不能小于1',
  '最大货主用户数': '最大货主用户数',
  '最大货位数': '最大货位数',
  '最大长度为30': '最大长度为30',
  '最小体积': '最小体积',
  '最小打印标签数': '最小打印标签数',
  '展示下一单门店信息': '展示下一单门店信息',
  '展示门店拣货进度': '展示门店拣货进度',
  '最小批号': '最小批号',
  '最高最低库存': '最高最低库存',
  '有': '有',
  '有效': '有效',
  '服务关闭成功': '服务关闭成功',
  '服务启动成功': '服务启动成功',
  '服务器管理': '服务器管理',
  '服务地址': '服务地址',
  '服务模式': '服务模式',
  '服务版本号': '服务版本号',
  '服务重启成功': '服务重启成功',
  '未交接': '未交接',
  '未分配强分数量': '未分配强分数量',
  '未勾选的不能移动': '未勾选的不能移动',
  '未命名': '未命名',
  '未在订单中找到此商品条码': '未在订单中找到此商品条码',
  '未完成': '未完成',
  '未审核': '未审核',
  '未批准': '未批准',
  '未找到可提交的复核数据': '未找到可提交的复核数据',
  '未找到复核商品': '未找到复核商品',
  '未找到当前容器类型序列': '未找到当前容器类型序列',
  '未找到此承运商的复核台配置': '未找到此承运商的复核台配置',
  '未拼箱': '未拼箱',
  '未排车': '未排车',
  '未查询到快递公司信息': '未查询到快递公司信息',
  '未查询到所选商品的拣货位方案': '未查询到所选商品的拣货位方案',
  '未查询到通知单中的商品': '未查询到通知单中的商品',
  '未添加配置项': '未添加配置项',
  '未生成盘点单，该盘点计划已完成': '未生成盘点单，该盘点计划已完成',
  '未生成补货单': '未生成补货单',
  '未维护打印机设置': '未维护打印机设置',
  '未维护打印机，请先配置打印机': '未维护打印机，请先配置打印机',
  '未维护虚拟货位': '未维护虚拟货位',
  '未装车': '未装车',
  '未设置分播打印模板，请设置打印模板设置': '未设置分播打印模板，请设置打印模板设置',
  '未设置提总打印模板，请设置打印模板设置': '未设置提总打印模板，请设置打印模板设置',
  '未质检': '未质检',
  '未配置iWMS打印插件': '未配置iWMS打印插件',
  '未配置打印模板': '未配置打印模板',
  '未配置端口，检查设备是否已连接': '未配置端口，检查设备是否已连接',
  '本次复查无差异，是否确认结束？': '本次复查无差异，是否确认结束？',
  '本次收货超过超收比例，是否确认收货？': '本次收货超过超收比例，是否确认收货？',
  '本次送出容器': '本次送出容器',
  '本次送出容器 + 装车时在门店容器': '本次送出容器 + 装车时在门店容器',
  '本次预约': '本次预约',
  '机器人拣货': '机器人拣货',
  '权限信息': '权限信息',
  '条': '条',
  '条码': '条码',
  '条码前缀': '条码前缀',
  '条码前缀必须是大写字母组成，长度最大为2位': '条码前缀必须是大写字母组成，长度最大为2位',
  '条码类型': '条码类型',
  '条码规格关系配置': '条码规格关系配置',
  '条码长度': '条码长度',
  '条码：{barcode} 已存在，规格：{qpcStr} 已存在': '条码：{barcode} 已存在，规格：{qpcStr} 已存在',
  '来源仓库': '来源仓库',
  '来源代码': '来源代码',
  '来源位置': '来源位置',
  '来源单号': '来源单号',
  '来源单号最大长度为30': '来源单号最大长度为30',
  '来源单据': '来源单据',
  '来源单据类型': '来源单据类型',
  '来源单据行号': '来源单据行号',
  '来源容器': '来源容器',
  '来源对象': '来源对象',
  '来源方式': '来源方式',
  '来源类型': '来源类型',
  '来源组织': '来源组织',
  '来源货位': '来源货位',
  '来源货位用途': '来源货位用途',
  '来源货位范围': '来源货位范围',
  '构建菜单结构': '构建菜单结构',
  '查看': '查看',
  '查看任务': '查看任务',
  '查看差异': '查看差异',
  '查看详情': '查看详情',
  '查询': '查询',
  '查询上游库存': '查询上游库存',
  '标准规格': '标准规格',
  '标签': '标签',
  '标签分播': '标签分播',
  '标签提总/分播': '标签提总/分播',
  '标签地址': '标签地址',
  '标签属性': '标签属性',
  '标签拣货': '标签拣货',
  '标签提总': '标签提总',
  '标签提总/分播配置': '标签提总/分播配置',
  '标签类型': '标签类型',
  '标签范围': '标签范围',
  '标签补货': '标签补货',
  '校验强度': '校验强度',
  '校验码': '校验码',
  '校验规则': '校验规则',
  '样品大类': '样品大类',
  '样品小类': '样品小类',
  '核价{length}个选项': '核价{length}个选项',
  '核对价格高于原价': '核对价格高于原价',
  '根据目标货位：{toBinCode}查不到生鲜拣货分区配置': '根据目标货位：{toBinCode}查不到生鲜拣货分区配置',
  '格式为1*m*n': '格式为1*m*n',
  '格式：2001-3090,4001-5090 格式': '格式：2001-3090,4001-5090 格式',
  '档期编号': '档期编号',
  '检查到你还有未提交数据，请先满容提交再结束复核': '检查到你还有未提交数据，请先满容提交再结束复核',
  '检查插件': '检查插件',
  '检测单位': '检测单位',
  '检测员': '检测员',
  '检测时间': '检测时间',
  '检测机构代码': '检测机构代码',
  '检测机构代码最大长度为30': '检测机构代码最大长度为30',
  '检测机构名称': '检测机构名称',
  '检测机构名称最大长度为100': '检测机构名称最大长度为100',
  '检疫证': '检疫证',
  '概要': '概要',
  '模块名': '模块名',
  '模式': '模式',
  '模板': '模板',
  '模板下载': '模板下载',
  '模板名称': '模板名称',
  '模板路径': '模板路径',
  '模板配置': '模板配置',
  '正向修改': '正向修改',
  '正向修正单明细第{line}行与第{otherLine}行重复！': '正向修正单明细第{line}行与第{otherLine}行重复！',
  '正向修正明细第{line}行修正原因不能为空！': '正向修正明细第{line}行修正原因不能为空！',
  '正向修正明细第{line}行到效期不能为空！': '正向修正明细第{line}行到效期不能为空！',
  '正向修正明细第{line}行单价不能为空或小于0！': '正向修正明细第{line}行单价不能为空或小于0！',
  '正向修正明细第{line}行商品不能为空！': '正向修正明细第{line}行商品不能为空！',
  '正向修正明细第{line}行容器条码不能为空！': '正向修正明细第{line}行容器条码不能为空！',
  '正向修正明细第{line}行数量不能为0！': '正向修正明细第{line}行数量不能为0！',
  '正向修正明细第{line}行生产日期不能为空！': '正向修正明细第{line}行生产日期不能为空！',
  '正向修正明细第{line}行货位代码不能为空！': '正向修正明细第{line}行货位代码不能为空！',
  '正在{action}': '正在{action}',
  '正在复核：{box},当前第{index}个,共{total}个': '正在复核：{box},当前第{index}个,共{total}个',
  '正常': '正常',
  '正常收货': '正常收货',
  '正排序': '正排序',
  '此包裹号已扫描': '此包裹号已扫描',
  '此快递单中没有此包裹号或此包裹已扫描过': '此快递单中没有此包裹号或此包裹已扫描过',
  '此快递单号查询结果为空': '此快递单号查询结果为空',
  '此盘点单不允许多人盘点': '此盘点单不允许多人盘点',
  '此规格存在库存,不允许被删除': '此规格存在库存,不允许被删除',
  '此订单没有待收货的商品或已收货完毕': '此订单没有待收货的商品或已收货完毕',
  '每次新增': '每次新增',
  '每次跨度': '每次跨度',
  '每组拣货单数量': '每组拣货单数量',
  '每组拣货单数量不为空': '每组拣货单数量不为空',
  '比例分配': '比例分配',
  '比较录入结果': '比较录入结果',
  '毛重': '毛重',
  '毛重/皮重': '毛重/皮重',
  '毛重/皮重管理方案': '毛重/皮重管理方案',
  '毛重/皮重管理配置': '毛重/皮重管理配置',
  '毛重/读称': '毛重/读称',
  '永久': '永久',
  '汇总信息': '汇总信息',
  '没有分播门店信息或已分播完毕，无法提交': '没有分播门店信息或已分播完毕，无法提交',
  '没有可分组数据': '没有可分组数据',
  '没有商品规格信息返回': '没有商品规格信息返回',
  '没有指定箱号': '没有指定箱号',
  '没有数据': '没有数据',
  '没有选择货主。': '没有选择货主。',
  '没有选择货主或者仓位。': '没有选择货主或者仓位。',
  '没有需要提交的数据！': '没有需要提交的数据！',
  '油耗': '油耗',
  '波次(%)': '波次(%)',
  '波次-选择释放时机': '波次-选择释放时机',
  '波次任务释放时机配置': '波次任务释放时机配置',
  '波次作业分单配单类型配置': '波次作业分单配单类型配置',
  '波次信息': '波次信息',
  '波次单': '波次单',
  '波次单不能为空': '波次单不能为空',
  '波次单号': '波次单号',
  '波次单号不能为空': '波次单号不能为空',
  '波次单号，多个波次单号以英文逗号隔开': '波次单号，多个波次单号以英文逗号隔开',
  '波次单号，多个波次单号以逗号隔开': '波次单号，多个波次单号以逗号隔开',
  '波次单选择': '波次单选择',
  '波次号': '波次号',
  '波次号不能为空': '波次号不能为空',
  '波次执行是否允许修改释放时机': '波次执行是否允许修改释放时机',
  '波次算法功能配置': '波次算法功能配置',
  '波次类型': '波次类型',
  '波次补货': '波次补货',
  '波特率': '波特率',
  '注册成功': '注册成功',
  '注解:': '注解:',
  '派件中': '派件中',
  '流程进度': '流程进度',
  '测试': '测试',
  '测试新建': '测试新建',
  '测试查看': '测试查看',
  '测试编辑': '测试编辑',
  '浏览历史': '浏览历史',
  '海外': '海外',
  '海鼎': '海鼎',
  '海鼎信息工程股份有限公司': '海鼎信息工程股份有限公司',
  '消息配置': '消息配置',
  '混合单据日志': '混合单据日志',
  '混合提总': '混合提总',
  '混载': '混载',
  '混载上架': '混载上架',
  '添加': '添加',
  '添加上级菜单': '添加上级菜单',
  '添加分割线': '添加分割线',
  '添加容器': '添加容器',
  '添加平级菜单': '添加平级菜单',
  '添加库存信息': '添加库存信息',
  '添加成功': '添加成功',
  '添加明细': '添加明细',
  '添加用户': '添加用户',
  '添加线路': '添加线路',
  '添加网关': '添加网关',
  '添加门店': '添加门店',
  '添加门店组': '添加门店组',
  '添加默认门店': '添加默认门店',
  '清屏': '清屏',
  '温度': '温度',
  '溢余': '溢余',
  '溢余件数': '溢余件数',
  '溢余前件数': '溢余前件数',
  '溢余前数量': '溢余前数量',
  '溢余单': '溢余单',
  '溢余单保存成功': '溢余单保存成功',
  '溢余单品数量金额限制': '溢余单品数量金额限制',
  '溢余单明细不能为空！': '溢余单明细不能为空！',
  '溢余单明细第{line1}行与第{line2}行重复！': '溢余单明细第{line1}行与第{line2}行重复！',
  '溢余单明细第{line}行与第{otherLine}行重复！': '溢余单明细第{line}行与第{otherLine}行重复！',
  '溢余单明细第{line}行件数或数量不合法': '溢余单明细第{line}行件数或数量不合法',
  '溢余单明细第{line}行供应商不能为空！': '溢余单明细第{line}行供应商不能为空！',
  '溢余单明细第{line}行到效期不能为空！': '溢余单明细第{line}行到效期不能为空！',
  '溢余单明细第{line}行单价不能为空！': '溢余单明细第{line}行单价不能为空！',
  '溢余单明细第{line}行商品不能为空！': '溢余单明细第{line}行商品不能为空！',
  '溢余单明细第{line}行备注长度最大为255！': '溢余单明细第{line}行备注长度最大为255！',
  '溢余单明细第{line}行容器条码不能为空！': '溢余单明细第{line}行容器条码不能为空！',
  '溢余单明细第{line}行溢余数量不能为0！': '溢余单明细第{line}行溢余数量不能为0！',
  '溢余单明细第{line}行生产日期不能为空！': '溢余单明细第{line}行生产日期不能为空！',
  '溢余单明细第{line}行货位代码不能为空！': '溢余单明细第{line}行货位代码不能为空！',
  '溢余后件数': '溢余后件数',
  '溢余后数量': '溢余后数量',
  '溢余员': '溢余员',
  '溢余类型': '溢余类型',
  '溢出': '溢出',
  '满容': '满容',
  '满容{length}个选项': '满容{length}个选项',
  '满容并打印': '满容并打印',
  '满容成功': '满容成功',
  '满容成功！': '满容成功！',
  '满箱': '满箱',
  '满足m+n、m格式': '满足m+n、m格式',
  '满足格式10、10(1/2)、10-20，多个以逗号隔开': '满足格式10、10(1/2)、10-20，多个以逗号隔开',
  '点击上传': '点击上传',
  '爆品模式': '爆品模式',
  '爆品模式条件配置': '爆品模式条件配置',
  '爆品秒杀': '爆品秒杀',
  '父容器': '父容器',
  '版本信息': '版本信息',
  '版本号': '版本号',
  '物流及ERP均可发起': '物流及ERP均可发起',
  '物流发起': '物流发起',
  '物流模式': '物流模式',
  '物流模式为“越库”时，订单号必须输入。': '物流模式为“越库”时，订单号必须输入。',
  '物流模式：{logisticMode}': '物流模式：{logisticMode}',
  '状态': '状态',
  '状态：': '状态：',
  '理化质检单': '理化质检单',
  '理化质检看板': '理化质检看板',
  '理化质检科目': '理化质检科目',
  '理化质检配置': '理化质检配置',
  '生产企业': '生产企业',
  '生产日期': '生产日期',
  '生产日期不能晚于当前日期': '生产日期不能晚于当前日期',
  '生产日期管理配置': '生产日期管理配置',
  '生产规格': '生产规格',
  '生成任务': '生成任务',
  '生成快照': '生成快照',
  '生成快照{length}个选项': '生成快照{length}个选项',
  '生成快照成功': '生成快照成功',
  '生成成功': '生成成功',
  '生成指令': '生成指令',
  '生成指令成功': '生成指令成功',
  '生成排车单': '生成排车单',
  '生成数量': '生成数量',
  '生成时间': '生成时间',
  '生成盘点单': '生成盘点单',
  '生成装车单': '生成装车单',
  '生成规则': '生成规则',
  '生成进度': '生成进度',
  '生效': '生效',
  '生效成功': '生效成功',
  '生鲜': '生鲜',
  '生鲜拣货分区配置': '生鲜拣货分区配置',
  '生鲜拣货打印配置': '生鲜拣货打印配置',
  '生鲜摘果': '生鲜摘果',
  '生鲜摘果使用容器方式': '生鲜摘果使用容器方式',
  '生鲜播种': '生鲜播种',
  '生鲜收货': '生鲜收货',
  '生鲜盘点': '生鲜盘点',
  '生鲜配置': '生鲜配置',
  '生鲜面板拣货顺序方案配置': '生鲜面板拣货顺序方案配置',
  '用户': '用户',
  '用户信息': '用户信息',
  '用户名': '用户名',
  '用户管理': '用户管理',
  '用户配置': '用户配置',
  '货位容器管理配置': '货位容器管理配置',
  '存储位容器管理 保存成功': '存储位容器管理 保存成功',
  '存储位容器管理': '存储位容器管理',
  '用途': '用途',
  '电商': '电商',
  '电商分播': '电商分播',
  '电商客户订单可作废状态配置': '电商客户订单可作废状态配置',
  '电商拣货': '电商拣货',
  '电商拣货设备配置': '电商拣货设备配置',
  '电商专人拣货配货类型配置': '电商专人拣货配货类型配置',
  '电商提总是否自动带出箱零': '电商提总是否自动带出箱零',
  '电商模式每次只允许复核一张拣货单': '电商模式每次只允许复核一张拣货单',
  '电商运单信息': '电商运单信息',
  '电商配置': '电商配置',
  '电子凭证单': '电子凭证单',
  '电子凭证单保存成功': '电子凭证单保存成功',
  '电子凭证单明细不能为空！': '电子凭证单明细不能为空！',
  '电子凭证单明细第{line}行原因不能为空！': '电子凭证单明细第{line}行原因不能为空！',
  '电子凭证单明细第{line}行备注长度最大为255！': '电子凭证单明细第{line}行备注长度最大为255！',
  '电子标签': '电子标签',
  '电子标签包装数': '电子标签包装数',
  '电子标签回传': '电子标签回传',
  '电子标签拣货作业': '电子标签拣货作业',
  '电子标签组件': '电子标签组件',
  '电子标签组件：': '电子标签组件：',
  '电子秤': '电子秤',
  '电子秤测试': '电子秤测试',
  '电子运单号': '电子运单号',
  '界面显示': '界面显示',
  '界面跳转': '界面跳转',
  '登录信息失效，请重新登录！': '登录信息失效，请重新登录！',
  '登记成功': '登记成功',
  '皮重/读称': '皮重/读称',
  '皮重值(kg)': '皮重值(kg)',
  '皮重比例': '皮重比例',
  '皮重类型': '皮重类型',
  '皮重记录维度': '皮重记录维度',
  '皮重记录维度设置': '皮重记录维度设置',
  '盒马门店条码': '盒马门店条码',
  '盘点': '盘点',
  '盘点件数触发值': '盘点件数触发值',
  '盘点信息': '盘点信息',
  '盘点修改': '盘点修改',
  '盘点单': '盘点单',
  '盘点单生成成功，共生成单据{data}张': '盘点单生成成功，共生成单据{data}张',
  '盘点员': '盘点员',
  '盘点员不能为空': '盘点员不能为空',
  '盘点序列号': '盘点序列号',
  '盘点库存处理方式': '盘点库存处理方式',
  '盘点录入': '盘点录入',
  '盘点方式': '盘点方式',
  '盘点方式不能为空': '盘点方式不能为空',
  '盘点明细不能为空': '盘点明细不能为空',
  '盘点模式': '盘点模式',
  '盘点模式不能为空': '盘点模式不能为空',
  '盘点生产日期': '盘点生产日期',
  '盘点生成': '盘点生成',
  '盘点范围': '盘点范围',
  '盘点计划': '盘点计划',
  '盘点计划已删除': '盘点计划已删除',
  '盘点计划已完成': '盘点计划已完成',
  '盘点路径顺序': '盘点路径顺序',
  '盘点配置': '盘点配置',
  '盘点默认计入方式': '盘点默认计入方式',
  '目录名称': '目录名称',
  '目标优先级': '目标优先级',
  '目标位置': '目标位置',
  '目标位置不能为空': '目标位置不能为空',
  '目标位置为集货暂存位时，必须输入目标容器': '目标位置为集货暂存位时，必须输入目标容器',
  '目标容器': '目标容器',
  '目标序号': '目标序号',
  '目标操作方式': '目标操作方式',
  '目标状态': '目标状态',
  '目标组号': '目标组号',
  '目标行号': '目标行号',
  '目标货位': '目标货位',
  '目标货位为{caption}须填写目标容器': '目标货位为{caption}须填写目标容器',
  '盲盘': '盲盘',
  '省/直辖市': '省/直辖市',
  '看板展示': '看板展示',
  '看板库存配置': '看板库存配置',
  '知道了': '知道了',
  '码头': '码头',
  '码头不存在': '码头不存在',
  '码头信息': '码头信息',
  '码头集': '码头集',
  '码头集不能为空': '码头集不能为空',
  '码头集货位配置': '码头集货位配置',
  '码头集配置': '码头集配置',
  '码头集集货位配置': '码头集集货位配置',
  '确定': '确定',
  '确定删除该拣货员作业配置:{name}吗?': '确定删除该拣货员作业配置:{name}吗?',
  '确定删除该领料员作业配置:{name}吗?': '确定删除该领料员作业配置:{name}吗?',
  '确定要停止测试吗?': '确定要停止测试吗?',
  '确定要删除当前数据': '确定要删除当前数据',
  '确定要删除当前线路？': '确定要删除当前线路？',
  '确定要删除所选门店': '确定要删除所选门店',
  '确定要删除所选门店？': '确定要删除所选门店？',
  '确定要启动测试吗?': '确定要启动测试吗?',
  '确认': '确认',
  '确认{length}个选项': '确认{length}个选项',
  '确认{message}': '确认{message}',
  '确认{operate}': '确认{operate}',
  '确认{operate}该{object}吗?': '确认{operate}该{object}吗?',
  '确认{operate}该商品组？': '确认{operate}该商品组？',
  '确认{operate}该报表[{reportName}]吗？': '确认{operate}该报表[{reportName}]吗？',
  '确认{operate}该模板？': '确认{operate}该模板？',
  '确认{operate}该目录[{menuName}]吗?若该目录下存在报表，则不能被删除，建议将报表移动至到其他目录下再做删除操作': '确认{operate}该目录[{menuName}]吗?若该目录下存在报表，则不能被删除，建议将报表移动至到其他目录下再做删除操作',
  '确认{operate}该配置：{name}': '确认{operate}该配置：{name}',
  '确认{operate}该门店组？': '确认{operate}该门店组？',
  '确认中断录入结果操作吗？': '确认中断录入结果操作吗？',
  '确认修改分拣策略类型?修改分拣策略类型将导致明细清空': '确认修改分拣策略类型?修改分拣策略类型将导致明细清空',
  '确认修改分播方式{length}个选项': '确认修改分播方式{length}个选项',
  '确认修改商品？修改商品将会导致耗材明细清空': '确认修改商品？修改商品将会导致耗材明细清空',
  '确认修改拣货员{length}个选项': '确认修改拣货员{length}个选项',
  '确认修改拣货类型为单品模式': '确认修改拣货类型为单品模式',
  '确认修改拣货类型为多品模式': '确认修改拣货类型为多品模式',
  '确认修改补货步骤': '确认修改补货步骤',
  '确认分播审核{length}个选项': '确认分播审核{length}个选项',
  '确认删除': '确认删除',
  '确认删除?': '确认删除?',
  '确认删除[': '确认删除[',
  '确认删除[{code}{name}]角色吗?': '确认删除[{code}{name}]角色吗?',
  '确认删除{length}个选项': '确认删除{length}个选项',
  '确认删除控制器[': '确认删除控制器[',
  '确认删除此交接单{billNumber}？': '确认删除此交接单{billNumber}？',
  '确认删除此分拣道口:{billNumber}？': '确认删除此分拣道口:{billNumber}？',
  '确认删除此分播管理方案{entity}？': '确认删除此分播管理方案{entity}？',
  '确认删除此商品耗材:{billNumber}？': '确认删除此商品耗材:{billNumber}？',
  '确认删除此附件？': '确认删除此附件？',
  '确认删除该分播类型：{type}': '确认删除该分播类型：{type}',
  '确认删除该拣货组？': '确认删除该拣货组？',
  '确认删除该模板？': '确认删除该模板？',
  '确认删除该配置{codeName}？': '确认删除该配置{codeName}？',
  '确认删除该配置？': '确认删除该配置？',
  '确认删除选中的明细？': '确认删除选中的明细？',
  '确认删除？': '确认删除？',
  '确认启用该分拣道口管理：{code}': '确认启用该分拣道口管理：{code}',
  '确认启用该门店道口关系:{code}': '确认启用该门店道口关系:{code}',
  '确认完成{length}个选项': '确认完成{length}个选项',
  '确认审核吗': '确认审核吗',
  '确认对播种拣货单 [{billNumber}] 分播？': '确认对播种拣货单 [{billNumber}] 分播？',
  '确认对播种拣货单 [{billNumber}] 提总？': '确认对播种拣货单 [{billNumber}] 提总？',
  '确认并创建': '确认并创建',
  '确认成功': '确认成功',
  '确认打印?': '确认打印?',
  '确认批量删除{length}个选项': '确认批量删除{length}个选项',
  '确认批量生成拣货单{length}个选项': '确认批量生成拣货单{length}个选项',
  '确认提总审核{length}个选项': '确认提总审核{length}个选项',
  '确认清屏吗？': '确认清屏吗？',
  '确认满容': '确认满容',
  '确认生效{length}个选项': '确认生效{length}个选项',
  '确认禁用该分拣道口管理：{code}': '确认禁用该分拣道口管理：{code}',
  '确认禁用该门店道口关系：{code}': '确认禁用该门店道口关系：{code}',
  '确认离开后，此页面数据将不会保存': '确认离开后，此页面数据将不会保存',
  '确认离开当前页面吗？': '确认离开当前页面吗？',
  '确认离开此界面？': '确认离开此界面？',
  '确认移除': '确认移除',
  '确认要删除{title}{code}下的货位吗？': '确认要删除{title}{code}下的货位吗？',
  '确认要删除该数据？': '确认要删除该数据？',
  '确认要删除该高叉员作业配置:{name}吗？': '确认要删除该高叉员作业配置:{name}吗？',
  '确认该波次单{name}吗?': '确认该波次单{name}吗?',
  '确认配送': '确认配送',
  '确认释放{length}个选项！': '确认释放{length}个选项！',
  '磁盘详情': '磁盘详情',
  '禁止': '禁止',
  '禁用': '禁用',
  '禁用{length}个选项': '禁用{length}个选项',
  '禁用成功': '禁用成功',
  '秒': '秒',
  '称重': '称重',
  '称重价': '称重价',
  '移动': '移动',
  '移动成功': '移动成功',
  '移库': '移库',
  '移库不上传类型配置': '移库不上传类型配置',
  '移库中': '移库中',
  '移库入': '移库入',
  '移库出': '移库出',
  '移库单': '移库单',
  '移库单不上传移库类型配置': '移库单不上传移库类型配置',
  '移库单日结': '移库单日结',
  '移库暂存位': '移库暂存位',
  '移库类型': '移库类型',
  '移库配置': '移库配置',
  '移库锁定': '移库锁定',
  '移除': '移除',
  '移除用户': '移除用户',
  '税率': '税率',
  '空': '空',
  '空闲': '空闲',
  '端口号': '端口号',
  '第{count}行明细地址记为-,只允许一行明细地址记录为-': '第{count}行明细地址记为-,只允许一行明细地址记录为-',
  '第{errorLines}行录入单价不允许高于含税单价': '第{errorLines}行录入单价不允许高于含税单价',
  '第{id}行耗材不能为空': '第{id}行耗材不能为空',
  '第{id}行耗材数量不能为空': '第{id}行耗材数量不能为空',
  '第{id}行耗材重复': '第{id}行耗材重复',
  '第{id}行道口不能为空': '第{id}行道口不能为空',
  '第{id}行道口对应门店{repeatStore}已有配置': '第{id}行道口对应门店{repeatStore}已有配置',
  '第{id}行道口明细不能为空': '第{id}行道口明细不能为空',
  '第{id}行道口重复': '第{id}行道口重复',
  '第{id}行门店{repeatStore}已有配置道口': '第{id}行门店{repeatStore}已有配置道口',
  '第{id}行门店不能为空': '第{id}行门店不能为空',
  '第{id}行门店明细不能为空': '第{id}行门店明细不能为空',
  '第{length}行商品：{article}费用明细重复': '第{length}行商品：{article}费用明细重复',
  '第{length}行实际数量大于超拣数量，是否确认？': '第{length}行实际数量大于超拣数量，是否确认？',
  '第{length}行录入单价高于含税单价，是否确认！': '第{length}行录入单价高于含税单价，是否确认！',
  '第{length}行行数量不能为0': '第{length}行行数量不能为0',
  '第{length}行货位范围不{message}': '第{length}行货位范围不{message}',
  '第{length}行费用明细费用类型不能为空': '第{length}行费用明细费用类型不能为空',
  '第{length}行费用明细费用金额不能为空': '第{length}行费用明细费用金额不能为空',
  '第{line}行{title}': '第{line}行{title}',
  '第{line}行{wrh}仓位已有配置货位范围': '第{line}行{wrh}仓位已有配置货位范围',
  '第{line}行与第{otherLine}行容器相同，货位不同！': '第{line}行与第{otherLine}行容器相同，货位不同！',
  '第{line}行与第{otherLine}行重复': '第{line}行与第{otherLine}行重复',
  '第{line}行与第{otherLine}行重复！': '第{line}行与第{otherLine}行重复！',
  '第{line}行价格不能为空且不能小于0': '第{line}行价格不能为空且不能小于0',
  '第{line}行供应商不能为空！': '第{line}行供应商不能为空！',
  '第{line}行到效期不能为空！': '第{line}行到效期不能为空！',
  '第{line}行到效期不能早于当前日期！': '第{line}行到效期不能早于当前日期！',
  '第{line}行单价不能为空': '第{line}行单价不能为空',
  '第{line}行可预约最大品项数为{maxArticleCount}，最小为0且不能为0，请检查！': '第{line}行可预约最大品项数为{maxArticleCount}，最小为0且不能为0，请检查！',
  '第{line}行商品{article}是温度管理商品，温度不能为空': '第{line}行商品{article}是温度管理商品，温度不能为空',
  '第{line}行商品不能为空！': '第{line}行商品不能为空！',
  '第{line}行商品为空': '第{line}行商品为空',
  '第{line}行商品实拣数量小于数量，来源容器不能作为目标容器。': '第{line}行商品实拣数量小于数量，来源容器不能作为目标容器。',
  '第{line}行商品，实拣件数小于件数或实拣数量小于数量，来源容器不能作为目标容器。': '第{line}行商品，实拣件数小于件数或实拣数量小于数量，来源容器不能作为目标容器。',
  '第{line}行备注长度最大为255': '第{line}行备注长度最大为255',
  '第{line}行外部批次不能为空！': '第{line}行外部批次不能为空！',
  '第{line}行实拣件数不能大于件数。': '第{line}行实拣件数不能大于件数。',
  '第{line}行实拣数量不能大于数量。': '第{line}行实拣数量不能大于数量。',
  '第{line}行实际件数不能大于件数': '第{line}行实际件数不能大于件数',
  '第{line}行实验数量不能小于等于0！': '第{line}行实验数量不能小于等于0！',
  '第{line}行容器不能为空！': '第{line}行容器不能为空！',
  '第{line}行容器条码不能为-！': '第{line}行容器条码不能为-！',
  '第{line}行容器条码不能为空！': '第{line}行容器条码不能为空！',
  '第{line}行容器类型不能为空！': '第{line}行容器类型不能为空！',
  '第{line}行差异类型不能为空！': '第{line}行差异类型不能为空！',
  '第{line}行库存相关信息：货位、容器、供应商、批号、生产日期、规格、批次等不能为空，请检查修改。': '第{line}行库存相关信息：货位、容器、供应商、批号、生产日期、规格、批次等不能为空，请检查修改。',
  '第{line}行总数量不能小于等于0！': '第{line}行总数量不能小于等于0！',
  '第{line}行批次不能为空！': '第{line}行批次不能为空！',
  '第{line}行数据实际件数不能小于0': '第{line}行数据实际件数不能小于0',
  '第{line}行数量、件数不能同时小于等于0！': '第{line}行数量、件数不能同时小于等于0！',
  '第{line}行数量不能为0': '第{line}行数量不能为0',
  '第{line}行数量不能小于0！': '第{line}行数量不能小于0！',
  '第{line}行数量不能小于等于0！': '第{line}行数量不能小于等于0！',
  '第{line}行数量必须大于0': '第{line}行数量必须大于0',
  '第{line}行明细不能为空': '第{line}行明细不能为空',
  '第{line}行明细与第{line}行明细相同': '第{line}行明细与第{line}行明细相同',
  '第{line}行是重量结算商品，件数、数量不能同时为0，且不可为负数。': '第{line}行是重量结算商品，件数、数量不能同时为0，且不可为负数。',
  '第{line}行来源容器条码不能为空！': '第{line}行来源容器条码不能为空！',
  '第{line}行生产日期不能为空！': '第{line}行生产日期不能为空！',
  '第{line}行生产日期不能晚于当前日期！': '第{line}行生产日期不能晚于当前日期！',
  '第{line}行的单价不允许为空或0，请检查修改。': '第{line}行的单价不允许为空或0，请检查修改。',
  '第{line}行的目标货位不能为空': '第{line}行的目标货位不能为空',
  '第{line}行目标位置为空，请填写后再审核': '第{line}行目标位置为空，请填写后再审核',
  '第{line}行目标容器不能为空。': '第{line}行目标容器不能为空。',
  '第{line}行目标容器条码不能为空！': '第{line}行目标容器条码不能为空！',
  '第{line}行目标货位不可以为空': '第{line}行目标货位不可以为空',
  '第{line}行目标货位不能为空。': '第{line}行目标货位不能为空。',
  '第{line}行目标货位不能为空！': '第{line}行目标货位不能为空！',
  '第{line}行目标货位为集货暂存位，目标容器不能为空或-': '第{line}行目标货位为集货暂存位，目标容器不能为空或-',
  '第{line}行码头集不能为空': '第{line}行码头集不能为空',
  '第{line}行规格不能为空！': '第{line}行规格不能为空！',
  '第{line}行订单不能为空': '第{line}行订单不能为空',
  '第{line}行货位不是存储位、拣货位、拣货存储位、虚拟货位、大型拣货位，容器不能为虚拟容器！': '第{line}行货位不是存储位、拣货位、拣货存储位、虚拟货位、大型拣货位，容器不能为虚拟容器！',
  '第{line}行货位不能为空': '第{line}行货位不能为空',
  '第{line}行货位不能为空！': '第{line}行货位不能为空！',
  '第{line}行货位代码不能为空！': '第{line}行货位代码不能为空！',
  '第{line}行货位用途不能为空': '第{line}行货位用途不能为空',
  '第{line}行退仓类型不能为空！': '第{line}行退仓类型不能为空！',
  '第{line}行门店不能为空': '第{line}行门店不能为空',
  '第{line}行集货位不能为空': '第{line}行集货位不能为空',
  '第{line}行集货位代码不能为空': '第{line}行集货位代码不能为空',
  '第{line}行集货位数不能为空，且值需为大于0的整数': '第{line}行集货位数不能为空，且值需为大于0的整数',
  '第{line}行集货位数据超长!': '第{line}行集货位数据超长!',
  '第{line}行集货位范围不能为空': '第{line}行集货位范围不能为空',
  '第{line}行预约件数不能为空且不能为0': '第{line}行预约件数不能为空且不能为0',
  '第{line}行，请先设置目标货位！': '第{line}行，请先设置目标货位！',
  '第{line}行，配差结果均为0，不允许保存！': '第{line}行，配差结果均为0，不允许保存！',
  '第{line}行，零散数不可大于{maxQtyStr}': '第{line}行，零散数不可大于{maxQtyStr}',
  '第{line}行，非整托拣货类型的供应商拣货单，来源容器不能作为目标容器': '第{line}行，非整托拣货类型的供应商拣货单，来源容器不能作为目标容器',
  '第{line}行与第{otherLine}行同一目标容器，但不同目标货位，不允许。': '第{line}行与第{otherLine}行同一目标容器，但不同目标货位，不允许。',
  '第{qtyIds}行实拣数量不能大于超拣比例': '第{qtyIds}行实拣数量不能大于超拣比例',
  '第{stringify}行数据相同': '第{stringify}行数据相同',
  '第{stringify}行数据门店相同': '第{stringify}行数据门店相同',
  '第{valueIds}行实拣数量不能为0': '第{valueIds}行实拣数量不能为0',
  '第{weightIds}行实拣数量大于超拣比例。': '第{weightIds}行实拣数量大于超拣比例。',
  '简体中文': '简体中文',
  '简称': '简称',
  '算法加强': '算法加强',
  '管理': '管理',
  '管理凭证原因': '管理凭证原因',
  '管理卸货方式': '管理卸货方式',
  '管理员名称': '管理员名称',
  '管理员手机号': '管理员手机号',
  '管理外部批次': '管理外部批次',
  '管理外部批次配置': '管理外部批次配置',
  '管理存储条件': '管理存储条件',
  '管理容器': '管理容器',
  '管理库存调整原因': '管理库存调整原因',
  '管理拒收原因': '管理拒收原因',
  '管理挂起原因': '管理挂起原因',
  '管理方案': '管理方案',
  '管理类型': '管理类型',
  '管理订单类型': '管理订单类型',
  '管理费用类型': '管理费用类型',
  '管理起要量': '管理起要量',
  '管理返还类型': '管理返还类型',
  '管理退货类型': '管理退货类型',
  '管理送货对象类型': '管理送货对象类型',
  '管理领用类型': '管理领用类型',
  '箱/零': '箱/零',
  '箱号': '箱号',
  '箱号不唯一，无法指定箱号': '箱号不唯一，无法指定箱号',
  '箱号不能为空': '箱号不能为空',
  '箱标': '箱标',
  '箱标打印机': '箱标打印机',
  '箱标打印模板': '箱标打印模板',
  '箱码': '箱码',
  '箱类型': '箱类型',
  '类别': '类别',
  '类别存储范围配置': '类别存储范围配置',
  '类型': '类型',
  '类型不能为空': '类型不能为空',
  '类越库': '类越库',
  '类越库不可同时分播多容器员工配置': '类越库不可同时分播多容器员工配置',
  '类越库分播': '类越库分播',
  '类越库分播是否需要跳过商品扫描': '类越库分播是否需要跳过商品扫描',
  '类越库分播显示门店代码': '类越库分播显示门店代码',
  '类越库分播管理方案配置': '类越库分播管理方案配置',
  '类越库商品分播': '类越库商品分播',
  '库存查询': '库存查询',
  '最小配货规格': '最小配货规格',
  '最小批号库存规格': '最小批号库存规格',
  '数量结算商品整箱起要量使用规格配置': '数量结算商品整箱起要量使用规格配置',
  '类越库容器类型': '类越库容器类型',
  '类越库库存分配配置': '类越库库存分配配置',
  '类越库打印模板': '类越库打印模板',
  '类越库拣货': '类越库拣货',
  '类越库收货': '类越库收货',
  '类越库收货暂存位': '类越库收货暂存位',
  '类越库波次单功能配置': '类越库波次单功能配置',
  '类越库波次门店及商品组限制': '类越库波次门店及商品组限制',
  '类越库自动获取容器': '类越库自动获取容器',
  '类越库集货': '类越库集货',
  '粗式管理': '粗式管理',
  '精细化管理': '精细化管理',
  '精细化管理打包暂存位配单类型': '精细化管理打包暂存位配单类型',
  '系统功能': '系统功能',
  '系统推送': '系统推送',
  '繁体中文': '繁体中文',
  '线上预约': '线上预约',
  '线路': '线路',
  '线路体系': '线路体系',
  '线路体系新建成功': '线路体系新建成功',
  '线路新建成功': '线路新建成功',
  '组别': '组别',
  '组号': '组号',
  '组织': '组织',
  '组织类型': '组织类型',
  '终止条码': '终止条码',
  '终止列码': '终止列码',
  '终止层码': '终止层码',
  '终止货区范围': '终止货区范围',
  '终止货架范围': '终止货架范围',
  '终止货道范围': '终止货道范围',
  '经营类型': '经营类型',
  '经营面积': '经营面积',
  '绑定': '绑定',
  '绑定员': '绑定员',
  '绑定时间': '绑定时间',
  '结束': '结束',
  '结束上架': '结束上架',
  '结束上架时间': '结束上架时间',
  '结束交接': '结束交接',
  '结束作业': '结束作业',
  '结束加工波次': '结束加工波次',
  '结束复查': '结束复查',
  '结束复核': '结束复核',
  '结束复核成功': '结束复核成功',
  '结束拆并': '结束拆并',
  '结束拆并时间': '结束拆并时间',
  '结束拣货': '结束拣货',
  '结束播种': '结束播种',
  '结束收货': '结束收货',
  '结束收货时间': '结束收货时间',
  '结束时间': '结束时间',
  '结束时间必须大于开始时间': '结束时间必须大于开始时间',
  '结束盘点': '结束盘点',
  '结束盘点时间': '结束盘点时间',
  '结束移库时间': '结束移库时间',
  '结束绑定': '结束绑定',
  '结束绑定时间': '结束绑定时间',
  '结束补货': '结束补货',
  '结束装车': '结束装车',
  '结束订单': '结束订单',
  '结束退仓': '结束退仓',
  '结束退仓时间': '结束退仓时间',
  '结点': '结点',
  '结点地址': '结点地址',
  '结点用途': '结点用途',
  '结点类型': '结点类型',
  '结算方式': '结算方式',
  '统配': '统配',
  '统配分播位面板': '统配分播位面板',
  '统配容器类型': '统配容器类型',
  '统配打印模板': '统配打印模板',
  '统配拣货': '统配拣货',
  '统配拣货实拣显示': '统配拣货实拣显示',
  '统配拣货显示商品代码': '统配拣货显示商品代码',
  '统配拣货满容后跳转平移': '统配拣货满容后跳转平移',
  '统配收货': '统配收货',
  '统配收货暂存位': '统配收货暂存位',
  '统配波次多次执行': '统配波次多次执行',
  '统配波次多次执行配置': '统配波次多次执行配置',
  '统配自动获取容器': '统配自动获取容器',
  '统配集货': '统配集货',
  '统配集货位面板': '统配集货位面板',
  '统配集货暂存位': '统配集货暂存位',
  '继续': '继续',
  '维护值': '维护值',
  '编译时间': '编译时间',
  '编辑': '编辑',
  '编辑{bill}': '编辑{bill}',
  '编辑上架单不存在！': '编辑上架单不存在！',
  '编辑保存成功': '编辑保存成功',
  '编辑分播墙': '编辑分播墙',
  '编辑分播管理方案': '编辑分播管理方案',
  '编辑承运商交接单': '编辑承运商交接单',
  '编辑拣货位调整单': '编辑拣货位调整单',
  '编辑模板': '编辑模板',
  '编辑的修正单不存在！': '编辑的修正单不存在！',
  '编辑的封仓解仓单不存在！': '编辑的封仓解仓单不存在！',
  '编辑的损耗单不存在！': '编辑的损耗单不存在！',
  '编辑的收货单不存在！': '编辑的收货单不存在！',
  '编辑的波次单不存在！': '编辑的波次单不存在！',
  '编辑的溢余单不存在！': '编辑的溢余单不存在！',
  '编辑的电子凭证单不存在！': '编辑的电子凭证单不存在！',
  '编辑的移库单不存在！': '编辑的移库单不存在！',
  '编辑的订单不存在！': '编辑的订单不存在！',
  '编辑的配单不存在！': '编辑的配单不存在！',
  '编辑的配货差异单不存在！': '编辑的配货差异单不存在！',
  '编辑的锁定解锁单不存在！': '编辑的锁定解锁单不存在！',
  '编辑的集货位管理方案不存在！': '编辑的集货位管理方案不存在！',
  '编辑的预检单不存在！': '编辑的预检单不存在！',
  '编辑的预约单不存在！': '编辑的预约单不存在！',
  '编辑的领用单不存在！': '编辑的领用单不存在！',
  '编辑的领用返还单不存在！': '编辑的领用返还单不存在！',
  '编辑盘点单': '编辑盘点单',
  '编辑门店': '编辑门店',
  '编辑页行数': '编辑页行数',
  '缺货': '缺货',
  '缺货不允许关单类型配置': '缺货不允许关单类型配置',
  '缺货分配优先级': '缺货分配优先级',
  '缺货库存分配方案配置': '缺货库存分配方案配置',
  '网关': '网关',
  '网关号': '网关号',
  '网关服务': '网关服务',
  '网络订单号': '网络订单号',
  '耗材': '耗材',
  '耗材库存填充': '耗材库存填充',
  '耗材数量': '耗材数量',
  '耗材明细': '耗材明细',
  '耗材明细不能为空': '耗材明细不能为空',
  '耗材标记': '耗材标记',
  '耗材类型': '耗材类型',
  '自动': '自动',
  '自动创建': '自动创建',
  '自动包装': '自动包装',
  '自动差错': '自动差错',
  '自动模式': '自动模式',
  '自定义': '自定义',
  '自定义付款模式': '自定义付款模式',
  '自定义字段1名称': '自定义字段1名称',
  '自定义字段2名称': '自定义字段2名称',
  '自定义字段3名称': '自定义字段3名称',
  '自定义字段4名称': '自定义字段4名称',
  '自定义字段5名称': '自定义字段5名称',
  '自定义字段6名称': '自定义字段6名称',
  '自定义字段名称': '自定义字段名称',
  '自定义导入': '自定义导入',
  '自定义导入配置': '自定义导入配置',
  '自定义服务模式': '自定义服务模式',
  '自定义模板': '自定义模板',
  '自定义菜单': '自定义菜单',
  '自定义运单号': '自定义运单号',
  '自定义间隔时间': '自定义间隔时间',
  '自重(kg)': '自重(kg)',
  '至多输入30个字符': '至多输入30个字符',
  '至多输入80个字符': '至多输入80个字符',
  '获取': '获取',
  '获取上一单失败': '获取上一单失败',
  '获取下一单失败': '获取下一单失败',
  '获取商品控制天数信息失败': '获取商品控制天数信息失败',
  '获取堆栈': '获取堆栈',
  '获取打印机失败': '获取打印机失败',
  '获取收货容器成功！': '获取收货容器成功！',
  '获取用户组织信息失败！': '获取用户组织信息失败！',
  '获取线程': '获取线程',
  '获取验证码': '获取验证码',
  '蓝牙打印': '蓝牙打印',
  '虚拟容器': '虚拟容器',
  '虚拟货位': '虚拟货位',
  '虚拟货位不能为空': '虚拟货位不能为空',
  '虚拟货位来源': '虚拟货位来源',
  '行': '行',
  '行号': '行号',
  '行号调整': '行号调整',
  '补货': '补货',
  '补货上架': '补货上架',
  '补货下架': '补货下架',
  '补货中': '补货中',
  '补货中转位': '补货中转位',
  '补货件数': '补货件数',
  '补货任务释放成功！': '补货任务释放成功！',
  '补货入': '补货入',
  '补货单': '补货单',
  '补货员': '补货员',
  '补货回板': '补货回板',
  '补货工具': '补货工具',
  '补货扫描': '补货扫描',
  '补货显示代码': '补货显示代码',
  '补货显示总量': '补货显示总量',
  '补货显示数量': '补货显示数量',
  '补货显示整箱数量': '补货显示整箱数量',
  '补货显示零散数量': '补货显示零散数量',
  '补货暂存位': '补货暂存位',
  '补货步骤': '补货步骤',
  '补货满': '补货满',
  '补货算法': '补货算法',
  '补货配置': '补货配置',
  '补货释放时机': '补货释放时机',
  '表名': '表名',
  '被检企业': '被检企业',
  '装卸员': '装卸员',
  '装盘建议': '装盘建议',
  '装盘建议不能为空': '装盘建议不能为空',
  '装车': '装车',
  '装车上传': '装车上传',
  '装车中': '装车中',
  '装车件数': '装车件数',
  '装车件数来源配置': '装车件数来源配置',
  '装车单': '装车单',
  '装车员': '装车员',
  '装车完成': '装车完成',
  '装车容器的展示按时间排序': '装车容器的展示按时间排序',
  '装车数': '装车数',
  '装车数量': '装车数量',
  '装车时在门店容器': '装车时在门店容器',
  '装车来源配置查询出错': '装车来源配置查询出错',
  '装车类型': '装车类型',
  '装车自动完成加工单': '装车自动完成加工单',
  '是否启用门店交接单初始状态': '是否启用门店交接单初始状态',
  '感官质检单审核后是否自动完成': '感官质检单审核后是否自动完成',
  '装车项': '装车项',
  '装车顺序': '装车顺序',
  '装载号': '装载号',
  '要货': '要货',
  '要货 :': '要货 :',
  '要货件数': '要货件数',
  '要货品项数上限': '要货品项数上限',
  '要货数量': '要货数量',
  '要货量': '要货量',
  '规格': '规格',
  '规格/单位': '规格/单位',
  '规格/计量单位': '规格/计量单位',
  '规格/计量单品': '规格/计量单品',
  '规格作条件': '规格作条件',
  '规格信息': '规格信息',
  '规格调整': '规格调整',
  '规格：{qpcStr} 已存在': '规格：{qpcStr} 已存在',
  '角色': '角色',
  '角色管理': '角色管理',
  '解仓': '解仓',
  '解析外部批号': '解析外部批号',
  '解析外部批号配置': '解析外部批号配置',
  '解释说明': '解释说明',
  '解锁': '解锁',
  '解除成功': '解除成功',
  '解除挂起': '解除挂起',
  '解除锁定': '解除锁定',
  '触发401': '触发401',
  '触发403': '触发403',
  '触发404': '触发404',
  '触发500': '触发500',
  '计划件数': '计划件数',
  '计划数量': '计划数量',
  '计划配货件数': '计划配货件数',
  '计划配货体积': '计划配货体积',
  '计划量': '计划量',
  '计费': '计费',
  '订单': '订单',
  '订单体积(m³)': '订单体积(m³)',
  '订单供应商存在退货，确认继续收货？': '订单供应商存在退货，确认继续收货？',
  '订单单号': '订单单号',
  '订单号': '订单号',
  '订单品项数': '订单品项数',
  '订单完成成功': '订单完成成功',
  '订单收货成功': '订单收货成功',
  '订单收货日结': '订单收货日结',
  '订单明细不能为空': '订单明细不能为空',
  '订单未收货信息': '订单未收货信息',
  '订单来源单号': '订单来源单号',
  '订单类型': '订单类型',
  '订单类型不为类越库或二步越库，无法进行分播': '订单类型不为类越库或二步越库，无法进行分播',
  '订单过期日结': '订单过期日结',
  '订单：{billNumber}无可预检项': '订单：{billNumber}无可预检项',
  '记为整箱复核的容器类型配置': '记为整箱复核的容器类型配置',
  '记录': '记录',
  '记录值': '记录值',
  '许可证内容': '许可证内容',
  '许可证内容不能为空': '许可证内容不能为空',
  '许可证前端地址': '许可证前端地址',
  '许可证密码不能为空': '许可证密码不能为空',
  '许可证服务地址': '许可证服务地址',
  '许可证服务地址不能为空': '许可证服务地址不能为空',
  '许可证用户名不能为空': '许可证用户名不能为空',
  '许可证管理': '许可证管理',
  '许可证配置': '许可证配置',
  '设为默认': '设为默认',
  '设备代码': '设备代码',
  '设备名称': '设备名称',
  '设备维护': '设备维护',
  '设置别名': '设置别名',
  '设置失败': '设置失败',
  '设置差异原因': '设置差异原因',
  '设置成功': '设置成功',
  '设置拣货位成功': '设置拣货位成功',
  '设置拣货员': '设置拣货员',
  '设置目标位置': '设置目标位置',
  '设置目标容器': '设置目标容器',
  '设置目标货位': '设置目标货位',
  '设置码头集': '设置码头集',
  '设置菜单权限': '设置菜单权限',
  '设置调整数量': '设置调整数量',
  '设置货位校验码': '设置货位校验码',
  '设置配送中心': '设置配送中心',
  '设置首选收货成功': '设置首选收货成功',
  '设置首选退货成功': '设置首选退货成功',
  '诚信包裹收货': '诚信包裹收货',
  '诚信收货': '诚信收货',
  '诚信无包裹收货': '诚信无包裹收货',
  '该功能在企业端不适用！': '该功能在企业端不适用！',
  '该单未预检': '该单未预检',
  '该单未预约': '该单未预约',
  '该商品需要检疫证，请核实有无检疫证': '该商品需要检疫证，请核实有无检疫证',
  '该波次单{billNumber}：{msg}，是否继续？': '该波次单{billNumber}：{msg}，是否继续？',
  '该目录下为空': '该目录下为空',
  '该订单未预检，不可收货': '该订单未预检，不可收货',
  '该订单未预约，不可收货': '该订单未预约，不可收货',
  '详情': '详情',
  '详情查看': '详情查看',
  '详情页行数': '详情页行数',
  '列表页数据自动加载': '列表页数据自动加载',
  '有效范围': '有效单据范围: 入库订单，上架单，收货单，配货通知单，波次单，拣货单，补货单，溢余单，损耗单，移库单，装车单，门店交接单，退仓通知单，退仓单，供应商拣货单',
  '列表页查询条件完整展示': '列表页查询条件完整展示',
  '请上传RF安装文件': '请上传RF安装文件',
  '请下载安装打印服务，重新打开页面': '请下载安装打印服务，重新打开页面',
  '请使用英文输入法输入逗号': '请使用英文输入法输入逗号',
  '请先上传文件': '请先上传文件',
  '请先勾选': '请先勾选',
  '请先勾选,再进行批量操作': '请先勾选,再进行批量操作',
  '请先勾选商品': '请先勾选商品',
  '请先勾选，再进行操作': '请先勾选，再进行操作',
  '请先安装插件': '请先安装插件',
  '请先按条件查询返回结果集': '请先按条件查询返回结果集',
  '请先清空复核区': '请先清空复核区',
  '请先确认拆零页,再提交': '请先确认拆零页,再提交',
  '请先获取任务': '请先获取任务',
  '请先选择仓位': '请先选择仓位',
  '请先选择修正类型': '请先选择修正类型',
  '请先选择加工波次单': '请先选择加工波次单',
  '请先选择单据商品': '请先选择单据商品',
  '请先选择单据商品及规格': '请先选择单据商品及规格',
  '请先选择商品！': '请先选择商品！',
  '请先选择复核容器': '请先选择复核容器',
  '请先选择容器': '请先选择容器',
  '请先选择异常拣货单': '请先选择异常拣货单',
  '请先选择或新建线路体系': '请先选择或新建线路体系',
  '请先选择打印机': '请先选择打印机',
  '请先选择拣货单': '请先选择拣货单',
  '请先选择数据': '请先选择数据',
  '请先选择数据行': '请先选择数据行',
  '请先选择来源单据': '请先选择来源单据',
  '请先选择线路': '请先选择线路',
  '请先选择行': '请先选择行',
  '请先选择要修改的行': '请先选择要修改的行',
  '请先选择要修改的行！': '请先选择要修改的行！',
  '请先选择要删除的数据': '请先选择要删除的数据',
  '请先选择要删除的线路': '请先选择要删除的线路',
  '请先选择要删除的行': '请先选择要删除的行',
  '请先选择要删除行！': '请先选择要删除行！',
  '请先选择要刷新的明细': '请先选择要刷新的明细',
  '请先选择要刷新的装车员': '请先选择要刷新的装车员',
  '请先选择要添加的行': '请先选择要添加的行',
  '请先选择要设置目标供应商退货位的行': '请先选择要设置目标供应商退货位的行',
  '请先选择要设置目标供应商退货位的行！': '请先选择要设置目标供应商退货位的行！',
  '请先选择要设置目标供应商退货位行的供应商': '请先选择要设置目标供应商退货位行的供应商',
  '请先选择要设置目标供应商退货位行的供应商！': '请先选择要设置目标供应商退货位行的供应商！',
  '请先选择要设置目标拣货位的行！': '请先选择要设置目标拣货位的行！',
  '请先选择要设置目标拣货位行的商品': '请先选择要设置目标拣货位行的商品',
  '请先选择要设置目标拣货位行的商品！': '请先选择要设置目标拣货位行的商品！',
  '请先选择订单/入园单': '请先选择订单/入园单',
  '请先选择订单商品': '请先选择订单商品',
  '请先选择退仓通知单！': '请先选择退仓通知单！',
  '请先选择道口': '请先选择道口',
  '请勾选数据': '请勾选数据',
  '请勾选，再进行批量操作': '请勾选，再进行批量操作',
  '请勾选，再进行操作': '请勾选，再进行操作',
  '请填入真实的手机号': '请填入真实的手机号',
  '请填入真实的联系方式': '请填入真实的联系方式',
  '请填入真实的邮编': '请填入真实的邮编',
  '请填写完整': '请填写完整',
  '请扫描商品条码': '请扫描商品条码',
  '请求超时': '请求超时',
  '请添加明细': '请添加明细',
  '请确认商品规格': '请确认商品规格',
  '请设置多配默认处理方式': '请设置多配默认处理方式',
  '请设置少配默认处理方式': '请设置少配默认处理方式',
  '请设置拆零配置': '请设置拆零配置',
  '请设置整件配置': '请设置整件配置',
  '请设置默认打印模板！': '请设置默认打印模板！',
  '请输入': '请输入',
  '请输入0-10000之间的整数': '请输入0-10000之间的整数',
  '请输入0-100之间的整数': '请输入0-100之间的整数',
  '请输入6-16位密码，允许数字字母以及特殊字符#@!~%^&*': '请输入6-16位密码，允许数字字母以及特殊字符#@!~%^&*',
  '请输入Token': '请输入Token',
  '请输入excel表字段': '请输入excel表字段',
  '请输入{placeholderName}的名称': '请输入{placeholderName}的名称',
  '请输入不合格数量': '请输入不合格数量',
  '请输入不超过30位A-H之内的字母': '请输入不超过30位A-H之内的字母',
  '请输入不超过30位字母数字组合': '请输入不超过30位字母数字组合',
  '请输入业务单号': '请输入业务单号',
  '请输入中间表字段名': '请输入中间表字段名',
  '请输入代码': '请输入代码',
  '请输入企业代码': '请输入企业代码',
  '请输入体积': '请输入体积',
  '请输入到效期': '请输入到效期',
  '请输入前端地址': '请输入前端地址',
  '请输入加工人数': '请输入加工人数',
  '请输入包名': '请输入包名',
  '请输入包含的配货通知单单号': '请输入包含的配货通知单单号',
  '请输入包裹号': '请输入包裹号',
  '请输入单号': '请输入单号',
  '请输入司机': '请输入司机',
  '请输入名称': '请输入名称',
  '请输入员工代码': '请输入员工代码',
  '请输入员工代码或名称': '请输入员工代码或名称',
  '请输入商品': '请输入商品',
  '请输入商品代码': '请输入商品代码',
  '请输入商品备注': '请输入商品备注',
  '请输入商品条码': '请输入商品条码',
  '请输入固定的最低库存件数，如10。': '请输入固定的最低库存件数，如10。',
  '请输入固定的最高库存件数，如10。': '请输入固定的最高库存件数，如10。',
  '请输入备注': '请输入备注',
  '请输入复核商品条码': '请输入复核商品条码',
  '请输入外部批次': '请输入外部批次',
  '请输入外部批次号': '请输入外部批次号',
  '请输入大于0的数': '请输入大于0的数',
  '请输入实体日志表保留时长': '请输入实体日志表保留时长',
  '请输入实际值': '请输入实际值',
  '请输入客户单数': '请输入客户单数',
  '请输入容器条码': '请输入容器条码',
  '请输入容器条码！': '请输入容器条码！',
  '请输入密码': '请输入密码',
  '请输入库存操作日志表保留时长': '请输入库存操作日志表保留时长',
  '请输入库存流水表保留时长': '请输入库存流水表保留时长',
  '请输入快递单号': '请输入快递单号',
  '请输入报警前缀': '请输入报警前缀',
  '请输入抽样件数': '请输入抽样件数',
  '请输入拣货单号': '请输入拣货单号',
  '请输入拣货单数量': '请输入拣货单数量',
  '请输入接口中间表保留时长': '请输入接口中间表保留时长',
  '请输入接口日志表保留时长': '请输入接口日志表保留时长',
  '请输入收货数量！': '请输入收货数量！',
  '请输入数量': '请输入数量',
  '请输入更正件数': '请输入更正件数',
  '请输入更正数量': '请输入更正数量',
  '请输入替换量': '请输入替换量',
  '请输入正确的容器条码格式': '请输入正确的容器条码格式',
  '请输入波次单号': '请输入波次单号',
  '请输入温度': '请输入温度',
  '请输入满足率': '请输入满足率',
  '请输入生产日期': '请输入生产日期',
  '请输入用户名': '请输入用户名',
  '请输入目标位置': '请输入目标位置',
  '请输入码头集代码或名称': '请输入码头集代码或名称',
  '请输入耗材数量': '请输入耗材数量',
  '请输入自定义值': '请输入自定义值',
  '请输入装卸员': '请输入装卸员',
  '请输入装盘规格对应的百分比，如80。': '请输入装盘规格对应的百分比，如80。',
  '请输入要调整的序号': '请输入要调整的序号',
  '请输入订单单号': '请输入订单单号',
  '请输入订单号': '请输入订单号',
  '请输入订单号/入园单号': '请输入订单号/入园单号',
  '请输入订单号/入园单号/预检序号': '请输入订单号/入园单号/预检序号',
  '请输入许可证内容': '请输入许可证内容',
  '请输入许可证服务地址': '请输入许可证服务地址',
  '请输入调整数量': '请输入调整数量',
  '请输入货位': '请输入货位',
  '请输入货位范围': '请输入货位范围',
  '请输入质检员': '请输入质检员',
  '请输入质检明细第{length}行合格结果': '请输入质检明细第{length}行合格结果',
  '请输入费用金额': '请输入费用金额',
  '请输入车型': '请输入车型',
  '请输入车辆': '请输入车辆',
  '请输入载重': '请输入载重',
  '请输入通知单号': '请输入通知单号',
  '请输入配置名称': '请输入配置名称',
  '请输入重命名': '请输入重命名',
  '请输入重量': '请输入重量',
  '请输入门店交接单': '请输入门店交接单',
  '请输入门店代码/名称': '请输入门店代码/名称',
  '请输入门店代码或名称': '请输入门店代码或名称',
  '请输入门店封签号': '请输入门店封签号',
  '请输入门店组代码': '请输入门店组代码',
  '请输入间隔时间': '请输入间隔时间',
  '请输入集货位': '请输入集货位',
  '请输入预分配量': '请输入预分配量',
  '请选择': '请选择',
  '请选择人员': '请选择人员',
  '请选择人员类型': '请选择人员类型',
  '请选择仓位': '请选择仓位',
  '请选择企业': '请选择企业',
  '请选择供应商': '请选择供应商',
  '请选择入库仓位': '请选择入库仓位',
  '请选择分单内容': '请选择分单内容',
  '请选择分单配置': '请选择分单配置',
  '请选择分播打印模板': '请选择分播打印模板',
  '请选择加工单配方限制': '请选择加工单配方限制',
  '请选择满容录入附件限制': '请选择满容录入附件限制',
  '请选择加工台': '请选择加工台',
  '请选择加工台和加工方案': '请选择加工台和加工方案',
  '请选择原料量上下限制计算维度': '请选择原料量上下限制计算维度',
  '请选择员工': '请选择员工',
  '请选择商品': '请选择商品',
  '请选择商品下拉框': '请选择商品下拉框',
  '请选择商品组': '请选择商品组',
  '请选择商品！': '请选择商品！',
  '请选择回收容器取值模式': '请选择回收容器取值模式',
  '请选择处理人': '请选择处理人',
  '请选择复核台': '请选择复核台',
  '请选择容器': '请选择容器',
  '请选择容器号': '请选择容器号',
  '请选择容器类型': '请选择容器类型',
  '请选择少配类型的明细行': '请选择少配类型的明细行',
  '请选择待处理数据': '请选择待处理数据',
  '请选择快递公司类型': '请选择快递公司类型',
  '请选择成品商品': '请选择成品商品',
  '请选择打印机': '请选择打印机',
  '请选择打印模板': '请选择打印模板',
  '请选择承运商': '请选择承运商',
  '请选择拣货单': '请选择拣货单',
  '请选择拣货员': '请选择拣货员',
  '请选择配货类型': '请选择配货类型',
  '配货类型和拣货员只能同时为空或同时不为空': '配货类型和拣货员只能同时为空或同时不为空',
  '请选择挂起原因': '请选择挂起原因',
  '请选择提总打印模板': '请选择提总打印模板',
  '请选择插件类型': '请选择插件类型',
  '请选择操作方式': '请选择操作方式',
  '请选择数据': '请选择数据',
  '请选择新品结算方式默认值': '请选择新品结算方式默认值',
  '请选择日志级别': '请选择日志级别',
  '请选择是否允许定位交接': '请选择是否允许定位交接',
  '请选择是否合格': '请选择是否合格',
  '请选择是否损耗': '请选择是否损耗',
  '请选择是否支持所有门店': '请选择是否支持所有门店',
  '请选择是否整单加工': '请选择是否整单加工',
  '请选择模板': '请选择模板',
  '请选择波次号': '请选择波次号',
  '请选择目标位置': '请选择目标位置',
  '请选择管理类型': '请选择管理类型',
  '请选择箱类型': '请选择箱类型',
  '请选择箱类型,箱类型不能为空': '请选择箱类型,箱类型不能为空',
  '请选择耗材类型': '请选择耗材类型',
  '请选择虚拟货位': '请选择虚拟货位',
  '请选择装卸员': '请选择装卸员',
  '请选择要删除的数据': '请选择要删除的数据',
  '请选择要删除的明细': '请选择要删除的明细',
  '请选择要删除的门店': '请选择要删除的门店',
  '请选择要调整的数据': '请选择要调整的数据',
  '请选择规格': '请选择规格',
  '请选择货主': '请选择货主',
  '请选择货位': '请选择货位',
  '请选择货位用途': '请选择货位用途',
  '请选择费用类型': '请选择费用类型',
  '请选择车辆': '请选择车辆',
  '请选择道口': '请选择道口',
  '请选择配送中心': '请选择配送中心',
  '请选择配送任务': '请选择配送任务',
  '请选择门店': '请选择门店',
  '请选择门店分播位': '请选择门店分播位',
  '请选择门店分播方案': '请选择门店分播方案',
  '请选择门店集货方案': '请选择门店集货方案',
  '请选择需要打印的数据': '请选择需要打印的数据',
  '请选择需要操作的数据': '请选择需要操作的数据',
  '请配置模板打印机': '请配置模板打印机',
  '请配置波次任务释放时机': '请配置波次任务释放时机',
  '请重试或返回列表页': '请重试或返回列表页',
  '读取数据': '读取数据',
  '调序': '调序',
  '调序成功': '调序成功',
  '调度看板': '调度看板',
  '调度看板展示容器类型': '调度看板展示容器类型',
  '调拨': '调拨',
  '调拨收货': '调拨收货',
  '调拨类型': '调拨类型',
  '调拨类型退仓单不支持': '调拨类型退仓单不支持',
  '调拨返厂退仓收货中': '调拨返厂退仓收货中',
  '调整': '调整',
  '调整件数': '调整件数',
  '调整原因': '调整原因',
  '调整员': '调整员',
  '调整序号': '调整序号',
  '调整成功': '调整成功',
  '调整数量': '调整数量',
  '调整数量不能为空': '调整数量不能为空',
  '调整类型': '调整类型',
  '调整行号': '调整行号',
  '调整量': '调整量',
  '调用': '调用',
  '调用打印机失败': '调用打印机失败',
  '账号管理': '账号管理',
  '货主': '货主',
  '货主创建': '货主创建',
  '货主别名': '货主别名',
  '货主或仓位未填选！': '货主或仓位未填选！',
  '货主数': '货主数',
  '货主权限信息': '货主权限信息',
  '货位': '货位',
  '货位不能为空': '货位不能为空',
  '货位代码': '货位代码',
  '货位代码,多个货位以逗号隔开': '货位代码,多个货位以逗号隔开',
  '货位代码显示格式': '货位代码显示格式',
  '货位代码显示格式{successLocale}': '货位代码显示格式{successLocale}',
  '货位别名': '货位别名',
  '货位及货位用途': '货位及货位用途',
  '货位名称': '货位名称',
  '货位地址': '货位地址',
  '货位展示及确认配置': '货位展示及确认配置',
  '货位展示及确认配置{successLocale}': '货位展示及确认配置{successLocale}',
  '货位数': '货位数',
  '货位显示配置': '货位显示配置',
  '货位来源类型不能为空': '货位来源类型不能为空',
  '货位校验码范围': '货位校验码范围',
  '货位状态': '货位状态',
  '货位用途': '货位用途',
  '货位类型': '货位类型',
  '货位类型存储关系': '货位类型存储关系',
  '货位范围': '货位范围',
  '货位范围、起始日期、货位用途、拣货分区、货位类型与商品范围不能同时为空': '货位范围、起始日期、货位用途、拣货分区、货位类型与商品范围不能同时为空',
  '货位裁剪': '货位裁剪',
  '货位输入方式': '货位输入方式',
  '货位顺序': '货位顺序',
  '货区': '货区',
  '货区/货道/货位': '货区/货道/货位',
  '货区代码': '货区代码',
  '货区名称': '货区名称',
  '货区范围': '货区范围',
  '货区范围不为空，请填写完整': '货区范围不为空，请填写完整',
  '商品复核数量与拣货数量不一致，请查看后再结束复核': '商品复核数量与拣货数量不一致，请查看后再结束复核',
  '货架': '货架',
  '货架数': '货架数',
  '货架数必须为正整数': '货架数必须为正整数',
  '货架范围': '货架范围',
  '货架范围不为空，请填写完整': '货架范围不为空，请填写完整',
  '货道': '货道',
  '货道范围': '货道范围',
  '货道范围不为空，请填写完整': '货道范围不为空，请填写完整',
  '质检': '质检',
  '质检{length}个选项': '质检{length}个选项',
  '质检中': '质检中',
  '质检单': '质检单',
  '质检单号': '质检单号',
  '质检单生成成功': '质检单生成成功',
  '质检员': '质检员',
  '质检强度': '质检强度',
  '质检成功': '质检成功',
  '质检时间': '质检时间',
  '质检明细': '质检明细',
  '质检明细第{length}行质检实际值不能为空': '质检明细第{length}行质检实际值不能为空',
  '质检明细第{length}行质检实际值不能超过1000000': '质检明细第{length}行质检实际值不能超过1000000',
  '质检机构代码': '质检机构代码',
  '质检机构名称': '质检机构名称',
  '质检标记': '质检标记',
  '质检标识': '质检标识',
  '质检科目': '质检科目',
  '质检科目数': '质检科目数',
  '质检类型': '质检类型',
  '质检结果': '质检结果',
  '质检通知单': '质检通知单',
  '质检通知单号': '质检通知单号',
  '费率': '费率',
  '费用单': '费用单',
  '费用明细': '费用明细',
  '费用类型': '费用类型',
  '费用金额': '费用金额',
  '起始条码': '起始条码',
  '起始列码': '起始列码',
  '起始单数': '起始单数',
  '起始层码': '起始层码',
  '起始货区范围': '起始货区范围',
  '起始货架': '起始货架',
  '起始货架范围': '起始货架范围',
  '起始货道': '起始货道',
  '起始货道范围': '起始货道范围',
  '超保出货': '超保出货',
  '超保单日结': '超保单日结',
  '超保质期出货': '超保质期出货',
  '超出了超拣比例，是否确认？': '超出了超拣比例，是否确认？',
  '超出比例(%)': '超出比例(%)',
  '超拣上限': '超拣上限',
  '超拣比例': '超拣比例',
  '超控制天数出库配置': '超控制天数出库配置',
  '超收': '超收',
  '超收/超出/超拣限制影响配置': '超收/超出/超拣限制影响配置',
  '超收/超出/超拣限制影响配置{successLocale}': '超收/超出/超拣限制影响配置{successLocale}',
  '一步越库超收限制配置': '一步越库超收限制配置',
  '超配拣货': '超配拣货',
  '超配货控制天数出货': '超配货控制天数出货',
  '越库': '越库',
  '越库分播管理方案配置': '越库分播管理方案配置',
  '越库已集货': '越库已集货',
  '越库拣货': '越库拣货',
  '越库收货': '越库收货',
  '越库未集货': '越库未集货',
  '越库波次完成日结': '越库波次完成日结',
  '越库集货': '越库集货',
  '越库集货暂存位': '越库集货暂存位',
  '跳过': '跳过',
  '跳过{action}': '跳过{action}',
  '车型': '车型',
  '车牌号': '车牌号',
  '车牌号或车辆代码': '车牌号或车辆代码',
  '车辆': '车辆',
  '车辆状态': '车辆状态',
  '车队承担': '车队承担',
  '转运': '转运',
  '载重(吨)': '载重(吨)',
  '输入字符串过长': '输入字符串过长',
  '输入插件ID': '输入插件ID',
  '输入方式': '输入方式',
  '输入货位取值': '输入货位取值',
  '输入配单号，则只以配单装车，否则以波次+门店进行装车': '输入配单号，则只以配单装车，否则以波次+门店进行装车',
  '边拣边播': '边拣边播',
  '运单状态': '运单状态',
  '运输中': '运输中',
  '运输波次': '运输波次',
  '运输管理': '运输管理',
  '返厂': '返厂',
  '返厂控制天数': '返厂控制天数',
  '返厂的目标货位': '返厂的目标货位',
  '返厂退仓收货中': '返厂退仓收货中',
  '返厂集货 ': '返厂集货 ',
  '返回': '返回',
  '返配件数': '返配件数',
  '返配明细': '返配明细',
  '返配明细第{line}行与第{otherLine}行重复！': '返配明细第{line}行与第{otherLine}行重复！',
  '返配明细第{line}行返配件数不能为空！': '返配明细第{line}行返配件数不能为空！',
  '返配明细第{line}行返配件数必须大于0！': '返配明细第{line}行返配件数必须大于0！',
  '返配明细第{line}行返配类型不能为空！': '返配明细第{line}行返配类型不能为空！',
  '返配类型': '返配类型',
  '返配类型配置': '返配类型配置',
  '还原': '还原',
  '还原容器{containerBarcode}失败': '还原容器{containerBarcode}失败',
  '进入': '进入',
  '进入虚拟货位': '进入虚拟货位',
  '进行中': '进行中',
  '进行中的项目': '进行中的项目',
  '连接出错，检查插件和设置是否正常连接': '连接出错，检查插件和设置是否正常连接',
  '连续打印次数': '连续打印次数',
  '退仓': '退仓',
  '退仓上架中': '退仓上架中',
  '退仓上架单': '退仓上架单',
  '退仓上架明细不能为空': '退仓上架明细不能为空',
  '退仓业务': '退仓业务',
  '退仓修正': '退仓修正',
  '退仓单': '退仓单',
  '退仓单供应商退货位推荐配置': '退仓单供应商退货位推荐配置',
  '退仓单操作默认值配置': '退仓单操作默认值配置',
  '退仓单收货日结': '退仓单收货日结',
  '退仓原因': '退仓原因',
  '退仓员': '退仓员',
  '退仓收货': '退仓收货',
  '退仓收货实收显示': '退仓收货实收显示',
  '退仓收货暂存位': '退仓收货暂存位',
  '退仓明细不能为空': '退仓明细不能为空',
  '退仓类型': '退仓类型',
  '退仓通知单': '退仓通知单',
  '退仓通知单过期日结': '退仓通知单过期日结',
  '退件': '退件',
  '退件已签收': '退件已签收',
  '退出': '退出',
  '退出登录': '退出登录',
  '退单明细': '退单明细',
  '退货': '退货',
  '退货仓位': '退货仓位',
  '退货修正': '退货修正',
  '退货条件': '退货条件',
  '退货类型': '退货类型',
  '退货调拨配置': '退货调拨配置',
  '退货通知单号': '退货通知单号',
  '退货配置': '退货配置',
  '送货地址': '送货地址',
  '送货地址不能为空。': '送货地址不能为空。',
  '送货对象': '送货对象',
  '送货对象不可用容器类型配置': '送货对象不可用容器类型配置',
  '送货对象类型': '送货对象类型',
  '送货对象类型不可用容器类型配置': '送货对象类型不可用容器类型配置',
  '送货类型': '送货类型',
  '适应门店明细第{line}行与第{otherLine}行重复！': '适应门店明细第{line}行与第{otherLine}行重复！',
  '适应门店明细第{line}行门店不能为空！': '适应门店明细第{line}行门店不能为空！',
  '逆向修改': '逆向修改',
  '逆向修正单明细第{line}行与第{otherLine}行重复！': '逆向修正单明细第{line}行与第{otherLine}行重复！',
  '逆向修正明细第{line}行修正原因不能为空！': '逆向修正明细第{line}行修正原因不能为空！',
  '逆向修正明细第{line}行单价不能空或小于0！': '逆向修正明细第{line}行单价不能空或小于0！',
  '逆向修正明细第{line}行商品不能为空！': '逆向修正明细第{line}行商品不能为空！',
  '逆向修正明细第{line}行数量不能为0！': '逆向修正明细第{line}行数量不能为0！',
  '逆向物流': '逆向物流',
  '选取波次号': '选取波次号',
  '选择': '选择',
  '选择全选时请取消其他选项！': '选择全选时请取消其他选项！',
  '选择加工波次': '选择加工波次',
  '选择包装机类型': '选择包装机类型',
  '选择商品': '选择商品',
  '选择录入结果': '选择录入结果',
  '选择打印数据': '选择打印数据',
  '选择明细中没有退仓类型位好退的明细,请重新勾选': '选择明细中没有退仓类型位好退的明细,请重新勾选',
  '选择标签属性': '选择标签属性',
  '选择的数据中包含状态为非已审核的数据，请选择已审核的数据': '选择的数据中包含状态为非已审核的数据，请选择已审核的数据',
  '选择的明细只能为同一供应商': '选择的明细只能为同一供应商',
  '选择的订单已无可预检项': '选择的订单已无可预检项',
  '选择虚拟货位': '选择虚拟货位',
  '选择装车员': '选择装车员',
  '选择装车来源': '选择装车来源',
  '选择订单仓位与预检已有仓位不一致': '选择订单仓位与预检已有仓位不一致',
  '选择订单供应商与预检已有供应商不一致': '选择订单供应商与预检已有供应商不一致',
  '选择订单货主与预检已有货主不一致': '选择订单货主与预检已有货主不一致',
  '选择货位': '选择货位',
  '选项配置': '选项配置',
  '通知单': '通知单',
  '通知单到效日期不能早于当前日期': '通知单到效日期不能早于当前日期',
  '通知单到效期不能早于当前日期': '通知单到效期不能早于当前日期',
  '通知单号': '通知单号',
  '通知单号或来源单号': '通知单号或来源单号',
  '通知单明细不能为空': '通知单明细不能为空',
  '通知单来源单号': '通知单来源单号',
  '通知单来源行号': '通知单来源行号',
  '通知单退货日期不能早于当前日期': '通知单退货日期不能早于当前日期',
  '通知管理': '通知管理',
  '通道数': '通道数',
  '通道数必须为正整数': '通道数必须为正整数',
  '逾期关闭': '逾期关闭',
  '道口': '道口',
  '道口货位': '道口货位',
  '部分预检': '部分预检',
  '部分预约': '部分预约',
  '配单不能为空': '配单不能为空',
  '配单拣货完成日结': '配单拣货完成日结',
  '配单接收': '配单接收',
  '配单数据上传TMS': '配单数据上传TMS',
  '配单类型配置': '配单类型配置',
  '配单装车状态刷新日结': '配单装车状态刷新日结',
  '配单过期日结': '配单过期日结',
  '配差单类型': '配差单类型',
  '配置中心': '配置中心',
  '配置信息': '配置信息',
  '配置名称': '配置名称',
  '配置日志': '配置日志',
  '配置类型': '配置类型',
  '配货单号': '配货单号',
  '配货差异使用虚拟货位配置': '配货差异使用虚拟货位配置',
  '配货差异单': '配货差异单',
  '配货差异单日志': '配货差异单日志',
  '配货差异单移库': '配货差异单移库',
  '配货差异可用处理方式配置': '配货差异可用处理方式配置',
  '配货差异审核提示配置': '配货差异审核提示配置',
  '配货控制天数': '配货控制天数',
  '配货日期': '配货日期',
  '配货状态': '配货状态',
  '配货类型': '配货类型',
  '配货通知单': '配货通知单',
  '配货通知单号': '配货通知单号',
  '配货通知单类型': '配货通知单类型',
  '配送': '配送',
  '配送中': '配送中',
  '配送中心': '配送中心',
  '配送中心不为空': '配送中心不为空',
  '配送中心权限信息': '配送中心权限信息',
  '配送中心组织': '配送中心组织',
  '配送中心设置成功': '配送中心设置成功',
  '配送中心：{code} 已存在': '配送中心：{code} 已存在',
  '配送主动退货供应商配置': '配送主动退货供应商配置',
  '配送周期': '配送周期',
  '配送周期代码': '配送周期代码',
  '配送周期名称': '配送周期名称',
  '配送周期方案': '配送周期方案',
  '配送确认': '配送确认',
  '配送设置': '配送设置',
  '采购核价配置': '采购核价配置',
  '采集体积': '采集体积',
  '释放': '释放',
  '释放成功': '释放成功',
  '释放拣货单': '释放拣货单',
  '释放补货单': '释放补货单',
  '里程': '里程',
  '里程登记': '里程登记',
  '重': '重',
  '重(g)': '重(g)',
  '重印': '重印',
  '重发': '重发',
  '重发{length}个选项': '重发{length}个选项',
  '重启': '重启',
  '重命名': '重命名',
  '重命名不能为空': '重命名不能为空',
  '重算{length}个选项': '重算{length}个选项',
  '重算成功': '重算成功',
  '重置': '重置',
  '重置密码': '重置密码',
  '重置密码成功': '重置密码成功',
  '重量': '重量',
  '重量(kg)': '重量(kg)',
  '重量(吨)': '重量(吨)',
  '重量/读称': '重量/读称',
  '重量不能为空': '重量不能为空',
  '重量商品拣货自动提交': '重量商品拣货自动提交',
  '金额': '金额',
  '金额(元)': '金额(元)',
  '钉钉配置': '钉钉配置',
  '锁定': '锁定',
  '锁定解锁配置': '锁定解锁配置',
  '镇/街道': '镇/街道',
  '长': '长',
  '长(cm)': '长(cm)',
  '长/宽/高': '长/宽/高',
  '门店': '门店',
  '门店 :': '门店 :',
  '门店/客户': '门店/客户',
  '门店{code} 已存在': '门店{code} 已存在',
  '门店交接': '门店交接',
  '门店交接单': '门店交接单',
  '门店代码': '门店代码',
  '门店代码/名称': '门店代码/名称',
  '门店价格查询': '门店价格查询',
  '门店信息': '门店信息',
  '门店信息第{line}行封签号不能为空！': '门店信息第{line}行封签号不能为空！',
  '门店分播位': '门店分播位',
  '门店分播位数量与客户单数不符': '门店分播位数量与客户单数不符',
  '门店分播位方案': '门店分播位方案',
  '门店分播方案不能为空': '门店分播方案不能为空',
  '门店单号': '门店单号',
  '门店名称': '门店名称',
  '门店容器数': '门店容器数',
  '门店封签号': '门店封签号',
  '门店已交接': '门店已交接',
  '门店拣货信息调整面板': '门店拣货信息调整面板',
  '门店拣货容器类型提示': '门店拣货容器类型提示',
  '门店拣货容器类型配置': '门店拣货容器类型配置',
  '门店明细': '门店明细',
  '门店权限信息': '门店权限信息',
  '门店业态': '门店业态',
  '门店纬度': '门店纬度',
  '门店线路': '门店线路',
  '门店组': '门店组',
  '门店组名称': '门店组名称',
  '门店组织': '门店组织',
  '门店组配置': '门店组配置',
  '门店要货量': '门店要货量',
  '门店起要量': '门店起要量',
  '门店跳过成功！': '门店跳过成功！',
  '门店退仓': '门店退仓',
  '门店退仓通知单': '门店退仓通知单',
  '门店道口关系{sortStrategy}': '门店道口关系{sortStrategy}',
  '门店道口关系不存在': '门店道口关系不存在',
  '门店道口关系方案': '门店道口关系方案',
  '门店道口关系方案：{entity}': '门店道口关系方案：{entity}',
  '间隔时间(ms)': '间隔时间(ms)',
  '间隔时间设置': '间隔时间设置',
  '附件': '附件',
  '附件信息': '附件信息',
  '附件入库': '附件入库',
  '附件出库': '附件出库',
  '附件明细': '附件明细',
  '附件管理': '附件管理',
  '附件类型': '附件类型',
  '附件绑定维护分类': '附件绑定维护分类',
  '附件配置': '附件配置',
  '降幅': '降幅',
  '限1M以内': '限1M以内',
  '限制字段': '限制字段',
  '限制强度': '限制强度',
  '限制影响类型': '限制影响类型',
  '随波次': '随波次',
  '随统配集货': '随统配集货',
  '随车': '随车',
  '集货位': '集货位',
  '集货位{tips}已在其他门店分配记录中，是否确认保存?': '集货位{tips}已在其他门店分配记录中，是否确认保存?',
  '集货位复查单日结': '集货位复查单日结',
  '集货位数': '集货位数',
  '集货位管理方案-指定货位数管理': '集货位管理方案-指定货位数管理',
  '集货位管理方案-粗式管理': '集货位管理方案-粗式管理',
  '集货位管理方案-精细化管理': '集货位管理方案-精细化管理',
  '集货位跨度': '集货位跨度',
  '集货位面板': '集货位面板',
  '集货信息查询': '集货信息查询',
  '集货区复查': '集货区复查',
  '集货区复查容器最大输入数量配置': '集货区复查容器最大输入数量配置',
  '集货区复查容器类型配置': '集货区复查容器类型配置',
  '集货区复查是否影响装车': '集货区复查是否影响装车',
  '集货区复查是否影响装车配置': '集货区复查是否影响装车配置',
  '集货区复查装车配置': '集货区复查装车配置',
  '集货区复查规格维护': '集货区复查规格维护',
  '集货区复查货位用途配置': '集货区复查货位用途配置',
  '集货复查后装车': '集货复查后装车',
  '集货复查装车': '集货复查装车',
  '集货方案': '集货方案',
  '集货暂存位': '集货暂存位',
  '集货管理方案': '集货管理方案',
  '零散': '零散',
  '零散数': '零散数',
  '需要检疫证': '需要检疫证',
  '静态补货': '静态补货',
  '非手工单据的分播方式将修改为手工单据，手工单据的将修改为原分播方式': '非手工单据的分播方式将修改为手工单据，手工单据的将修改为原分播方式',
  '非手工单据的拣货单将修改为手工单据，手工单据的将修改为原操作方式': '非手工单据的拣货单将修改为手工单据，手工单据的将修改为原操作方式',
  '非手工单据的提总方式将修改为手工单据，手工单据的将修改为原提总方式': '非手工单据的提总方式将修改为手工单据，手工单据的将修改为原提总方式',
  '非手工单据的补货单将修改为手工单据，手工单据的将修改为原操作方式': '非手工单据的补货单将修改为手工单据，手工单据的将修改为原操作方式',
  '非整托': '非整托',
  '非整托补货': '非整托补货',
  '非配送数据支持配货差异': '非配送数据支持配货差异',
  '非配送数据支持配货差异配置': '非配送数据支持配货差异配置',
  '非默认规格': '非默认规格',
  '面单打印机': '面单打印机',
  '页面正在编辑中，如要刷新请先取消编辑': '页面正在编辑中，如要刷新请先取消编辑',
  '项目数': '项目数',
  '项目访问': '项目访问',
  '顺序调整': '顺序调整',
  '顾客下单时间': '顾客下单时间',
  '预估卸货时长(h)': '预估卸货时长(h)',
  '预分配': '预分配',
  '预分配明细': '预分配明细',
  '预分配量': '预分配量',
  '预分配：<空>': '预分配：<空>',
  '预分配：{article}': '预分配：{article}',
  '预检': '预检',
  '预检不能混物流模式': '预检不能混物流模式',
  '预检单': '预检单',
  '预检单完成日结': '预检单完成日结',
  '预检员': '预检员',
  '预检完成': '预检完成',
  '预检序号': '预检序号',
  '预检库存多规格校验': '预检库存多规格校验',
  '预检限制': '预检限制',
  '预留操作高度(cm)': '预留操作高度(cm)',
  '预约': '预约',
  '预约人': '预约人',
  '预约单号': '预约单号',
  '预约品项数': '预约品项数',
  '预约完成': '预约完成',
  '预约日期': '预约日期',
  '预约日期：{time}': '预约日期：{time}',
  '预约时间': '预约时间',
  '预约时间配置': '预约时间配置',
  '预约量配置': '预约量配置',
  '预约限制': '预约限制',
  '预约预检流程配置': '预约预检流程配置',
  '预补': '预补',
  '预补补货': '预补补货',
  '预览': '预览',
  '预计送达时间': '预计送达时间',
  '领用': '领用',
  '领用{length}个选项': '领用{length}个选项',
  '领用主动发起配置': '领用主动发起配置',
  '领用主动发起配置{successLocale}': '领用主动发起配置{successLocale}',
  '领用主动发起配置类型': '领用主动发起配置类型',
  '领用人': '领用人',
  '领用人代码': '领用人代码',
  '领用单': '领用单',
  '领用对象': '领用对象',
  '领用成功': '领用成功',
  '领用来源单号': '领用来源单号',
  '领用类型': '领用类型',
  '领用通知单': '领用通知单',
  '首选收货': '首选收货',
  '首选退货': '首选退货',
  '首选退货供应商': '首选退货供应商',
  '上游配送中心默认供应商': '上游配送中心默认供应商',
  '驾驶员': '驾驶员',
  '验证码只能包含数字和英文字母': '验证码只能包含数字和英文字母',
  '高': '高',
  '高(cm)': '高(cm)',
  '高叉作业': '高叉作业',
  '高叉作业补货跳过源容器校验': '高叉作业补货跳过源容器校验',
  '高叉员作业配置': '高叉员作业配置',
  '默认': '默认',
  '默认付款方式': '默认付款方式',
  '默认供应商': '默认供应商',
  '默认供应商退货位': '默认供应商退货位',
  '默认处理方式': '默认处理方式',
  '默认库存分配类型': '默认库存分配类型',
  '默认强分门店配置': '默认强分门店配置',
  '默认操作方式': '默认操作方式',
  '默认正常仓位': '默认正常仓位',
  '默认状态': '默认状态',
  '默认生产日期配置': '默认生产日期配置',
  '默认箱类型': '默认箱类型',
  '默认虚拟货位': '默认虚拟货位',
  '默认规格': '默认规格',
  '默认退仓类型': '默认退仓类型',
  '默认退货仓位': '默认退货仓位',
  '，祝你开心每一天！': '，祝你开心每一天！',
  '同一门店码头集是否允许同时排多车配置': '同一门店码头集是否允许同时排多车配置',
  '修改拣货方式': '修改拣货方式',
  '已发送状态拣货单，是否更改成功需等待外部系统确认结果，需保持关注': '已发送状态拣货单，是否更改成功需等待外部系统确认结果，需保持关注',
  '已发送状态拣货单，是否更改成功需等待外部系统确认结果，请保持关注': '已发送状态拣货单，是否更改成功需等待外部系统确认结果，请保持关注',
  '接口状态': '接口状态',
  '确认中': '确认中',
  '封签号管理配置': '封签号管理配置',
  '封签号样式配置': '封签号样式配置',
  '单条码': '单条码',
  '组合条码': '组合条码',
  '封签号数量配置': '封签号数量配置',
  '单门': '单门',
  '多门': '多门',
  '封签号位置': '封签号位置',
  '封签号为多门时，必须维护封签号位置': '封签号为多门时，必须维护封签号位置',
  '预分配总量': '预分配总量',
  '预分配总量大于可分配量': '预分配总量大于可分配量',
  '剩余可分配量': '剩余可分配量',
  '共存在{x}家门店的预分配量为0，是否继续生成指令?': '共存在{x}家门店的预分配量为0，是否继续生成指令?',
  '电子标签拣货': '电子标签拣货',
  '勾选后支持电子标签拣货负库存': '勾选后支持电子标签拣货负库存',
  '封签号为多门时，必须维护封签号门位置': '封签号为多门时，必须维护封签号门位置',
  '请先选择要设置整件拣货位的行！': '请先选择要设置整件拣货位的行！',
  '请先选择要设置拆零拣货位的行！': '请先选择要设置拆零拣货位的行！',
  '请先选择要设置整件拣货位行的商品！': '请先选择要设置整件拣货位行的商品！',
  '请先选择要设置拆零拣货位行的商品！': '请先选择要设置拆零拣货位行的商品！',
  '封签号': '封签号',
  '封签条码': '封签条码',
  '封签位置': '封签位置',
  '封签信息': '封签信息',
  '封签信息第{line}行封签位置不能为空': '封签信息第{line}行封签位置不能为空',
  '封签信息第{line}行封签号不能为空': '封签信息第{line}行封签号不能为空',
  '封签信息第{line}行封签条码不能为空': '封签信息第{line}行封签条码不能为空',
  '门店{stores}有装车库存,但未录入封签信息': '门店{stores}有装车库存,但未录入封签信息',
  '容器交接类型维度配置': '容器交接类型维度配置',
  '容器交接类型维度': '容器交接类型维度',
  '门店交接单操作配置': '门店交接单操作配置',
  '已交接的门店交接单web端可确认': '已交接的门店交接单web端可确认',
  '未交接的门店交接单web端可确认': '未交接的门店交接单web端可确认',
  '承运商交接单审核生成': '承运商交接单审核生成',
  '全部配送中心': '全部配送中心',
  '入库流程/收货单日结，请至少填写一个时间': '入库流程/收货单日结，请至少填写一个时间',
  '定时': '定时',
  '轮询': '轮询',
  '小时': '小时',
  '不强制复查的码头集配置': '不强制复查的码头集配置',
  '日结锁定忽略货位用途配置': '日结锁定忽略货位用途配置',
  '拣货位多库存规格配置': '拣货位多库存规格配置',
  '奇数容器': '奇数容器',
  '奇偶容器': '奇偶容器',
  '偶数容器': '偶数容器',
  '封签明细第{line}行封签位置不能为空！': '封签明细第{line}行封签位置不能为空！',
  '封签明细第{line}行封签号不能为空！': '封签明细第{line}行封签号不能为空！',
  '封签明细第{line}行封签码不能为空！': '封签明细第{line}行封签码不能为空！',
  '门店提报数': '门店提报数',
  '实际装车数': '实际装车数',
  '封签位置': '封签位置',
  '封签号': '封签号',
  '封签条码': '封签条码',
  '已复查': '已复查',
  '部分复查': '部分复查',
  '未复查': '未复查',
  '仓库确认': '仓库确认',
  '无法批量修改拣货数量，请单独进入拣货数量调整模块操作': '无法批量修改拣货数量，请单独进入拣货数量调整模块操作',
  '拣货单{pickupBillNumber}，已无可调整明细，请核实': '拣货单{pickupBillNumber}，已无可调整明细，请核实',
  '复查标记': '复查标记',
  '回收信息中，容器类型{containerType}有多行，不允许保存': '回收信息中，容器类型{containerType}有多行，不允许保存',
  '收拣业务小数位配置': '收拣业务小数位配置',
  '小数位数': '小数位数',
  '无需复查': '无需复查',
  '勾选后可在排车看板页面查看AGV出库暂存位的信息,不可装车': '勾选后可在排车看板页面查看AGV出库暂存位的信息,不可装车',
  '回收明细第{line}行容器类型不能为空！': '回收明细第{line}行容器类型不能为空！',
  '回收明细第{line}行交接类型不能为空！': '回收明细第{line}行交接类型不能为空！',
  '回收明细第{line}行实际回收数不能为空！': '回收明细第{line}行实际回收数不能为空！',
  '容器类型${containerTypes}，实际回收数为0，而门店提报量非0，是否确认?': '容器类型${containerTypes}，实际回收数为0，而门店提报量非0，是否确认?',
  '距预计送达时间（M）': '距预计送达时间（M）',
  '轮询间隔（M）': '轮询间隔（M）',
  '自动波次配置': '自动波次配置',
  '声音文件': '声音文件',
  '支持wav': '支持wav',
  '文件名': '文件名',
  '试听': '试听',
  '播放': '播放',
  'iwms保存报错': 'iwms保存报错',
  '提示音': '提示音',
  '目标货位状态': '目标货位状态',
  '是否自动交接': '是否自动交接',
  'rawRequisitionBill.title': '领料单',
  'rawRequisitionBill.index.batchButton.modifyPicker': '修改领料员',
  'rawRequisitionBill.detail.table.column.pickTime': '领料时间',
  'rawRequisitionBill.picker': '领料员',
  '修改领料员{length}个选项': '修改领料员{length}个选项',
  '请先选择领料单。': '请先选择领料单。',
  '领料员不能为空。': '领料员不能为空。',
  '开始领料': '开始领料',
  '结束领料': '结束领料',
  '应领件数': '应领件数',
  '打印数据不能为空': '打印数据不能为空',
  '无默认模板，请先完成配置': '无默认模板，请先完成配置',
  '电子标签日志': '电子标签日志',
  '确认按数量回收{length}个选项': '确认按数量回收{length}个选项',
  '领料任务': '领料任务',
  '请输入上浮比例': '请输入上浮比例',
  '选择配货日期': '选择配货日期',
  '生成领料单': '生成领料单',
  '目标数量': '目标数量',
  '可用库存': '可用库存',
  '待加工量': '待加工量',
  'menu.inner.rawRequisitionTask': '领料任务',
  '波次原因': '波次原因',
  '库存分配类型': '库存分配类型',
  '预设条件': '预设条件',
  '周时间': '周时间',
  '自定义语句': '自定义语句',
  '保存预设条件': '保存预设条件',
  '预设条件名称': '预设条件名称',
  '波次': '波次',
  '名称已存在，是否覆盖当前预设条件': '名称已存在，是否覆盖当前预设条件',
  '是否确认删除': '是否确认删除',
  '确认生成领料单?': '确认生成领料单?',
  '上浮比例请输入0-100的数字': '上浮比例请输入0-100的数字',
  '待加工量为0': '待加工量为0',
  '按天': '按天',
  '按波次': '按波次',
  '领料集货': '领料集货',
  '自定义语句中使用到主表时，需要使用占位符{masterAlias}进行替代': '自定义语句中使用到主表时，需要使用占位符{masterAlias}进行替代',
  '建议加工量': '建议加工量',
  '待加工量': '待加工量',
  '已加工量': '已加工量',
  '成品容器': '成品容器',
  '箱': '箱',
  '零': '零',
  '选择模板': '选择模板',
  '结束加工': '结束加工',
  '选择加工方案': '选择加工方案',
  '输入搜索加工方案': '输入搜索加工方案',
  '选择加工台': '选择加工台',
  '请先选择加工台': '请先选择加工台',
  '商品/规格': '商品/规格',
  '选择原料池': '选择原料池',
  '结束加工-剩余原料': '结束加工-剩余原料',
  'Web加工': "Web加工",
  '容器/商品': '容器/商品',
  '规格/单位': "规格/单位",
  '跨波次跟随': "跨波次跟随",
  '集货区复查是否受拣货完成限制配置': '集货区复查是否受拣货完成限制配置',
  '体积范围最大值必须大于0': '体积范围最大值必须大于0',
  '正在前往IWMS系统，请稍后...': '正在前往IWMS系统，请稍后...',
  '按超收比例': '按超收比例',
  '不允许超量': '不允许超量',
  '不允许超收': '不允许超收',
  '目标货位范围': '目标货位范围',
  '补货触发时机': '补货触发时机',
  '固定件数': '固定件数',
  '随拣货分区': '随拣货分区',
  '拣货分区和目标货位不能同时为空': '拣货分区和目标货位不能同时为空',
  '低于最低库存': '低于最低库存',
  '低于固定件数': '低于固定件数',
  '低于库存比例': '低于库存比例',
  '指定配货数据': '指定配货数据',
  '打印标志': '打印标志',
  '配单数': '配单数',
  '实际配货金额': '实际配货金额',
  '配单打印看板': '配单打印看板',
  '可打印': '可打印',
  '不可打印': '不可打印',
  '体积范围最大值必须大于0': '体积范围最大值必须大于0',
  '{article}商品实退{realQty}超出应退数量{qty}.': '{article}商品实退{realQty}超出应退数量{qty}.',
  '是否确认': '是否确认',
  '是否确认删除该预设条件：{name}吗？': '是否确认删除该预设条件：{name}吗？',
  '只允许输入正整数数字': '只允许输入正整数数字',
  '补货优先级': '补货优先级',
  '费用登记': '费用登记',
  '装卸费用': '装卸费用',
  '车型': '车型',
  '费用备注': '费用备注',
  '补货优先级': '补货优先级',
  '报表-': '报表-',
  '无匹配结果': '无匹配结果',
  '需满足非负数格式': '需满足非负数格式',
  '配送进价': '配送进价',
  '配送售价': '配送售价',
  '请输入分播中转位代码': '请输入分播中转位代码',
  '看板线路体系默认值配置': '看板线路体系默认值配置',
  '代码最小': '代码最小',
  '摘果拣货后直接平移': '摘果拣货后直接平移',
  '生鲜摘果是否需要跳过商品校验': '生鲜摘果是否需要跳过商品校验',
  '控制RF生鲜摘果拣货模块，是否展示输入/扫描商品条码': '控制RF生鲜摘果拣货模块，是否展示输入/扫描商品条码',
  '请先确定勾选所在行的新商品！': '请先确定勾选所在行的新商品！',
  '明细第{line}行无供应商{vendor}！': '明细第{line}行无供应商{vendor}！',
  '明细第{line}行无商品规格{qpcStr}！': '明细第{line}行无商品规格{qpcStr}！',
  '修改新供应商': '修改新供应商',
  '修改新生产日期': '修改新生产日期',
  '修改新商品': "修改新商品",
  '批量修改新规格': '批量修改新规格',
  '是否要撤销删除此行？': "是否要撤销删除此行？",
  '撤销删除': '撤销删除',
  '接口上传': '接口上传',
  '修改新规格': '修改新规格',
  '商品转换': '商品转换',
  '新商品': '新商品',
  '商品组别': '商品组别',
  '附件支持jpg、jpeg、png、doc、docx、xls、xlsx、pdf格式文件，一行明细最多上传3个附件': '附件支持jpg、jpeg、png、doc、docx、xls、xlsx、pdf格式文件，一行明细最多上传3个附件',
  '明细第{line}行新商品不能为空！': '明细第{line}行新商品不能为空！',
  '取&emsp;消': '取  消',
  '确&emsp;认': '确  认',
  '总接收件数': '总接收件数',
  '总接收品项数': '总接收品项数',
  '总接收金额': '总接收金额',
  '平移容器': '平移容器',
  '容器未校验或校验不通过': '容器未校验或校验不通过',
  '平移容器': '平移容器',
  '大型拣货位上架逻辑': '大型拣货位上架逻辑',
  '只上拣货位': '只上拣货位',
  '依据上架货位维护值': '依据上架货位维护值',
  '上架配置': '上架配置',
  '扣减费用': '扣减费用',
  '选择的明细只能为同一供应商': '选择的明细只能为同一供应商',
  '确认{operate}{length}个选项': '确认{operate}{length}个选项',
  '附件下载': '附件下载',
  '{name}大小超过30M,无法上传': '{name}大小超过30M,无法上传',
  '普通盘点': '普通盘点',
  '匹配货位盘点': '匹配货位盘点',
  '实盘来源': '实盘来源',
  '复盘单生成维度配置': '复盘单生成维度配置',
  '货位+容器+商品': '货位+容器+商品',
  '车牌号': '车牌号',
  '仅支持jpg、jpeg、png、doc、docx、xls、xlsx、pdf格式': '仅支持jpg、jpeg、png、doc、docx、xls、xlsx、pdf格式',
  '文件大小不要超过30M': '文件大小不要超过30M',
  '特殊门店集货位范围': '特殊门店集货位范围',
  '附件支持jpg、jpeg、png、doc、docx、xls、xlsx、pdf格式文件，建议上传文件大小不超过30M，一行明细最多上传{count}个附件': '附件支持jpg、jpeg、png、doc、docx、xls、xlsx、pdf格式文件，建议上传文件大小不超过30M，一行明细最多上传{count}个附件',
  "第{a_line}行明细与第{b_line}行明细相同": '第{a_line}行明细与第{b_line}行明细相同',
  '出库无皮重记录时的采集维度': '出库无皮重记录时的采集维度',
  "到货日期": '到货日期',
  '订单/来源订单号': '订单/来源订单号',
  '装车码头': '装车码头',
  '件数不能小于等于0': '件数不能小于等于0',
  '毛重不能小于等于0': '毛重不能小于等于0',
  '皮重不能大于毛重': '皮重不能大于毛重',
  '实现全程精细化、智能化管理': '实现全程精细化、智能化管理',
  '海鼎智慧仓储管理系统': "海鼎智慧仓储管理系统",
  '仅支持上传图片': '仅支持上传图片',
  '{name}大小超过{count}M,无法上传': "{name}大小超过{count}M,无法上传",
  '登录页设置': '登录页设置',
  '主标题': "主标题",
  '副标题': '副标题',
  '自定义图片': "自定义图片",
  '建议图片尺寸{width}*{height}px,大小不超过{size}M': "建议图片尺寸{width}*{height}px,大小不超过{size}M",
  '首页设置': "首页设置",
  "成品加工位容器管理": '成品加工位容器管理',
  "成品加工位容器管理 保存成功": '成品加工位容器管理 保存成功',
  'WMS配送中心': 'WMS配送中心',
  '优先上游配送中心': '优先上游配送中心',
  '库存模式&商品状态取值来源': '库存模式&商品状态取值来源',
  '库存模式&商品状态业务限制': '库存模式&商品状态业务限制',
  '新橙家特制条码': '新橙家特制条码',
  '门店拣货校验生产日期配置': '门店拣货校验生产日期配置',
  '拣货日期比例': '拣货日期比例',
  '预留天数': '预留天数',
  '-100~100整数': '-100~100整数',
  '分子请输入1~100整数': '分子请输入1~100整数',
  '分母请输入1~100整数': '分母请输入1~100整数',
  '拣货日期比例分子不能大于分母': '拣货日期比例分子不能大于分母',
  '门店代码或名称': '门店代码或名称',
  '加工方向': '加工方向',
  '逆向': '逆向',
  '正向': '正向',
  '门店计划时间提示/展示': '门店计划时间提示/展示',
  '勾选后RF统配拣货、容器复查、分播等模块提示或展示计划开始拣货时间、计划结束拣货时间、计划装车完成时间': '勾选后RF统配拣货、容器复查、分播等模块提示或展示计划开始拣货时间、计划结束拣货时间、计划装车完成时间',
  '供应商退货位和供应商集货位只能同时为空或同时不为空': '供应商退货位和供应商集货位只能同时为空或同时不为空',
  '日结虚拟货位': '日结虚拟货位',
  '分钟': '分钟',
  '请输入正整数': '请输入正整数',
  '轮询时间最大不可超过1440': '轮询时间最大不可超过1440',
  '轮询时间': '轮询时间',
  '收货采集车牌号': '收货采集车牌号',
  '勾选后RF正常收货、RF快速收货、RF诚信收货采集车牌号': '勾选后RF正常收货、RF快速收货、RF诚信收货采集车牌号',
  '统配波次允许多分播方案': '统配波次允许多分播方案',
  '允许多分播方案': '允许多分播方案',
  '预检单号': '预检单号',
  "末次拣货时间": "末次拣货时间",
  "末次拣货员": "末次拣货员",
  "一键分播": "一键分播",
  '拣货分区组': '拣货分区组',
  '拣货分区范围': '拣货分区范围',
  '无附件可下载': '无附件可下载',
  '门店指定日期配货配置': '门店指定日期配货配置',
  '配货日期比例提示': 'M/N格式，门店要求距离商品到效日期的天数不得少于该商品保质期的M/N',
  '配货日期比例分子不能大于分母': '配货日期比例分子不能大于分母',
  '配货日期比例': '配货日期比例',
  '指定类型': '指定类型',
  '语言切换': '语言切换',
  '组合单号不为空，不允许修改拣货员！': '组合单号不为空，不允许修改拣货员！',
  '组合单号不为空，不允许修改拣货方式！': '组合单号不为空，不允许修改拣货方式！',
  '组合类型': '组合类型',
  '组合单号': '组合单号',
  '指定类型': '指定类型',
  '确认修改{length}个选项': '确认修改{length}个选项',
  '同店多区': '同店多区',
  '同区多店': '同区多店',
  '拣货分区组不能为空': '拣货分区组不能为空',
  '拣货单状态': '拣货单状态',
  '品项数范围': '品项数范围',
  '起始品项数': '起始品项数',
  '终止品项数': '终止品项数',
  '件数范围': '件数范围',
  '起始件数': '起始件数',
  '终止件数': '终止件数',
  '体积范围(m³)': '体积范围(m³)',
  '起始体积': '起始体积',
  '终止体积': '终止体积',
  '1~100整数': '1~100整数',
  '同店多区组合': '同店多区组合',
  '确认是否进行同店多区组合': '确认是否进行同店多区组合',
  '计划开始拣货时间': '计划开始拣货时间',
  '计划结束拣货时间': '计划结束拣货时间',
  '确认修改{length}个选项！': '确认修改{length}个选项！',
  '拣货单组合': '拣货单组合',
  '拣货件数进度': '拣货件数进度',
  '拣货体积进度': '拣货体积进度',
  '总应拣件数': '总应拣件数',
  '总应拣体积(m³)': '总应拣体积(m³)',
  '应拣体积(m³)': '应拣体积(m³)',
  '选中应拣件数': '选中应拣件数',
  '选中应拣体积(m³)': '选中应拣体积(m³)',
  '选择明细中没有退仓类型为返厂的明细,请重新勾选': '选择明细中没有退仓类型为返厂的明细,请重新勾选',
  '序号请输入正整数':'序号请输入正整数',
  '请输入拣货分区':'请输入拣货分区',
  '选择全部门店':'选择全部门店',
  '配出件数': '配出件数',
  '配出数量': '配出数量',
  '总实际件数': '总实际件数',
  '总实际金额': '总实际金额',
  '总实际体积': '总实际体积',
  '总实际品项数': '总实际品项数',
  '总实际重量': '总实际重量',
  '自定义字段': '自定义字段',
  '备用1': '备用1',
  '备用2': '备用2',
  '波次启动校验配置':'波次启动校验配置',
  '是否强制更新': '是否强制更新',
  '强制维护固定拣货位仓位范围': '强制维护固定拣货位仓位范围',
  '领用返还单': '领用返还单',
  '当前订单中包含已保存的收货单，确认是否完成该订单?': '当前订单中包含已保存的收货单，确认是否完成该订单?',
  '订单{billNumber}存在已保存收货单，是否确认完成?': '订单{billNumber}存在已保存收货单，是否确认完成?',
  '货位{binCode}存在商品{articleCode}库存，是否确认修改': '货位{binCode}存在商品{articleCode}库存，是否确认修改',
  '第{line}行重量结算商品，件数不为0，重量不能为0': '第{line}行重量结算商品，件数不为0，重量不能为0',
  '订单{billNumber}存在已保存收货单，是否确认完成?': '订单{billNumber}存在已保存收货单，是否确认完成?',
  '系统规则': '系统规则',
  '全局配置': '全局配置',
  '资料配置': '资料配置',
  '运输配置': '运输配置',
  '移库规则': '移库规则',
  '业务单据使用货位用途规则': '业务单据使用货位用途规则',
  'RF操作配置' : 'RF操作配置',
  '单据操作限制配置': '单据操作限制配置',
  '容器后置打印配置': '容器后置打印配置',
  '员工作业配置': '员工作业配置',
  '类越库拣货员作业配置': '类越库拣货员作业配置',
  '退货拣货员作业配置': '退货拣货员作业配置',
  '预约预检': '预约预检',
  '波次配置': '波次配置',
  '默认库存分配方案配置': '默认库存分配方案配置',
  '默认拣货顺序方案配置': '默认拣货顺序方案配置',
  '默认集货管理方案配置': '默认集货管理方案配置',
  '默认集货复查装车配置': '默认集货复查装车配置',
  '默认允许重复执行配置': '默认允许重复执行配置',
  '默认商品组分单配置': '默认商品组分单配置',
  '分单默认值配置': '分单默认值配置',
  '同容器拣货限制': '同容器拣货限制',
  '请选择分单默认值配置': '请选择分单默认值配置',
  '请选择同容器拣货限制': '请选择同容器拣货限制',
  '默认越库分播管理方案配置': '默认越库分播管理方案配置',
  '超控制天数出库仓位配置': '超控制天数出库仓位配置',
  '拣货配置': '拣货配置',
  '集货配置': '集货配置',
  '拣货区域与码头集对应配置': '拣货区域与码头集对应配置',
  '配货差异': '配货差异',
  '指令配置': '指令配置',
  '运输配置': '运输配置',
  '看板配置': '看板配置',
  '排车配置': '排车配置',
  '装车配置': '装车配置',
  '交接配置': '交接配置',
  '返配类型': '返配类型',
  '请先选择要设置目标货位行的商品': '请先选择要设置目标货位行的商品',
  '请选择少配移库类型的明细行': '请选择少配移库类型的明细行',
  '上一个': '上一个',
  '下一个': '下一个',
  '不存在上一个': '不存在上一个',
  '不存在下一个': '不存在下一个',
  '获取上一个失败': '获取上一个失败',
  '获取下一个失败': '获取下一个失败',
  '调序成功': '调序成功',
  '订单 {billNumber} 存在已保存收货单，是否确认完成？': '订单 {billNumber} 存在已保存收货单，是否确认完成？',
  '备用3': '备用3',
  '备用4': '备用4',
  '订单 {billNumber} 存在已保存收货单，是否确认完成？': '订单 {billNumber} 存在已保存收货单，是否确认完成？',
  '领料单': '领料单',
  '统配拣货显示商品条码': '统配拣货显示商品条码',
  '临时车辆配置': '临时车辆配置',
  '临时车辆使用已有车型': '临时车辆使用已有车型',
  '勾选后RF统配拣货模块显示商品的第二代码,不勾选不显示': '勾选后RF统配拣货模块显示商品的第二代码,不勾选不显示',
  'WEB': 'WEB' ,
  '采集终端': '采集终端',
  '附件强度': '附件强度',
  '第{line}行明细,感官质检科目{sense}的附件强度为强制限制,质检结果至少要有一个附件': '第{line}行明细,感官质检科目{sense}的附件强度为强制限制,质检结果至少要有一个附件',
  '不合格原因': '不合格原因',
  '审批结果': '审批结果',
  '第{line}行明细,质检结果为不合格,至少选择一个不合格原因': '第{line}行明细,质检结果为不合格,至少选择一个不合格原因',
  '可复核缺货处理配单类型': '可复核缺货处理配单类型',
  '分单标识': '分单标识',
  '分单描述': '分单描述',
  '同时存在分单标识{conditionStr}的单据，分单标识不同不能合并预检': '同时存在分单标识{conditionStr}的单据，分单标识不同不能合并预检',
  '同时存在分单标识{conditionStr}的单据，分单标识不同不能存在一个波次中': '同时存在分单标识{conditionStr}的单据，分单标识不同不能存在一个波次中',
  '复核缺货打印': '复核缺货打印',
  '不支持多容器打印': '不支持多容器打印',
  '缺货打印机': '缺货打印机',
  '报表类型': '报表类型',
  '帆软': '帆软',
  '最高最低为0': '最高最低为0',
  '帆软': '帆软',
  'Token密钥': 'Token密钥',
  '租户': '租户',
  'Gem服务': 'Gem服务',
  '配置': '配置',
  'FineReport': 'FineReport',
  'PasoReport': 'PasoReport',
  '请填写模板路径': '请填写模板路径',
  '模板路径(FineReport)': '模板路径(FineReport)',
  '模板路径(PasoReport)': '模板路径(PasoReport)',
  '修改配置': '修改配置',
  '出入业务小数位配置 ': '出入业务小数位配置 ',
  '请输入Token密钥': '请输入Token密钥',
  '请输入租户': '请输入租户',
  '请输入Gem服务': '请输入Gem服务',
  'Token有效期': 'Token有效期',
  '商品{article}包装规格{qpcStr}不存在装盘建议' : '商品{article}包装规格{qpcStr}不存在装盘建议',
  '商品{article}包装规格{qpcStr}最低库存应小于等于最高库存' : '商品{article}包装规格{qpcStr}最低库存应小于等于最高库存',
  '修改货主会导致替换商品/适用门店信息清空，请确认修改？': '修改货主会导致替换商品/适用门店信息清空，请确认修改？',
  '是否继续审核？': '是否继续审核？',
  '确认审核': '确认审核',
  '商品：{article}，拣货数量：{qty}，超过最大拣货数量：{overQty}': '商品：{article}，拣货数量：{qty}，超过最大拣货数量：{overQty}',
  '拣货是否直接平移': '拣货是否直接平移',
  '用于登录页以及系统导航展开时左上角位置显示，图片要求.png格式,大小不超过2M': '用于登录页以及系统导航展开时左上角位置显示，图片要求.png格式,大小不超过2M',
  '用于系统导航收起时左上角位置显示，图片要求.png格式,大小不超过2M': '用于系统导航收起时左上角位置显示，图片要求.png格式,大小不超过2M',
  'LOGO长图片': 'LOGO长图片',
  'LOGO方图片': 'LOGO方图片',
  '副文案': '副文案',
  '登录页左侧插图': '登录页左侧插图',
  '货主范围': '货主范围',
  '登录页LOGO图片': '登录页LOGO图片',
  '用于登录页右上角位置显示，图片要求.png格式,大小不超过2M': '用于登录页右上角位置显示，图片要求.png格式,大小不超过2M',
  '菜单LOGO图片': '菜单LOGO图片',
  '用于菜单导航栏展开/收起是的左上角位置显示,图片要求.png格式,大小不超过2M': '用于菜单导航栏展开/收起是的左上角位置显示,图片要求.png格式,大小不超过2M',
  '长logo': '长logo',
  '方logo': '方logo',
  '仅支持PNG的图片': '仅支持PNG的图片',
  '移库单跨仓移库限制配置': '移库单跨仓移库限制配置',
  '是否确认损耗': '是否确认损耗',
};
